export const resultDatas = [
  {
    mmsi: 994126601,
    lng: 109.020472,
    lat: 17.50825,
    lastdyn: 1719859911,
    type: 30,
    shiptype: 'navigation',
    name: 'YA CHENG GUAN DAO 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126601,
  },
  {
    mmsi: 994136855,
    lng: 108.46,
    lat: 18.178333,
    lastdyn: 1719859850,
    type: 28,
    shiptype: 'navigation',
    name: 'YUE NAN AO YU36062',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136855,
  },
  {
    mmsi: 994136865,
    lng: 108.747192,
    lat: 18.159722,
    lastdyn: 1719859853,
    type: 28,
    shiptype: 'navigation',
    name: 'QB 92699 TS WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136865,
  },
  {
    mmsi: 994136906,
    lng: 109.126805,
    lat: 18.243083,
    lastdyn: 1719859906,
    type: 28,
    shiptype: 'navigation',
    name: 'SHEN SHI JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136906,
  },
  {
    mmsi: 994126602,
    lng: 109.106083,
    lat: 18.24925,
    lastdyn: 1719859913,
    type: 30,
    shiptype: 'navigation',
    name: 'YA CHENG GUAN DAO 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126602,
  },
  {
    mmsi: 994136904,
    lng: 109.389778,
    lat: 18.205055,
    lastdyn: 1719859859,
    type: 28,
    shiptype: 'navigation',
    name: 'SAN YA SHUANG FEI SH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136904,
  },
  {
    mmsi: 994136907,
    lng: 109.350445,
    lat: 18.216417,
    lastdyn: 1719859910,
    type: 28,
    shiptype: 'navigation',
    name: 'BAN LU SHI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136907,
  },
  {
    mmsi: 994126655,
    lng: 109.08836,
    lat: 18.308795,
    lastdyn: 1719859749,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 1 MAODI 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126655,
  },
  {
    mmsi: 994126656,
    lng: 109.078727,
    lat: 18.299212,
    lastdyn: 1719859767,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 1 MAODI 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126656,
  },
  {
    mmsi: 994126659,
    lng: 109.097778,
    lat: 18.268793,
    lastdyn: 1719859754,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 2 MAODI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126659,
  },
  {
    mmsi: 994126663,
    lng: 109.135333,
    lat: 18.301283,
    lastdyn: 1719859764,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 3 MAODI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126663,
  },
  {
    mmsi: 994126657,
    lng: 109.078587,
    lat: 18.283553,
    lastdyn: 1719859770,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 1 MAODI 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126657,
  },
  {
    mmsi: 994126603,
    lng: 109.142778,
    lat: 18.302333,
    lastdyn: 1719859917,
    type: 30,
    shiptype: 'navigation',
    name: 'YA CHENG GUAN DAO 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126603,
  },
  {
    mmsi: 994126654,
    lng: 109.11418,
    lat: 18.285112,
    lastdyn: 1719859745,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 1 MAODI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126654,
  },
  {
    mmsi: 994126661,
    lng: 109.063695,
    lat: 18.276705,
    lastdyn: 1719859758,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 2 MAODI 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126661,
  },
  {
    mmsi: 994126653,
    lng: 109.101807,
    lat: 18.272802,
    lastdyn: 1719859742,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 1 MAODI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126653,
  },
  {
    mmsi: 994126658,
    lng: 109.085575,
    lat: 18.256652,
    lastdyn: 1719859752,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 2 MAODI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126658,
  },
  {
    mmsi: 994126660,
    lng: 109.069083,
    lat: 18.28208,
    lastdyn: 1719859756,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN SHAN 2 MAODI 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126660,
  },
  {
    mmsi: 994136903,
    lng: 110.141445,
    lat: 18.4365,
    lastdyn: 1719859856,
    type: 28,
    shiptype: 'navigation',
    name: 'LING SHUI SHUANG FAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994136903,
  },
  {
    mmsi: 994126624,
    lng: 110.447222,
    lat: 18.711667,
    lastdyn: 1719859865,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126624,
  },
  {
    mmsi: 994126627,
    lng: 110.469445,
    lat: 18.628333,
    lastdyn: 1719859874,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126627,
  },
  {
    mmsi: 994126628,
    lng: 110.461388,
    lat: 18.666112,
    lastdyn: 1719859877,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126628,
  },
  {
    mmsi: 994126623,
    lng: 110.466667,
    lat: 18.618333,
    lastdyn: 1719859862,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126623,
  },
  {
    mmsi: 994126626,
    lng: 110.535,
    lat: 18.636667,
    lastdyn: 1719859871,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126626,
  },
  {
    mmsi: 994126629,
    lng: 110.511388,
    lat: 18.68111,
    lastdyn: 1719859880,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126629,
  },
  {
    mmsi: 994126630,
    lng: 110.525,
    lat: 18.641667,
    lastdyn: 1719859883,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126630,
  },
  {
    mmsi: 994126625,
    lng: 110.501667,
    lat: 18.731667,
    lastdyn: 1719859868,
    type: 30,
    shiptype: 'navigation',
    name: 'DA ZHOU BIAN JIE VIR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126625,
  },
  {
    mmsi: 999992320,
    lng: 110.632502,
    lat: 19.288003,
    lastdyn: 1719463146,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2320',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992320,
  },
  {
    mmsi: 999999011,
    lng: 117.619733,
    lat: 19.377137,
    lastdyn: 1719686692,
    type: 31,
    shiptype: 'navigation',
    name: 'CESHI',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999011,
  },
  {
    mmsi: 995741893,
    lng: 105.81773,
    lat: 19.305162,
    lastdyn: 1719859564,
    type: 21,
    shiptype: 'navigation',
    name: 'NSE10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741893,
  },
  {
    mmsi: 995741896,
    lng: 105.825128,
    lat: 19.296688,
    lastdyn: 1719859325,
    type: 25,
    shiptype: 'navigation',
    name: 'NS5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741896,
  },
  {
    mmsi: 995741890,
    lng: 105.816688,
    lat: 19.308575,
    lastdyn: 1719859600,
    type: 21,
    shiptype: 'navigation',
    name: 'NSE12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741890,
  },
  {
    mmsi: 995741897,
    lng: 105.845792,
    lat: 19.27411,
    lastdyn: 1719859168,
    type: 24,
    shiptype: 'navigation',
    name: 'NS2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741897,
  },
  {
    mmsi: 995741894,
    lng: 105.81979,
    lat: 19.299697,
    lastdyn: 1719859504,
    type: 24,
    shiptype: 'navigation',
    name: 'NS8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741894,
  },
  {
    mmsi: 995741895,
    lng: 105.823167,
    lat: 19.294883,
    lastdyn: 1719858719,
    type: 24,
    shiptype: 'navigation',
    name: 'NS6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741895,
  },
  {
    mmsi: 995741889,
    lng: 105.822323,
    lat: 19.300715,
    lastdyn: 1719859543,
    type: 25,
    shiptype: 'navigation',
    name: 'NS7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741889,
  },
  {
    mmsi: 994136905,
    lng: 108.64375,
    lat: 19.351445,
    lastdyn: 1719859830,
    type: 28,
    shiptype: 'navigation',
    name: 'DA PAI JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136905,
  },
  {
    mmsi: 999993014,
    lng: 108.56454,
    lat: 20.708555,
    lastdyn: 1719849796,
    type: 31,
    shiptype: 'navigation',
    name: 'JIFENGGUANCE04',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993014,
  },
  {
    mmsi: 994136902,
    lng: 111.031805,
    lat: 19.466805,
    lastdyn: 1719859813,
    type: 28,
    shiptype: 'navigation',
    name: 'LUO NI YAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136902,
  },
  {
    mmsi: 999999035,
    lng: 113.76771,
    lat: 19.344655,
    lastdyn: 1719825411,
    type: 31,
    shiptype: 'navigation',
    name: 'SF313',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999035,
  },
  {
    mmsi: 994126930,
    lng: 108.939043,
    lat: 19.659925,
    lastdyn: 1719859438,
    type: 30,
    shiptype: 'navigation',
    name: 'YP1HYOXFB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126930,
  },
  {
    mmsi: 994141828,
    lng: 109.201667,
    lat: 19.724833,
    lastdyn: 1719859917,
    type: 25,
    shiptype: 'navigation',
    name: 'YANG PU GANG VIRTUAL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994141828,
  },
  {
    mmsi: 994126664,
    lng: 109.061117,
    lat: 19.65305,
    lastdyn: 1719859746,
    type: 30,
    shiptype: 'navigation',
    name: 'YP11 ANCHORAGE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126664,
  },
  {
    mmsi: 994126865,
    lng: 109.132472,
    lat: 19.698305,
    lastdyn: 1719859779,
    type: 24,
    shiptype: 'navigation',
    name: 'YP4 VIRTUAL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126865,
  },
  {
    mmsi: 994126665,
    lng: 109.080267,
    lat: 19.65305,
    lastdyn: 1719859749,
    type: 30,
    shiptype: 'navigation',
    name: 'YP11 ANCHORAGE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126665,
  },
  {
    mmsi: 994126669,
    lng: 109.130283,
    lat: 19.676367,
    lastdyn: 1719859761,
    type: 30,
    shiptype: 'navigation',
    name: 'YP12 ANCHORAGE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126669,
  },
  {
    mmsi: 994126864,
    lng: 109.112833,
    lat: 19.699667,
    lastdyn: 1719859776,
    type: 24,
    shiptype: 'navigation',
    name: 'YP2 VIRTUAL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126864,
  },
  {
    mmsi: 994126671,
    lng: 109.093333,
    lat: 19.637233,
    lastdyn: 1719859767,
    type: 30,
    shiptype: 'navigation',
    name: 'YP12 ANCHORAGE 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126671,
  },
  {
    mmsi: 994126666,
    lng: 109.080267,
    lat: 19.632767,
    lastdyn: 1719859752,
    type: 30,
    shiptype: 'navigation',
    name: 'YP11 ANCHORAGE 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126666,
  },
  {
    mmsi: 994126670,
    lng: 109.138883,
    lat: 19.66165,
    lastdyn: 1719859764,
    type: 30,
    shiptype: 'navigation',
    name: 'YP12 ANCHORAGE 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126670,
  },
  {
    mmsi: 994126668,
    lng: 109.084733,
    lat: 19.652217,
    lastdyn: 1719859758,
    type: 30,
    shiptype: 'navigation',
    name: 'YP12 ANCHORAGE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126668,
  },
  {
    mmsi: 994136851,
    lng: 109.041113,
    lat: 19.726922,
    lastdyn: 1719859743,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN WRECK 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136851,
  },
  {
    mmsi: 994126667,
    lng: 109.061117,
    lat: 19.632767,
    lastdyn: 1719859755,
    type: 30,
    shiptype: 'navigation',
    name: 'YP11 ANCHORAGE 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126667,
  },
  {
    mmsi: 994126866,
    lng: 109.150167,
    lat: 19.697083,
    lastdyn: 1719859782,
    type: 24,
    shiptype: 'navigation',
    name: 'YP6 VIRTUAL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126866,
  },
  {
    mmsi: 999000049,
    lng: 110.820817,
    lat: 19.564925,
    lastdyn: 1719859885,
    type: 31,
    shiptype: 'navigation',
    name: 'SF308',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000049,
  },
  {
    mmsi: 999991028,
    lng: 110.822098,
    lat: 19.563783,
    lastdyn: 1719859904,
    type: 25,
    shiptype: 'navigation',
    name: 'ATON 1028',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991028,
  },
  {
    mmsi: 994136908,
    lng: 110.841722,
    lat: 19.541195,
    lastdyn: 1719859816,
    type: 25,
    shiptype: 'navigation',
    name: 'QING LAN AIS 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136908,
  },
  {
    mmsi: 994131792,
    lng: 110.819623,
    lat: 19.56418,
    lastdyn: 1719859887,
    type: 25,
    shiptype: 'navigation',
    name: 'QING LAN GANG 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131792,
  },
  {
    mmsi: 994126931,
    lng: 108.955353,
    lat: 19.864715,
    lastdyn: 1719859457,
    type: 30,
    shiptype: 'navigation',
    name: 'YP2HYOXFB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126931,
  },
  {
    mmsi: 994126806,
    lng: 109.110833,
    lat: 19.987333,
    lastdyn: 1719859740,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126806,
  },
  {
    mmsi: 994131933,
    lng: 109.466433,
    lat: 19.87875,
    lastdyn: 1719859693,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131933,
  },
  {
    mmsi: 994131931,
    lng: 109.46575,
    lat: 19.88938,
    lastdyn: 1719859861,
    type: 30,
    shiptype: 'navigation',
    name: 'HSW ANCHORAGE 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131931,
  },
  {
    mmsi: 994126672,
    lng: 109.4587,
    lat: 19.89985,
    lastdyn: 1719859770,
    type: 30,
    shiptype: 'navigation',
    name: 'HSW ANCHORAGE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126672,
  },
  {
    mmsi: 994131932,
    lng: 109.466,
    lat: 19.8841,
    lastdyn: 1719859753,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131932,
  },
  {
    mmsi: 994131930,
    lng: 109.46524,
    lat: 19.89559,
    lastdyn: 1719859741,
    type: 30,
    shiptype: 'navigation',
    name: 'HSW ANCHORAGE 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131930,
  },
  {
    mmsi: 994126673,
    lng: 109.458833,
    lat: 19.89585,
    lastdyn: 1719859773,
    type: 30,
    shiptype: 'navigation',
    name: 'HSW ANCHORAGE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126673,
  },
  {
    mmsi: 994136901,
    lng: 111.210083,
    lat: 19.886805,
    lastdyn: 1719859781,
    type: 28,
    shiptype: 'navigation',
    name: 'QI ZHOU SHUANG FAN S',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136901,
  },
  {
    mmsi: 995746986,
    lng: 107.115,
    lat: 20.215,
    lastdyn: 1719859614,
    type: 28,
    shiptype: 'navigation',
    name: 'HOANG THINH 68 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 995746986,
  },
  {
    mmsi: 994136668,
    lng: 109.212903,
    lat: 20.224247,
    lastdyn: 1719859825,
    type: 28,
    shiptype: 'navigation',
    name: 'QIONG LIN GAO 05001',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136668,
  },
  {
    mmsi: 994121660,
    lng: 109.11164,
    lat: 20.14231,
    lastdyn: 1719859840,
    type: 3,
    shiptype: 'navigation',
    name: 'YP2CFT1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121660,
  },
  {
    mmsi: 994136849,
    lng: 109.601472,
    lat: 20.245583,
    lastdyn: 1719859895,
    type: 23,
    shiptype: 'navigation',
    name: 'LEI ZHOU XI BU 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136849,
  },
  {
    mmsi: 994121662,
    lng: 109.966122,
    lat: 20.181957,
    lastdyn: 1719859809,
    type: 19,
    shiptype: 'navigation',
    name: 'QIONG HAI DIAN 8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121662,
  },
  {
    mmsi: 994126808,
    lng: 109.869837,
    lat: 20.172683,
    lastdyn: 1719859794,
    type: 28,
    shiptype: 'navigation',
    name: 'JIAHE 128 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126808,
  },
  {
    mmsi: 994126632,
    lng: 109.96693,
    lat: 20.168397,
    lastdyn: 1719859787,
    type: 30,
    shiptype: 'navigation',
    name: 'QIONG HAI DIAN VIRTU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126632,
  },
  {
    mmsi: 994136846,
    lng: 109.811612,
    lat: 20.230612,
    lastdyn: 1719859890,
    type: 22,
    shiptype: 'navigation',
    name: 'LEI ZHOU XI BU 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136846,
  },
  {
    mmsi: 994121663,
    lng: 109.95302,
    lat: 20.06197,
    lastdyn: 1719846606,
    type: 30,
    shiptype: 'navigation',
    name: 'QIONGHAIDIAN16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121663,
  },
  {
    mmsi: 994126633,
    lng: 109.957553,
    lat: 20.167825,
    lastdyn: 1719859791,
    type: 30,
    shiptype: 'navigation',
    name: 'QIONG HAI DIAN VIRTU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126633,
  },
  {
    mmsi: 994136921,
    lng: 110.129,
    lat: 20.049638,
    lastdyn: 1719859847,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136921,
  },
  {
    mmsi: 994136916,
    lng: 110.123138,
    lat: 20.1,
    lastdyn: 1719859651,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136916,
  },
  {
    mmsi: 994136918,
    lng: 110.125055,
    lat: 20.075583,
    lastdyn: 1719859658,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136918,
  },
  {
    mmsi: 994136917,
    lng: 110.125055,
    lat: 20.100138,
    lastdyn: 1719859835,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136917,
  },
  {
    mmsi: 994136914,
    lng: 110.121233,
    lat: 20.124412,
    lastdyn: 1719859826,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136914,
  },
  {
    mmsi: 994136919,
    lng: 110.126972,
    lat: 20.075722,
    lastdyn: 1719859841,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136919,
  },
  {
    mmsi: 994136920,
    lng: 110.126972,
    lat: 20.051167,
    lastdyn: 1719859664,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136920,
  },
  {
    mmsi: 994136915,
    lng: 110.123078,
    lat: 20.125367,
    lastdyn: 1719859829,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEHAI VIRTUAL 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136915,
  },
  {
    mmsi: 994131785,
    lng: 110.25157,
    lat: 20.17632,
    lastdyn: 1719840240,
    type: 0,
    shiptype: 'navigation',
    name: 'QZ DINGXIANZHIJING2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131785,
  },
  {
    mmsi: 994131776,
    lng: 110.28215,
    lat: 20.23837,
    lastdyn: 1719848101,
    type: 28,
    shiptype: 'navigation',
    name: 'NIU MU JIAO SHI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131776,
  },
  {
    mmsi: 994131784,
    lng: 110.39727,
    lat: 20.197908,
    lastdyn: 1719853023,
    type: 29,
    shiptype: 'navigation',
    name: 'QZDINGXIANZHI JING 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131784,
  },
  {
    mmsi: 994131790,
    lng: 110.25446,
    lat: 20.08123,
    lastdyn: 1719762547,
    type: 25,
    shiptype: 'navigation',
    name: 'XIUYINGGANG1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131790,
  },
  {
    mmsi: 991220001,
    lng: 11.980985,
    lat: 57.721592,
    lastdyn: 1681280113,
    type: 0,
    shiptype: 'navigation',
    name: 'JACK IIBUOY1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 991220001,
  },
  {
    mmsi: 994136988,
    lng: 109.301967,
    lat: 20.32,
    lastdyn: 1719859858,
    type: 28,
    shiptype: 'navigation',
    name: 'QIONG LIN YU 00276 W',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136988,
  },
  {
    mmsi: 994126951,
    lng: 109.63853,
    lat: 20.48714,
    lastdyn: 1719859812,
    type: 3,
    shiptype: 'navigation',
    name: 'WS235',
    length: 30,
    width: 42,
    left: 41,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126951,
  },
  {
    mmsi: 994136873,
    lng: 109.723667,
    lat: 20.284028,
    lastdyn: 1719859898,
    type: 28,
    shiptype: 'navigation',
    name: 'LEI ZHOU XI BU 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136873,
  },
  {
    mmsi: 994136847,
    lng: 109.788695,
    lat: 20.255222,
    lastdyn: 1719859892,
    type: 20,
    shiptype: 'navigation',
    name: 'LEI ZHOU XI BU 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136847,
  },
  {
    mmsi: 994136728,
    lng: 110.418267,
    lat: 20.2616,
    lastdyn: 1719859821,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK YUE YANG JIANG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136728,
  },
  {
    mmsi: 994136910,
    lng: 110.6784,
    lat: 20.439933,
    lastdyn: 1719859842,
    type: 28,
    shiptype: 'navigation',
    name: 'YGZG 0222',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136910,
  },
  {
    mmsi: 994121883,
    lng: 110.58037,
    lat: 20.31364,
    lastdyn: 1719859560,
    type: 30,
    shiptype: 'navigation',
    name: 'HZ FENG DIAN 2',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121883,
  },
  {
    mmsi: 994131649,
    lng: 110.823073,
    lat: 20.348797,
    lastdyn: 1719850028,
    type: 30,
    shiptype: 'navigation',
    name: 'BEI SHUI DAO 6',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131649,
  },
  {
    mmsi: 995741970,
    lng: 106.98097,
    lat: 20.704997,
    lastdyn: 1719848898,
    type: 24,
    shiptype: 'navigation',
    name: 'HP8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741970,
  },
  {
    mmsi: 995741972,
    lng: 106.99028,
    lat: 20.69363,
    lastdyn: 1719712483,
    type: 24,
    shiptype: 'navigation',
    name: 'HP6',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741972,
  },
  {
    mmsi: 995741877,
    lng: 106.936722,
    lat: 20.747945,
    lastdyn: 1719859083,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB3',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741877,
  },
  {
    mmsi: 995741876,
    lng: 106.939555,
    lat: 20.744308,
    lastdyn: 1719859049,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB4',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741876,
  },
  {
    mmsi: 995741869,
    lng: 106.955083,
    lat: 20.724305,
    lastdyn: 1719858603,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB11',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741869,
  },
  {
    mmsi: 995741968,
    lng: 106.953912,
    lat: 20.739855,
    lastdyn: 1719859488,
    type: 24,
    shiptype: 'navigation',
    name: 'HP14',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741968,
  },
  {
    mmsi: 995741874,
    lng: 106.9445,
    lat: 20.737918,
    lastdyn: 1719859420,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB6',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741874,
  },
  {
    mmsi: 995741870,
    lng: 106.952972,
    lat: 20.727,
    lastdyn: 1719859434,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB10',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741870,
  },
  {
    mmsi: 995741998,
    lng: 106.870167,
    lat: 20.6635,
    lastdyn: 1719859607,
    type: 28,
    shiptype: 'navigation',
    name: 'SHIP WRECK SHUN AN X',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741998,
  },
  {
    mmsi: 995741973,
    lng: 106.991792,
    lat: 20.694493,
    lastdyn: 1719859540,
    type: 25,
    shiptype: 'navigation',
    name: 'HP5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741973,
  },
  {
    mmsi: 995741872,
    lng: 106.94875,
    lat: 20.732445,
    lastdyn: 1719859490,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB8',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741872,
  },
  {
    mmsi: 995741873,
    lng: 106.94664,
    lat: 20.735195,
    lastdyn: 1719859553,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB7',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741873,
  },
  {
    mmsi: 995741868,
    lng: 106.957195,
    lat: 20.721583,
    lastdyn: 1719859634,
    type: 19,
    shiptype: 'navigation',
    name: 'HPB12',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741868,
  },
  {
    mmsi: 995741959,
    lng: 107.177777,
    lat: 20.729715,
    lastdyn: 1719859042,
    type: 29,
    shiptype: 'navigation',
    name: 'HG0',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741959,
  },
  {
    mmsi: 995741503,
    lng: 107.247078,
    lat: 20.748733,
    lastdyn: 1719859028,
    type: 25,
    shiptype: 'navigation',
    name: 'P03',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741503,
  },
  {
    mmsi: 995741996,
    lng: 107.159302,
    lat: 20.623015,
    lastdyn: 1719859548,
    type: 5,
    shiptype: 'navigation',
    name: 'LONG CHAU',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741996,
  },
  {
    mmsi: 995741976,
    lng: 107.02335,
    lat: 20.652547,
    lastdyn: 1719858595,
    type: 29,
    shiptype: 'navigation',
    name: 'HP0',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741976,
  },
  {
    mmsi: 995741974,
    lng: 107.00838,
    lat: 20.66992,
    lastdyn: 1719826476,
    type: 24,
    shiptype: 'navigation',
    name: 'HP2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741974,
  },
  {
    mmsi: 995746987,
    lng: 107.092467,
    lat: 20.710183,
    lastdyn: 1719859627,
    type: 21,
    shiptype: 'navigation',
    name: 'E2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995746987,
  },
  {
    mmsi: 994136756,
    lng: 109.276945,
    lat: 20.738612,
    lastdyn: 1719859875,
    type: 28,
    shiptype: 'navigation',
    name: 'GUI FANG 13029 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136756,
  },
  {
    mmsi: 994136687,
    lng: 109.26,
    lat: 20.7235,
    lastdyn: 1719859861,
    type: 28,
    shiptype: 'navigation',
    name: 'XINTIAN 6 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136687,
  },
  {
    mmsi: 992404022,
    lng: 109.74928,
    lat: 20.743578,
    lastdyn: 1719847981,
    type: 0,
    shiptype: 'navigation',
    name: 'LAMP POST 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 992404022,
  },
  {
    mmsi: 994126949,
    lng: 109.63689,
    lat: 20.54983,
    lastdyn: 1719859759,
    type: 3,
    shiptype: 'navigation',
    name: 'WS172',
    length: 41,
    width: 61,
    left: 60,
    trail: 40,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126949,
  },
  {
    mmsi: 994136647,
    lng: 109.586133,
    lat: 20.509533,
    lastdyn: 1719859872,
    type: 28,
    shiptype: 'navigation',
    name: 'XIN BAO HANG 168',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136647,
  },
  {
    mmsi: 994121714,
    lng: 109.63916,
    lat: 20.7288,
    lastdyn: 1719859716,
    type: 30,
    shiptype: 'navigation',
    name: 'B10HYDROLOGICALAIS',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121714,
  },
  {
    mmsi: 994126950,
    lng: 109.61733,
    lat: 20.55141,
    lastdyn: 1719859800,
    type: 3,
    shiptype: 'navigation',
    name: 'WS161W',
    length: 41,
    width: 56,
    left: 55,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126950,
  },
  {
    mmsi: 994136784,
    lng: 109.726667,
    lat: 20.733612,
    lastdyn: 1719859881,
    type: 28,
    shiptype: 'navigation',
    name: 'QI SHUI WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136784,
  },
  {
    mmsi: 997100227,
    lng: 109.827235,
    lat: 20.546528,
    lastdyn: 1719859903,
    type: 17,
    shiptype: 'navigation',
    name: 'ZKHX',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 997100227,
  },
  {
    mmsi: 994121854,
    lng: 110.532403,
    lat: 20.746707,
    lastdyn: 1719859766,
    type: 30,
    shiptype: 'navigation',
    name: 'XIN LIAO 8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121854,
  },
  {
    mmsi: 994131771,
    lng: 110.560872,
    lat: 20.629793,
    lastdyn: 1719859756,
    type: 25,
    shiptype: 'navigation',
    name: 'WAI LUO 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131771,
  },
  {
    mmsi: 994136679,
    lng: 110.581945,
    lat: 20.647222,
    lastdyn: 1719859888,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK YONGSHENG 168',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136679,
  },
  {
    mmsi: 994121857,
    lng: 110.668208,
    lat: 20.605343,
    lastdyn: 1719859791,
    type: 3,
    shiptype: 'navigation',
    name: 'YUE DIAN 15',
    length: 100,
    width: 100,
    left: 50,
    trail: 50,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121857,
  },
  {
    mmsi: 994121876,
    lng: 110.70842,
    lat: 20.52909,
    lastdyn: 1719859719,
    type: 30,
    shiptype: 'navigation',
    name: 'XUWEN FENGDIAN S5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121876,
  },
  {
    mmsi: 994121705,
    lng: 110.62826,
    lat: 20.616813,
    lastdyn: 1719832903,
    type: 19,
    shiptype: 'navigation',
    name: 'YUE DIAN 4',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121705,
  },
  {
    mmsi: 994136666,
    lng: 110.604217,
    lat: 20.702133,
    lastdyn: 1719859885,
    type: 28,
    shiptype: 'navigation',
    name: 'BEI JIN KOU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136666,
  },
  {
    mmsi: 994121708,
    lng: 110.57956,
    lat: 20.5712,
    lastdyn: 1719859761,
    type: 30,
    shiptype: 'navigation',
    name: 'YUE DIAN DENG FU 1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121708,
  },
  {
    mmsi: 994136879,
    lng: 110.630917,
    lat: 20.684767,
    lastdyn: 1719859918,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN OBSTRUCTION',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136879,
  },
  {
    mmsi: 994121851,
    lng: 110.577743,
    lat: 20.737878,
    lastdyn: 1719859917,
    type: 30,
    shiptype: 'navigation',
    name: 'XIN LIAO 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121851,
  },
  {
    mmsi: 994121853,
    lng: 110.573708,
    lat: 20.676427,
    lastdyn: 1719854991,
    type: 30,
    shiptype: 'navigation',
    name: 'XIN LIAO 3',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121853,
  },
  {
    mmsi: 994121707,
    lng: 110.61436,
    lat: 20.52907,
    lastdyn: 1719859718,
    type: 30,
    shiptype: 'navigation',
    name: 'YUE DIAN 8',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121707,
  },
  {
    mmsi: 994121852,
    lng: 110.582395,
    lat: 20.710565,
    lastdyn: 1719855106,
    type: 30,
    shiptype: 'navigation',
    name: 'XIN LIAO 2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121852,
  },
  {
    mmsi: 994121856,
    lng: 110.655637,
    lat: 20.63305,
    lastdyn: 1719859872,
    type: 3,
    shiptype: 'navigation',
    name: 'YUE DIAN 14',
    length: 100,
    width: 100,
    left: 50,
    trail: 50,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121856,
  },
  {
    mmsi: 994131749,
    lng: 110.70008,
    lat: 20.66357,
    lastdyn: 1719846730,
    type: 30,
    shiptype: 'navigation',
    name: 'XWZRSGQLS2',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131749,
  },
  {
    mmsi: 994121709,
    lng: 110.53613,
    lat: 20.55619,
    lastdyn: 1719859873,
    type: 30,
    shiptype: 'navigation',
    name: 'YUE DIAN DENG FU 6',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121709,
  },
  {
    mmsi: 994121704,
    lng: 110.58457,
    lat: 20.59286,
    lastdyn: 1719859747,
    type: 30,
    shiptype: 'navigation',
    name: 'YUE DIAN 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121704,
  },
  {
    mmsi: 994136779,
    lng: 110.715425,
    lat: 20.681953,
    lastdyn: 1719859744,
    type: 30,
    shiptype: 'navigation',
    name: 'XWCS5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136779,
  },
  {
    mmsi: 994131769,
    lng: 110.604403,
    lat: 20.716657,
    lastdyn: 1717603549,
    type: 29,
    shiptype: 'navigation',
    name: 'BEI JIN KOU 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131769,
  },
  {
    mmsi: 994121706,
    lng: 110.628633,
    lat: 20.530278,
    lastdyn: 1719859705,
    type: 30,
    shiptype: 'navigation',
    name: 'YUE DIAN 7',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121706,
  },
  {
    mmsi: 994131772,
    lng: 110.54511,
    lat: 20.5346,
    lastdyn: 1719859760,
    type: 25,
    shiptype: 'navigation',
    name: 'WAI LUO 7',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131772,
  },
  {
    mmsi: 994121855,
    lng: 110.64361,
    lat: 20.62573,
    lastdyn: 1719859761,
    type: 30,
    shiptype: 'navigation',
    name: 'YUE DIAN 13',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121855,
  },
  {
    mmsi: 994121873,
    lng: 110.75063,
    lat: 20.65873,
    lastdyn: 1719859680,
    type: 30,
    shiptype: 'navigation',
    name: 'XU WEN FENG DIAN N6',
    length: 12,
    width: 0,
    left: 0,
    trail: 6,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121873,
  },
  {
    mmsi: 994121874,
    lng: 110.79177,
    lat: 20.58334,
    lastdyn: 1719856487,
    type: 30,
    shiptype: 'navigation',
    name: 'XUWEN FENGDIAN S1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121874,
  },
  {
    mmsi: 994121875,
    lng: 110.79162,
    lat: 20.52904,
    lastdyn: 1719858379,
    type: 30,
    shiptype: 'navigation',
    name: 'XUWEN FENGDIAN S3',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121875,
  },
  {
    mmsi: 994136755,
    lng: 111.205555,
    lat: 20.551667,
    lastdyn: 1719859824,
    type: 28,
    shiptype: 'navigation',
    name: 'GUIBEIYU24022 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136755,
  },
  {
    mmsi: 995741700,
    lng: 106.707473,
    lat: 20.887612,
    lastdyn: 1719859160,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741700,
  },
  {
    mmsi: 995741978,
    lng: 106.704427,
    lat: 20.878528,
    lastdyn: 1719859528,
    type: 0,
    shiptype: 'navigation',
    name: 'SONG CAM METEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741978,
  },
  {
    mmsi: 995741786,
    lng: 106.702068,
    lat: 20.873128,
    lastdyn: 1703388123,
    type: 24,
    shiptype: 'navigation',
    name: 'D2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741786,
  },
  {
    mmsi: 995741789,
    lng: 106.691558,
    lat: 20.85731,
    lastdyn: 1684369842,
    type: 20,
    shiptype: 'navigation',
    name: 'N4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741789,
  },
  {
    mmsi: 995741796,
    lng: 106.702137,
    lat: 20.873385,
    lastdyn: 1709347062,
    type: 24,
    shiptype: 'navigation',
    name: 'N2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741796,
  },
  {
    mmsi: 995746917,
    lng: 106.765417,
    lat: 20.847638,
    lastdyn: 1719859620,
    type: 19,
    shiptype: 'navigation',
    name: 'CBD2',
    length: 2,
    width: 1,
    left: 0,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995746917,
  },
  {
    mmsi: 995746919,
    lng: 106.7635,
    lat: 20.846638,
    lastdyn: 1719859623,
    type: 9,
    shiptype: 'navigation',
    name: 'CBD4',
    length: 2,
    width: 1,
    left: 0,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995746919,
  },
  {
    mmsi: 995741983,
    lng: 106.84025,
    lat: 20.80689,
    lastdyn: 1719856068,
    type: 12,
    shiptype: 'navigation',
    name: 'TV3',
    length: 2,
    width: 1,
    left: 0,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741983,
  },
  {
    mmsi: 995746985,
    lng: 106.767805,
    lat: 20.845972,
    lastdyn: 1719859629,
    type: 19,
    shiptype: 'navigation',
    name: 'PLCBD',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 995746985,
  },
  {
    mmsi: 995741824,
    lng: 106.858055,
    lat: 20.813833,
    lastdyn: 1719859506,
    type: 13,
    shiptype: 'navigation',
    name: 'HP HN6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741824,
  },
  {
    mmsi: 995741830,
    lng: 106.701912,
    lat: 20.873033,
    lastdyn: 1719859529,
    type: 13,
    shiptype: 'navigation',
    name: 'HP HN4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741830,
  },
  {
    mmsi: 995746918,
    lng: 106.765277,
    lat: 20.848027,
    lastdyn: 1719859800,
    type: 19,
    shiptype: 'navigation',
    name: 'CBD3',
    length: 2,
    width: 1,
    left: 0,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995746918,
  },
  {
    mmsi: 995741986,
    lng: 106.821127,
    lat: 20.83186,
    lastdyn: 1719859613,
    type: 17,
    shiptype: 'navigation',
    name: 'ARRYO',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741986,
  },
  {
    mmsi: 995741842,
    lng: 106.917222,
    lat: 20.82325,
    lastdyn: 1719859380,
    type: 8,
    shiptype: 'navigation',
    name: 'HP D',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741842,
  },
  {
    mmsi: 995741964,
    lng: 106.922057,
    lat: 20.780852,
    lastdyn: 1719856592,
    type: 24,
    shiptype: 'navigation',
    name: 'HP22',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741964,
  },
  {
    mmsi: 995741984,
    lng: 106.8389,
    lat: 20.80684,
    lastdyn: 1719859020,
    type: 10,
    shiptype: 'navigation',
    name: 'TV4',
    length: 2,
    width: 1,
    left: 0,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741984,
  },
  {
    mmsi: 995741965,
    lng: 106.920138,
    lat: 20.78725,
    lastdyn: 1719858484,
    type: 25,
    shiptype: 'navigation',
    name: 'HP21',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741965,
  },
  {
    mmsi: 995741820,
    lng: 106.847055,
    lat: 20.812057,
    lastdyn: 1719859621,
    type: 13,
    shiptype: 'navigation',
    name: 'HP HN8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741820,
  },
  {
    mmsi: 995746916,
    lng: 106.767193,
    lat: 20.849,
    lastdyn: 1719859613,
    type: 14,
    shiptype: 'navigation',
    name: 'CBD1',
    length: 2,
    width: 1,
    left: 0,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995746916,
  },
  {
    mmsi: 995741981,
    lng: 106.84172,
    lat: 20.80684,
    lastdyn: 1719858721,
    type: 12,
    shiptype: 'navigation',
    name: 'TV1',
    length: 2,
    width: 1,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741981,
  },
  {
    mmsi: 995741961,
    lng: 106.913722,
    lat: 20.804083,
    lastdyn: 1719857870,
    type: 23,
    shiptype: 'navigation',
    name: 'W',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741961,
  },
  {
    mmsi: 995741967,
    lng: 181,
    lat: 91,
    lastdyn: 1719859529,
    type: 25,
    shiptype: 'navigation',
    name: 'HP17',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741967,
  },
  {
    mmsi: 995741977,
    lng: 106.907747,
    lat: 20.82205,
    lastdyn: 1719858450,
    type: 0,
    shiptype: 'navigation',
    name: 'LACH HUYEN METEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741977,
  },
  {
    mmsi: 995741966,
    lng: 106.93578,
    lat: 20.763163,
    lastdyn: 1719859528,
    type: 24,
    shiptype: 'navigation',
    name: 'HP18',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741966,
  },
  {
    mmsi: 995741960,
    lng: 106.910277,
    lat: 20.805555,
    lastdyn: 1719852662,
    type: 22,
    shiptype: 'navigation',
    name: 'S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741960,
  },
  {
    mmsi: 995741843,
    lng: 106.907722,
    lat: 20.822028,
    lastdyn: 1719859540,
    type: 7,
    shiptype: 'navigation',
    name: 'HP C',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741843,
  },
  {
    mmsi: 995741963,
    lng: 106.915527,
    lat: 20.796828,
    lastdyn: 1719858089,
    type: 25,
    shiptype: 'navigation',
    name: 'HP23',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741963,
  },
  {
    mmsi: 995741831,
    lng: 106.8465,
    lat: 20.816028,
    lastdyn: 1719824404,
    type: 0,
    shiptype: 'navigation',
    name: 'HP CL1 BEACON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741831,
  },
  {
    mmsi: 995741982,
    lng: 106.840333,
    lat: 20.806833,
    lastdyn: 1719859513,
    type: 10,
    shiptype: 'navigation',
    name: 'TV2',
    length: 2,
    width: 1,
    left: 0,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741982,
  },
  {
    mmsi: 995741834,
    lng: 106.87925,
    lat: 20.816528,
    lastdyn: 1719859321,
    type: 13,
    shiptype: 'navigation',
    name: 'HP HN2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741834,
  },
  {
    mmsi: 995741962,
    lng: 106.914392,
    lat: 20.790752,
    lastdyn: 1719859182,
    type: 24,
    shiptype: 'navigation',
    name: 'HP24',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741962,
  },
  {
    mmsi: 995741792,
    lng: 106.691522,
    lat: 20.85738,
    lastdyn: 1689346181,
    type: 21,
    shiptype: 'navigation',
    name: 'NE8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741792,
  },
  {
    mmsi: 995741797,
    lng: 106.70199,
    lat: 20.873048,
    lastdyn: 1710323104,
    type: 24,
    shiptype: 'navigation',
    name: 'S2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741797,
  },
  {
    mmsi: 995741920,
    lng: 107.097168,
    lat: 20.864378,
    lastdyn: 1719858928,
    type: 7,
    shiptype: 'navigation',
    name: 'HONMOT',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741920,
  },
  {
    mmsi: 995741948,
    lng: 107.093022,
    lat: 20.872105,
    lastdyn: 1719858968,
    type: 24,
    shiptype: 'navigation',
    name: 'HG8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741948,
  },
  {
    mmsi: 995741932,
    lng: 107.062585,
    lat: 20.966872,
    lastdyn: 1719858197,
    type: 24,
    shiptype: 'navigation',
    name: 'HG24',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741932,
  },
  {
    mmsi: 995741955,
    lng: 107.15967,
    lat: 20.763817,
    lastdyn: 1719858879,
    type: 21,
    shiptype: 'navigation',
    name: 'HGE2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741955,
  },
  {
    mmsi: 995741950,
    lng: 107.144585,
    lat: 20.804177,
    lastdyn: 1719858955,
    type: 24,
    shiptype: 'navigation',
    name: 'HG6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741950,
  },
  {
    mmsi: 995741922,
    lng: 107.138082,
    lat: 20.829342,
    lastdyn: 1719859045,
    type: 14,
    shiptype: 'navigation',
    name: 'HONPHAO',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741922,
  },
  {
    mmsi: 995741949,
    lng: 107.094732,
    lat: 20.872628,
    lastdyn: 1719858935,
    type: 25,
    shiptype: 'navigation',
    name: 'HG7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741949,
  },
  {
    mmsi: 995741937,
    lng: 107.070143,
    lat: 20.935272,
    lastdyn: 1719858936,
    type: 25,
    shiptype: 'navigation',
    name: 'HG19',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741937,
  },
  {
    mmsi: 995741954,
    lng: 107.165288,
    lat: 20.75392,
    lastdyn: 1719859108,
    type: 24,
    shiptype: 'navigation',
    name: 'HG2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741954,
  },
  {
    mmsi: 995741925,
    lng: 107.049418,
    lat: 20.980223,
    lastdyn: 1719857609,
    type: 25,
    shiptype: 'navigation',
    name: 'HG31',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741925,
  },
  {
    mmsi: 995741940,
    lng: 107.076982,
    lat: 20.913535,
    lastdyn: 1719859168,
    type: 24,
    shiptype: 'navigation',
    name: 'HG16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741940,
  },
  {
    mmsi: 995741926,
    lng: 107.052343,
    lat: 20.977795,
    lastdyn: 1719856439,
    type: 25,
    shiptype: 'navigation',
    name: 'HG29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741926,
  },
  {
    mmsi: 995741927,
    lng: 107.05521,
    lat: 20.977808,
    lastdyn: 1719858013,
    type: 22,
    shiptype: 'navigation',
    name: 'HGS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741927,
  },
  {
    mmsi: 995741921,
    lng: 107.125077,
    lat: 20.849317,
    lastdyn: 1719858876,
    type: 13,
    shiptype: 'navigation',
    name: 'DAUTRAU',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741921,
  },
  {
    mmsi: 995741957,
    lng: 107.161885,
    lat: 20.771778,
    lastdyn: 1719859046,
    type: 25,
    shiptype: 'navigation',
    name: 'HG1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741957,
  },
  {
    mmsi: 995741934,
    lng: 107.063312,
    lat: 20.954678,
    lastdyn: 1719858349,
    type: 24,
    shiptype: 'navigation',
    name: 'HG22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741934,
  },
  {
    mmsi: 995741942,
    lng: 107.081155,
    lat: 20.903055,
    lastdyn: 1719859179,
    type: 24,
    shiptype: 'navigation',
    name: 'HG14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741942,
  },
  {
    mmsi: 995741941,
    lng: 107.078403,
    lat: 20.914212,
    lastdyn: 1719859070,
    type: 25,
    shiptype: 'navigation',
    name: 'HG15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741941,
  },
  {
    mmsi: 995741947,
    lng: 107.090933,
    lat: 20.882387,
    lastdyn: 1719859175,
    type: 25,
    shiptype: 'navigation',
    name: 'HG9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741947,
  },
  {
    mmsi: 995741939,
    lng: 107.074307,
    lat: 20.924623,
    lastdyn: 1719859081,
    type: 25,
    shiptype: 'navigation',
    name: 'HG17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741939,
  },
  {
    mmsi: 995741928,
    lng: 106.867722,
    lat: 20.816083,
    lastdyn: 1719859505,
    type: 13,
    shiptype: 'navigation',
    name: 'HP B',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741928,
  },
  {
    mmsi: 995741933,
    lng: 107.063497,
    lat: 20.967845,
    lastdyn: 1719858851,
    type: 25,
    shiptype: 'navigation',
    name: 'HG23',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741933,
  },
  {
    mmsi: 995741952,
    lng: 107.151372,
    lat: 20.787922,
    lastdyn: 1719859054,
    type: 24,
    shiptype: 'navigation',
    name: 'HG4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741952,
  },
  {
    mmsi: 995741931,
    lng: 107.059943,
    lat: 20.97094,
    lastdyn: 1719859129,
    type: 25,
    shiptype: 'navigation',
    name: 'HG25',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741931,
  },
  {
    mmsi: 995741958,
    lng: 107.170758,
    lat: 20.75542,
    lastdyn: 1719859075,
    type: 23,
    shiptype: 'navigation',
    name: 'HGW',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741958,
  },
  {
    mmsi: 995741502,
    lng: 107.245118,
    lat: 20.749818,
    lastdyn: 1719859154,
    type: 24,
    shiptype: 'navigation',
    name: 'P02',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741502,
  },
  {
    mmsi: 995741938,
    lng: 107.072993,
    lat: 20.923757,
    lastdyn: 1719858241,
    type: 24,
    shiptype: 'navigation',
    name: 'HG18',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741938,
  },
  {
    mmsi: 995741929,
    lng: 107.056755,
    lat: 20.973918,
    lastdyn: 1719858964,
    type: 25,
    shiptype: 'navigation',
    name: 'HG27',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741929,
  },
  {
    mmsi: 995741936,
    lng: 107.068497,
    lat: 20.934382,
    lastdyn: 1719859164,
    type: 24,
    shiptype: 'navigation',
    name: 'HG20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741936,
  },
  {
    mmsi: 995741946,
    lng: 107.089547,
    lat: 20.881677,
    lastdyn: 1719859120,
    type: 24,
    shiptype: 'navigation',
    name: 'HG10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741946,
  },
  {
    mmsi: 995741943,
    lng: 107.0827,
    lat: 20.903688,
    lastdyn: 1719859142,
    type: 25,
    shiptype: 'navigation',
    name: 'HG13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741943,
  },
  {
    mmsi: 995741945,
    lng: 107.086663,
    lat: 20.893038,
    lastdyn: 1719859174,
    type: 25,
    shiptype: 'navigation',
    name: 'HG11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741945,
  },
  {
    mmsi: 995741935,
    lng: 107.066108,
    lat: 20.965648,
    lastdyn: 1719683372,
    type: 27,
    shiptype: 'navigation',
    name: 'HG21',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741935,
  },
  {
    mmsi: 995741953,
    lng: 107.154113,
    lat: 20.788913,
    lastdyn: 1719859041,
    type: 25,
    shiptype: 'navigation',
    name: 'HG3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741953,
  },
  {
    mmsi: 995741923,
    lng: 107.136755,
    lat: 20.8201,
    lastdyn: 1719859115,
    type: 13,
    shiptype: 'navigation',
    name: 'HONMIEU',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741923,
  },
  {
    mmsi: 995741930,
    lng: 181,
    lat: 91,
    lastdyn: 1719645584,
    type: 24,
    shiptype: 'navigation',
    name: 'HG26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 229,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741930,
  },
  {
    mmsi: 995741980,
    lng: 107.05724,
    lat: 20.970707,
    lastdyn: 1719859165,
    type: 19,
    shiptype: 'navigation',
    name: 'CAI LAN METEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741980,
  },
  {
    mmsi: 995741979,
    lng: 107.1168,
    lat: 20.854855,
    lastdyn: 1719858986,
    type: 0,
    shiptype: 'navigation',
    name: 'LACH MIEU METEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741979,
  },
  {
    mmsi: 995741951,
    lng: 107.147223,
    lat: 20.805498,
    lastdyn: 1719859041,
    type: 25,
    shiptype: 'navigation',
    name: 'HG5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741951,
  },
  {
    mmsi: 995741924,
    lng: 107.157905,
    lat: 20.770317,
    lastdyn: 1719858959,
    type: 10,
    shiptype: 'navigation',
    name: 'CONCHIM',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741924,
  },
  {
    mmsi: 995741944,
    lng: 107.085223,
    lat: 20.892343,
    lastdyn: 1719859172,
    type: 24,
    shiptype: 'navigation',
    name: 'HG12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741944,
  },
  {
    mmsi: 995741528,
    lng: 107.30609,
    lat: 20.847898,
    lastdyn: 1719859574,
    type: 14,
    shiptype: 'navigation',
    name: 'DT LO MUC',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741528,
  },
  {
    mmsi: 995741533,
    lng: 107.29813,
    lat: 20.93869,
    lastdyn: 1719859083,
    type: 15,
    shiptype: 'navigation',
    name: 'DT BO CAN',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741533,
  },
  {
    mmsi: 995741535,
    lng: 107.348152,
    lat: 20.965995,
    lastdyn: 1719859505,
    type: 14,
    shiptype: 'navigation',
    name: 'DT CON ONG',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741535,
  },
  {
    mmsi: 995741514,
    lng: 107.295285,
    lat: 20.837265,
    lastdyn: 1719859511,
    type: 24,
    shiptype: 'navigation',
    name: 'P14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741514,
  },
  {
    mmsi: 995741511,
    lng: 107.280787,
    lat: 20.807192,
    lastdyn: 1719859148,
    type: 25,
    shiptype: 'navigation',
    name: 'P11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741511,
  },
  {
    mmsi: 995741521,
    lng: 107.360297,
    lat: 20.983895,
    lastdyn: 1719859537,
    type: 25,
    shiptype: 'navigation',
    name: 'P21',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741521,
  },
  {
    mmsi: 995741504,
    lng: 107.254037,
    lat: 20.764308,
    lastdyn: 1719858863,
    type: 24,
    shiptype: 'navigation',
    name: 'P04',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741504,
  },
  {
    mmsi: 995741508,
    lng: 107.270538,
    lat: 20.793592,
    lastdyn: 1719859267,
    type: 24,
    shiptype: 'navigation',
    name: 'P08',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741508,
  },
  {
    mmsi: 995741527,
    lng: 107.294845,
    lat: 20.826692,
    lastdyn: 1719859149,
    type: 5,
    shiptype: 'navigation',
    name: 'SOI DEN',
    length: 100,
    width: 100,
    left: 50,
    trail: 50,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741527,
  },
  {
    mmsi: 995741529,
    lng: 107.296403,
    lat: 20.859063,
    lastdyn: 1719859548,
    type: 13,
    shiptype: 'navigation',
    name: 'DT HON GOI',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741529,
  },
  {
    mmsi: 995741513,
    lng: 107.289038,
    lat: 20.821717,
    lastdyn: 1719829270,
    type: 25,
    shiptype: 'navigation',
    name: 'P13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741513,
  },
  {
    mmsi: 995741515,
    lng: 107.297378,
    lat: 20.836387,
    lastdyn: 1719859511,
    type: 25,
    shiptype: 'navigation',
    name: 'P15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741515,
  },
  {
    mmsi: 995741516,
    lng: 107.299073,
    lat: 20.845123,
    lastdyn: 1719859151,
    type: 21,
    shiptype: 'navigation',
    name: 'P16',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741516,
  },
  {
    mmsi: 995741531,
    lng: 107.28369,
    lat: 20.877098,
    lastdyn: 1719859144,
    type: 15,
    shiptype: 'navigation',
    name: 'DT GIENG CUT',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 229,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741531,
  },
  {
    mmsi: 995741509,
    lng: 107.272508,
    lat: 20.792702,
    lastdyn: 1719859508,
    type: 25,
    shiptype: 'navigation',
    name: 'P09',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741509,
  },
  {
    mmsi: 995741534,
    lng: 107.310882,
    lat: 20.939953,
    lastdyn: 1719859534,
    type: 14,
    shiptype: 'navigation',
    name: 'DT THE VANG',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741534,
  },
  {
    mmsi: 995741517,
    lng: 107.294918,
    lat: 20.927073,
    lastdyn: 1719859149,
    type: 25,
    shiptype: 'navigation',
    name: 'P17',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741517,
  },
  {
    mmsi: 995741510,
    lng: 107.278785,
    lat: 20.80807,
    lastdyn: 1719859147,
    type: 24,
    shiptype: 'navigation',
    name: 'P10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741510,
  },
  {
    mmsi: 995741507,
    lng: 107.26407,
    lat: 20.77819,
    lastdyn: 1719858969,
    type: 25,
    shiptype: 'navigation',
    name: 'P07',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741507,
  },
  {
    mmsi: 995741519,
    lng: 107.35252,
    lat: 20.973627,
    lastdyn: 1719859512,
    type: 27,
    shiptype: 'navigation',
    name: 'P19',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741519,
  },
  {
    mmsi: 995741505,
    lng: 107.255532,
    lat: 20.763723,
    lastdyn: 1719859034,
    type: 25,
    shiptype: 'navigation',
    name: 'P05',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741505,
  },
  {
    mmsi: 995741523,
    lng: 107.368515,
    lat: 20.994272,
    lastdyn: 1719858965,
    type: 24,
    shiptype: 'navigation',
    name: 'P23',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741523,
  },
  {
    mmsi: 995741512,
    lng: 107.287032,
    lat: 20.82294,
    lastdyn: 1719859148,
    type: 24,
    shiptype: 'navigation',
    name: 'P12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741512,
  },
  {
    mmsi: 995741506,
    lng: 107.261982,
    lat: 20.779072,
    lastdyn: 1719859036,
    type: 24,
    shiptype: 'navigation',
    name: 'P06',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741506,
  },
  {
    mmsi: 995741530,
    lng: 107.2881,
    lat: 20.875257,
    lastdyn: 1719859573,
    type: 14,
    shiptype: 'navigation',
    name: 'DT DAU GIUONG',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741530,
  },
  {
    mmsi: 995741518,
    lng: 107.273098,
    lat: 20.894453,
    lastdyn: 1719859573,
    type: 25,
    shiptype: 'navigation',
    name: 'P18',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741518,
  },
  {
    mmsi: 995741536,
    lng: 107.36814,
    lat: 20.998997,
    lastdyn: 1719859025,
    type: 17,
    shiptype: 'navigation',
    name: 'DANG TIEU 8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741536,
  },
  {
    mmsi: 995741532,
    lng: 107.284493,
    lat: 20.905893,
    lastdyn: 1719859324,
    type: 14,
    shiptype: 'navigation',
    name: 'DT MOM DA CON',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741532,
  },
  {
    mmsi: 995741520,
    lng: 107.359018,
    lat: 20.984945,
    lastdyn: 1719859622,
    type: 24,
    shiptype: 'navigation',
    name: 'P20',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741520,
  },
  {
    mmsi: 994136657,
    lng: 108.948862,
    lat: 20.880112,
    lastdyn: 1719859822,
    type: 30,
    shiptype: 'navigation',
    name: 'WEI ZHOU DAO PIPELIN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136657,
  },
  {
    mmsi: 994131697,
    lng: 109.21317,
    lat: 20.905147,
    lastdyn: 1719859768,
    type: 3,
    shiptype: 'navigation',
    name: 'XIE YANG DAO NAN',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131697,
  },
  {
    mmsi: 994136868,
    lng: 109.241888,
    lat: 20.839963,
    lastdyn: 1719859852,
    type: 28,
    shiptype: 'navigation',
    name: 'DONG KUN 01 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136868,
  },
  {
    mmsi: 994121640,
    lng: 110.601277,
    lat: 20.987645,
    lastdyn: 1719859546,
    type: 3,
    shiptype: 'navigation',
    name: 'DRAIN OUTLET',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121640,
  },
  {
    mmsi: 994136739,
    lng: 110.7075,
    lat: 20.825278,
    lastdyn: 1719859894,
    type: 28,
    shiptype: 'navigation',
    name: 'YUE DONG GUAN CHUI 0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136739,
  },
  {
    mmsi: 994131768,
    lng: 110.60346,
    lat: 20.80066,
    lastdyn: 1719818168,
    type: 25,
    shiptype: 'navigation',
    name: 'NAO ZHOU 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131768,
  },
  {
    mmsi: 994131835,
    lng: 110.57468,
    lat: 20.96371,
    lastdyn: 1719859819,
    type: 24,
    shiptype: 'navigation',
    name: 'NAO ZHOU 11',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131835,
  },
  {
    mmsi: 994136626,
    lng: 110.733333,
    lat: 20.798888,
    lastdyn: 1719859900,
    type: 28,
    shiptype: 'navigation',
    name: 'HONGXIANG538 SHIPWRE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136626,
  },
  {
    mmsi: 994131767,
    lng: 110.61785,
    lat: 20.9909,
    lastdyn: 1719859276,
    type: 25,
    shiptype: 'navigation',
    name: 'DOULONG A2',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131767,
  },
  {
    mmsi: 994121871,
    lng: 113.712333,
    lat: 22.47696,
    lastdyn: 1715710204,
    type: 30,
    shiptype: 'navigation',
    name: 'FANG HU SY1',
    length: 3,
    width: 3,
    left: 2,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121871,
  },
  {
    mmsi: 994136680,
    lng: 110.861472,
    lat: 20.87,
    lastdyn: 1719859892,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK LI AN 198',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136680,
  },
  {
    mmsi: 994131779,
    lng: 111.033363,
    lat: 20.90746,
    lastdyn: 1719857675,
    type: 28,
    shiptype: 'navigation',
    name: 'SHI TAI 666 WRECK 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131779,
  },
  {
    mmsi: 994136623,
    lng: 111.034333,
    lat: 20.9065,
    lastdyn: 1719859882,
    type: 28,
    shiptype: 'navigation',
    name: 'SHIP WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136623,
  },
  {
    mmsi: 994136878,
    lng: 111.453,
    lat: 20.991155,
    lastdyn: 1719859786,
    type: 30,
    shiptype: 'navigation',
    name: 'QINGZHOU LIU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136878,
  },
  {
    mmsi: 999062620,
    lng: 117.295895,
    lat: 21.002335,
    lastdyn: 1719844631,
    type: 31,
    shiptype: 'navigation',
    name: '',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999062620,
  },
  {
    mmsi: 995741540,
    lng: 107.37947,
    lat: 21.028072,
    lastdyn: 1719858846,
    type: 8,
    shiptype: 'navigation',
    name: 'CHAP TIEU D',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741540,
  },
  {
    mmsi: 995741522,
    lng: 107.369997,
    lat: 21.003905,
    lastdyn: 1719859563,
    type: 24,
    shiptype: 'navigation',
    name: 'P22',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741522,
  },
  {
    mmsi: 995741542,
    lng: 107.373092,
    lat: 21.034318,
    lastdyn: 1719858672,
    type: 8,
    shiptype: 'navigation',
    name: 'CHAP TIEU F',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741542,
  },
  {
    mmsi: 995741525,
    lng: 107.375135,
    lat: 21.013252,
    lastdyn: 1719859506,
    type: 27,
    shiptype: 'navigation',
    name: 'P27',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741525,
  },
  {
    mmsi: 995741526,
    lng: 107.37434,
    lat: 21.02901,
    lastdyn: 1719858968,
    type: 25,
    shiptype: 'navigation',
    name: 'P31',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741526,
  },
  {
    mmsi: 995741539,
    lng: 107.377387,
    lat: 21.022238,
    lastdyn: 1719858489,
    type: 7,
    shiptype: 'navigation',
    name: 'CHAP TIEU C',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741539,
  },
  {
    mmsi: 995741524,
    lng: 107.371667,
    lat: 21.003572,
    lastdyn: 1719859324,
    type: 25,
    shiptype: 'navigation',
    name: 'P25',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741524,
  },
  {
    mmsi: 995741541,
    lng: 107.373168,
    lat: 21.03361,
    lastdyn: 1719858492,
    type: 7,
    shiptype: 'navigation',
    name: 'CHAP TIEU E',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741541,
  },
  {
    mmsi: 995741538,
    lng: 107.380112,
    lat: 21.010728,
    lastdyn: 1719859568,
    type: 7,
    shiptype: 'navigation',
    name: 'CHAP TIEU B',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995741538,
  },
  {
    mmsi: 994136896,
    lng: 108.855017,
    lat: 21.210867,
    lastdyn: 1719859864,
    type: 28,
    shiptype: 'navigation',
    name: 'GUIBEIYU82099 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136896,
  },
  {
    mmsi: 994136653,
    lng: 108.995,
    lat: 21.110333,
    lastdyn: 1719859813,
    type: 30,
    shiptype: 'navigation',
    name: 'TIE SHAN ANCHORAGE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136653,
  },
  {
    mmsi: 994136655,
    lng: 108.936833,
    lat: 21.104222,
    lastdyn: 1719859816,
    type: 30,
    shiptype: 'navigation',
    name: 'TIE SHAN ANCHORAGE 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136655,
  },
  {
    mmsi: 994136654,
    lng: 108.939472,
    lat: 21.095528,
    lastdyn: 1719859831,
    type: 30,
    shiptype: 'navigation',
    name: 'TIE SHAN ANCHORAGE 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136654,
  },
  {
    mmsi: 994136652,
    lng: 108.992362,
    lat: 21.119028,
    lastdyn: 1719859828,
    type: 30,
    shiptype: 'navigation',
    name: 'TIE SHAN ANCHORAGE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136652,
  },
  {
    mmsi: 994136656,
    lng: 109.049195,
    lat: 21.005472,
    lastdyn: 1719859819,
    type: 30,
    shiptype: 'navigation',
    name: 'WEI ZHOU DAO PIPELIN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136656,
  },
  {
    mmsi: 994136841,
    lng: 109.085388,
    lat: 21.056028,
    lastdyn: 1719859870,
    type: 24,
    shiptype: 'navigation',
    name: 'WEI ZHOU DAO 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136841,
  },
  {
    mmsi: 994131696,
    lng: 109.09832,
    lat: 21.008203,
    lastdyn: 1719859046,
    type: 3,
    shiptype: 'navigation',
    name: 'PO YIN SHI',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131696,
  },
  {
    mmsi: 994136986,
    lng: 109.151667,
    lat: 21.213333,
    lastdyn: 1719859873,
    type: 28,
    shiptype: 'navigation',
    name: 'GUI BEI 55868 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136986,
  },
  {
    mmsi: 994131695,
    lng: 109.123237,
    lat: 21.01888,
    lastdyn: 1719859691,
    type: 3,
    shiptype: 'navigation',
    name: 'WAN ZAI JIAO',
    length: 40,
    width: 40,
    left: 20,
    trail: 20,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131695,
  },
  {
    mmsi: 994136875,
    lng: 109.444,
    lat: 21.1155,
    lastdyn: 1719859886,
    type: 28,
    shiptype: 'navigation',
    name: 'LEI ZHOU XI BU 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136875,
  },
  {
    mmsi: 994136874,
    lng: 109.544195,
    lat: 21.120833,
    lastdyn: 1719859883,
    type: 28,
    shiptype: 'navigation',
    name: 'LEI ZHOU XI BU 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136874,
  },
  {
    mmsi: 994136603,
    lng: 121.793,
    lat: 36.179722,
    lastdyn: 1719859820,
    type: 28,
    shiptype: 'navigation',
    name: 'LURUYU54868 WRECK PA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136603,
  },
  {
    mmsi: 994131764,
    lng: 110.43486,
    lat: 21.21735,
    lastdyn: 1719806069,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 60',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131764,
  },
  {
    mmsi: 994136812,
    lng: 110.425362,
    lat: 21.24035,
    lastdyn: 1719859577,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 61A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136812,
  },
  {
    mmsi: 994131762,
    lng: 110.41695,
    lat: 21.13228,
    lastdyn: 1719859786,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 53',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131762,
  },
  {
    mmsi: 994131763,
    lng: 110.41298,
    lat: 21.1593,
    lastdyn: 1719859820,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 56',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131763,
  },
  {
    mmsi: 994131761,
    lng: 110.46118,
    lat: 21.07214,
    lastdyn: 1719859237,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 46',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131761,
  },
  {
    mmsi: 994131765,
    lng: 110.43064,
    lat: 21.233185,
    lastdyn: 1719859915,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHAN JAING GANG 61',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131765,
  },
  {
    mmsi: 999414008,
    lng: 110.511827,
    lat: 21.09882,
    lastdyn: 1719858421,
    type: 0,
    shiptype: 'navigation',
    name: 'GD08',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999414008,
  },
  {
    mmsi: 994131698,
    lng: 110.5311,
    lat: 21.08918,
    lastdyn: 1719853358,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 41',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131698,
  },
  {
    mmsi: 994131757,
    lng: 110.71826,
    lat: 21.04102,
    lastdyn: 1719859000,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 25',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131757,
  },
  {
    mmsi: 994131759,
    lng: 110.61788,
    lat: 21.05279,
    lastdyn: 1719818532,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 35',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131759,
  },
  {
    mmsi: 994131760,
    lng: 110.616747,
    lat: 21.048533,
    lastdyn: 1719859916,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 36',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131760,
  },
  {
    mmsi: 994136750,
    lng: 110.731112,
    lat: 21.063055,
    lastdyn: 1719859165,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK WU MING',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136750,
  },
  {
    mmsi: 994131732,
    lng: 110.967978,
    lat: 21.00844,
    lastdyn: 1719859174,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 2',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131732,
  },
  {
    mmsi: 994136682,
    lng: 111.258333,
    lat: 21.055,
    lastdyn: 1719859797,
    type: 28,
    shiptype: 'navigation',
    name: 'MEI HANG 839 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136682,
  },
  {
    mmsi: 994126906,
    lng: 111.615383,
    lat: 21.220683,
    lastdyn: 1719858918,
    type: 30,
    shiptype: 'navigation',
    name: 'MYSPFD 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126906,
  },
  {
    mmsi: 994136941,
    lng: 111.597517,
    lat: 21.100817,
    lastdyn: 1719859910,
    type: 3,
    shiptype: 'navigation',
    name: 'YQ PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136941,
  },
  {
    mmsi: 994136871,
    lng: 111.681712,
    lat: 21.14002,
    lastdyn: 1719859768,
    type: 19,
    shiptype: 'navigation',
    name: 'QZYE CABLE V1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136871,
  },
  {
    mmsi: 994136876,
    lng: 111.677862,
    lat: 21.22933,
    lastdyn: 1719859771,
    type: 30,
    shiptype: 'navigation',
    name: 'QZYE CABLE V2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136876,
  },
  {
    mmsi: 994131727,
    lng: 111.521597,
    lat: 21.220635,
    lastdyn: 1719859847,
    type: 3,
    shiptype: 'navigation',
    name: 'SXSPFD S31',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131727,
  },
  {
    mmsi: 994136600,
    lng: 112.327617,
    lat: 21.248883,
    lastdyn: 1719859801,
    type: 28,
    shiptype: 'navigation',
    name: 'YUANHANG 286 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136600,
  },
  {
    mmsi: 999666003,
    lng: 125.472932,
    lat: -8.565792,
    lastdyn: 1680114009,
    type: 0,
    shiptype: 'navigation',
    name: 'NO1',
    length: 40,
    width: 40,
    left: 20,
    trail: 20,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999666003,
  },
  {
    mmsi: 999666002,
    lng: 125.47474,
    lat: -8.563498,
    lastdyn: 1679962894,
    type: 24,
    shiptype: 'navigation',
    name: 'NO2',
    length: 40,
    width: 40,
    left: 20,
    trail: 20,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999666002,
  },
  {
    mmsi: 999666001,
    lng: 181,
    lat: 91,
    lastdyn: 1701656993,
    type: 29,
    shiptype: 'navigation',
    name: 'SPARE FB01',
    length: 20,
    width: 20,
    left: 10,
    trail: 10,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999666001,
  },
  {
    mmsi: 994196068,
    lng: 88.233333,
    lat: 21.274167,
    lastdyn: 1719844002,
    type: 1,
    shiptype: 'navigation',
    name: 'NX2VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196068,
  },
  {
    mmsi: 994196067,
    lng: 88.233333,
    lat: 21.255,
    lastdyn: 1719844002,
    type: 1,
    shiptype: 'navigation',
    name: 'NX3VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196067,
  },
  {
    mmsi: 994196066,
    lng: 88.224167,
    lat: 21.3025,
    lastdyn: 1719844004,
    type: 1,
    shiptype: 'navigation',
    name: 'NX1VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196066,
  },
  {
    mmsi: 995746988,
    lng: 108.045,
    lat: 21.40135,
    lastdyn: 1719859606,
    type: 28,
    shiptype: 'navigation',
    name: 'QUE BAC0345 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 995746988,
  },
  {
    mmsi: 999999020,
    lng: 108.161608,
    lat: 21.485185,
    lastdyn: 1719859725,
    type: 31,
    shiptype: 'navigation',
    name: 'FCGHYFB06',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999020,
  },
  {
    mmsi: 994131668,
    lng: 108.35556,
    lat: 21.46829,
    lastdyn: 1719859893,
    type: 25,
    shiptype: 'navigation',
    name: 'FANG CHENG GANG 11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131668,
  },
  {
    mmsi: 994131669,
    lng: 108.35559,
    lat: 21.485822,
    lastdyn: 1719858282,
    type: 25,
    shiptype: 'navigation',
    name: 'FANG CHENG GANG 13',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131669,
  },
  {
    mmsi: 994131667,
    lng: 119.51862,
    lat: 35.2855,
    lastdyn: 1719859802,
    type: 24,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S46',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131667,
  },
  {
    mmsi: 994131901,
    lng: 108.639172,
    lat: 21.476365,
    lastdyn: 1719853126,
    type: 27,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 31',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131901,
  },
  {
    mmsi: 994136691,
    lng: 108.63575,
    lat: 21.470472,
    lastdyn: 1719859739,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136691,
  },
  {
    mmsi: 994131902,
    lng: 108.639037,
    lat: 21.49011,
    lastdyn: 1719682553,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 33',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131902,
  },
  {
    mmsi: 994136987,
    lng: 108.787,
    lat: 21.277933,
    lastdyn: 1719859876,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136987,
  },
  {
    mmsi: 994131819,
    lng: 108.784193,
    lat: 21.33751,
    lastdyn: 1719858610,
    type: 30,
    shiptype: 'navigation',
    name: 'CSSC WIND TOWER 5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131819,
  },
  {
    mmsi: 994136651,
    lng: 108.991083,
    lat: 21.356305,
    lastdyn: 1719859867,
    type: 30,
    shiptype: 'navigation',
    name: 'BEI HAI ANCHORAGE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136651,
  },
  {
    mmsi: 994121750,
    lng: 109.077118,
    lat: 21.494055,
    lastdyn: 1719859705,
    type: 24,
    shiptype: 'navigation',
    name: 'BEI HAI GANG 17',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121750,
  },
  {
    mmsi: 994131682,
    lng: 109.11555,
    lat: 21.379308,
    lastdyn: 1719859858,
    type: 25,
    shiptype: 'navigation',
    name: 'KE YUN 1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131682,
  },
  {
    mmsi: 994131818,
    lng: 109.043112,
    lat: 21.469697,
    lastdyn: 1719859911,
    type: 30,
    shiptype: 'navigation',
    name: 'BEI HAI CRUISE PIER',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131818,
  },
  {
    mmsi: 994121752,
    lng: 109.084787,
    lat: 21.485465,
    lastdyn: 1719859833,
    type: 24,
    shiptype: 'navigation',
    name: 'NEI GANG JIN GANG 2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121752,
  },
  {
    mmsi: 994136650,
    lng: 109.012388,
    lat: 21.352388,
    lastdyn: 1719859864,
    type: 30,
    shiptype: 'navigation',
    name: 'BEI HAI ANCHORAGE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136650,
  },
  {
    mmsi: 994131661,
    lng: 109.000848,
    lat: 21.355672,
    lastdyn: 1719538343,
    type: 24,
    shiptype: 'navigation',
    name: 'BEI HAI GANG 2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131661,
  },
  {
    mmsi: 994131662,
    lng: 109.018955,
    lat: 21.445343,
    lastdyn: 1719859611,
    type: 24,
    shiptype: 'navigation',
    name: 'BEI HAI GANG 10B',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131662,
  },
  {
    mmsi: 994136787,
    lng: 109.49032,
    lat: 21.292733,
    lastdyn: 1719859840,
    type: 30,
    shiptype: 'navigation',
    name: 'TIE SHAN ANCHORAGE 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136787,
  },
  {
    mmsi: 994136785,
    lng: 109.456408,
    lat: 21.262592,
    lastdyn: 1719859834,
    type: 30,
    shiptype: 'navigation',
    name: 'TIE SHAN ANCHORAGE 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136785,
  },
  {
    mmsi: 994136786,
    lng: 109.477925,
    lat: 21.264295,
    lastdyn: 1719859837,
    type: 30,
    shiptype: 'navigation',
    name: 'TIE SHAN ANCHORAGE 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136786,
  },
  {
    mmsi: 994121753,
    lng: 109.57368,
    lat: 21.33525,
    lastdyn: 1719859802,
    type: 18,
    shiptype: 'navigation',
    name: 'TIE SHAN GANG 0',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121753,
  },
  {
    mmsi: 994121754,
    lng: 109.564295,
    lat: 21.485032,
    lastdyn: 1719859885,
    type: 25,
    shiptype: 'navigation',
    name: 'TIE SHAN GANG 17',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121754,
  },
  {
    mmsi: 997100229,
    lng: 109.797303,
    lat: 21.46971,
    lastdyn: 1719828862,
    type: 17,
    shiptype: 'navigation',
    name: 'ZKHX',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 997100229,
  },
  {
    mmsi: 994131653,
    lng: 110.41324,
    lat: 21.26277,
    lastdyn: 1719859699,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 67',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131653,
  },
  {
    mmsi: 994131836,
    lng: 110.40914,
    lat: 21.26223,
    lastdyn: 1719859852,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 66',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131836,
  },
  {
    mmsi: 994131766,
    lng: 110.41631,
    lat: 21.25612,
    lastdyn: 1719859782,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 65',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131766,
  },
  {
    mmsi: 994131655,
    lng: 110.42065,
    lat: 21.28455,
    lastdyn: 1719859809,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 70',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131655,
  },
  {
    mmsi: 994136676,
    lng: 110.410555,
    lat: 21.264722,
    lastdyn: 1719859737,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136676,
  },
  {
    mmsi: 994131699,
    lng: 111.08945,
    lat: 21.46814,
    lastdyn: 1719859786,
    type: 24,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 14',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131699,
  },
  {
    mmsi: 994131690,
    lng: 111.077355,
    lat: 21.486717,
    lastdyn: 1719741938,
    type: 17,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 25',
    length: 4,
    width: 2,
    left: 1,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131690,
  },
  {
    mmsi: 994121700,
    lng: 111.069297,
    lat: 21.284148,
    lastdyn: 1719859807,
    type: 30,
    shiptype: 'navigation',
    name: 'B08HYDROLOGICALAIS',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121700,
  },
  {
    mmsi: 994131685,
    lng: 111.107598,
    lat: 21.436182,
    lastdyn: 1719859885,
    type: 24,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131685,
  },
  {
    mmsi: 994131683,
    lng: 111.11884,
    lat: 21.38478,
    lastdyn: 1719859744,
    type: 24,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131683,
  },
  {
    mmsi: 999000036,
    lng: 0,
    lat: 0,
    lastdyn: 1660935843,
    type: 0,
    shiptype: 'navigation',
    name: '',
    length: 8,
    width: 100,
    left: 49,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 130,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000036,
  },
  {
    mmsi: 994136709,
    lng: 111.1045,
    lat: 21.453472,
    lastdyn: 1719859918,
    type: 28,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG LAN S',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136709,
  },
  {
    mmsi: 994131689,
    lng: 111.078573,
    lat: 21.475705,
    lastdyn: 1719859886,
    type: 10,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 24',
    length: 4,
    width: 2,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131689,
  },
  {
    mmsi: 999000032,
    lng: 68.200123,
    lat: 98.645898,
    lastdyn: 1682022959,
    type: 0,
    shiptype: 'navigation',
    name: '',
    length: 770,
    width: 56,
    left: 28,
    trail: 285,
    offsetstatus: 0,
    atonstatus: 8,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999000032,
  },
  {
    mmsi: 994131688,
    lng: 111.08251,
    lat: 21.47228,
    lastdyn: 1719859858,
    type: 23,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 23',
    length: 3,
    width: 3,
    left: 0,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131688,
  },
  {
    mmsi: 999000034,
    lng: 119.872467,
    lat: 34.729977,
    lastdyn: 1693458706,
    type: 31,
    shiptype: 'navigation',
    name: 'BEAHAI0163',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000034,
  },
  {
    mmsi: 994131686,
    lng: 111.10921,
    lat: 21.43646,
    lastdyn: 1719859807,
    type: 25,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 7',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131686,
  },
  {
    mmsi: 994131687,
    lng: 111.097405,
    lat: 21.460307,
    lastdyn: 1719859913,
    type: 28,
    shiptype: 'navigation',
    name: 'SHUI DONG GANG 12',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131687,
  },
  {
    mmsi: 994121784,
    lng: 111.30212,
    lat: 21.40564,
    lastdyn: 1719859890,
    type: 25,
    shiptype: 'navigation',
    name: 'XIN GANG FANG BO DI',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121784,
  },
  {
    mmsi: 994131774,
    lng: 111.40216,
    lat: 21.47313,
    lastdyn: 1719859876,
    type: 28,
    shiptype: 'navigation',
    name: 'JI DA 1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131774,
  },
  {
    mmsi: 994121743,
    lng: 111.39057,
    lat: 21.43994,
    lastdyn: 1719859657,
    type: 30,
    shiptype: 'navigation',
    name: 'WFXINDENG 02',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121743,
  },
  {
    mmsi: 994136959,
    lng: 111.293972,
    lat: 21.41925,
    lastdyn: 1719859777,
    type: 24,
    shiptype: 'navigation',
    name: 'BHMTHD6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136959,
  },
  {
    mmsi: 994136900,
    lng: 111.379667,
    lat: 21.279833,
    lastdyn: 1719859904,
    type: 28,
    shiptype: 'navigation',
    name: 'FU JING 001 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136900,
  },
  {
    mmsi: 994121811,
    lng: 111.494972,
    lat: 21.257395,
    lastdyn: 1719859889,
    type: 30,
    shiptype: 'navigation',
    name: 'SXSP TOWER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121811,
  },
  {
    mmsi: 994136957,
    lng: 111.308278,
    lat: 21.378638,
    lastdyn: 1719859783,
    type: 24,
    shiptype: 'navigation',
    name: 'BHMTHD2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136957,
  },
  {
    mmsi: 994131723,
    lng: 111.454122,
    lat: 21.371063,
    lastdyn: 1719859766,
    type: 3,
    shiptype: 'navigation',
    name: 'SXSPFD S13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131723,
  },
  {
    mmsi: 994136613,
    lng: 111.410122,
    lat: 21.347823,
    lastdyn: 1719859915,
    type: 2,
    shiptype: 'navigation',
    name: 'RACON O',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136613,
  },
  {
    mmsi: 994136958,
    lng: 111.301112,
    lat: 21.398945,
    lastdyn: 1719859780,
    type: 24,
    shiptype: 'navigation',
    name: 'BHMTHD4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136958,
  },
  {
    mmsi: 994121977,
    lng: 111.41115,
    lat: 21.44535,
    lastdyn: 1719859781,
    type: 25,
    shiptype: 'navigation',
    name: 'JIDA EAST 1',
    length: 3,
    width: 3,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121977,
  },
  {
    mmsi: 994136826,
    lng: 111.654337,
    lat: 21.397233,
    lastdyn: 1719859757,
    type: 30,
    shiptype: 'navigation',
    name: 'MYSHPHDDL3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136826,
  },
  {
    mmsi: 994136877,
    lng: 111.68172,
    lat: 21.324145,
    lastdyn: 1719859774,
    type: 30,
    shiptype: 'navigation',
    name: 'QZYE CABLE V3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136877,
  },
  {
    mmsi: 994131725,
    lng: 111.664245,
    lat: 21.33348,
    lastdyn: 1719859902,
    type: 3,
    shiptype: 'navigation',
    name: 'SXSPFD S22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131725,
  },
  {
    mmsi: 994136822,
    lng: 111.726567,
    lat: 21.454933,
    lastdyn: 1719859802,
    type: 28,
    shiptype: 'navigation',
    name: 'QIONG WEN YU 33111 W',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136822,
  },
  {
    mmsi: 994136827,
    lng: 111.654337,
    lat: 21.457855,
    lastdyn: 1719859912,
    type: 30,
    shiptype: 'navigation',
    name: 'MYSPHDDL4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136827,
  },
  {
    mmsi: 994136765,
    lng: 111.633333,
    lat: 21.448372,
    lastdyn: 1719859561,
    type: 30,
    shiptype: 'navigation',
    name: 'SXCABLE S4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136765,
  },
  {
    mmsi: 994136766,
    lng: 111.63615,
    lat: 21.462472,
    lastdyn: 1719859745,
    type: 30,
    shiptype: 'navigation',
    name: 'SXCABLE S5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136766,
  },
  {
    mmsi: 994136769,
    lng: 111.658542,
    lat: 21.257438,
    lastdyn: 1719859712,
    type: 3,
    shiptype: 'navigation',
    name: 'SXSP TOWER V2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136769,
  },
  {
    mmsi: 994136823,
    lng: 111.675675,
    lat: 21.262362,
    lastdyn: 1719859751,
    type: 30,
    shiptype: 'navigation',
    name: 'MYSPHDDL1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136823,
  },
  {
    mmsi: 994126921,
    lng: 111.553047,
    lat: 21.376288,
    lastdyn: 1719859852,
    type: 30,
    shiptype: 'navigation',
    name: 'YUE DIAN SPFD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126921,
  },
  {
    mmsi: 994131724,
    lng: 111.524105,
    lat: 21.376687,
    lastdyn: 1719859825,
    type: 3,
    shiptype: 'navigation',
    name: 'SXSPFD S17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131724,
  },
  {
    mmsi: 994136824,
    lng: 111.675687,
    lat: 21.385363,
    lastdyn: 1719859754,
    type: 30,
    shiptype: 'navigation',
    name: 'MYSPHDDL2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136824,
  },
  {
    mmsi: 994126920,
    lng: 111.662722,
    lat: 21.373203,
    lastdyn: 1719859792,
    type: 30,
    shiptype: 'navigation',
    name: 'YUEDDIANSPFD2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126920,
  },
  {
    mmsi: 994136938,
    lng: 111.567167,
    lat: 21.325833,
    lastdyn: 1719859907,
    type: 28,
    shiptype: 'navigation',
    name: 'FU JING 001 WRECK 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136938,
  },
  {
    mmsi: 994136762,
    lng: 111.582337,
    lat: 21.434555,
    lastdyn: 1719859739,
    type: 30,
    shiptype: 'navigation',
    name: 'SXCABLE S3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136762,
  },
  {
    mmsi: 994136759,
    lng: 111.53137,
    lat: 21.282762,
    lastdyn: 1719859913,
    type: 30,
    shiptype: 'navigation',
    name: 'SXCABLE S1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136759,
  },
  {
    mmsi: 994136961,
    lng: 111.530278,
    lat: 21.383717,
    lastdyn: 1719859916,
    type: 30,
    shiptype: 'navigation',
    name: 'SXCABLE S2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136961,
  },
  {
    mmsi: 994121810,
    lng: 111.977695,
    lat: 21.496445,
    lastdyn: 1719859886,
    type: 30,
    shiptype: 'navigation',
    name: 'SXHLD TOWER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121810,
  },
  {
    mmsi: 994121641,
    lng: 115.092778,
    lat: 22.651422,
    lastdyn: 1719859902,
    type: 24,
    shiptype: 'navigation',
    name: 'HAUL RUN 2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121641,
  },
  {
    mmsi: 994136789,
    lng: 112.288945,
    lat: 21.427362,
    lastdyn: 1719859898,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGGUANGHE V4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136789,
  },
  {
    mmsi: 994121615,
    lng: 114.293513,
    lat: 21.390385,
    lastdyn: 1719854271,
    type: 7,
    shiptype: 'navigation',
    name: 'OSCVB01',
    length: 6,
    width: 9,
    left: 5,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121615,
  },
  {
    mmsi: 994196078,
    lng: 87.926033,
    lat: 21.70055,
    lastdyn: 1719844196,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENV',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196078,
  },
  {
    mmsi: 994196094,
    lng: 87.979617,
    lat: 21.72255,
    lastdyn: 1719844159,
    type: 1,
    shiptype: 'navigation',
    name: 'ADVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196094,
  },
  {
    mmsi: 994196077,
    lng: 87.940533,
    lat: 21.717567,
    lastdyn: 1719845986,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENIV',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196077,
  },
  {
    mmsi: 994196075,
    lng: 87.950933,
    lat: 21.745517,
    lastdyn: 1719843981,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENII',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196075,
  },
  {
    mmsi: 994196099,
    lng: 87.973333,
    lat: 21.545,
    lastdyn: 1719844144,
    type: 1,
    shiptype: 'navigation',
    name: 'BG 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196099,
  },
  {
    mmsi: 994196034,
    lng: 87.984417,
    lat: 21.7342,
    lastdyn: 1719844068,
    type: 1,
    shiptype: 'navigation',
    name: 'LEAVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196034,
  },
  {
    mmsi: 994196079,
    lng: 87.918567,
    lat: 21.677933,
    lastdyn: 1719844194,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENVI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196079,
  },
  {
    mmsi: 994196076,
    lng: 87.930433,
    lat: 21.7252,
    lastdyn: 1719844200,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENIII',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196076,
  },
  {
    mmsi: 994196052,
    lng: 87.938615,
    lat: 21.734388,
    lastdyn: 1719843802,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENWP8VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196052,
  },
  {
    mmsi: 994196069,
    lng: 88.02,
    lat: 21.671667,
    lastdyn: 1719843994,
    type: 1,
    shiptype: 'navigation',
    name: 'NEWA1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196069,
  },
  {
    mmsi: 994196098,
    lng: 88.001667,
    lat: 21.574,
    lastdyn: 1719844151,
    type: 1,
    shiptype: 'navigation',
    name: 'BG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196098,
  },
  {
    mmsi: 994196100,
    lng: 88.006667,
    lat: 21.56,
    lastdyn: 1719844143,
    type: 1,
    shiptype: 'navigation',
    name: 'BG 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196100,
  },
  {
    mmsi: 994196033,
    lng: 88.004167,
    lat: 21.7,
    lastdyn: 1719844069,
    type: 1,
    shiptype: 'navigation',
    name: 'LASVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196033,
  },
  {
    mmsi: 994196073,
    lng: 88.04,
    lat: 21.718333,
    lastdyn: 1719843987,
    type: 1,
    shiptype: 'navigation',
    name: 'NEWUESFVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196073,
  },
  {
    mmsi: 994196042,
    lng: 88,
    lat: 21.733383,
    lastdyn: 1719844273,
    type: 1,
    shiptype: 'navigation',
    name: 'LM3VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196042,
  },
  {
    mmsi: 994196065,
    lng: 88.021867,
    lat: 21.662083,
    lastdyn: 1719844006,
    type: 1,
    shiptype: 'navigation',
    name: 'WKOFSOHAM1BARGE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196065,
  },
  {
    mmsi: 994196072,
    lng: 88.029167,
    lat: 21.712167,
    lastdyn: 1719843988,
    type: 1,
    shiptype: 'navigation',
    name: 'NEWA4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196072,
  },
  {
    mmsi: 994196071,
    lng: 88.023833,
    lat: 21.7,
    lastdyn: 1719843990,
    type: 1,
    shiptype: 'navigation',
    name: 'NEWA3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196071,
  },
  {
    mmsi: 994051010,
    lng: 91.842425,
    lat: 21.6692,
    lastdyn: 1719859347,
    type: 25,
    shiptype: 'navigation',
    name: 'NO9G',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051010,
  },
  {
    mmsi: 994051006,
    lng: 91.827765,
    lat: 21.625732,
    lastdyn: 1719859319,
    type: 25,
    shiptype: 'navigation',
    name: 'NO5G',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051006,
  },
  {
    mmsi: 994051008,
    lng: 91.835147,
    lat: 21.647448,
    lastdyn: 1719859347,
    type: 25,
    shiptype: 'navigation',
    name: 'NO7G',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051008,
  },
  {
    mmsi: 994051004,
    lng: 91.820447,
    lat: 21.604067,
    lastdyn: 1719859353,
    type: 25,
    shiptype: 'navigation',
    name: 'NO3G',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051004,
  },
  {
    mmsi: 994051012,
    lng: 91.846537,
    lat: 21.67941,
    lastdyn: 1719859365,
    type: 25,
    shiptype: 'navigation',
    name: 'NO11G',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051012,
  },
  {
    mmsi: 994051002,
    lng: 91.813527,
    lat: 21.5942,
    lastdyn: 1719859136,
    type: 24,
    shiptype: 'navigation',
    name: 'NO2R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051002,
  },
  {
    mmsi: 994051009,
    lng: 91.83559,
    lat: 21.659268,
    lastdyn: 1719859340,
    type: 24,
    shiptype: 'navigation',
    name: 'NO8R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051009,
  },
  {
    mmsi: 994051005,
    lng: 91.820882,
    lat: 21.615843,
    lastdyn: 1719859325,
    type: 24,
    shiptype: 'navigation',
    name: 'NO4R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051005,
  },
  {
    mmsi: 994051007,
    lng: 91.828235,
    lat: 21.637573,
    lastdyn: 1719859349,
    type: 24,
    shiptype: 'navigation',
    name: 'NO6R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051007,
  },
  {
    mmsi: 994121716,
    lng: 108.0642,
    lat: 21.517547,
    lastdyn: 1719859333,
    type: 25,
    shiptype: 'navigation',
    name: 'HUANG HAO DUN',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121716,
  },
  {
    mmsi: 994121715,
    lng: 108.33662,
    lat: 21.51265,
    lastdyn: 1719859890,
    type: 28,
    shiptype: 'navigation',
    name: 'SAN YA SHI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121715,
  },
  {
    mmsi: 994131673,
    lng: 108.3251,
    lat: 21.60224,
    lastdyn: 1719859765,
    type: 25,
    shiptype: 'navigation',
    name: 'FANG CHENG GANG 35',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131673,
  },
  {
    mmsi: 994131670,
    lng: 108.353658,
    lat: 21.538575,
    lastdyn: 1719859294,
    type: 24,
    shiptype: 'navigation',
    name: 'FANG CHENG GANG 19',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131670,
  },
  {
    mmsi: 994131672,
    lng: 108.335305,
    lat: 21.56445,
    lastdyn: 1719858731,
    type: 25,
    shiptype: 'navigation',
    name: 'FANG CHENG GANG 27',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131672,
  },
  {
    mmsi: 994131671,
    lng: 108.349123,
    lat: 21.550403,
    lastdyn: 1719859731,
    type: 25,
    shiptype: 'navigation',
    name: 'FANG CHENG GANG 23',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131671,
  },
  {
    mmsi: 994131674,
    lng: 108.362948,
    lat: 21.579232,
    lastdyn: 1719859822,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG WAN A',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131674,
  },
  {
    mmsi: 994121718,
    lng: 108.367227,
    lat: 21.582093,
    lastdyn: 1719858653,
    type: 26,
    shiptype: 'navigation',
    name: 'DONG WAN 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121718,
  },
  {
    mmsi: 994121717,
    lng: 108.351307,
    lat: 21.549788,
    lastdyn: 1719858697,
    type: 3,
    shiptype: 'navigation',
    name: 'FANG CHEN GANG WHARF',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121717,
  },
  {
    mmsi: 994136843,
    lng: 108.60275,
    lat: 21.69875,
    lastdyn: 1719859880,
    type: 24,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 73B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136843,
  },
  {
    mmsi: 994136782,
    lng: 108.576833,
    lat: 21.531833,
    lastdyn: 1719859763,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136782,
  },
  {
    mmsi: 994136692,
    lng: 108.635945,
    lat: 21.516472,
    lastdyn: 1719859743,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136692,
  },
  {
    mmsi: 994131814,
    lng: 108.614728,
    lat: 21.692045,
    lastdyn: 1719821200,
    type: 24,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 71',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131814,
  },
  {
    mmsi: 994131903,
    lng: 108.639037,
    lat: 21.503555,
    lastdyn: 1719852301,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 35',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131903,
  },
  {
    mmsi: 994131908,
    lng: 108.642993,
    lat: 21.572063,
    lastdyn: 1719859232,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 47',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131908,
  },
  {
    mmsi: 994131916,
    lng: 108.65473,
    lat: 21.65105,
    lastdyn: 1719859790,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 65',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131916,
  },
  {
    mmsi: 994126723,
    lng: 108.641605,
    lat: 21.5407,
    lastdyn: 1719859778,
    type: 24,
    shiptype: 'navigation',
    name: 'EMERGENCY CHANNEL 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126723,
  },
  {
    mmsi: 994136842,
    lng: 108.603667,
    lat: 21.700112,
    lastdyn: 1719859881,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 73A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136842,
  },
  {
    mmsi: 999999015,
    lng: 108.512413,
    lat: 21.553025,
    lastdyn: 1719859675,
    type: 31,
    shiptype: 'navigation',
    name: 'FCGHYFB04',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999015,
  },
  {
    mmsi: 994121618,
    lng: 108.63405,
    lat: 21.70466,
    lastdyn: 1719859803,
    type: 25,
    shiptype: 'navigation',
    name: 'JIN GU JIANG J3D',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121618,
  },
  {
    mmsi: 994136738,
    lng: 108.597278,
    lat: 21.509112,
    lastdyn: 1719859913,
    type: 28,
    shiptype: 'navigation',
    name: 'PU JI 341 SHIP WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136738,
  },
  {
    mmsi: 994131909,
    lng: 108.648893,
    lat: 21.581413,
    lastdyn: 1719816514,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 49',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131909,
  },
  {
    mmsi: 994126722,
    lng: 108.652167,
    lat: 21.539467,
    lastdyn: 1719859775,
    type: 25,
    shiptype: 'navigation',
    name: 'EMERGENCY CHANNEL 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126722,
  },
  {
    mmsi: 994136697,
    lng: 108.658583,
    lat: 21.631222,
    lastdyn: 1719859758,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136697,
  },
  {
    mmsi: 994131676,
    lng: 108.558188,
    lat: 21.52297,
    lastdyn: 1719859849,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU W1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131676,
  },
  {
    mmsi: 994136696,
    lng: 108.661055,
    lat: 21.617362,
    lastdyn: 1719859754,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136696,
  },
  {
    mmsi: 994131907,
    lng: 108.641073,
    lat: 21.565592,
    lastdyn: 1719817523,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 45',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131907,
  },
  {
    mmsi: 994126721,
    lng: 108.662117,
    lat: 21.537655,
    lastdyn: 1719859784,
    type: 25,
    shiptype: 'navigation',
    name: 'EMERGENCY CHANNEL 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126721,
  },
  {
    mmsi: 994131904,
    lng: 108.63904,
    lat: 21.517485,
    lastdyn: 1719824137,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 37',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131904,
  },
  {
    mmsi: 994136694,
    lng: 108.654888,
    lat: 21.597472,
    lastdyn: 1719859748,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136694,
  },
  {
    mmsi: 994131677,
    lng: 108.580103,
    lat: 21.651798,
    lastdyn: 1719859684,
    type: 24,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG W17',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131677,
  },
  {
    mmsi: 994136716,
    lng: 108.629358,
    lat: 21.685112,
    lastdyn: 1719859910,
    type: 27,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 69A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136716,
  },
  {
    mmsi: 994136649,
    lng: 108.585278,
    lat: 21.708638,
    lastdyn: 1719859908,
    type: 30,
    shiptype: 'navigation',
    name: 'QIN ZHOU MAO DI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136649,
  },
  {
    mmsi: 994136698,
    lng: 108.653778,
    lat: 21.645722,
    lastdyn: 1719859760,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136698,
  },
  {
    mmsi: 994126724,
    lng: 108.641825,
    lat: 21.541347,
    lastdyn: 1719859781,
    type: 25,
    shiptype: 'navigation',
    name: 'EMERGENCY CHANNEL 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126724,
  },
  {
    mmsi: 994131910,
    lng: 108.654548,
    lat: 21.591055,
    lastdyn: 1719843684,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 51',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131910,
  },
  {
    mmsi: 994131822,
    lng: 108.588432,
    lat: 21.707398,
    lastdyn: 1719859614,
    type: 24,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 76',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131822,
  },
  {
    mmsi: 994131915,
    lng: 108.6593,
    lat: 21.63755,
    lastdyn: 1719859747,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 61',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131915,
  },
  {
    mmsi: 994131912,
    lng: 108.66758,
    lat: 21.612418,
    lastdyn: 1719845222,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 55',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131912,
  },
  {
    mmsi: 991901401,
    lng: 108.64063,
    lat: 21.73326,
    lastdyn: 1719654470,
    type: 0,
    shiptype: 'navigation',
    name: '1901401',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 991901401,
  },
  {
    mmsi: 994131815,
    lng: 108.60727,
    lat: 21.69629,
    lastdyn: 1719859513,
    type: 24,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 72',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131815,
  },
  {
    mmsi: 994131812,
    lng: 108.674925,
    lat: 21.551763,
    lastdyn: 1719859438,
    type: 22,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG A13',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131812,
  },
  {
    mmsi: 994131914,
    lng: 108.663377,
    lat: 21.626168,
    lastdyn: 1719842314,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 59',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131914,
  },
  {
    mmsi: 994131813,
    lng: 108.59848,
    lat: 21.70138,
    lastdyn: 1719859755,
    type: 24,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 74 AIS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131813,
  },
  {
    mmsi: 994131911,
    lng: 108.660255,
    lat: 21.600213,
    lastdyn: 1719855188,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 53',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131911,
  },
  {
    mmsi: 994136693,
    lng: 108.636138,
    lat: 21.56675,
    lastdyn: 1719859745,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136693,
  },
  {
    mmsi: 994136811,
    lng: 108.64775,
    lat: 21.663667,
    lastdyn: 1719859766,
    type: 30,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 66A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136811,
  },
  {
    mmsi: 994126919,
    lng: 108.650522,
    lat: 21.521597,
    lastdyn: 1719859738,
    type: 0,
    shiptype: 'navigation',
    name: 'QZWHQGC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126919,
  },
  {
    mmsi: 994126720,
    lng: 108.66198,
    lat: 21.536995,
    lastdyn: 1719859772,
    type: 24,
    shiptype: 'navigation',
    name: 'EMERGENCY CHANNEL 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126720,
  },
  {
    mmsi: 994131906,
    lng: 108.639272,
    lat: 21.544603,
    lastdyn: 1719859794,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 41',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131906,
  },
  {
    mmsi: 994136695,
    lng: 108.659945,
    lat: 21.609222,
    lastdyn: 1719859751,
    type: 26,
    shiptype: 'navigation',
    name: '200000 TONS LEFT 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136695,
  },
  {
    mmsi: 994136815,
    lng: 108.64825,
    lat: 21.666528,
    lastdyn: 1719859769,
    type: 30,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 66B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136815,
  },
  {
    mmsi: 994136605,
    lng: 108.589305,
    lat: 21.698945,
    lastdyn: 1719859904,
    type: 30,
    shiptype: 'navigation',
    name: 'QIN ZHOU MAO DI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136605,
  },
  {
    mmsi: 994136844,
    lng: 108.587667,
    lat: 21.713638,
    lastdyn: 1719859917,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 71A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136844,
  },
  {
    mmsi: 994131905,
    lng: 108.638978,
    lat: 21.530563,
    lastdyn: 1719859843,
    type: 25,
    shiptype: 'navigation',
    name: 'QIN ZHOU GANG 39',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131905,
  },
  {
    mmsi: 994121756,
    lng: 109.60959,
    lat: 21.54108,
    lastdyn: 1719859806,
    type: 25,
    shiptype: 'navigation',
    name: 'TIE SHAN GANG 24',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121756,
  },
  {
    mmsi: 994121755,
    lng: 109.604608,
    lat: 21.514377,
    lastdyn: 1719859881,
    type: 25,
    shiptype: 'navigation',
    name: 'TIE SHAN GANG 22',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121755,
  },
  {
    mmsi: 994136767,
    lng: 111.655838,
    lat: 21.506875,
    lastdyn: 1719859748,
    type: 30,
    shiptype: 'navigation',
    name: 'SXCABLE S6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136767,
  },
  {
    mmsi: 994136828,
    lng: 111.677775,
    lat: 21.504978,
    lastdyn: 1719859915,
    type: 30,
    shiptype: 'navigation',
    name: 'MYSPHDDL5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136828,
  },
  {
    mmsi: 994136790,
    lng: 112.198638,
    lat: 21.504862,
    lastdyn: 1719859909,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGGUANGHE V12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136790,
  },
  {
    mmsi: 994136658,
    lng: 112.345367,
    lat: 21.642267,
    lastdyn: 1719859786,
    type: 28,
    shiptype: 'navigation',
    name: 'YUEANYUN 63 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136658,
  },
  {
    mmsi: 994136764,
    lng: 112.471667,
    lat: 21.596667,
    lastdyn: 1719859789,
    type: 28,
    shiptype: 'navigation',
    name: 'YINHANG 168 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136764,
  },
  {
    mmsi: 999413094,
    lng: 112.795778,
    lat: 21.570888,
    lastdyn: 1719859783,
    type: 5,
    shiptype: 'navigation',
    name: 'WEI JIA DAO',
    length: 20,
    width: 20,
    left: 10,
    trail: 10,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413094,
  },
  {
    mmsi: 994136617,
    lng: 113.064805,
    lat: 21.744417,
    lastdyn: 1719859844,
    type: 28,
    shiptype: 'navigation',
    name: 'SHIP WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136617,
  },
  {
    mmsi: 994136820,
    lng: 113.075278,
    lat: 21.7125,
    lastdyn: 1719859868,
    type: 28,
    shiptype: 'navigation',
    name: 'SHENGLONG168',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136820,
  },
  {
    mmsi: 994121619,
    lng: 113.383237,
    lat: 21.638157,
    lastdyn: 1719806226,
    type: 30,
    shiptype: 'navigation',
    name: 'B06HYDROLOGICALAIS',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121619,
  },
  {
    mmsi: 994196053,
    lng: 87.954445,
    lat: 21.771,
    lastdyn: 1719844020,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENWP9VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196053,
  },
  {
    mmsi: 994196081,
    lng: 87.991667,
    lat: 21.777767,
    lastdyn: 1719843743,
    type: 1,
    shiptype: 'navigation',
    name: 'MAIVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196081,
  },
  {
    mmsi: 994196082,
    lng: 87.95755,
    lat: 21.766667,
    lastdyn: 1719845523,
    type: 1,
    shiptype: 'navigation',
    name: 'EESVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196082,
  },
  {
    mmsi: 994196043,
    lng: 87.988883,
    lat: 21.8,
    lastdyn: 1719844272,
    type: 1,
    shiptype: 'navigation',
    name: 'LM1VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196043,
  },
  {
    mmsi: 994196036,
    lng: 87.951167,
    lat: 21.7968,
    lastdyn: 1719844064,
    type: 1,
    shiptype: 'navigation',
    name: 'NEWASVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196036,
  },
  {
    mmsi: 994196092,
    lng: 87.95135,
    lat: 21.77655,
    lastdyn: 1719844163,
    type: 1,
    shiptype: 'navigation',
    name: 'WESVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196092,
  },
  {
    mmsi: 994196093,
    lng: 87.981383,
    lat: 21.817783,
    lastdyn: 1719844162,
    type: 1,
    shiptype: 'navigation',
    name: 'EAIVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196093,
  },
  {
    mmsi: 994196074,
    lng: 87.94605,
    lat: 21.764783,
    lastdyn: 1719844204,
    type: 1,
    shiptype: 'navigation',
    name: 'EDENI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196074,
  },
  {
    mmsi: 994196039,
    lng: 88.028283,
    lat: 21.9333,
    lastdyn: 1719844052,
    type: 1,
    shiptype: 'navigation',
    name: 'EJ1VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196039,
  },
  {
    mmsi: 994196047,
    lng: 88.088695,
    lat: 21.91255,
    lastdyn: 1719843812,
    type: 1,
    shiptype: 'navigation',
    name: 'EBSVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196047,
  },
  {
    mmsi: 994196046,
    lng: 88.056667,
    lat: 21.899833,
    lastdyn: 1719844039,
    type: 1,
    shiptype: 'navigation',
    name: 'UBSVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196046,
  },
  {
    mmsi: 994196086,
    lng: 88.049633,
    lat: 21.99425,
    lastdyn: 1719844174,
    type: 1,
    shiptype: 'navigation',
    name: 'USFVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196086,
  },
  {
    mmsi: 994196050,
    lng: 88.173713,
    lat: 21.985845,
    lastdyn: 1719844031,
    type: 1,
    shiptype: 'navigation',
    name: 'USTVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196050,
  },
  {
    mmsi: 994196040,
    lng: 88.005083,
    lat: 21.902733,
    lastdyn: 1719844052,
    type: 1,
    shiptype: 'navigation',
    name: 'TFVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196040,
  },
  {
    mmsi: 994196080,
    lng: 88.02295,
    lat: 21.945067,
    lastdyn: 1719844192,
    type: 1,
    shiptype: 'navigation',
    name: 'ATG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196080,
  },
  {
    mmsi: 994196049,
    lng: 88.150417,
    lat: 21.959853,
    lastdyn: 1719844033,
    type: 1,
    shiptype: 'navigation',
    name: 'CSTVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196049,
  },
  {
    mmsi: 994196088,
    lng: 88.03745,
    lat: 21.978033,
    lastdyn: 1719844170,
    type: 1,
    shiptype: 'navigation',
    name: 'SFVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196088,
  },
  {
    mmsi: 994196048,
    lng: 88.141508,
    lat: 21.946302,
    lastdyn: 1719844255,
    type: 1,
    shiptype: 'navigation',
    name: 'ESTVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196048,
  },
  {
    mmsi: 994196089,
    lng: 88.02605,
    lat: 21.950517,
    lastdyn: 1719844169,
    type: 1,
    shiptype: 'navigation',
    name: 'JBVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196089,
  },
  {
    mmsi: 994196045,
    lng: 88.03415,
    lat: 21.8569,
    lastdyn: 1719844041,
    type: 1,
    shiptype: 'navigation',
    name: 'MC1VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196045,
  },
  {
    mmsi: 994196090,
    lng: 88.013783,
    lat: 21.920467,
    lastdyn: 1719844166,
    type: 1,
    shiptype: 'navigation',
    name: 'J2VATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196090,
  },
  {
    mmsi: 994196087,
    lng: 88.058217,
    lat: 21.994283,
    lastdyn: 1719844173,
    type: 1,
    shiptype: 'navigation',
    name: 'HSVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196087,
  },
  {
    mmsi: 994196091,
    lng: 88.009717,
    lat: 21.76675,
    lastdyn: 1719843719,
    type: 1,
    shiptype: 'navigation',
    name: 'LMIIVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196091,
  },
  {
    mmsi: 994050001,
    lng: 89.546735,
    lat: 21.756472,
    lastdyn: 1719851447,
    type: 18,
    shiptype: 'navigation',
    name: 'JAFFORDPOINT',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994050001,
  },
  {
    mmsi: 994131820,
    lng: 108.59012,
    lat: 21.835995,
    lastdyn: 1719859845,
    type: 25,
    shiptype: 'navigation',
    name: 'DA TONG LUO',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131820,
  },
  {
    mmsi: 994121748,
    lng: 108.555393,
    lat: 21.751463,
    lastdyn: 1719859761,
    type: 25,
    shiptype: 'navigation',
    name: 'XIANG SHUI SHI',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121748,
  },
  {
    mmsi: 994121951,
    lng: 112.991295,
    lat: 21.842078,
    lastdyn: 1719859905,
    type: 30,
    shiptype: 'navigation',
    name: 'JM RESERVE 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121951,
  },
  {
    mmsi: 994136732,
    lng: 112.878333,
    lat: 21.868055,
    lastdyn: 1719859868,
    type: 28,
    shiptype: 'navigation',
    name: 'SHI TAI 158 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136732,
  },
  {
    mmsi: 994131604,
    lng: 113.20607,
    lat: 21.909155,
    lastdyn: 1719859803,
    type: 24,
    shiptype: 'navigation',
    name: 'GAO LAN 20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131604,
  },
  {
    mmsi: 994136856,
    lng: 113.140675,
    lat: 21.998387,
    lastdyn: 1719859903,
    type: 24,
    shiptype: 'navigation',
    name: 'GAO LAN 48A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136856,
  },
  {
    mmsi: 994136670,
    lng: 113.207778,
    lat: 21.882778,
    lastdyn: 1719859880,
    type: 22,
    shiptype: 'navigation',
    name: 'YA MEN KOU EAST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136670,
  },
  {
    mmsi: 994136618,
    lng: 113.035583,
    lat: 21.897583,
    lastdyn: 1719859871,
    type: 17,
    shiptype: 'navigation',
    name: 'DANGER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136618,
  },
  {
    mmsi: 994136638,
    lng: 113.227312,
    lat: 21.890663,
    lastdyn: 1719859847,
    type: 25,
    shiptype: 'navigation',
    name: 'GAO LAN H10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136638,
  },
  {
    mmsi: 994136777,
    lng: 113.342805,
    lat: 21.970138,
    lastdyn: 1719859867,
    type: 30,
    shiptype: 'navigation',
    name: 'JW CABLE 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136777,
  },
  {
    mmsi: 994121606,
    lng: 113.37286,
    lat: 21.8067,
    lastdyn: 1719857424,
    type: 0,
    shiptype: 'navigation',
    name: 'PIPELINE 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121606,
  },
  {
    mmsi: 994136795,
    lng: 113.328787,
    lat: 21.890408,
    lastdyn: 1719859862,
    type: 30,
    shiptype: 'navigation',
    name: 'DF PIPELINE 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136795,
  },
  {
    mmsi: 994136775,
    lng: 113.390138,
    lat: 21.939055,
    lastdyn: 1719859861,
    type: 30,
    shiptype: 'navigation',
    name: 'JW CABLE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136775,
  },
  {
    mmsi: 994121604,
    lng: 113.38055,
    lat: 21.77493,
    lastdyn: 1719800142,
    type: 0,
    shiptype: 'navigation',
    name: 'PIPELINE 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121604,
  },
  {
    mmsi: 994121773,
    lng: 113.46375,
    lat: 21.876862,
    lastdyn: 1719859888,
    type: 30,
    shiptype: 'navigation',
    name: 'JW WINDFARM 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121773,
  },
  {
    mmsi: 994136634,
    lng: 113.352778,
    lat: 21.867862,
    lastdyn: 1719859825,
    type: 30,
    shiptype: 'navigation',
    name: 'PIPELINE 14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136634,
  },
  {
    mmsi: 994136923,
    lng: 113.297778,
    lat: 21.891945,
    lastdyn: 1719859903,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHONGXIE 808 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136923,
  },
  {
    mmsi: 994121776,
    lng: 113.47519,
    lat: 21.89288,
    lastdyn: 1719859861,
    type: 3,
    shiptype: 'navigation',
    name: 'JW WINDFARM9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121776,
  },
  {
    mmsi: 994136792,
    lng: 113.495652,
    lat: 21.828492,
    lastdyn: 1719859853,
    type: 30,
    shiptype: 'navigation',
    name: 'DF PIPELINE 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136792,
  },
  {
    mmsi: 994121611,
    lng: 113.31211,
    lat: 21.88952,
    lastdyn: 1719859829,
    type: 30,
    shiptype: 'navigation',
    name: 'PIPELINE 20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121611,
  },
  {
    mmsi: 994136633,
    lng: 113.350945,
    lat: 21.866528,
    lastdyn: 1719859822,
    type: 30,
    shiptype: 'navigation',
    name: 'PIPELINE 13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136633,
  },
  {
    mmsi: 994136793,
    lng: 113.444922,
    lat: 21.848487,
    lastdyn: 1719859856,
    type: 30,
    shiptype: 'navigation',
    name: 'DF PIPELINE 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136793,
  },
  {
    mmsi: 994121612,
    lng: 113.29835,
    lat: 21.88831,
    lastdyn: 1719859881,
    type: 30,
    shiptype: 'navigation',
    name: 'PIPELINE 22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121612,
  },
  {
    mmsi: 994121772,
    lng: 113.475222,
    lat: 21.892917,
    lastdyn: 1719859885,
    type: 30,
    shiptype: 'navigation',
    name: 'JW WINDFARM 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121772,
  },
  {
    mmsi: 994136798,
    lng: 113.496667,
    lat: 21.91,
    lastdyn: 1719859865,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHU WAN 3786 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136798,
  },
  {
    mmsi: 994136774,
    lng: 113.413805,
    lat: 21.9235,
    lastdyn: 1719859858,
    type: 30,
    shiptype: 'navigation',
    name: 'JW CABLE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136774,
  },
  {
    mmsi: 994136776,
    lng: 113.366472,
    lat: 21.954583,
    lastdyn: 1719859864,
    type: 30,
    shiptype: 'navigation',
    name: 'JW CABLE 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136776,
  },
  {
    mmsi: 994136636,
    lng: 113.340945,
    lat: 21.878528,
    lastdyn: 1719859831,
    type: 30,
    shiptype: 'navigation',
    name: 'PIPELINE 16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136636,
  },
  {
    mmsi: 994136794,
    lng: 113.394153,
    lat: 21.868412,
    lastdyn: 1719859859,
    type: 30,
    shiptype: 'navigation',
    name: 'DF PIPELINE 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136794,
  },
  {
    mmsi: 994136635,
    lng: 113.339638,
    lat: 21.876722,
    lastdyn: 1719859828,
    type: 30,
    shiptype: 'navigation',
    name: 'PIPELINE 15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136635,
  },
  {
    mmsi: 994121605,
    lng: 113.376643,
    lat: 21.79085,
    lastdyn: 1719859863,
    type: 0,
    shiptype: 'navigation',
    name: 'GAOLANGANGQU PIPELIN',
    length: 3,
    width: 3,
    left: 2,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121605,
  },
  {
    mmsi: 994121771,
    lng: 113.487362,
    lat: 21.928583,
    lastdyn: 1719859883,
    type: 30,
    shiptype: 'navigation',
    name: 'JW WINDFARM 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121771,
  },
  {
    mmsi: 994121777,
    lng: 113.43093,
    lat: 21.912375,
    lastdyn: 1719859891,
    type: 30,
    shiptype: 'navigation',
    name: 'JW WINDFARM 11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121777,
  },
  {
    mmsi: 997100213,
    lng: 113.71717,
    lat: 21.934788,
    lastdyn: 1719859801,
    type: 15,
    shiptype: 'navigation',
    name: 'ZKHX',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 997100213,
  },
  {
    mmsi: 994136805,
    lng: 113.536833,
    lat: 21.927083,
    lastdyn: 1719859870,
    type: 30,
    shiptype: 'navigation',
    name: 'YCXGPIPELINE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136805,
  },
  {
    mmsi: 997100218,
    lng: 113.716187,
    lat: 21.933657,
    lastdyn: 1719859915,
    type: 16,
    shiptype: 'navigation',
    name: 'ZKHX',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 997100218,
  },
  {
    mmsi: 999413097,
    lng: 113.937667,
    lat: 21.813583,
    lastdyn: 1719859784,
    type: 5,
    shiptype: 'navigation',
    name: 'WEN WEI ZHOU',
    length: 20,
    width: 20,
    left: 10,
    trail: 10,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413097,
  },
  {
    mmsi: 994121994,
    lng: 114.01257,
    lat: 21.83206,
    lastdyn: 1719839671,
    type: 30,
    shiptype: 'navigation',
    name: 'PR B6 MARINE MONITOR',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121994,
  },
  {
    mmsi: 999413000,
    lng: 121.59179,
    lat: 32.102062,
    lastdyn: 1719859753,
    type: 3,
    shiptype: 'navigation',
    name: 'ATON 00',
    length: 10,
    width: 6,
    left: 3,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413000,
  },
  {
    mmsi: 994136721,
    lng: 115.983333,
    lat: 21.983333,
    lastdyn: 1719859835,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHONG KE HANG 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136721,
  },
  {
    mmsi: 994196084,
    lng: 88.09025,
    lat: 22.018633,
    lastdyn: 1719845519,
    type: 1,
    shiptype: 'navigation',
    name: 'CEHVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196084,
  },
  {
    mmsi: 994196096,
    lng: 88.07365,
    lat: 22.017417,
    lastdyn: 1719844155,
    type: 1,
    shiptype: 'navigation',
    name: 'MOORING BUOY M2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196096,
  },
  {
    mmsi: 994196083,
    lng: 88.101317,
    lat: 22.024117,
    lastdyn: 1719844185,
    type: 1,
    shiptype: 'navigation',
    name: 'UEHVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196083,
  },
  {
    mmsi: 994196051,
    lng: 88.20884,
    lat: 22.11915,
    lastdyn: 1719844024,
    type: 1,
    shiptype: 'navigation',
    name: 'KFVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196051,
  },
  {
    mmsi: 994196095,
    lng: 88.075517,
    lat: 22.018267,
    lastdyn: 1719844157,
    type: 1,
    shiptype: 'navigation',
    name: 'MOORING BUOY M1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196095,
  },
  {
    mmsi: 994196097,
    lng: 88.10725,
    lat: 22.033,
    lastdyn: 1719844153,
    type: 1,
    shiptype: 'navigation',
    name: 'IWAI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196097,
  },
  {
    mmsi: 994196085,
    lng: 88.07355,
    lat: 22.011417,
    lastdyn: 1719844181,
    type: 1,
    shiptype: 'navigation',
    name: 'LEHVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196085,
  },
  {
    mmsi: 994196041,
    lng: 88.063933,
    lat: 22.011717,
    lastdyn: 1719844049,
    type: 1,
    shiptype: 'navigation',
    name: 'HRVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196041,
  },
  {
    mmsi: 994056011,
    lng: 91.83202,
    lat: 22.246578,
    lastdyn: 1719859608,
    type: 25,
    shiptype: 'navigation',
    name: 'V 11 MA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056011,
  },
  {
    mmsi: 994056005,
    lng: 91.823013,
    lat: 22.235638,
    lastdyn: 1719859583,
    type: 25,
    shiptype: 'navigation',
    name: 'V 5 KAFCO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056005,
  },
  {
    mmsi: 994056003,
    lng: 91.819272,
    lat: 22.233113,
    lastdyn: 1719859594,
    type: 25,
    shiptype: 'navigation',
    name: 'V 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056003,
  },
  {
    mmsi: 994056002,
    lng: 91.803997,
    lat: 22.225062,
    lastdyn: 1719859588,
    type: 24,
    shiptype: 'navigation',
    name: 'V 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056002,
  },
  {
    mmsi: 994056004,
    lng: 91.810842,
    lat: 22.230062,
    lastdyn: 1719859548,
    type: 24,
    shiptype: 'navigation',
    name: 'V 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056004,
  },
  {
    mmsi: 994051003,
    lng: 91.799787,
    lat: 22.217785,
    lastdyn: 1719859423,
    type: 14,
    shiptype: 'navigation',
    name: 'NO 3',
    length: 1,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051003,
  },
  {
    mmsi: 994051072,
    lng: 91.80312,
    lat: 22.220502,
    lastdyn: 1719859347,
    type: 30,
    shiptype: 'navigation',
    name: 'WKB01522',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051072,
  },
  {
    mmsi: 994056001,
    lng: 91.812197,
    lat: 22.228058,
    lastdyn: 1719859586,
    type: 25,
    shiptype: 'navigation',
    name: 'V 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056001,
  },
  {
    mmsi: 994056006,
    lng: 91.818178,
    lat: 22.234803,
    lastdyn: 1719859601,
    type: 24,
    shiptype: 'navigation',
    name: 'V 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056006,
  },
  {
    mmsi: 994056009,
    lng: 91.829388,
    lat: 22.24187,
    lastdyn: 1719859495,
    type: 25,
    shiptype: 'navigation',
    name: 'V 9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056009,
  },
  {
    mmsi: 994056008,
    lng: 91.831347,
    lat: 22.248995,
    lastdyn: 1719859433,
    type: 24,
    shiptype: 'navigation',
    name: 'V 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056008,
  },
  {
    mmsi: 994056007,
    lng: 91.826317,
    lat: 22.238267,
    lastdyn: 1719859470,
    type: 25,
    shiptype: 'navigation',
    name: 'V 7 CUFL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056007,
  },
  {
    mmsi: 994051104,
    lng: 91.805368,
    lat: 22.23109,
    lastdyn: 1719859633,
    type: 7,
    shiptype: 'navigation',
    name: 'DISC FRONT',
    length: 1,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051104,
  },
  {
    mmsi: 994131823,
    lng: 113.13784,
    lat: 22.00199,
    lastdyn: 1719859820,
    type: 24,
    shiptype: 'navigation',
    name: 'GAO LAN 50',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131823,
  },
  {
    mmsi: 994136648,
    lng: 113.144083,
    lat: 22.001945,
    lastdyn: 1719859850,
    type: 25,
    shiptype: 'navigation',
    name: 'SAN YI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136648,
  },
  {
    mmsi: 994136929,
    lng: 113.73195,
    lat: 22.030233,
    lastdyn: 1719859894,
    type: 28,
    shiptype: 'navigation',
    name: 'XIAOYEJIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136929,
  },
  {
    mmsi: 994531002,
    lng: 113.608067,
    lat: 22.174717,
    lastdyn: 1719859912,
    type: 29,
    shiptype: 'navigation',
    name: 'ENTRADA DO PORTO EXT',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994531002,
  },
  {
    mmsi: 994131639,
    lng: 113.69875,
    lat: 22.06166,
    lastdyn: 1719859862,
    type: 28,
    shiptype: 'navigation',
    name: 'YE DING JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131639,
  },
  {
    mmsi: 994136723,
    lng: 113.648695,
    lat: 22.243778,
    lastdyn: 1719859790,
    type: 24,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136723,
  },
  {
    mmsi: 994531006,
    lng: 113.574833,
    lat: 22.177667,
    lastdyn: 1719859860,
    type: 25,
    shiptype: 'navigation',
    name: 'M7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994531006,
  },
  {
    mmsi: 994121899,
    lng: 113.655283,
    lat: 22.240868,
    lastdyn: 1719859778,
    type: 25,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121899,
  },
  {
    mmsi: 994531007,
    lng: 113.577667,
    lat: 22.175833,
    lastdyn: 1719859861,
    type: 24,
    shiptype: 'navigation',
    name: 'M8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994531007,
  },
  {
    mmsi: 994121993,
    lng: 113.65049,
    lat: 22.20241,
    lastdyn: 1719849005,
    type: 30,
    shiptype: 'navigation',
    name: 'PR B1 MARINE MONITOR',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121993,
  },
  {
    mmsi: 994121659,
    lng: 119.73546,
    lat: 35.12013,
    lastdyn: 1684607164,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO320',
    length: 2,
    width: 9,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121659,
  },
  {
    mmsi: 994136730,
    lng: 113.653972,
    lat: 22.240445,
    lastdyn: 1719859781,
    type: 25,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136730,
  },
  {
    mmsi: 994531004,
    lng: 113.613267,
    lat: 22.1198,
    lastdyn: 1719859861,
    type: 24,
    shiptype: 'navigation',
    name: 'KH 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994531004,
  },
  {
    mmsi: 994531005,
    lng: 113.611283,
    lat: 22.167202,
    lastdyn: 1719859860,
    type: 25,
    shiptype: 'navigation',
    name: 'M1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994531005,
  },
  {
    mmsi: 994136717,
    lng: 113.649945,
    lat: 22.239417,
    lastdyn: 1719859784,
    type: 24,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136717,
  },
  {
    mmsi: 994136807,
    lng: 113.699138,
    lat: 22.217862,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'YCXGPIPELINE 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136807,
  },
  {
    mmsi: 994121667,
    lng: 113.73548,
    lat: 22.16076,
    lastdyn: 1719859861,
    type: 19,
    shiptype: 'navigation',
    name: 'GS WID FARM 01',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121667,
  },
  {
    mmsi: 994121669,
    lng: 113.6972,
    lat: 22.124695,
    lastdyn: 1719859840,
    type: 30,
    shiptype: 'navigation',
    name: 'GS WIND FARM 03',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121669,
  },
  {
    mmsi: 994136864,
    lng: 113.727545,
    lat: 22.163395,
    lastdyn: 1719859817,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHU XIANG 1715 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136864,
  },
  {
    mmsi: 994121656,
    lng: 187.37173,
    lat: 18.24925,
    lastdyn: 1706512164,
    type: 0,
    shiptype: 'navigation',
    name: '',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994121656,
  },
  {
    mmsi: 994121668,
    lng: 113.74628,
    lat: 22.106213,
    lastdyn: 1719859837,
    type: 30,
    shiptype: 'navigation',
    name: 'GS WIND FARM 02',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121668,
  },
  {
    mmsi: 994131657,
    lng: 113.599468,
    lat: 22.243032,
    lastdyn: 1719859775,
    type: 22,
    shiptype: 'navigation',
    name: 'HAI TA ZHOU NAN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131657,
  },
  {
    mmsi: 994121747,
    lng: 113.712312,
    lat: 22.1088,
    lastdyn: 1719833326,
    type: 30,
    shiptype: 'navigation',
    name: 'GSFD4',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121747,
  },
  {
    mmsi: 994531003,
    lng: 113.613817,
    lat: 22.165633,
    lastdyn: 1719859917,
    type: 24,
    shiptype: 'navigation',
    name: 'M2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994531003,
  },
  {
    mmsi: 994136806,
    lng: 113.590193,
    lat: 22.042305,
    lastdyn: 1719859873,
    type: 30,
    shiptype: 'navigation',
    name: 'YCXGPIPELINE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136806,
  },
  {
    mmsi: 994121892,
    lng: 113.648537,
    lat: 22.239072,
    lastdyn: 1719858017,
    type: 24,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121892,
  },
  {
    mmsi: 994136718,
    lng: 113.652722,
    lat: 22.244805,
    lastdyn: 1719859787,
    type: 25,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136718,
  },
  {
    mmsi: 994531001,
    lng: 113.601905,
    lat: 22.162752,
    lastdyn: 1719859907,
    type: 29,
    shiptype: 'navigation',
    name: 'ENTRADA NA TAIPA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994531001,
  },
  {
    mmsi: 994136859,
    lng: 113.848358,
    lat: 22.158842,
    lastdyn: 1719859814,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHU XIANG 2491 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136859,
  },
  {
    mmsi: 994121979,
    lng: 113.804818,
    lat: 22.231267,
    lastdyn: 1719859903,
    type: 30,
    shiptype: 'navigation',
    name: 'PR B4 MARINEMONITORI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121979,
  },
  {
    mmsi: 994131681,
    lng: 113.86136,
    lat: 22.05212,
    lastdyn: 1719859690,
    type: 25,
    shiptype: 'navigation',
    name: 'GUANGZHOU W1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131681,
  },
  {
    mmsi: 999413091,
    lng: 113.82915,
    lat: 22.18095,
    lastdyn: 1719859862,
    type: 29,
    shiptype: 'navigation',
    name: 'GUI SHAN BEI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413091,
  },
  {
    mmsi: 994131711,
    lng: 113.16046,
    lat: 23.15634,
    lastdyn: 1719859844,
    type: 30,
    shiptype: 'navigation',
    name: 'PR B3 MARINE MONITOR',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131711,
  },
  {
    mmsi: 994131632,
    lng: 120.36499,
    lat: 35.95854,
    lastdyn: 1719859906,
    type: 25,
    shiptype: 'navigation',
    name: 'QINGDAO PORT NO511',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131632,
  },
  {
    mmsi: 994771017,
    lng: 113.83358,
    lat: 22.236767,
    lastdyn: 1719859887,
    type: 30,
    shiptype: 'navigation',
    name: 'PWWHK',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994771017,
  },
  {
    mmsi: 994131629,
    lng: 113.79165,
    lat: 22.1858,
    lastdyn: 1719859915,
    type: 25,
    shiptype: 'navigation',
    name: 'RONG SHU TOU 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131629,
  },
  {
    mmsi: 994136760,
    lng: 113.786117,
    lat: 22.010833,
    lastdyn: 1719859787,
    type: 28,
    shiptype: 'navigation',
    name: 'YUEDONGGUANCUI0079 W',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136760,
  },
  {
    mmsi: 994136659,
    lng: 113.78175,
    lat: 22.159583,
    lastdyn: 1719859900,
    type: 30,
    shiptype: 'navigation',
    name: 'GUI SHAN MAO DI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136659,
  },
  {
    mmsi: 994771018,
    lng: 113.963302,
    lat: 22.155387,
    lastdyn: 1719859895,
    type: 3,
    shiptype: 'navigation',
    name: 'HONG KONG OFFSHORE L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994771018,
  },
  {
    mmsi: 999412901,
    lng: 113.81854,
    lat: 22.13658,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: 'TEST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412901,
  },
  {
    mmsi: 994771004,
    lng: 114.160232,
    lat: 22.191788,
    lastdyn: 1719859887,
    type: 30,
    shiptype: 'navigation',
    name: 'EPD 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994771004,
  },
  {
    mmsi: 994136943,
    lng: 114.019888,
    lat: 22.1043,
    lastdyn: 1719859808,
    type: 28,
    shiptype: 'navigation',
    name: 'SHIWEIZUI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136943,
  },
  {
    mmsi: 994131795,
    lng: 114.226038,
    lat: 22.127257,
    lastdyn: 1719859790,
    type: 31,
    shiptype: 'navigation',
    name: 'DAN GAN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131795,
  },
  {
    mmsi: 994136980,
    lng: 114.105058,
    lat: 22.069622,
    lastdyn: 1719859790,
    type: 30,
    shiptype: 'navigation',
    name: 'HAI SHA 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136980,
  },
  {
    mmsi: 994136981,
    lng: 114.087453,
    lat: 22.069708,
    lastdyn: 1719859793,
    type: 30,
    shiptype: 'navigation',
    name: 'HAI SHA 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136981,
  },
  {
    mmsi: 994136982,
    lng: 114.087228,
    lat: 22.055867,
    lastdyn: 1719859796,
    type: 30,
    shiptype: 'navigation',
    name: 'HAI SHA 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136982,
  },
  {
    mmsi: 994136983,
    lng: 114.105083,
    lat: 22.055692,
    lastdyn: 1719859799,
    type: 30,
    shiptype: 'navigation',
    name: 'HAI SHA 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136983,
  },
  {
    mmsi: 999991868,
    lng: 114.287585,
    lat: 22.23657,
    lastdyn: 1719859684,
    type: 30,
    shiptype: 'navigation',
    name: 'TLC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991868,
  },
  {
    mmsi: 994136845,
    lng: 116.276943,
    lat: 22.118888,
    lastdyn: 1719859796,
    type: 28,
    shiptype: 'navigation',
    name: 'HANG SHENG 88 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136845,
  },
  {
    mmsi: 994196057,
    lng: 88.090817,
    lat: 22.275533,
    lastdyn: 1719844234,
    type: 1,
    shiptype: 'navigation',
    name: 'LPSVATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994196057,
  },
  {
    mmsi: 994056013,
    lng: 91.835505,
    lat: 22.253875,
    lastdyn: 1719859589,
    type: 25,
    shiptype: 'navigation',
    name: 'V 13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056013,
  },
  {
    mmsi: 994051105,
    lng: 91.838807,
    lat: 22.256873,
    lastdyn: 1719859638,
    type: 7,
    shiptype: 'navigation',
    name: 'ACTIVE FRONT',
    length: 1,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051105,
  },
  {
    mmsi: 994051015,
    lng: 91.797538,
    lat: 22.284832,
    lastdyn: 1719859615,
    type: 14,
    shiptype: 'navigation',
    name: 'NO 15 CUTTING BEND',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051015,
  },
  {
    mmsi: 994056017,
    lng: 91.83087,
    lat: 22.269338,
    lastdyn: 1719859586,
    type: 25,
    shiptype: 'navigation',
    name: 'V 17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056017,
  },
  {
    mmsi: 994056016,
    lng: 91.828822,
    lat: 22.267303,
    lastdyn: 1719859612,
    type: 24,
    shiptype: 'navigation',
    name: 'V 16',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056016,
  },
  {
    mmsi: 994051071,
    lng: 91.838427,
    lat: 22.261145,
    lastdyn: 1719859548,
    type: 30,
    shiptype: 'navigation',
    name: 'WKB01492',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994051071,
  },
  {
    mmsi: 994056014,
    lng: 91.833342,
    lat: 22.265153,
    lastdyn: 1719859545,
    type: 24,
    shiptype: 'navigation',
    name: 'V 14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056014,
  },
  {
    mmsi: 994056015,
    lng: 91.837695,
    lat: 22.262422,
    lastdyn: 1719859629,
    type: 25,
    shiptype: 'navigation',
    name: 'V 15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994056015,
  },
  {
    mmsi: 994121678,
    lng: -105.688697,
    lat: 98.709968,
    lastdyn: 1717102305,
    type: 0,
    shiptype: 'navigation',
    name: 'YTJ2QX ZXFG',
    length: 202,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121678,
  },
  {
    mmsi: 994136641,
    lng: 113.21915,
    lat: 22.4974,
    lastdyn: 1719859878,
    type: 30,
    shiptype: 'navigation',
    name: 'SLOW SPEED B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136641,
  },
  {
    mmsi: 994136643,
    lng: 113.223233,
    lat: 22.499867,
    lastdyn: 1719859884,
    type: 30,
    shiptype: 'navigation',
    name: 'SLOW SPEED D',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136643,
  },
  {
    mmsi: 999999988,
    lng: 24.659588,
    lat: 59.396205,
    lastdyn: 1712575810,
    type: 24,
    shiptype: 'navigation',
    name: 'ATON TEST RED 261',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999988,
  },
  {
    mmsi: 994136628,
    lng: 113.644888,
    lat: 22.256833,
    lastdyn: 1719859802,
    type: 24,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136628,
  },
  {
    mmsi: 994136609,
    lng: 113.648917,
    lat: 22.257862,
    lastdyn: 1719859799,
    type: 25,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136609,
  },
  {
    mmsi: 994121901,
    lng: 113.727717,
    lat: 22.266345,
    lastdyn: 1719859768,
    type: 24,
    shiptype: 'navigation',
    name: 'QINGZHOUHANGDAO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121901,
  },
  {
    mmsi: 994121902,
    lng: 113.73562,
    lat: 22.29993,
    lastdyn: 1719859820,
    type: 25,
    shiptype: 'navigation',
    name: 'QINGZHOUHANGDAO 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121902,
  },
  {
    mmsi: 994121903,
    lng: 113.72789,
    lat: 22.29975,
    lastdyn: 1719859818,
    type: 24,
    shiptype: 'navigation',
    name: 'QINGZHOUHANGDAO 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121903,
  },
  {
    mmsi: 994121898,
    lng: 113.64343,
    lat: 22.256598,
    lastdyn: 1719859322,
    type: 24,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO 8',
    length: 3,
    width: 3,
    left: 2,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121898,
  },
  {
    mmsi: 994136639,
    lng: 113.615372,
    lat: 22.38062,
    lastdyn: 1719859844,
    type: 24,
    shiptype: 'navigation',
    name: 'TANG JIA GANG 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136639,
  },
  {
    mmsi: 994136665,
    lng: 113.61265,
    lat: 22.37745,
    lastdyn: 1719859847,
    type: 25,
    shiptype: 'navigation',
    name: 'TANG JIA GANG 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136665,
  },
  {
    mmsi: 994136729,
    lng: 113.646167,
    lat: 22.252472,
    lastdyn: 1719859796,
    type: 24,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136729,
  },
  {
    mmsi: 994136707,
    lng: 113.612737,
    lat: 22.375217,
    lastdyn: 1719859853,
    type: 23,
    shiptype: 'navigation',
    name: 'TANG JIA GANG 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136707,
  },
  {
    mmsi: 994121893,
    lng: 113.65035,
    lat: 22.25831,
    lastdyn: 1719859822,
    type: 25,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121893,
  },
  {
    mmsi: 994136637,
    lng: 113.615455,
    lat: 22.382962,
    lastdyn: 1719859841,
    type: 25,
    shiptype: 'navigation',
    name: 'TANG JIA GANG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136637,
  },
  {
    mmsi: 994136700,
    lng: 113.613538,
    lat: 22.37702,
    lastdyn: 1719859850,
    type: 24,
    shiptype: 'navigation',
    name: 'TANG JIA GANG 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136700,
  },
  {
    mmsi: 994136724,
    lng: 113.650195,
    lat: 22.2535,
    lastdyn: 1719859793,
    type: 25,
    shiptype: 'navigation',
    name: 'JIANGHAIHANGDAO V5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136724,
  },
  {
    mmsi: 994121900,
    lng: 113.62293,
    lat: 22.38897,
    lastdyn: 1715758929,
    type: 25,
    shiptype: 'navigation',
    name: 'QINGZHOUHANGDAO 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121900,
  },
  {
    mmsi: 994136821,
    lng: 113.8575,
    lat: 22.498888,
    lastdyn: 1719859826,
    type: 25,
    shiptype: 'navigation',
    name: 'HAIXING',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136821,
  },
  {
    mmsi: 994131621,
    lng: 113.752183,
    lat: 22.48986,
    lastdyn: 1719859910,
    type: 25,
    shiptype: 'navigation',
    name: 'GZ GANG 23',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131621,
  },
  {
    mmsi: 994136712,
    lng: 113.857805,
    lat: 22.495028,
    lastdyn: 1719859778,
    type: 28,
    shiptype: 'navigation',
    name: 'MAWAN OUTFALLS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136712,
  },
  {
    mmsi: 994776001,
    lng: 113.88875,
    lat: 22.429,
    lastdyn: 1719859851,
    type: 25,
    shiptype: 'navigation',
    name: 'CPV1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994776001,
  },
  {
    mmsi: 994136616,
    lng: 116.159127,
    lat: 22.720767,
    lastdyn: 1719859892,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136616,
  },
  {
    mmsi: 994131680,
    lng: 113.87751,
    lat: 22.436153,
    lastdyn: 1719859914,
    type: 30,
    shiptype: 'navigation',
    name: 'GONG GONG HANG DAO 2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131680,
  },
  {
    mmsi: 994136808,
    lng: 113.835555,
    lat: 22.331833,
    lastdyn: 1719859820,
    type: 30,
    shiptype: 'navigation',
    name: 'YCXGPIPELINE 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136808,
  },
  {
    mmsi: 994136615,
    lng: 113.879195,
    lat: 22.454305,
    lastdyn: 1719859775,
    type: 25,
    shiptype: 'navigation',
    name: 'KAI FENG MA TOU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136615,
  },
  {
    mmsi: 994136810,
    lng: 113.768117,
    lat: 22.418683,
    lastdyn: 1719859814,
    type: 28,
    shiptype: 'navigation',
    name: 'NEI LING DING XI WRE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136810,
  },
  {
    mmsi: 994131637,
    lng: 113.868425,
    lat: 22.44246,
    lastdyn: 1719859780,
    type: 24,
    shiptype: 'navigation',
    name: 'GONG GONG HANG DAO 1',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131637,
  },
  {
    mmsi: 994136627,
    lng: 113.840745,
    lat: 22.324445,
    lastdyn: 1719859835,
    type: 28,
    shiptype: 'navigation',
    name: 'LONG GU WRECK 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136627,
  },
  {
    mmsi: 994131617,
    lng: 113.78273,
    lat: 22.37217,
    lastdyn: 1719859872,
    type: 14,
    shiptype: 'navigation',
    name: 'GZ GANG 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131617,
  },
  {
    mmsi: 994131636,
    lng: 113.886265,
    lat: 22.445302,
    lastdyn: 1719859641,
    type: 24,
    shiptype: 'navigation',
    name: 'SHE KOU GANG 2',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131636,
  },
  {
    mmsi: 994771019,
    lng: 114.193633,
    lat: 22.294118,
    lastdyn: 1719859528,
    type: 30,
    shiptype: 'navigation',
    name: 'EPD3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994771019,
  },
  {
    mmsi: 994771016,
    lng: 114.002397,
    lat: 22.339508,
    lastdyn: 1719858995,
    type: 30,
    shiptype: 'navigation',
    name: 'EPD2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994771016,
  },
  {
    mmsi: 994776019,
    lng: 114.16665,
    lat: 22.285017,
    lastdyn: 1719859833,
    type: 30,
    shiptype: 'navigation',
    name: 'CMDV1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994776019,
  },
  {
    mmsi: 994776020,
    lng: 114.16395,
    lat: 22.286017,
    lastdyn: 1719859839,
    type: 30,
    shiptype: 'navigation',
    name: 'CMDV2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994776020,
  },
  {
    mmsi: 994126910,
    lng: 114.8456,
    lat: 22.31365,
    lastdyn: 1719859795,
    type: 0,
    shiptype: 'navigation',
    name: 'GANGKOU FD20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126910,
  },
  {
    mmsi: 994136612,
    lng: 114.773888,
    lat: 22.486667,
    lastdyn: 1719859814,
    type: 28,
    shiptype: 'navigation',
    name: 'DA YA WAN SHOAL 14M8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136612,
  },
  {
    mmsi: 994126909,
    lng: 114.845683,
    lat: 22.258,
    lastdyn: 1719859195,
    type: 0,
    shiptype: 'navigation',
    name: 'GANGKOU FD16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126909,
  },
  {
    mmsi: 994126911,
    lng: 114.902883,
    lat: 22.33965,
    lastdyn: 1719858785,
    type: 0,
    shiptype: 'navigation',
    name: 'GANGKOU FD22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126911,
  },
  {
    mmsi: 994121915,
    lng: 114.94425,
    lat: 22.252733,
    lastdyn: 1719858735,
    type: 0,
    shiptype: 'navigation',
    name: 'GANGKOU FD12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121915,
  },
  {
    mmsi: 994136611,
    lng: 114.766667,
    lat: 22.474445,
    lastdyn: 1719859811,
    type: 28,
    shiptype: 'navigation',
    name: 'DA YA WAN SHOAL 13M6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136611,
  },
  {
    mmsi: 994121914,
    lng: 114.96198,
    lat: 22.278285,
    lastdyn: 1719858986,
    type: 0,
    shiptype: 'navigation',
    name: 'GANG KOU FD11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121914,
  },
  {
    mmsi: 994121912,
    lng: 115.023153,
    lat: 22.290045,
    lastdyn: 1719858603,
    type: 0,
    shiptype: 'navigation',
    name: 'GANG KOU FD07',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121912,
  },
  {
    mmsi: 994121913,
    lng: 115.005162,
    lat: 22.266443,
    lastdyn: 1719858608,
    type: 0,
    shiptype: 'navigation',
    name: 'GANG KOU FD09',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121913,
  },
  {
    mmsi: 994136802,
    lng: 115.025833,
    lat: 22.310833,
    lastdyn: 1719859831,
    type: 28,
    shiptype: 'navigation',
    name: 'SHENGPING001 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136802,
  },
  {
    mmsi: 994136829,
    lng: 115.12443,
    lat: 22.316042,
    lastdyn: 1719859846,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHENTOUYAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136829,
  },
  {
    mmsi: 994136830,
    lng: 115.417833,
    lat: 22.474433,
    lastdyn: 1719859838,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHU GUI 6496 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136830,
  },
  {
    mmsi: 994126946,
    lng: 115.51733,
    lat: 22.407072,
    lastdyn: 1719859144,
    type: 30,
    shiptype: 'navigation',
    name: 'HONGHAIWAN 3 CF',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126946,
  },
  {
    mmsi: 994136869,
    lng: 115.573888,
    lat: 22.281083,
    lastdyn: 1719859847,
    type: 22,
    shiptype: 'navigation',
    name: 'HAI HONG 03 SOUTH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136869,
  },
  {
    mmsi: 994136866,
    lng: 115.57632,
    lat: 22.283333,
    lastdyn: 1719859841,
    type: 21,
    shiptype: 'navigation',
    name: 'HAI HONG 03 EAST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136866,
  },
  {
    mmsi: 994136870,
    lng: 115.573888,
    lat: 22.285583,
    lastdyn: 1719859850,
    type: 20,
    shiptype: 'navigation',
    name: 'HAI HONG 03 NORTH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136870,
  },
  {
    mmsi: 994136867,
    lng: 115.571458,
    lat: 22.283333,
    lastdyn: 1719859844,
    type: 23,
    shiptype: 'navigation',
    name: 'HAI HONG 03 WEST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136867,
  },
  {
    mmsi: 994121930,
    lng: 115.626528,
    lat: 22.432733,
    lastdyn: 1719859147,
    type: 31,
    shiptype: 'navigation',
    name: 'HHWPF',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121930,
  },
  {
    mmsi: 994126935,
    lng: 115.625522,
    lat: 22.378912,
    lastdyn: 1719859154,
    type: 19,
    shiptype: 'navigation',
    name: 'HONGHAIWANG6 CF',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126935,
  },
  {
    mmsi: 994136928,
    lng: 116.528333,
    lat: 22.266667,
    lastdyn: 1719792507,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHONGFUSHENG WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136928,
  },
  {
    mmsi: 994136831,
    lng: 117.05,
    lat: 22.333333,
    lastdyn: 1719859790,
    type: 28,
    shiptype: 'navigation',
    name: 'XINCHENMIN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136831,
  },
  {
    mmsi: 994160209,
    lng: -105.105768,
    lat: -43.190613,
    lastdyn: 1700702625,
    type: 0,
    shiptype: 'navigation',
    name: 'X',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994160209,
  },
  {
    mmsi: 994161667,
    lng: 120.147307,
    lat: 23.380192,
    lastdyn: 1709435512,
    type: 1,
    shiptype: 'navigation',
    name: 'BUTAIKANG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161667,
  },
  {
    mmsi: 994161833,
    lng: 120.434648,
    lat: 22.470662,
    lastdyn: 1719859500,
    type: 1,
    shiptype: 'navigation',
    name: 'YENPU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161833,
  },
  {
    mmsi: 994160220,
    lng: -105.106382,
    lat: 96.96696,
    lastdyn: 1666736580,
    type: 26,
    shiptype: 'navigation',
    name: '4SWFQFK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994160220,
  },
  {
    mmsi: 994161806,
    lng: 120.3665,
    lat: 22.328802,
    lastdyn: 1719859545,
    type: 6,
    shiptype: 'navigation',
    name: 'LIUQIUYU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161806,
  },
  {
    mmsi: 994164913,
    lng: 121.427632,
    lat: 24.982877,
    lastdyn: 1719532968,
    type: 0,
    shiptype: 'navigation',
    name: '2063MIN LED ON 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994164913,
  },
  {
    mmsi: 994136640,
    lng: 113.216933,
    lat: 22.500433,
    lastdyn: 1719859875,
    type: 30,
    shiptype: 'navigation',
    name: 'SLOW SPEED A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136640,
  },
  {
    mmsi: 994136642,
    lng: 113.219833,
    lat: 22.502283,
    lastdyn: 1719859881,
    type: 30,
    shiptype: 'navigation',
    name: 'SLOW SPEED C',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136642,
  },
  {
    mmsi: 999413042,
    lng: 113.692667,
    lat: 22.644683,
    lastdyn: 1719859692,
    type: 26,
    shiptype: 'navigation',
    name: 'GUANG ZHOU GANG 42',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413042,
  },
  {
    mmsi: 994131692,
    lng: 113.71091,
    lat: 22.58953,
    lastdyn: 1719859172,
    type: 24,
    shiptype: 'navigation',
    name: 'GZ GANG 36A',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131692,
  },
  {
    mmsi: 994136852,
    lng: 113.667528,
    lat: 22.667972,
    lastdyn: 1719859910,
    type: 29,
    shiptype: 'navigation',
    name: 'NAN SHA SI QI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136852,
  },
  {
    mmsi: 994136621,
    lng: 113.659305,
    lat: 22.732222,
    lastdyn: 1719859853,
    type: 30,
    shiptype: 'navigation',
    name: 'GZ GREEN WAY 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136621,
  },
  {
    mmsi: 999414011,
    lng: 113.725678,
    lat: 22.675498,
    lastdyn: 1719859859,
    type: 0,
    shiptype: 'navigation',
    name: 'GD11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999414011,
  },
  {
    mmsi: 994126948,
    lng: 113.72567,
    lat: 22.55513,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'LINGDINGQIAO11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126948,
  },
  {
    mmsi: 994121980,
    lng: 113.671902,
    lat: 22.705365,
    lastdyn: 1719859784,
    type: 30,
    shiptype: 'navigation',
    name: 'PR B5 MARINEMONITORI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121980,
  },
  {
    mmsi: 994136669,
    lng: 113.686417,
    lat: 22.6615,
    lastdyn: 1719859838,
    type: 29,
    shiptype: 'navigation',
    name: 'NAN SHA GANG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136669,
  },
  {
    mmsi: 994126947,
    lng: 113.630752,
    lat: 22.555515,
    lastdyn: 1719859796,
    type: 0,
    shiptype: 'navigation',
    name: 'ZHONGSHANQIAO5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126947,
  },
  {
    mmsi: 994131623,
    lng: 113.67613,
    lat: 22.70784,
    lastdyn: 1719859710,
    type: 24,
    shiptype: 'navigation',
    name: 'GZ GANG 52',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131623,
  },
  {
    mmsi: 994121881,
    lng: 114.30675,
    lat: 22.56676,
    lastdyn: 1719859621,
    type: 25,
    shiptype: 'navigation',
    name: 'YAN TIAN 1A',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121881,
  },
  {
    mmsi: 999413096,
    lng: 114.328797,
    lat: 22.568243,
    lastdyn: 1719859613,
    type: 25,
    shiptype: 'navigation',
    name: 'YAN TIAN GANG 1',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413096,
  },
  {
    mmsi: 994136752,
    lng: 114.57643,
    lat: 22.685013,
    lastdyn: 1719859812,
    type: 23,
    shiptype: 'navigation',
    name: 'SHIHUAYIHAODENGFU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136752,
  },
  {
    mmsi: 994136974,
    lng: 114.550305,
    lat: 22.693,
    lastdyn: 1719859838,
    type: 21,
    shiptype: 'navigation',
    name: 'HUI ZHOU GANG 211',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136974,
  },
  {
    mmsi: 994136861,
    lng: 114.72948,
    lat: 22.578287,
    lastdyn: 1719859883,
    type: 24,
    shiptype: 'navigation',
    name: 'PINGHAI 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136861,
  },
  {
    mmsi: 994136951,
    lng: 114.641138,
    lat: 22.714443,
    lastdyn: 1719859859,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGLIAN 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136951,
  },
  {
    mmsi: 994136949,
    lng: 114.664805,
    lat: 22.689277,
    lastdyn: 1719859853,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGLIAN 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136949,
  },
  {
    mmsi: 994136891,
    lng: 114.563528,
    lat: 22.692028,
    lastdyn: 1719859819,
    type: 25,
    shiptype: 'navigation',
    name: 'HUI ZHOU GANG 191',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136891,
  },
  {
    mmsi: 994136890,
    lng: 114.566667,
    lat: 22.6895,
    lastdyn: 1719859819,
    type: 25,
    shiptype: 'navigation',
    name: 'HUI ZHOU GANG 181',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136890,
  },
  {
    mmsi: 994136973,
    lng: 114.57643,
    lat: 22.680117,
    lastdyn: 1719859836,
    type: 25,
    shiptype: 'navigation',
    name: 'HUI ZHOU GANG 17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136973,
  },
  {
    mmsi: 994136952,
    lng: 114.676305,
    lat: 22.66461,
    lastdyn: 1719859862,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGLIAN D2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136952,
  },
  {
    mmsi: 994136976,
    lng: 114.583472,
    lat: 22.700277,
    lastdyn: 1719859844,
    type: 25,
    shiptype: 'navigation',
    name: 'CHUN ZHOU C51',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136976,
  },
  {
    mmsi: 994136975,
    lng: 114.583333,
    lat: 22.683333,
    lastdyn: 1719859841,
    type: 25,
    shiptype: 'navigation',
    name: 'CHUN ZHOU C3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136975,
  },
  {
    mmsi: 994136899,
    lng: 114.651317,
    lat: 22.7197,
    lastdyn: 1719859877,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136899,
  },
  {
    mmsi: 994136860,
    lng: 114.729395,
    lat: 22.562033,
    lastdyn: 1719859880,
    type: 24,
    shiptype: 'navigation',
    name: 'PINGHAI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136860,
  },
  {
    mmsi: 994121649,
    lng: 114.646163,
    lat: 22.656718,
    lastdyn: 1719859900,
    type: 0,
    shiptype: 'navigation',
    name: 'HUA YING RANLIAOYOU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121649,
  },
  {
    mmsi: 994136893,
    lng: 114.616055,
    lat: 22.735445,
    lastdyn: 1719859822,
    type: 27,
    shiptype: 'navigation',
    name: 'DONG LIAN 19',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136893,
  },
  {
    mmsi: 994136862,
    lng: 114.670638,
    lat: 22.682333,
    lastdyn: 1719859850,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGLIAN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136862,
  },
  {
    mmsi: 994136892,
    lng: 114.560445,
    lat: 22.694445,
    lastdyn: 1719859821,
    type: 25,
    shiptype: 'navigation',
    name: 'HUI ZHOU GANG 201',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136892,
  },
  {
    mmsi: 994136950,
    lng: 114.652972,
    lat: 22.70186,
    lastdyn: 1719859856,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGLIAN 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136950,
  },
  {
    mmsi: 994136710,
    lng: 114.995,
    lat: 22.51,
    lastdyn: 1719859819,
    type: 28,
    shiptype: 'navigation',
    name: 'NAN HUI 68 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136710,
  },
  {
    mmsi: 994136887,
    lng: 114.979267,
    lat: 22.53095,
    lastdyn: 1719859831,
    type: 28,
    shiptype: 'navigation',
    name: 'YUE HAI YU 11259 WRE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136887,
  },
  {
    mmsi: 994121864,
    lng: 115.095117,
    lat: 22.652483,
    lastdyn: 1719786775,
    type: 25,
    shiptype: 'navigation',
    name: '0802748',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121864,
  },
  {
    mmsi: 994121633,
    lng: 115.039833,
    lat: 22.736783,
    lastdyn: 1719859853,
    type: 24,
    shiptype: 'navigation',
    name: 'HUA RUN 16',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121633,
  },
  {
    mmsi: 994121623,
    lng: 115.076283,
    lat: 22.677983,
    lastdyn: 1719859896,
    type: 24,
    shiptype: 'navigation',
    name: 'HUA RUN 6',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121623,
  },
  {
    mmsi: 994121643,
    lng: 115.08527,
    lat: 22.664435,
    lastdyn: 1719859897,
    type: 24,
    shiptype: 'navigation',
    name: 'HUA RUN 4',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121643,
  },
  {
    mmsi: 994121890,
    lng: 115.027963,
    lat: 22.679617,
    lastdyn: 1719858593,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGHHZGK1 DLAIS 05',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121890,
  },
  {
    mmsi: 994121626,
    lng: 115.064117,
    lat: 22.702917,
    lastdyn: 1719859873,
    type: 25,
    shiptype: 'navigation',
    name: 'HUA RUN 9',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121626,
  },
  {
    mmsi: 994121628,
    lng: 115.057023,
    lat: 22.714492,
    lastdyn: 1719859887,
    type: 25,
    shiptype: 'navigation',
    name: 'HUARUN 11',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121628,
  },
  {
    mmsi: 994121622,
    lng: 115.078615,
    lat: 22.679177,
    lastdyn: 1719859877,
    type: 25,
    shiptype: 'navigation',
    name: 'HUA RUN 5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121622,
  },
  {
    mmsi: 994121627,
    lng: 115.061905,
    lat: 22.70159,
    lastdyn: 1719859771,
    type: 24,
    shiptype: 'navigation',
    name: 'HUA RUN 10',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121627,
  },
  {
    mmsi: 994121631,
    lng: 115.047587,
    lat: 22.724853,
    lastdyn: 1719859879,
    type: 24,
    shiptype: 'navigation',
    name: 'HUA RUN 14',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121631,
  },
  {
    mmsi: 994121629,
    lng: 115.054802,
    lat: 22.71308,
    lastdyn: 1719859891,
    type: 24,
    shiptype: 'navigation',
    name: 'HUA RUN 12',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121629,
  },
  {
    mmsi: 994121642,
    lng: 115.086903,
    lat: 22.665893,
    lastdyn: 1719859896,
    type: 25,
    shiptype: 'navigation',
    name: 'HUA RUN 3',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121642,
  },
  {
    mmsi: 994121632,
    lng: 115.044412,
    lat: 22.735005,
    lastdyn: 1719859890,
    type: 14,
    shiptype: 'navigation',
    name: 'HUA RUN 15',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121632,
  },
  {
    mmsi: 994121630,
    lng: 115.049678,
    lat: 22.726498,
    lastdyn: 1719859879,
    type: 25,
    shiptype: 'navigation',
    name: 'HUA RUN 13',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121630,
  },
  {
    mmsi: 994121882,
    lng: 115.04,
    lat: 22.74137,
    lastdyn: 1715839870,
    type: 24,
    shiptype: 'navigation',
    name: 'XIAOMOGANG X1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121882,
  },
  {
    mmsi: 994136836,
    lng: 115.65625,
    lat: 22.712833,
    lastdyn: 1719859874,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136836,
  },
  {
    mmsi: 994131748,
    lng: 115.62612,
    lat: 22.69263,
    lastdyn: 1719859681,
    type: 30,
    shiptype: 'navigation',
    name: 'SWCS8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131748,
  },
  {
    mmsi: 994136791,
    lng: 115.651697,
    lat: 22.710213,
    lastdyn: 1719859856,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136791,
  },
  {
    mmsi: 994136834,
    lng: 115.645778,
    lat: 22.729195,
    lastdyn: 1719859868,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136834,
  },
  {
    mmsi: 994136799,
    lng: 115.651678,
    lat: 22.700487,
    lastdyn: 1719859862,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136799,
  },
  {
    mmsi: 994136797,
    lng: 115.634067,
    lat: 22.700495,
    lastdyn: 1719859859,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136797,
  },
  {
    mmsi: 994136704,
    lng: 115.631325,
    lat: 22.712845,
    lastdyn: 1719792513,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136704,
  },
  {
    mmsi: 994136708,
    lng: 115.631325,
    lat: 22.730713,
    lastdyn: 1719792516,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136708,
  },
  {
    mmsi: 994136835,
    lng: 115.65625,
    lat: 22.729195,
    lastdyn: 1719859871,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136835,
  },
  {
    mmsi: 994136833,
    lng: 115.645778,
    lat: 22.712833,
    lastdyn: 1719859865,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136833,
  },
  {
    mmsi: 994136788,
    lng: 115.634072,
    lat: 22.710222,
    lastdyn: 1719859853,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136788,
  },
  {
    mmsi: 994136749,
    lng: 115.642638,
    lat: 22.712845,
    lastdyn: 1719792522,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136749,
  },
  {
    mmsi: 994136713,
    lng: 115.642638,
    lat: 22.730713,
    lastdyn: 1719792519,
    type: 30,
    shiptype: 'navigation',
    name: 'CAISHAQU3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136713,
  },
  {
    mmsi: 994121819,
    lng: 115.912577,
    lat: 22.653305,
    lastdyn: 1719858918,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 36',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121819,
  },
  {
    mmsi: 994121816,
    lng: 115.986035,
    lat: 22.676357,
    lastdyn: 1719858919,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 25',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121816,
  },
  {
    mmsi: 994121818,
    lng: 115.885392,
    lat: 22.677783,
    lastdyn: 1719859825,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 32',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121818,
  },
  {
    mmsi: 994121817,
    lng: 115.957647,
    lat: 22.702285,
    lastdyn: 1719859822,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121817,
  },
  {
    mmsi: 994121822,
    lng: 115.921513,
    lat: 22.703975,
    lastdyn: 1719859728,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM HL3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121822,
  },
  {
    mmsi: 994121823,
    lng: 115.897772,
    lat: 22.728632,
    lastdyn: 1719728864,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM HL4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121823,
  },
  {
    mmsi: 994121863,
    lng: 116.21836,
    lat: 22.66417,
    lastdyn: 1719857642,
    type: 3,
    shiptype: 'navigation',
    name: 'GDTSQ I 13',
    length: 16,
    width: 12,
    left: 6,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121863,
  },
  {
    mmsi: 994121996,
    lng: 116.216717,
    lat: 22.591912,
    lastdyn: 1719858912,
    type: 3,
    shiptype: 'navigation',
    name: 'JIAZI WIND FARM 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121996,
  },
  {
    mmsi: 994136608,
    lng: 116.2172,
    lat: 22.73898,
    lastdyn: 1719859892,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136608,
  },
  {
    mmsi: 994121694,
    lng: 116.122245,
    lat: 22.634422,
    lastdyn: 1719859842,
    type: 3,
    shiptype: 'navigation',
    name: 'JIAZI WIND FARM 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121694,
  },
  {
    mmsi: 994136645,
    lng: 116.062633,
    lat: 22.74849,
    lastdyn: 1719859714,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136645,
  },
  {
    mmsi: 994136631,
    lng: 116.03288,
    lat: 22.709595,
    lastdyn: 1719859893,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136631,
  },
  {
    mmsi: 994121998,
    lng: 116.04457,
    lat: 22.53527,
    lastdyn: 1719858636,
    type: 3,
    shiptype: 'navigation',
    name: 'JIAZI WIND FARM 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121998,
  },
  {
    mmsi: 994136630,
    lng: 116.04301,
    lat: 22.68427,
    lastdyn: 1719859714,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136630,
  },
  {
    mmsi: 994136644,
    lng: 116.022747,
    lat: 22.73492,
    lastdyn: 1719859893,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136644,
  },
  {
    mmsi: 994121807,
    lng: 116.088268,
    lat: 22.708788,
    lastdyn: 1719856817,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121807,
  },
  {
    mmsi: 994136607,
    lng: 116.246243,
    lat: 22.74808,
    lastdyn: 1719859892,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136607,
  },
  {
    mmsi: 994136629,
    lng: 116.072028,
    lat: 22.6934,
    lastdyn: 1719859893,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136629,
  },
  {
    mmsi: 994121813,
    lng: 116.097515,
    lat: 22.729197,
    lastdyn: 1719859510,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 19',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121813,
  },
  {
    mmsi: 994121814,
    lng: 116.135447,
    lat: 22.73963,
    lastdyn: 1719857130,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 21',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121814,
  },
  {
    mmsi: 994136671,
    lng: 116.106937,
    lat: 22.736688,
    lastdyn: 1719859893,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136671,
  },
  {
    mmsi: 994136672,
    lng: 116.131177,
    lat: 22.748577,
    lastdyn: 1719859893,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136672,
  },
  {
    mmsi: 994121995,
    lng: 116.197857,
    lat: 22.658133,
    lastdyn: 1719859508,
    type: 3,
    shiptype: 'navigation',
    name: 'JIAZI WIND FARM 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121995,
  },
  {
    mmsi: 994121997,
    lng: 116.141078,
    lat: 22.567098,
    lastdyn: 1719858923,
    type: 3,
    shiptype: 'navigation',
    name: 'JIAZI WIND FARM 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121997,
  },
  {
    mmsi: 994136610,
    lng: 116.188162,
    lat: 22.729877,
    lastdyn: 1719859713,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136610,
  },
  {
    mmsi: 994121812,
    lng: 116.066625,
    lat: 22.737385,
    lastdyn: 1719856816,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121812,
  },
  {
    mmsi: 994121808,
    lng: 116.049303,
    lat: 22.696468,
    lastdyn: 1719857135,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121808,
  },
  {
    mmsi: 994121809,
    lng: 116.03798,
    lat: 22.724615,
    lastdyn: 1719859808,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121809,
  },
  {
    mmsi: 994121693,
    lng: 181,
    lat: 91,
    lastdyn: 1719858585,
    type: 3,
    shiptype: 'navigation',
    name: 'JIAZI WIND FARM 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121693,
  },
  {
    mmsi: 994121968,
    lng: 116.338543,
    lat: 22.702073,
    lastdyn: 1719856997,
    type: 0,
    shiptype: 'navigation',
    name: 'SQ2WINDFARM12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121968,
  },
  {
    mmsi: 994121969,
    lng: 116.418882,
    lat: 22.708173,
    lastdyn: 1719859356,
    type: 19,
    shiptype: 'navigation',
    name: 'SQ2 WIND FARM 15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121969,
  },
  {
    mmsi: 994136781,
    lng: 116.541667,
    lat: 22.653333,
    lastdyn: 1719859787,
    type: 28,
    shiptype: 'navigation',
    name: 'JINHANG 98 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136781,
  },
  {
    mmsi: 994136985,
    lng: 116.514722,
    lat: 22.668333,
    lastdyn: 1719859619,
    type: 28,
    shiptype: 'navigation',
    name: 'VESSEL NOT UNDER CON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136985,
  },
  {
    mmsi: 994136720,
    lng: 117.835833,
    lat: 22.722667,
    lastdyn: 1719859782,
    type: 28,
    shiptype: 'navigation',
    name: 'DONG HONG WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136720,
  },
  {
    mmsi: 994136940,
    lng: 118.63,
    lat: 22.686667,
    lastdyn: 1719859806,
    type: 28,
    shiptype: 'navigation',
    name: 'SUN SHINE WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136940,
  },
  {
    mmsi: 994166343,
    lng: 120.316315,
    lat: 22.506263,
    lastdyn: 1719858690,
    type: 0,
    shiptype: 'navigation',
    name: 'UNSTP03 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166343,
  },
  {
    mmsi: 994169292,
    lng: 120.31554,
    lat: 22.503098,
    lastdyn: 1719857248,
    type: 0,
    shiptype: 'navigation',
    name: 'UNSTP02 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169292,
  },
  {
    mmsi: 994070555,
    lng: 220.246263,
    lat: 11.206357,
    lastdyn: 1700845456,
    type: 6,
    shiptype: 'navigation',
    name: 'QCN',
    length: 64,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994070555,
  },
  {
    mmsi: 994164131,
    lng: 120.313227,
    lat: 22.504357,
    lastdyn: 1719858524,
    type: 0,
    shiptype: 'navigation',
    name: 'UNSTP01 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994164131,
  },
  {
    mmsi: 994070534,
    lng: 61.000092,
    lat: 29.655787,
    lastdyn: 1712459288,
    type: 27,
    shiptype: 'navigation',
    name: 'XROZ0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994070534,
  },
  {
    mmsi: 994070532,
    lng: 119.554927,
    lat: 26.4495,
    lastdyn: 1693749292,
    type: 28,
    shiptype: 'navigation',
    name: '',
    length: 80,
    width: 16,
    left: 12,
    trail: 56,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994070532,
  },
  {
    mmsi: 994070560,
    lng: 2.717178,
    lat: 30.443537,
    lastdyn: 1682104574,
    type: 25,
    shiptype: 'navigation',
    name: '110B H',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994070560,
  },
  {
    mmsi: 994070559,
    lng: -101.75134,
    lat: 29.9019,
    lastdyn: 1703149958,
    type: 28,
    shiptype: 'navigation',
    name: 'ZP 0856 7PECK H',
    length: 48,
    width: 10,
    left: 5,
    trail: 24,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994070559,
  },
  {
    mmsi: 994070571,
    lng: 112.00035,
    lat: 22.35042,
    lastdyn: 1712770284,
    type: 28,
    shiptype: 'navigation',
    name: 'LFC C5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994070571,
  },
  {
    mmsi: 994070568,
    lng: 113.835555,
    lat: 22.331833,
    lastdyn: 1703890072,
    type: 24,
    shiptype: 'navigation',
    name: 'YCXGP',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 4,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994070568,
  },
  {
    mmsi: 994070573,
    lng: 169.583358,
    lat: 22.732213,
    lastdyn: 1673317664,
    type: 30,
    shiptype: 'navigation',
    name: 'G GREF WAY 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994070573,
  },
  {
    mmsi: 994070580,
    lng: 115.387395,
    lat: -61.629247,
    lastdyn: 1710518082,
    type: 24,
    shiptype: 'navigation',
    name: 'CHSFGHAIHNGDAO V8',
    length: 8,
    width: 0,
    left: 0,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994070580,
  },
  {
    mmsi: 994070577,
    lng: 114.07725,
    lat: 21.943138,
    lastdyn: 1685602598,
    type: 28,
    shiptype: 'navigation',
    name: 'LI XHN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 16,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994070577,
  },
  {
    mmsi: 994161835,
    lng: 121.15209,
    lat: 22.7439,
    lastdyn: 1719855363,
    type: 1,
    shiptype: 'navigation',
    name: 'CHINGYANG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161835,
  },
  {
    mmsi: 994160313,
    lng: 103.776378,
    lat: -85.877987,
    lastdyn: 1647525164,
    type: 0,
    shiptype: 'navigation',
    name: '',
    length: 73,
    width: 22,
    left: 8,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 160,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994160313,
  },
  {
    mmsi: 999000011,
    lng: 120.13235,
    lat: 31.952832,
    lastdyn: 1710617506,
    type: 3,
    shiptype: 'navigation',
    name: 'JIN9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999000011,
  },
  {
    mmsi: 999000013,
    lng: 120.129982,
    lat: 31.9537,
    lastdyn: 1710617371,
    type: 3,
    shiptype: 'navigation',
    name: 'JIN011',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999000013,
  },
  {
    mmsi: 999000014,
    lng: -43.153773,
    lat: -22.763803,
    lastdyn: 1717764497,
    type: 14,
    shiptype: 'navigation',
    name: 'BOIAPEDRADOCANAL',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000014,
  },
  {
    mmsi: 999000016,
    lng: -43.153772,
    lat: -22.763795,
    lastdyn: 1717719270,
    type: 16,
    shiptype: 'navigation',
    name: 'BOIANR2PREFBOREST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000016,
  },
  {
    mmsi: 999000012,
    lng: 120.131332,
    lat: 31.953165,
    lastdyn: 1710617368,
    type: 3,
    shiptype: 'navigation',
    name: 'JIN010',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999000012,
  },
  {
    mmsi: 999000015,
    lng: 181,
    lat: 91,
    lastdyn: 1717343779,
    type: 13,
    shiptype: 'navigation',
    name: 'BOIALAJEDOCACAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000015,
  },
  {
    mmsi: 994136832,
    lng: 113.571945,
    lat: 22.837083,
    lastdyn: 1719859889,
    type: 20,
    shiptype: 'navigation',
    name: 'GZ65DH ANCHORAGE NOR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136832,
  },
  {
    mmsi: 994136715,
    lng: 113.538112,
    lat: 22.982417,
    lastdyn: 1719859898,
    type: 25,
    shiptype: 'navigation',
    name: 'LIAN HUA SHAN 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136715,
  },
  {
    mmsi: 994131624,
    lng: 113.56189,
    lat: 22.85968,
    lastdyn: 1719859875,
    type: 24,
    shiptype: 'navigation',
    name: 'GZ GANG 58',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131624,
  },
  {
    mmsi: 994136853,
    lng: 113.599445,
    lat: 22.809167,
    lastdyn: 1719859914,
    type: 28,
    shiptype: 'navigation',
    name: 'XIANGLU REEF',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136853,
  },
  {
    mmsi: 994131660,
    lng: 113.55738,
    lat: 22.86426,
    lastdyn: 1719858551,
    type: 25,
    shiptype: 'navigation',
    name: 'SHA ZAI 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131660,
  },
  {
    mmsi: 994136796,
    lng: 113.651913,
    lat: 22.759247,
    lastdyn: 1719859865,
    type: 23,
    shiptype: 'navigation',
    name: 'NO48 ANCHORAGE SOUTH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136796,
  },
  {
    mmsi: 994136714,
    lng: 113.536528,
    lat: 22.987028,
    lastdyn: 1719859901,
    type: 25,
    shiptype: 'navigation',
    name: 'LIAN HUA SHAN 12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136714,
  },
  {
    mmsi: 994136614,
    lng: 113.553278,
    lat: 22.864,
    lastdyn: 1719859871,
    type: 24,
    shiptype: 'navigation',
    name: 'SHA ZAI 2A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136614,
  },
  {
    mmsi: 994131652,
    lng: 113.54355,
    lat: 22.95253,
    lastdyn: 1719859740,
    type: 24,
    shiptype: 'navigation',
    name: 'LIAN HUA SHAN 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131652,
  },
  {
    mmsi: 994136850,
    lng: 113.546722,
    lat: 22.870972,
    lastdyn: 1719859906,
    type: 25,
    shiptype: 'navigation',
    name: 'SHA ZAI 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136850,
  },
  {
    mmsi: 994136601,
    lng: 113.589442,
    lat: 22.803442,
    lastdyn: 1719859859,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN SHA HUO YUN 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136601,
  },
  {
    mmsi: 994131640,
    lng: 113.539983,
    lat: 22.967955,
    lastdyn: 1719859297,
    type: 30,
    shiptype: 'navigation',
    name: '2 HAO HENG YUE 4',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131640,
  },
  {
    mmsi: 994121648,
    lng: 113.569232,
    lat: 22.884377,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: 'HM2 BRIDGE 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121648,
  },
  {
    mmsi: 994131803,
    lng: 113.63384,
    lat: 22.768332,
    lastdyn: 1719821133,
    type: 24,
    shiptype: 'navigation',
    name: 'GUANG ZHOU GANG 53',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131803,
  },
  {
    mmsi: 994136778,
    lng: 113.647138,
    lat: 22.750833,
    lastdyn: 1719859886,
    type: 24,
    shiptype: 'navigation',
    name: 'GZ GANG 52A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136778,
  },
  {
    mmsi: 994136761,
    lng: 113.5702,
    lat: 22.844678,
    lastdyn: 1719859892,
    type: 30,
    shiptype: 'navigation',
    name: 'GUANGZHOU LNG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136761,
  },
  {
    mmsi: 994131631,
    lng: 113.55566,
    lat: 22.91007,
    lastdyn: 1719859802,
    type: 30,
    shiptype: 'navigation',
    name: 'XIAO CHUAN 12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131631,
  },
  {
    mmsi: 994131644,
    lng: 113.5448,
    lat: 22.94443,
    lastdyn: 1719859766,
    type: 26,
    shiptype: 'navigation',
    name: 'LIAN HUA SHAN',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131644,
  },
  {
    mmsi: 994136602,
    lng: 113.554163,
    lat: 22.936917,
    lastdyn: 1719859862,
    type: 24,
    shiptype: 'navigation',
    name: 'HONG YUAN AIS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136602,
  },
  {
    mmsi: 994121647,
    lng: 113.569065,
    lat: 22.883907,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: 'HM2 BRIDGE 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121647,
  },
  {
    mmsi: 994121824,
    lng: 115.880625,
    lat: 22.754168,
    lastdyn: 1719859710,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM HL5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121824,
  },
  {
    mmsi: 994121464,
    lng: 115.982693,
    lat: 22.783543,
    lastdyn: 1719834866,
    type: 25,
    shiptype: 'navigation',
    name: 'BAO LI HUA 1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121464,
  },
  {
    mmsi: 994121466,
    lng: 115.984397,
    lat: 22.798177,
    lastdyn: 1719859847,
    type: 25,
    shiptype: 'navigation',
    name: 'BAO LI HUA 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121466,
  },
  {
    mmsi: 994121825,
    lng: 115.858492,
    lat: 22.769392,
    lastdyn: 1719859777,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM HL6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121825,
  },
  {
    mmsi: 994121465,
    lng: 115.979558,
    lat: 22.784098,
    lastdyn: 1719859890,
    type: 30,
    shiptype: 'navigation',
    name: 'BAO LI HUA 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121465,
  },
  {
    mmsi: 994121696,
    lng: 115.887142,
    lat: 22.760695,
    lastdyn: 1719859773,
    type: 30,
    shiptype: 'navigation',
    name: 'JIAZI WIND FARM HL2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121696,
  },
  {
    mmsi: 994121467,
    lng: 115.981965,
    lat: 22.798512,
    lastdyn: 1719859786,
    type: 24,
    shiptype: 'navigation',
    name: 'BAO LI HUA 4',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121467,
  },
  {
    mmsi: 994121865,
    lng: 115.862722,
    lat: 22.77309,
    lastdyn: 1719859903,
    type: 24,
    shiptype: 'navigation',
    name: 'LU FENG HAI GONG 1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121865,
  },
  {
    mmsi: 994121469,
    lng: 115.98473,
    lat: 22.817643,
    lastdyn: 1719859787,
    type: 24,
    shiptype: 'navigation',
    name: 'BAO LI HUA 6',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121469,
  },
  {
    mmsi: 994121815,
    lng: 116.169147,
    lat: 22.756042,
    lastdyn: 1719847218,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 23',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121815,
  },
  {
    mmsi: 994136673,
    lng: 116.155495,
    lat: 22.760305,
    lastdyn: 1719859894,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V16',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136673,
  },
  {
    mmsi: 994136674,
    lng: 116.179743,
    lat: 22.772183,
    lastdyn: 1719859894,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136674,
  },
  {
    mmsi: 994136606,
    lng: 116.22516,
    lat: 22.765993,
    lastdyn: 1719859526,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136606,
  },
  {
    mmsi: 994121802,
    lng: 116.202247,
    lat: 22.772165,
    lastdyn: 1719859806,
    type: 0,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM 01',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121802,
  },
  {
    mmsi: 994136731,
    lng: 116.539138,
    lat: 22.979138,
    lastdyn: 1719859781,
    type: 24,
    shiptype: 'navigation',
    name: 'HUI LAI DIAN CHANG 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136731,
  },
  {
    mmsi: 994121990,
    lng: 116.64987,
    lat: 22.983377,
    lastdyn: 1719859782,
    type: 30,
    shiptype: 'navigation',
    name: 'JH CAISHA4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121990,
  },
  {
    mmsi: 994136740,
    lng: 116.588333,
    lat: 22.977222,
    lastdyn: 1719792501,
    type: 28,
    shiptype: 'navigation',
    name: 'YU TONG 1 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136740,
  },
  {
    mmsi: 994126622,
    lng: 116.575,
    lat: 22.846667,
    lastdyn: 1719859869,
    type: 28,
    shiptype: 'navigation',
    name: 'CE FENG TA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126622,
  },
  {
    mmsi: 994136735,
    lng: 116.537722,
    lat: 22.985222,
    lastdyn: 1719859784,
    type: 30,
    shiptype: 'navigation',
    name: 'HUI LAI 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136735,
  },
  {
    mmsi: 994136801,
    lng: 116.610555,
    lat: 22.989722,
    lastdyn: 1719859793,
    type: 28,
    shiptype: 'navigation',
    name: 'XINXINGDA18 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136801,
  },
  {
    mmsi: 994136814,
    lng: 117.517467,
    lat: 22.88965,
    lastdyn: 1719859791,
    type: 28,
    shiptype: 'navigation',
    name: 'JING WEI 188 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136814,
  },
  {
    mmsi: 994169282,
    lng: 120.167028,
    lat: 22.767235,
    lastdyn: 1719859479,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC282 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169282,
  },
  {
    mmsi: 994131710,
    lng: 113.16046,
    lat: 23.15634,
    lastdyn: 1719859300,
    type: 30,
    shiptype: 'navigation',
    name: 'PR B2 MARINE MONITOR',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131710,
  },
  {
    mmsi: 994131641,
    lng: 113.378828,
    lat: 23.035502,
    lastdyn: 1719724174,
    type: 25,
    shiptype: 'navigation',
    name: 'HAI XIN GANG 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131641,
  },
  {
    mmsi: 994131627,
    lng: 113.47483,
    lat: 23.07433,
    lastdyn: 1719859749,
    type: 26,
    shiptype: 'navigation',
    name: 'DONG HE DAO 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131627,
  },
  {
    mmsi: 999993341,
    lng: 113.432458,
    lat: 23.089127,
    lastdyn: 1719859787,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON3341',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993341,
  },
  {
    mmsi: 999998888,
    lng: 113.432565,
    lat: 23.089083,
    lastdyn: 1719859871,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 8888',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999998888,
  },
  {
    mmsi: 994136711,
    lng: 113.472,
    lat: 23.077945,
    lastdyn: 1719859895,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HE DAO 1A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136711,
  },
  {
    mmsi: 994131628,
    lng: 120.31387,
    lat: 35.88687,
    lastdyn: 1719859829,
    type: 31,
    shiptype: 'navigation',
    name: 'LIGHT VESSEL NO501',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131628,
  },
  {
    mmsi: 999990783,
    lng: 113.432365,
    lat: 23.089123,
    lastdyn: 1719859896,
    type: 0,
    shiptype: 'navigation',
    name: 'YDDQK2GT1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990783,
  },
  {
    mmsi: 999993035,
    lng: 113.507358,
    lat: 23.045572,
    lastdyn: 1719859323,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 3035',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993035,
  },
  {
    mmsi: 994131609,
    lng: 113.51458,
    lat: 23.02565,
    lastdyn: 1719859568,
    type: 24,
    shiptype: 'navigation',
    name: 'GUANG ZHOU GANG 74',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131609,
  },
  {
    mmsi: 999992018,
    lng: 113.511237,
    lat: 23.039452,
    lastdyn: 1719858806,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2018',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992018,
  },
  {
    mmsi: 999992009,
    lng: 113.509753,
    lat: 23.041803,
    lastdyn: 1719859326,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2009',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992009,
  },
  {
    mmsi: 994126621,
    lng: 116.666667,
    lat: 23.174305,
    lastdyn: 1719859835,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN ZAI JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126621,
  },
  {
    mmsi: 994121943,
    lng: 116.6626,
    lat: 23.19769,
    lastdyn: 1719859804,
    type: 30,
    shiptype: 'navigation',
    name: 'HM PHG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121943,
  },
  {
    mmsi: 994121944,
    lng: 116.670723,
    lat: 23.195937,
    lastdyn: 1719859758,
    type: 30,
    shiptype: 'navigation',
    name: 'HM PHG 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121944,
  },
  {
    mmsi: 994131739,
    lng: 116.63211,
    lat: 23.13675,
    lastdyn: 1719859759,
    type: 25,
    shiptype: 'navigation',
    name: 'HDST5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131739,
  },
  {
    mmsi: 999414005,
    lng: 116.606467,
    lat: 23.134852,
    lastdyn: 1719859687,
    type: 0,
    shiptype: 'navigation',
    name: 'GD05',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999414005,
  },
  {
    mmsi: 999414007,
    lng: 116.601025,
    lat: 23.158112,
    lastdyn: 1719859858,
    type: 0,
    shiptype: 'navigation',
    name: 'GD07',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999414007,
  },
  {
    mmsi: 994131738,
    lng: 116.62608,
    lat: 23.11641,
    lastdyn: 1719859873,
    type: 24,
    shiptype: 'navigation',
    name: 'HDST4',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131738,
  },
  {
    mmsi: 994136934,
    lng: 116.627612,
    lat: 23.169805,
    lastdyn: 1719859803,
    type: 30,
    shiptype: 'navigation',
    name: 'HAIMEN OIL PIER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136934,
  },
  {
    mmsi: 994136840,
    lng: 116.760753,
    lat: 23.225538,
    lastdyn: 1719859874,
    type: 22,
    shiptype: 'navigation',
    name: 'GUANG AO GANG QU NIA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136840,
  },
  {
    mmsi: 994136839,
    lng: 116.759872,
    lat: 23.226205,
    lastdyn: 1719859870,
    type: 23,
    shiptype: 'navigation',
    name: 'GUANG AO GANG QU NIA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136839,
  },
  {
    mmsi: 994136773,
    lng: 116.817383,
    lat: 23.231933,
    lastdyn: 1719859719,
    type: 30,
    shiptype: 'navigation',
    name: 'LMHDDL4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136773,
  },
  {
    mmsi: 994126927,
    lng: 116.9308,
    lat: 23.193733,
    lastdyn: 1719859745,
    type: 0,
    shiptype: 'navigation',
    name: 'HUANENGSTLM7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126927,
  },
  {
    mmsi: 994136999,
    lng: 116.878917,
    lat: 23.229583,
    lastdyn: 1719859844,
    type: 28,
    shiptype: 'navigation',
    name: 'YUE YANG XI YU 39668',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136999,
  },
  {
    mmsi: 994136770,
    lng: 116.930417,
    lat: 23.217138,
    lastdyn: 1719859890,
    type: 30,
    shiptype: 'navigation',
    name: 'LMHDDL1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136770,
  },
  {
    mmsi: 994136838,
    lng: 116.761638,
    lat: 23.226008,
    lastdyn: 1719859867,
    type: 21,
    shiptype: 'navigation',
    name: 'GUANG AO GANG QU NIA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136838,
  },
  {
    mmsi: 994136772,
    lng: 116.8495,
    lat: 23.22445,
    lastdyn: 1719859896,
    type: 30,
    shiptype: 'navigation',
    name: 'LMHDDL3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136772,
  },
  {
    mmsi: 994131693,
    lng: 116.76936,
    lat: 23.164652,
    lastdyn: 1719859871,
    type: 24,
    shiptype: 'navigation',
    name: 'GUANG AO 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131693,
  },
  {
    mmsi: 994126928,
    lng: 116.960233,
    lat: 23.232583,
    lastdyn: 1719859807,
    type: 0,
    shiptype: 'navigation',
    name: 'HUANENGSTLM10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126928,
  },
  {
    mmsi: 994121905,
    lng: 116.853712,
    lat: 23.178762,
    lastdyn: 1719859868,
    type: 30,
    shiptype: 'navigation',
    name: 'STDHB02AIS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121905,
  },
  {
    mmsi: 994131694,
    lng: 116.76652,
    lat: 23.164593,
    lastdyn: 1719859878,
    type: 0,
    shiptype: 'navigation',
    name: 'GUANG AO 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131694,
  },
  {
    mmsi: 994136771,
    lng: 116.8815,
    lat: 23.217,
    lastdyn: 1719859893,
    type: 30,
    shiptype: 'navigation',
    name: 'LMHDDL2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136771,
  },
  {
    mmsi: 994136725,
    lng: 117.089,
    lat: 23.0665,
    lastdyn: 1719859480,
    type: 28,
    shiptype: 'navigation',
    name: 'DONGAH 101 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136725,
  },
  {
    mmsi: 994126926,
    lng: 117.0425,
    lat: 23.193783,
    lastdyn: 1719859863,
    type: 0,
    shiptype: 'navigation',
    name: 'HUANENGSTLM1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126926,
  },
  {
    mmsi: 994126929,
    lng: 117.077683,
    lat: 23.232517,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: 'HUANENGSTLM16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126929,
  },
  {
    mmsi: 994136886,
    lng: 118.028833,
    lat: 23.212167,
    lastdyn: 1719859779,
    type: 28,
    shiptype: 'navigation',
    name: 'HONG XIANG 819 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136886,
  },
  {
    mmsi: 994136719,
    lng: 118.055983,
    lat: 23.015967,
    lastdyn: 1719859779,
    type: 28,
    shiptype: 'navigation',
    name: 'JIA LIANG 1 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136719,
  },
  {
    mmsi: 994136895,
    lng: 118.3974,
    lat: 23.122167,
    lastdyn: 1719859781,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136895,
  },
  {
    mmsi: 994136880,
    lng: 118.798333,
    lat: 23.178333,
    lastdyn: 1719859781,
    type: 28,
    shiptype: 'navigation',
    name: 'MIN DONG YU 61226 WR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136880,
  },
  {
    mmsi: 994161815,
    lng: 119.428042,
    lat: 23.190112,
    lastdyn: 1719859532,
    type: 1,
    shiptype: 'navigation',
    name: 'QIMEI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161815,
  },
  {
    mmsi: 994161122,
    lng: 120.200422,
    lat: 24.136158,
    lastdyn: 1719859503,
    type: 20,
    shiptype: 'navigation',
    name: 'TPC2 W1',
    length: 20,
    width: 20,
    left: 10,
    trail: 10,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161122,
  },
  {
    mmsi: 994166033,
    lng: 120.222943,
    lat: 23.001728,
    lastdyn: 1719858066,
    type: 0,
    shiptype: 'navigation',
    name: 'CWBFGCBUOY 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166033,
  },
  {
    mmsi: 994169240,
    lng: 120.223405,
    lat: 23.001255,
    lastdyn: 1719813436,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC240 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169240,
  },
  {
    mmsi: 994166029,
    lng: 120.22265,
    lat: 23.002055,
    lastdyn: 1719859573,
    type: 0,
    shiptype: 'navigation',
    name: 'CWBXLQBUOY 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166029,
  },
  {
    mmsi: 994166079,
    lng: 120.222762,
    lat: 23.001812,
    lastdyn: 1719789854,
    type: 0,
    shiptype: 'navigation',
    name: 'ANPINGWL 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166079,
  },
  {
    mmsi: 994161812,
    lng: 120.036025,
    lat: 23.100768,
    lastdyn: 1719799021,
    type: 6,
    shiptype: 'navigation',
    name: 'GUOSHENGANG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161812,
  },
  {
    mmsi: 994161836,
    lng: 121.415873,
    lat: 23.225847,
    lastdyn: 1719854641,
    type: 1,
    shiptype: 'navigation',
    name: 'WUSHIHBI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161836,
  },
  {
    mmsi: 994161805,
    lng: 121.3808,
    lat: 23.099697,
    lastdyn: 1719849793,
    type: 1,
    shiptype: 'navigation',
    name: 'HSINKANG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161805,
  },
  {
    mmsi: 994166124,
    lng: 121.420775,
    lat: 23.132802,
    lastdyn: 1719829808,
    type: 30,
    shiptype: 'navigation',
    name: 'CWACHENGGONGBUOY',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166124,
  },
  {
    mmsi: 994131611,
    lng: 116.73488,
    lat: 23.3432,
    lastdyn: 1719857448,
    type: 25,
    shiptype: 'navigation',
    name: 'SHAN TOU GANG 11',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131611,
  },
  {
    mmsi: 994136620,
    lng: 116.746528,
    lat: 23.332583,
    lastdyn: 1719859838,
    type: 25,
    shiptype: 'navigation',
    name: 'HAI WAN DA QIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136620,
  },
  {
    mmsi: 994121601,
    lng: 116.79246,
    lat: 23.288432,
    lastdyn: 1719859887,
    type: 25,
    shiptype: 'navigation',
    name: 'SHAN TOU GANG 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121601,
  },
  {
    mmsi: 999414012,
    lng: 116.754392,
    lat: 23.330302,
    lastdyn: 1719854287,
    type: 0,
    shiptype: 'navigation',
    name: 'GD12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999414012,
  },
  {
    mmsi: 994121924,
    lng: 116.993227,
    lat: 23.269253,
    lastdyn: 1719859890,
    type: 3,
    shiptype: 'navigation',
    name: 'DTLMI 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121924,
  },
  {
    mmsi: 994136936,
    lng: 116.78672,
    lat: 23.2993,
    lastdyn: 1719859883,
    type: 30,
    shiptype: 'navigation',
    name: 'OUTER TRAINING DAM G',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136936,
  },
  {
    mmsi: 994136935,
    lng: 116.7923,
    lat: 23.292737,
    lastdyn: 1719859880,
    type: 30,
    shiptype: 'navigation',
    name: 'OUTER TRAINING DAM G',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136935,
  },
  {
    mmsi: 994121923,
    lng: 117.052682,
    lat: 23.269217,
    lastdyn: 1719859879,
    type: 3,
    shiptype: 'navigation',
    name: 'DTLMI 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121923,
  },
  {
    mmsi: 994121925,
    lng: 117.004442,
    lat: 23.281597,
    lastdyn: 1719859899,
    type: 3,
    shiptype: 'navigation',
    name: 'DTLMI 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121925,
  },
  {
    mmsi: 994136809,
    lng: 117.194445,
    lat: 23.371388,
    lastdyn: 1719859788,
    type: 28,
    shiptype: 'navigation',
    name: 'WEI LONG 7 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136809,
  },
  {
    mmsi: 994136942,
    lng: 117.2425,
    lat: 23.398055,
    lastdyn: 1719859782,
    type: 28,
    shiptype: 'navigation',
    name: 'YUERAOPINGYU45040 WR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136942,
  },
  {
    mmsi: 994126918,
    lng: 117.301017,
    lat: 23.422583,
    lastdyn: 1719734033,
    type: 0,
    shiptype: 'navigation',
    name: 'SXNAYD CF',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126918,
  },
  {
    mmsi: 994126479,
    lng: 117.526638,
    lat: 23.482695,
    lastdyn: 1719859832,
    type: 29,
    shiptype: 'navigation',
    name: 'S1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126479,
  },
  {
    mmsi: 994136800,
    lng: 117.764247,
    lat: 23.381362,
    lastdyn: 1719859877,
    type: 28,
    shiptype: 'navigation',
    name: 'LIAN FENG 18 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136800,
  },
  {
    mmsi: 994161814,
    lng: 119.669262,
    lat: 23.260805,
    lastdyn: 1719859541,
    type: 1,
    shiptype: 'navigation',
    name: 'DONGJI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161814,
  },
  {
    mmsi: 994161817,
    lng: 120.133637,
    lat: 23.451237,
    lastdyn: 1719859513,
    type: 1,
    shiptype: 'navigation',
    name: 'TUNGSHIH',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161817,
  },
  {
    mmsi: 994166888,
    lng: 120.119593,
    lat: 23.380568,
    lastdyn: 1719859636,
    type: 0,
    shiptype: 'navigation',
    name: 'SUBMERGED BREAKWATER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166888,
  },
  {
    mmsi: 994166777,
    lng: 120.11472,
    lat: 23.377832,
    lastdyn: 1719859625,
    type: 0,
    shiptype: 'navigation',
    name: 'SUBMERGED BREAKWATER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166777,
  },
  {
    mmsi: 994166999,
    lng: 120.123667,
    lat: 23.37845,
    lastdyn: 1719859602,
    type: 0,
    shiptype: 'navigation',
    name: 'NO2 GREEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166999,
  },
  {
    mmsi: 994161827,
    lng: 120.147375,
    lat: 23.380192,
    lastdyn: 1719859500,
    type: 1,
    shiptype: 'navigation',
    name: 'BUTAIKANG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161827,
  },
  {
    mmsi: 994166666,
    lng: 120.127778,
    lat: 23.377222,
    lastdyn: 1719859587,
    type: 0,
    shiptype: 'navigation',
    name: 'NO6 RED',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166666,
  },
  {
    mmsi: 994131753,
    lng: 116.980658,
    lat: 23.601365,
    lastdyn: 1719858967,
    type: 13,
    shiptype: 'navigation',
    name: 'CHAOZHOUGANG20',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131753,
  },
  {
    mmsi: 994136933,
    lng: 117.207667,
    lat: 23.531138,
    lastdyn: 1719859800,
    type: 30,
    shiptype: 'navigation',
    name: 'LAONIU JIAO FISH HAV',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136933,
  },
  {
    mmsi: 994136930,
    lng: 117.213805,
    lat: 23.520972,
    lastdyn: 1719859794,
    type: 30,
    shiptype: 'navigation',
    name: 'LAONIU JIAO FISH HAV',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136930,
  },
  {
    mmsi: 994121602,
    lng: 117.201462,
    lat: 23.526228,
    lastdyn: 1719859816,
    type: 30,
    shiptype: 'navigation',
    name: 'LAO NIU JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121602,
  },
  {
    mmsi: 994136931,
    lng: 117.203333,
    lat: 23.510667,
    lastdyn: 1719859797,
    type: 30,
    shiptype: 'navigation',
    name: 'LAONIU JIAO FISH HAV',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136931,
  },
  {
    mmsi: 994136932,
    lng: 117.201,
    lat: 23.517,
    lastdyn: 1719859602,
    type: 30,
    shiptype: 'navigation',
    name: 'LAONIU JIAO FISH HAV',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136932,
  },
  {
    mmsi: 994131750,
    lng: 117.09274,
    lat: 23.530582,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'CHAO ZHOU GANG 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131750,
  },
  {
    mmsi: 994131752,
    lng: 117.040733,
    lat: 23.5893,
    lastdyn: 1719859633,
    type: 0,
    shiptype: 'navigation',
    name: 'CHAO ZHOU GANG 13',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131752,
  },
  {
    mmsi: 994136347,
    lng: 117.6475,
    lat: 23.577667,
    lastdyn: 1719859829,
    type: 28,
    shiptype: 'navigation',
    name: 'XDY WM WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136347,
  },
  {
    mmsi: 994126482,
    lng: 117.578472,
    lat: 23.653417,
    lastdyn: 1719859841,
    type: 29,
    shiptype: 'navigation',
    name: 'S4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126482,
  },
  {
    mmsi: 994126480,
    lng: 117.543778,
    lat: 23.539278,
    lastdyn: 1719859835,
    type: 29,
    shiptype: 'navigation',
    name: 'S2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126480,
  },
  {
    mmsi: 994126483,
    lng: 117.581667,
    lat: 23.689833,
    lastdyn: 1719859844,
    type: 29,
    shiptype: 'navigation',
    name: 'S5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126483,
  },
  {
    mmsi: 994126481,
    lng: 117.560972,
    lat: 23.595805,
    lastdyn: 1719859838,
    type: 29,
    shiptype: 'navigation',
    name: 'S3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126481,
  },
  {
    mmsi: 994169280,
    lng: 119.549503,
    lat: 23.724667,
    lastdyn: 1719859358,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC280 5V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169280,
  },
  {
    mmsi: 994166047,
    lng: 119.983367,
    lat: 23.519133,
    lastdyn: 1719855363,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN S1 AIS ATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166047,
  },
  {
    mmsi: 994166049,
    lng: 119.995483,
    lat: 23.629483,
    lastdyn: 1719855195,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN W1 AIS ATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166049,
  },
  {
    mmsi: 994166050,
    lng: 119.984683,
    lat: 23.578017,
    lastdyn: 1719855219,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN W2 AIS ATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166050,
  },
  {
    mmsi: 994146006,
    lng: 118.203833,
    lat: 38.345112,
    lastdyn: 1697259048,
    type: 25,
    shiptype: 'navigation',
    name: 'BINZHOU NO13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146006,
  },
  {
    mmsi: 994166046,
    lng: 120.061133,
    lat: 23.55375,
    lastdyn: 1719854696,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN E2 AIS ATON',
    length: 1,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166046,
  },
  {
    mmsi: 994166043,
    lng: 120.02915,
    lat: 23.661267,
    lastdyn: 1719855200,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN N1 AIS ATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166043,
  },
  {
    mmsi: 994166044,
    lng: 120.0731,
    lat: 23.66205,
    lastdyn: 1719855401,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN N2 AIS ATON',
    length: 1,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166044,
  },
  {
    mmsi: 994166045,
    lng: 120.07135,
    lat: 23.606617,
    lastdyn: 1719855223,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN E1 AIS ATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166045,
  },
  {
    mmsi: 994166048,
    lng: 120.0419,
    lat: 23.528917,
    lastdyn: 1719855735,
    type: 3,
    shiptype: 'navigation',
    name: 'YUN S2 AIS ATON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166048,
  },
  {
    mmsi: 994166070,
    lng: 120.059612,
    lat: 23.680347,
    lastdyn: 1719859518,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC070 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166070,
  },
  {
    mmsi: 994161818,
    lng: 121.528333,
    lat: 23.604568,
    lastdyn: 1719858087,
    type: 1,
    shiptype: 'navigation',
    name: 'HSINSHE',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161818,
  },
  {
    mmsi: 994136527,
    lng: 117.572945,
    lat: 23.7505,
    lastdyn: 1719859820,
    type: 24,
    shiptype: 'navigation',
    name: 'GU LEI 16A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136527,
  },
  {
    mmsi: 999990017,
    lng: 181,
    lat: 91,
    lastdyn: 1636427668,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST 017',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990017,
  },
  {
    mmsi: 999000001,
    lng: 181,
    lat: 91,
    lastdyn: 1697608208,
    type: 1,
    shiptype: 'navigation',
    name: 'TESTHUMA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000001,
  },
  {
    mmsi: 994136594,
    lng: 118.024777,
    lat: 23.81475,
    lastdyn: 1719859675,
    type: 22,
    shiptype: 'navigation',
    name: 'LIUAO D4 SG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136594,
  },
  {
    mmsi: 994126318,
    lng: 118.024917,
    lat: 23.832805,
    lastdyn: 1719859669,
    type: 9,
    shiptype: 'navigation',
    name: 'LIUAO D4 SG 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126318,
  },
  {
    mmsi: 994136566,
    lng: 118.034667,
    lat: 23.823693,
    lastdyn: 1719859666,
    type: 21,
    shiptype: 'navigation',
    name: 'LIUAO D4 SG 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136566,
  },
  {
    mmsi: 994136567,
    lng: 118.015027,
    lat: 23.823833,
    lastdyn: 1719859672,
    type: 23,
    shiptype: 'navigation',
    name: 'LIUAO D4 SG 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136567,
  },
  {
    mmsi: 994161813,
    lng: 119.600468,
    lat: 23.786272,
    lastdyn: 1719859555,
    type: 5,
    shiptype: 'navigation',
    name: 'MUDOUYU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161813,
  },
  {
    mmsi: 994166140,
    lng: 119.763407,
    lat: 23.986465,
    lastdyn: 1719859598,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166140,
  },
  {
    mmsi: 994166134,
    lng: 119.883627,
    lat: 23.979475,
    lastdyn: 1719859551,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166134,
  },
  {
    mmsi: 994166052,
    lng: 119.906138,
    lat: 23.901078,
    lastdyn: 1719859397,
    type: 29,
    shiptype: 'navigation',
    name: 'SAFE WATER2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166052,
  },
  {
    mmsi: 994166132,
    lng: 119.856788,
    lat: 23.944682,
    lastdyn: 1719859878,
    type: 11,
    shiptype: 'navigation',
    name: 'S2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166132,
  },
  {
    mmsi: 994166138,
    lng: 119.810992,
    lat: 23.965183,
    lastdyn: 1719859582,
    type: 11,
    shiptype: 'navigation',
    name: 'S1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166138,
  },
  {
    mmsi: 994166058,
    lng: 119.855082,
    lat: 23.949387,
    lastdyn: 1719859384,
    type: 22,
    shiptype: 'navigation',
    name: 'SOUTH MARK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166058,
  },
  {
    mmsi: 994166055,
    lng: 119.958705,
    lat: 23.968978,
    lastdyn: 1719859395,
    type: 30,
    shiptype: 'navigation',
    name: 'SPECIAL MARK3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166055,
  },
  {
    mmsi: 994166119,
    lng: 120.201165,
    lat: 23.967072,
    lastdyn: 1719859512,
    type: 21,
    shiptype: 'navigation',
    name: 'XD BUOY 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166119,
  },
  {
    mmsi: 994161009,
    lng: 120.225252,
    lat: 23.972138,
    lastdyn: 1719859531,
    type: 3,
    shiptype: 'navigation',
    name: 'TPC105',
    length: 18,
    width: 18,
    left: 0,
    trail: 17,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161009,
  },
  {
    mmsi: 994166120,
    lng: 120.144748,
    lat: 23.93848,
    lastdyn: 1719859517,
    type: 23,
    shiptype: 'navigation',
    name: 'ZNVB1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166120,
  },
  {
    mmsi: 994166059,
    lng: 120.031047,
    lat: 23.872188,
    lastdyn: 1719859369,
    type: 23,
    shiptype: 'navigation',
    name: 'WEST MARK1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166059,
  },
  {
    mmsi: 994166039,
    lng: 120.085152,
    lat: 23.970675,
    lastdyn: 1719859506,
    type: 30,
    shiptype: 'navigation',
    name: 'CF BUOY 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166039,
  },
  {
    mmsi: 994161084,
    lng: 120.124507,
    lat: 23.87487,
    lastdyn: 1719858995,
    type: 30,
    shiptype: 'navigation',
    name: 'ZNWBS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161084,
  },
  {
    mmsi: 994161067,
    lng: 120.148812,
    lat: 23.967503,
    lastdyn: 1719859544,
    type: 30,
    shiptype: 'navigation',
    name: 'BUOY1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161067,
  },
  {
    mmsi: 994161085,
    lng: 120.158405,
    lat: 23.918843,
    lastdyn: 1719859548,
    type: 30,
    shiptype: 'navigation',
    name: 'ZNWBN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161085,
  },
  {
    mmsi: 994161030,
    lng: 120.151013,
    lat: 23.780828,
    lastdyn: 1719859572,
    type: 1,
    shiptype: 'navigation',
    name: 'WESTPOINT',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161030,
  },
  {
    mmsi: 994166121,
    lng: 120.087815,
    lat: 23.865918,
    lastdyn: 1719859519,
    type: 23,
    shiptype: 'navigation',
    name: 'ZNVB2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166121,
  },
  {
    mmsi: 994166040,
    lng: 120.182585,
    lat: 23.94702,
    lastdyn: 1719859514,
    type: 30,
    shiptype: 'navigation',
    name: 'XD BUOY 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166040,
  },
  {
    mmsi: 994161011,
    lng: 120.234202,
    lat: 23.959077,
    lastdyn: 1719859431,
    type: 3,
    shiptype: 'navigation',
    name: 'TPC121',
    length: 18,
    width: 18,
    left: 5,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161011,
  },
  {
    mmsi: 994161081,
    lng: 120.135335,
    lat: 23.848437,
    lastdyn: 1719859329,
    type: 10,
    shiptype: 'navigation',
    name: 'ATON ZNCB3 EAST CA',
    length: 1,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161081,
  },
  {
    mmsi: 994166123,
    lng: 120.202985,
    lat: 23.930052,
    lastdyn: 1719859531,
    type: 21,
    shiptype: 'navigation',
    name: 'ZNVB4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166123,
  },
  {
    mmsi: 994166060,
    lng: 120.048108,
    lat: 23.94014,
    lastdyn: 1719859375,
    type: 23,
    shiptype: 'navigation',
    name: 'WEST MARK2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166060,
  },
  {
    mmsi: 994166122,
    lng: 120.140118,
    lat: 23.85616,
    lastdyn: 1719859527,
    type: 21,
    shiptype: 'navigation',
    name: 'ZNVB3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166122,
  },
  {
    mmsi: 994161082,
    lng: 120.203122,
    lat: 23.930383,
    lastdyn: 1719859157,
    type: 10,
    shiptype: 'navigation',
    name: 'ATON ZNCB4 EAST CA',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161082,
  },
  {
    mmsi: 994161080,
    lng: 120.080943,
    lat: 23.854147,
    lastdyn: 1719858827,
    type: 23,
    shiptype: 'navigation',
    name: 'ATON ZNCB2 WEST CA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161080,
  },
  {
    mmsi: 994166118,
    lng: 120.140172,
    lat: 23.966805,
    lastdyn: 1719859506,
    type: 22,
    shiptype: 'navigation',
    name: 'CF BUOY 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166118,
  },
  {
    mmsi: 994166117,
    lng: 120.179492,
    lat: 23.997823,
    lastdyn: 1719859503,
    type: 30,
    shiptype: 'navigation',
    name: 'CF BUOY 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166117,
  },
  {
    mmsi: 994161825,
    lng: 121.620157,
    lat: 23.980353,
    lastdyn: 1719859140,
    type: 1,
    shiptype: 'navigation',
    name: 'HUALIENKANG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161825,
  },
  {
    mmsi: 999412627,
    lng: 117.903888,
    lat: 24.037555,
    lastdyn: 1719859872,
    type: 2,
    shiptype: 'navigation',
    name: 'JIANG JUN TOU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999412627,
  },
  {
    mmsi: 994131501,
    lng: 118.120498,
    lat: 24.20639,
    lastdyn: 1719859872,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHANG ZHOU LNG 9 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131501,
  },
  {
    mmsi: 999412699,
    lng: 118.231055,
    lat: 24.229337,
    lastdyn: 1719825850,
    type: 27,
    shiptype: 'navigation',
    name: 'Y1 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412699,
  },
  {
    mmsi: 998519486,
    lng: 118.017467,
    lat: 24.208308,
    lastdyn: 1682216216,
    type: 0,
    shiptype: 'navigation',
    name: '8178 100',
    length: 10,
    width: 6,
    left: 3,
    trail: 4,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 998519486,
  },
  {
    mmsi: 999412644,
    lng: 118.27319,
    lat: 24.22403,
    lastdyn: 1719859893,
    type: 24,
    shiptype: 'navigation',
    name: '4 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412644,
  },
  {
    mmsi: 994126402,
    lng: 118.771333,
    lat: 24.186667,
    lastdyn: 1719859868,
    type: 28,
    shiptype: 'navigation',
    name: 'HX819 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126402,
  },
  {
    mmsi: 994166139,
    lng: 119.670105,
    lat: 24.028127,
    lastdyn: 1719859591,
    type: 12,
    shiptype: 'navigation',
    name: 'W1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166139,
  },
  {
    mmsi: 994166142,
    lng: 119.7227,
    lat: 24.04741,
    lastdyn: 1719859615,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166142,
  },
  {
    mmsi: 994166136,
    lng: 119.678098,
    lat: 24.047032,
    lastdyn: 1719859566,
    type: 9,
    shiptype: 'navigation',
    name: 'N1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166136,
  },
  {
    mmsi: 994166141,
    lng: 119.716763,
    lat: 24.007303,
    lastdyn: 1719859606,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166141,
  },
  {
    mmsi: 994166017,
    lng: 119.86352,
    lat: 24.161622,
    lastdyn: 1719859579,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW02 Z01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166017,
  },
  {
    mmsi: 994166013,
    lng: 119.830492,
    lat: 24.142763,
    lastdyn: 1719859629,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW02 S',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166013,
  },
  {
    mmsi: 994166003,
    lng: 119.982352,
    lat: 24.115063,
    lastdyn: 1719859584,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW01 SE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166003,
  },
  {
    mmsi: 994166001,
    lng: 119.906057,
    lat: 24.192705,
    lastdyn: 1719859569,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW01 NW',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166001,
  },
  {
    mmsi: 994166133,
    lng: 119.91048,
    lat: 24.014265,
    lastdyn: 1719859542,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166133,
  },
  {
    mmsi: 994166004,
    lng: 119.85619,
    lat: 24.119105,
    lastdyn: 1719859594,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW01 SW',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166004,
  },
  {
    mmsi: 994166018,
    lng: 119.810442,
    lat: 24.158235,
    lastdyn: 1719859588,
    type: 3,
    shiptype: 'navigation',
    name: 'CH2E10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166018,
  },
  {
    mmsi: 994166012,
    lng: 119.870885,
    lat: 24.140803,
    lastdyn: 1719859618,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW02 SE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166012,
  },
  {
    mmsi: 994166014,
    lng: 119.756473,
    lat: 24.193955,
    lastdyn: 1719859638,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW02 W',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166014,
  },
  {
    mmsi: 994166020,
    lng: 119.759852,
    lat: 24.198848,
    lastdyn: 1719859602,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW02 NW',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166020,
  },
  {
    mmsi: 994166009,
    lng: 119.873552,
    lat: 24.127607,
    lastdyn: 1719859555,
    type: 3,
    shiptype: 'navigation',
    name: 'CH1C25',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166009,
  },
  {
    mmsi: 994166011,
    lng: 119.911377,
    lat: 24.183423,
    lastdyn: 1719859573,
    type: 3,
    shiptype: 'navigation',
    name: 'CH1A25',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166011,
  },
  {
    mmsi: 994166010,
    lng: 119.888362,
    lat: 24.149467,
    lastdyn: 1719859565,
    type: 3,
    shiptype: 'navigation',
    name: 'CH1B25',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166010,
  },
  {
    mmsi: 994166015,
    lng: 119.869405,
    lat: 24.155753,
    lastdyn: 1719859470,
    type: 3,
    shiptype: 'navigation',
    name: 'CH2E01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166015,
  },
  {
    mmsi: 994166144,
    lng: 119.811907,
    lat: 24.048128,
    lastdyn: 1719859632,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166144,
  },
  {
    mmsi: 994166016,
    lng: 119.888803,
    lat: 24.184382,
    lastdyn: 1719859569,
    type: 3,
    shiptype: 'navigation',
    name: 'CH2D01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166016,
  },
  {
    mmsi: 994166131,
    lng: 119.937348,
    lat: 24.04905,
    lastdyn: 1719859526,
    type: 9,
    shiptype: 'navigation',
    name: 'N3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166131,
  },
  {
    mmsi: 994166143,
    lng: 119.767303,
    lat: 24.047777,
    lastdyn: 1719859622,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166143,
  },
  {
    mmsi: 994166137,
    lng: 119.856512,
    lat: 24.048468,
    lastdyn: 1719859574,
    type: 9,
    shiptype: 'navigation',
    name: 'N2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166137,
  },
  {
    mmsi: 994166019,
    lng: 119.765122,
    lat: 24.189575,
    lastdyn: 1719859601,
    type: 3,
    shiptype: 'navigation',
    name: 'CH2D26',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166019,
  },
  {
    mmsi: 994166005,
    lng: 119.991863,
    lat: 24.12869,
    lastdyn: 1719859605,
    type: 3,
    shiptype: 'navigation',
    name: 'CH1C01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166005,
  },
  {
    mmsi: 994166135,
    lng: 119.893652,
    lat: 24.048742,
    lastdyn: 1719859544,
    type: 30,
    shiptype: 'navigation',
    name: 'SM 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166135,
  },
  {
    mmsi: 994292166,
    lng: 119.887923,
    lat: 24.005793,
    lastdyn: 1719700061,
    type: 3,
    shiptype: 'navigation',
    name: 'H20T11 OSS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994292166,
  },
  {
    mmsi: 994166021,
    lng: 119.787783,
    lat: 24.173907,
    lastdyn: 1719859610,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW02 SW',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166021,
  },
  {
    mmsi: 994161094,
    lng: 119.887893,
    lat: 24.005753,
    lastdyn: 1719859622,
    type: 3,
    shiptype: 'navigation',
    name: 'HL20T11 OSS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161094,
  },
  {
    mmsi: 994161068,
    lng: 120.144383,
    lat: 24.037387,
    lastdyn: 1719859550,
    type: 30,
    shiptype: 'navigation',
    name: 'BUOY2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161068,
  },
  {
    mmsi: 994166051,
    lng: 120.16392,
    lat: 24.233617,
    lastdyn: 1719859382,
    type: 29,
    shiptype: 'navigation',
    name: 'SAFE WATER1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166051,
  },
  {
    mmsi: 994166006,
    lng: 120.008992,
    lat: 24.150825,
    lastdyn: 1719859615,
    type: 3,
    shiptype: 'navigation',
    name: 'CH1B01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166006,
  },
  {
    mmsi: 994166008,
    lng: 120.003048,
    lat: 24.156153,
    lastdyn: 1719859635,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW01 Z01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166008,
  },
  {
    mmsi: 994166116,
    lng: 120.192083,
    lat: 24.038323,
    lastdyn: 1719859503,
    type: 20,
    shiptype: 'navigation',
    name: 'CF BUOY 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166116,
  },
  {
    mmsi: 994166022,
    lng: 120.117213,
    lat: 24.037302,
    lastdyn: 1719859501,
    type: 30,
    shiptype: 'navigation',
    name: 'CF BUOY 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166022,
  },
  {
    mmsi: 994166053,
    lng: 120.111398,
    lat: 24.165765,
    lastdyn: 1719859015,
    type: 30,
    shiptype: 'navigation',
    name: 'SPECIAL MARK1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166053,
  },
  {
    mmsi: 994166007,
    lng: 120.030278,
    lat: 24.178318,
    lastdyn: 1719859534,
    type: 3,
    shiptype: 'navigation',
    name: 'CH1A01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166007,
  },
  {
    mmsi: 994166023,
    lng: 120.09038,
    lat: 24.002658,
    lastdyn: 1719859510,
    type: 30,
    shiptype: 'navigation',
    name: 'CF BUOY 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166023,
  },
  {
    mmsi: 994166054,
    lng: 120.060847,
    lat: 24.100745,
    lastdyn: 1719859022,
    type: 30,
    shiptype: 'navigation',
    name: 'SPECIAL MARK2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166054,
  },
  {
    mmsi: 994166056,
    lng: 120.009168,
    lat: 24.03409,
    lastdyn: 1719859375,
    type: 30,
    shiptype: 'navigation',
    name: 'SPECIAL MARK4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166056,
  },
  {
    mmsi: 994166038,
    lng: 120.15374,
    lat: 24.039237,
    lastdyn: 1719859501,
    type: 30,
    shiptype: 'navigation',
    name: 'CF BUOY 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166038,
  },
  {
    mmsi: 994166002,
    lng: 120.038063,
    lat: 24.187037,
    lastdyn: 1719859576,
    type: 3,
    shiptype: 'navigation',
    name: 'CHW01 NE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166002,
  },
  {
    mmsi: 994166127,
    lng: 120.531348,
    lat: 24.271417,
    lastdyn: 1719859157,
    type: 19,
    shiptype: 'navigation',
    name: 'FLS 30',
    length: 5,
    width: 3,
    left: 2,
    trail: 4,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166127,
  },
  {
    mmsi: 994161010,
    lng: 120.260327,
    lat: 24.001405,
    lastdyn: 1719859341,
    type: 3,
    shiptype: 'navigation',
    name: 'TPC116',
    length: 18,
    width: 18,
    left: 17,
    trail: 12,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161010,
  },
  {
    mmsi: 994166037,
    lng: 120.41358,
    lat: 24.239687,
    lastdyn: 1719859558,
    type: 0,
    shiptype: 'navigation',
    name: 'CWBTCBUOY 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166037,
  },
  {
    mmsi: 994167005,
    lng: 120.323333,
    lat: 24.093333,
    lastdyn: 1719859373,
    type: 4,
    shiptype: 'navigation',
    name: 'LUCKY',
    length: 140,
    width: 83,
    left: 63,
    trail: 20,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994167005,
  },
  {
    mmsi: 999412646,
    lng: 117.97491,
    lat: 24.404378,
    lastdyn: 1719859896,
    type: 25,
    shiptype: 'navigation',
    name: 'M3 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412646,
  },
  {
    mmsi: 999412647,
    lng: 117.960593,
    lat: 24.400607,
    lastdyn: 1719859867,
    type: 24,
    shiptype: 'navigation',
    name: 'M4 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412647,
  },
  {
    mmsi: 994126419,
    lng: 117.997805,
    lat: 24.446862,
    lastdyn: 1719859663,
    type: 25,
    shiptype: 'navigation',
    name: '609',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126419,
  },
  {
    mmsi: 994136350,
    lng: 118.192388,
    lat: 24.459695,
    lastdyn: 1719859673,
    type: 30,
    shiptype: 'navigation',
    name: 'WCYBHQ 2 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136350,
  },
  {
    mmsi: 999412607,
    lng: 118.181087,
    lat: 24.254298,
    lastdyn: 1719859865,
    type: 26,
    shiptype: 'navigation',
    name: 'Y6 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412607,
  },
  {
    mmsi: 994136349,
    lng: 118.150722,
    lat: 24.409583,
    lastdyn: 1719859669,
    type: 30,
    shiptype: 'navigation',
    name: 'WCYBHQ 1 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136349,
  },
  {
    mmsi: 999413285,
    lng: 118.061388,
    lat: 24.481945,
    lastdyn: 1719859645,
    type: 25,
    shiptype: 'navigation',
    name: '41A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413285,
  },
  {
    mmsi: 999413286,
    lng: 118.066945,
    lat: 24.489445,
    lastdyn: 1719859649,
    type: 25,
    shiptype: 'navigation',
    name: '41B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413286,
  },
  {
    mmsi: 999990571,
    lng: 118.076943,
    lat: 24.484542,
    lastdyn: 1719859867,
    type: 0,
    shiptype: 'navigation',
    name: 'K',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990571,
  },
  {
    mmsi: 999412602,
    lng: 118.05293,
    lat: 24.43679,
    lastdyn: 1719859867,
    type: 25,
    shiptype: 'navigation',
    name: '29 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412602,
  },
  {
    mmsi: 994136384,
    lng: 118.023028,
    lat: 24.440695,
    lastdyn: 1719859654,
    type: 25,
    shiptype: 'navigation',
    name: '605',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136384,
  },
  {
    mmsi: 994126352,
    lng: 118.049862,
    lat: 24.416278,
    lastdyn: 1719859666,
    type: 24,
    shiptype: 'navigation',
    name: '406 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126352,
  },
  {
    mmsi: 999412648,
    lng: 118.215215,
    lat: 24.298452,
    lastdyn: 1719859511,
    type: 25,
    shiptype: 'navigation',
    name: '201 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412648,
  },
  {
    mmsi: 999412649,
    lng: 118.183513,
    lat: 24.430237,
    lastdyn: 1719859866,
    type: 27,
    shiptype: 'navigation',
    name: '209 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412649,
  },
  {
    mmsi: 994136352,
    lng: 118.191888,
    lat: 24.445945,
    lastdyn: 1719859675,
    type: 30,
    shiptype: 'navigation',
    name: 'WCYBHQ 3 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136352,
  },
  {
    mmsi: 999412601,
    lng: 118.194628,
    lat: 24.321353,
    lastdyn: 1719859873,
    type: 25,
    shiptype: 'navigation',
    name: '11 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412601,
  },
  {
    mmsi: 999412606,
    lng: 118.13832,
    lat: 24.37001,
    lastdyn: 1719859689,
    type: 14,
    shiptype: 'navigation',
    name: '15 HAO DENGFU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 114,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412606,
  },
  {
    mmsi: 999412603,
    lng: 118.05828,
    lat: 24.482143,
    lastdyn: 1719859884,
    type: 24,
    shiptype: 'navigation',
    name: '42 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412603,
  },
  {
    mmsi: 999999013,
    lng: 118.001075,
    lat: 24.42926,
    lastdyn: 1719859890,
    type: 31,
    shiptype: 'navigation',
    name: 'CESHI',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999013,
  },
  {
    mmsi: 991100122,
    lng: 120.4498,
    lat: 36.0994,
    lastdyn: 1715883789,
    type: 0,
    shiptype: 'navigation',
    name: 'SDJH001',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 991100122,
  },
  {
    mmsi: 994161090,
    lng: 118.287648,
    lat: 24.451197,
    lastdyn: 1719859743,
    type: 13,
    shiptype: 'navigation',
    name: 'KM4',
    length: 40,
    width: 40,
    left: 20,
    trail: 20,
    offsetstatus: 1,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161090,
  },
  {
    mmsi: 994166125,
    lng: 118.284043,
    lat: 24.449842,
    lastdyn: 1719859860,
    type: 14,
    shiptype: 'navigation',
    name: 'KMP45',
    length: 1,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166125,
  },
  {
    mmsi: 994169173,
    lng: 118.412908,
    lat: 24.378528,
    lastdyn: 1719832475,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC173 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169173,
  },
  {
    mmsi: 994161809,
    lng: 118.287003,
    lat: 24.415442,
    lastdyn: 1719859905,
    type: 1,
    shiptype: 'navigation',
    name: 'SHUITOUGANG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161809,
  },
  {
    mmsi: 994161088,
    lng: 118.28806,
    lat: 24.449667,
    lastdyn: 1719859758,
    type: 13,
    shiptype: 'navigation',
    name: 'KM2',
    length: 40,
    width: 40,
    left: 20,
    trail: 20,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161088,
  },
  {
    mmsi: 994161087,
    lng: 118.284585,
    lat: 24.449058,
    lastdyn: 1719859873,
    type: 14,
    shiptype: 'navigation',
    name: 'KM1',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161087,
  },
  {
    mmsi: 994161839,
    lng: 118.409443,
    lat: 24.460465,
    lastdyn: 1719859911,
    type: 1,
    shiptype: 'navigation',
    name: 'TAIWUSHAN',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161839,
  },
  {
    mmsi: 994166126,
    lng: 118.28784,
    lat: 24.450428,
    lastdyn: 1719859859,
    type: 13,
    shiptype: 'navigation',
    name: 'KMP47',
    length: 1,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166126,
  },
  {
    mmsi: 994161089,
    lng: 118.28434,
    lat: 24.450648,
    lastdyn: 1719859875,
    type: 14,
    shiptype: 'navigation',
    name: 'KM3',
    length: 40,
    width: 40,
    left: 20,
    trail: 20,
    offsetstatus: 1,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161089,
  },
  {
    mmsi: 994161091,
    lng: 118.285963,
    lat: 24.44999,
    lastdyn: 1719859714,
    type: 19,
    shiptype: 'navigation',
    name: 'KMP46',
    length: 1,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161091,
  },
  {
    mmsi: 994136365,
    lng: 118.527667,
    lat: 24.4295,
    lastdyn: 1719859862,
    type: 28,
    shiptype: 'navigation',
    name: 'BDD OBSTRUCTION',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136365,
  },
  {
    mmsi: 999412666,
    lng: 118.545885,
    lat: 24.493713,
    lastdyn: 1719855195,
    type: 25,
    shiptype: 'navigation',
    name: 'WEI TOU WAN 3',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412666,
  },
  {
    mmsi: 994136549,
    lng: 118.531967,
    lat: 24.36095,
    lastdyn: 1719859829,
    type: 28,
    shiptype: 'navigation',
    name: 'MIN GUANG 188 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136549,
  },
  {
    mmsi: 994161810,
    lng: 118.504488,
    lat: 24.427477,
    lastdyn: 1719859883,
    type: 1,
    shiptype: 'navigation',
    name: 'BEIDING',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161810,
  },
  {
    mmsi: 994166057,
    lng: 120.091,
    lat: 24.256,
    lastdyn: 1719859390,
    type: 21,
    shiptype: 'navigation',
    name: 'EAST MARK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994166057,
  },
  {
    mmsi: 994161086,
    lng: 120.06046,
    lat: 24.409802,
    lastdyn: 1719859148,
    type: 30,
    shiptype: 'navigation',
    name: 'FENGMIAO',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161086,
  },
  {
    mmsi: 994161113,
    lng: 120.527158,
    lat: 24.269833,
    lastdyn: 1719859176,
    type: 30,
    shiptype: 'navigation',
    name: 'OHFLIDAR',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161113,
  },
  {
    mmsi: 994161118,
    lng: 121.809188,
    lat: 25.143907,
    lastdyn: 1719859558,
    type: 0,
    shiptype: 'navigation',
    name: 'NAMRCJBUOY 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161118,
  },
  {
    mmsi: 994161114,
    lng: 120.527368,
    lat: 24.270003,
    lastdyn: 1719859161,
    type: 30,
    shiptype: 'navigation',
    name: 'OHBUOY',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161114,
  },
  {
    mmsi: 999991608,
    lng: 118.210328,
    lat: 24.518642,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 1608',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991608,
  },
  {
    mmsi: 994131509,
    lng: 118.220957,
    lat: 24.51357,
    lastdyn: 1719859904,
    type: 25,
    shiptype: 'navigation',
    name: '219 HAO DENG FU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131509,
  },
  {
    mmsi: 999413902,
    lng: 118.083332,
    lat: 24.5,
    lastdyn: 1719859884,
    type: 30,
    shiptype: 'navigation',
    name: 'VIRTUAL ATON 902',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413902,
  },
  {
    mmsi: 999412625,
    lng: 118.201897,
    lat: 24.530907,
    lastdyn: 1719859909,
    type: 24,
    shiptype: 'navigation',
    name: 'JT 22 HAO DENG FU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412625,
  },
  {
    mmsi: 999412619,
    lng: 118.23318,
    lat: 24.515385,
    lastdyn: 1719859855,
    type: 25,
    shiptype: 'navigation',
    name: 'JT 15 HAO DENG FU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412619,
  },
  {
    mmsi: 999413901,
    lng: 118.08,
    lat: 24.5,
    lastdyn: 1719859884,
    type: 30,
    shiptype: 'navigation',
    name: 'VIRTUAL ATON 901',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413901,
  },
  {
    mmsi: 994136449,
    lng: 118.4945,
    lat: 24.545233,
    lastdyn: 1719859853,
    type: 28,
    shiptype: 'navigation',
    name: 'CHOU S G OBSTRUCTION',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136449,
  },
  {
    mmsi: 999880004,
    lng: 118.459157,
    lat: 24.539412,
    lastdyn: 1719859866,
    type: 27,
    shiptype: 'navigation',
    name: 'JH5A',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999880004,
  },
  {
    mmsi: 994126319,
    lng: 118.475805,
    lat: 24.548888,
    lastdyn: 1719859871,
    type: 25,
    shiptype: 'navigation',
    name: 'QUAN JIN 15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126319,
  },
  {
    mmsi: 994136593,
    lng: 118.4925,
    lat: 24.5245,
    lastdyn: 1719859841,
    type: 28,
    shiptype: 'navigation',
    name: 'XI SHA GUAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136593,
  },
  {
    mmsi: 999412608,
    lng: 118.435798,
    lat: 24.602082,
    lastdyn: 1719859871,
    type: 24,
    shiptype: 'navigation',
    name: 'WEI TOU WAN 18',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412608,
  },
  {
    mmsi: 999412609,
    lng: 118.486237,
    lat: 24.56071,
    lastdyn: 1719859866,
    type: 24,
    shiptype: 'navigation',
    name: 'WEI TOU WAN 12 HAO',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412609,
  },
  {
    mmsi: 999412664,
    lng: 118.54564,
    lat: 24.528478,
    lastdyn: 1719859872,
    type: 30,
    shiptype: 'navigation',
    name: 'JINJIN GONGSHUI 4',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412664,
  },
  {
    mmsi: 999412663,
    lng: 118.515035,
    lat: 24.502815,
    lastdyn: 1719859871,
    type: 19,
    shiptype: 'navigation',
    name: 'JINJIN GONGSHUI 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412663,
  },
  {
    mmsi: 999412628,
    lng: 118.762357,
    lat: 24.698988,
    lastdyn: 1719859911,
    type: 24,
    shiptype: 'navigation',
    name: 'HONG DIAN 1 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412628,
  },
  {
    mmsi: 994161819,
    lng: 120.859215,
    lat: 24.699967,
    lastdyn: 1719849977,
    type: 1,
    shiptype: 'navigation',
    name: 'LONGFENG',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161819,
  },
  {
    mmsi: 994161851,
    lng: 120.82488,
    lat: 24.730428,
    lastdyn: 1719858980,
    type: 3,
    shiptype: 'navigation',
    name: 'FOWIWTGA03',
    length: 18,
    width: 18,
    left: 9,
    trail: 9,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161851,
  },
  {
    mmsi: 994161852,
    lng: 120.789458,
    lat: 24.698553,
    lastdyn: 1719859181,
    type: 3,
    shiptype: 'navigation',
    name: 'FOWIWTGC32',
    length: 18,
    width: 18,
    left: 9,
    trail: 9,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161852,
  },
  {
    mmsi: 994161854,
    lng: 120.806708,
    lat: 24.690955,
    lastdyn: 1719859166,
    type: 3,
    shiptype: 'navigation',
    name: 'FOWIWTGD28',
    length: 18,
    width: 18,
    left: 9,
    trail: 9,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161854,
  },
  {
    mmsi: 994161828,
    lng: 120.771778,
    lat: 24.65107,
    lastdyn: 1719852657,
    type: 1,
    shiptype: 'navigation',
    name: 'WAIPU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161828,
  },
  {
    mmsi: 994161853,
    lng: 120.817117,
    lat: 24.693312,
    lastdyn: 1719857550,
    type: 3,
    shiptype: 'navigation',
    name: 'FOWIWTGD21',
    length: 18,
    width: 18,
    left: 9,
    trail: 9,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161853,
  },
  {
    mmsi: 994161823,
    lng: 121.882245,
    lat: 24.600405,
    lastdyn: 1719859546,
    type: 1,
    shiptype: 'navigation',
    name: 'SUAO',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161823,
  },
  {
    mmsi: 999412610,
    lng: 118.69253,
    lat: 24.863012,
    lastdyn: 1719859871,
    type: 23,
    shiptype: 'navigation',
    name: 'QUAN ZHOU WAN 21 HAO',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412610,
  },
  {
    mmsi: 999412612,
    lng: 118.71272,
    lat: 24.826028,
    lastdyn: 1719187550,
    type: 25,
    shiptype: 'navigation',
    name: 'QUAN ZHOU WAN 13 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412612,
  },
  {
    mmsi: 999413258,
    lng: 118.763472,
    lat: 24.8095,
    lastdyn: 1719859575,
    type: 17,
    shiptype: 'navigation',
    name: 'GANG XIN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413258,
  },
  {
    mmsi: 994136534,
    lng: 118.990833,
    lat: 24.861833,
    lastdyn: 1719780382,
    type: 28,
    shiptype: 'navigation',
    name: 'XIN BAO HANG 87 WREC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136534,
  },
  {
    mmsi: 999412652,
    lng: 118.82871,
    lat: 24.824135,
    lastdyn: 1719859873,
    type: 30,
    shiptype: 'navigation',
    name: 'WEI SHUI GUANG 1 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412652,
  },
  {
    mmsi: 999412611,
    lng: 118.819642,
    lat: 24.775573,
    lastdyn: 1719859811,
    type: 29,
    shiptype: 'navigation',
    name: 'QUAN ZHOU WAN KOU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412611,
  },
  {
    mmsi: 999412613,
    lng: 118.771287,
    lat: 24.810152,
    lastdyn: 1719859892,
    type: 25,
    shiptype: 'navigation',
    name: 'QUAN ZHOU WAN 5 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412613,
  },
  {
    mmsi: 999412620,
    lng: 119.006152,
    lat: 24.87662,
    lastdyn: 1719859916,
    type: 30,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN Q2 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412620,
  },
  {
    mmsi: 999412621,
    lng: 119.040915,
    lat: 24.918273,
    lastdyn: 1719859898,
    type: 24,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 2 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412621,
  },
  {
    mmsi: 999412622,
    lng: 119.050885,
    lat: 24.935048,
    lastdyn: 1719859340,
    type: 24,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 4 HAO',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412622,
  },
  {
    mmsi: 999413236,
    lng: 119.182817,
    lat: 24.839,
    lastdyn: 1719859914,
    type: 28,
    shiptype: 'navigation',
    name: 'NAN TAI 17 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413236,
  },
  {
    mmsi: 999412614,
    lng: 119.07008,
    lat: 24.954595,
    lastdyn: 1719859328,
    type: 25,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412614,
  },
  {
    mmsi: 999992204,
    lng: 119.23568,
    lat: 24.840825,
    lastdyn: 1719828366,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2204',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992204,
  },
  {
    mmsi: 999412623,
    lng: 119.06196,
    lat: 24.961272,
    lastdyn: 1719859501,
    type: 24,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412623,
  },
  {
    mmsi: 994161838,
    lng: 119.451448,
    lat: 24.992042,
    lastdyn: 1719859860,
    type: 1,
    shiptype: 'navigation',
    name: 'WUQIU CGA',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161838,
  },
  {
    mmsi: 999413213,
    lng: 119.540305,
    lat: 24.913603,
    lastdyn: 1719859910,
    type: 28,
    shiptype: 'navigation',
    name: 'WU QIU YU DONG NAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413213,
  },
  {
    mmsi: 994166115,
    lng: 120.680822,
    lat: 24.966795,
    lastdyn: 1719858829,
    type: 19,
    shiptype: 'navigation',
    name: 'AKROCEAN HSINCHU FLD',
    length: 5,
    width: 3,
    left: 2,
    trail: 4,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994166115,
  },
  {
    mmsi: 994160007,
    lng: 120.2,
    lat: 23.033333,
    lastdyn: 1660534412,
    type: 2,
    shiptype: 'navigation',
    name: 'KERKER2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 28,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994160007,
  },
  {
    mmsi: 999412604,
    lng: 118.969782,
    lat: 25.231165,
    lastdyn: 1719859866,
    type: 30,
    shiptype: 'navigation',
    name: 'LNG 2 HAO DENG FU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412604,
  },
  {
    mmsi: 999412605,
    lng: 118.94702,
    lat: 25.232278,
    lastdyn: 1719859818,
    type: 30,
    shiptype: 'navigation',
    name: 'LNG 3 HAO DENG FU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412605,
  },
  {
    mmsi: 999412651,
    lng: 119.053623,
    lat: 25.028802,
    lastdyn: 1719858969,
    type: 11,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 11',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412651,
  },
  {
    mmsi: 999412617,
    lng: 119.00917,
    lat: 25.19026,
    lastdyn: 1719859753,
    type: 25,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 33 HAO',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412617,
  },
  {
    mmsi: 999412658,
    lng: 119.000798,
    lat: 25.1343,
    lastdyn: 1719859867,
    type: 29,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 26 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412658,
  },
  {
    mmsi: 999412624,
    lng: 119.046662,
    lat: 25.029423,
    lastdyn: 1719859340,
    type: 24,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 12 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412624,
  },
  {
    mmsi: 999412615,
    lng: 119.041973,
    lat: 25.046122,
    lastdyn: 1719859325,
    type: 24,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 14',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 114,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412615,
  },
  {
    mmsi: 999412444,
    lng: 119.24735,
    lat: 25.07596,
    lastdyn: 1719859872,
    type: 30,
    shiptype: 'navigation',
    name: 'DONGWUPAI2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412444,
  },
  {
    mmsi: 999412443,
    lng: 119.24375,
    lat: 25.0798,
    lastdyn: 1719859707,
    type: 30,
    shiptype: 'navigation',
    name: 'DONGWUPAI1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412443,
  },
  {
    mmsi: 999412657,
    lng: 119.0088,
    lat: 25.075642,
    lastdyn: 1719859864,
    type: 26,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 18 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412657,
  },
  {
    mmsi: 999412659,
    lng: 119.009675,
    lat: 25.150443,
    lastdyn: 1719859864,
    type: 30,
    shiptype: 'navigation',
    name: 'GUO PAI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412659,
  },
  {
    mmsi: 999412616,
    lng: 119.008067,
    lat: 25.081617,
    lastdyn: 1719859706,
    type: 24,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 18A',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412616,
  },
  {
    mmsi: 999412654,
    lng: 119.050028,
    lat: 25.108395,
    lastdyn: 1719859865,
    type: 24,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 316',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412654,
  },
  {
    mmsi: 999413407,
    lng: 119.45994,
    lat: 25.159582,
    lastdyn: 1719826572,
    type: 0,
    shiptype: 'navigation',
    name: 'PING DIAN 404',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413407,
  },
  {
    mmsi: 994131425,
    lng: 119.380777,
    lat: 25.069253,
    lastdyn: 1719856449,
    type: 30,
    shiptype: 'navigation',
    name: 'PINGDIAN 15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131425,
  },
  {
    mmsi: 994131429,
    lng: 119.31533,
    lat: 25.097647,
    lastdyn: 1719857174,
    type: 30,
    shiptype: 'navigation',
    name: 'PINGDIAN 19',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131429,
  },
  {
    mmsi: 999412440,
    lng: 119.458252,
    lat: 25.182748,
    lastdyn: 1719829631,
    type: 0,
    shiptype: 'navigation',
    name: 'PING DIAN 407',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412440,
  },
  {
    mmsi: 999413408,
    lng: 119.449973,
    lat: 25.165075,
    lastdyn: 1719853389,
    type: 0,
    shiptype: 'navigation',
    name: 'PING DIAN 405',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413408,
  },
  {
    mmsi: 994132403,
    lng: 119.303568,
    lat: 25.129878,
    lastdyn: 1719859863,
    type: 30,
    shiptype: 'navigation',
    name: 'ZMFD DF 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132403,
  },
  {
    mmsi: 994132406,
    lng: 119.298582,
    lat: 25.11937,
    lastdyn: 1719859689,
    type: 30,
    shiptype: 'navigation',
    name: 'ZMFD DZ 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132406,
  },
  {
    mmsi: 999413404,
    lng: 119.493507,
    lat: 25.141363,
    lastdyn: 1719827474,
    type: 30,
    shiptype: 'navigation',
    name: 'PINGDIAN 401',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999413404,
  },
  {
    mmsi: 994131426,
    lng: 119.363075,
    lat: 25.07179,
    lastdyn: 1719857356,
    type: 30,
    shiptype: 'navigation',
    name: 'PING DIAN 16',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131426,
  },
  {
    mmsi: 994131427,
    lng: 119.263518,
    lat: 25.178373,
    lastdyn: 1719859863,
    type: 30,
    shiptype: 'navigation',
    name: 'PINGDIAN 17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131427,
  },
  {
    mmsi: 994131428,
    lng: 119.329057,
    lat: 25.085195,
    lastdyn: 1719857174,
    type: 30,
    shiptype: 'navigation',
    name: 'PINGDIAN 18',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131428,
  },
  {
    mmsi: 999412442,
    lng: 119.476913,
    lat: 25.163675,
    lastdyn: 1719859687,
    type: 0,
    shiptype: 'navigation',
    name: 'PING DIAN 409',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412442,
  },
  {
    mmsi: 999412441,
    lng: 119.482518,
    lat: 25.170658,
    lastdyn: 1719859507,
    type: 0,
    shiptype: 'navigation',
    name: 'PING DIAN 408',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412441,
  },
  {
    mmsi: 994131484,
    lng: 119.539147,
    lat: 25.214588,
    lastdyn: 1719859327,
    type: 0,
    shiptype: 'navigation',
    name: 'LYFD101',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131484,
  },
  {
    mmsi: 994161908,
    lng: 121.295337,
    lat: 25.126943,
    lastdyn: 1719859512,
    type: 30,
    shiptype: 'navigation',
    name: 'LINKOU BUOY NO8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161908,
  },
  {
    mmsi: 994161901,
    lng: 121.281272,
    lat: 25.138472,
    lastdyn: 1719859507,
    type: 24,
    shiptype: 'navigation',
    name: 'LINKOU BUOY NO1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161901,
  },
  {
    mmsi: 994161906,
    lng: 121.288788,
    lat: 25.129457,
    lastdyn: 1719859515,
    type: 30,
    shiptype: 'navigation',
    name: 'LINKOU BUOY NO6',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161906,
  },
  {
    mmsi: 999416001,
    lng: 121.466772,
    lat: 32.916683,
    lastdyn: 1668211590,
    type: 24,
    shiptype: 'navigation',
    name: 'TEST 001',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999416001,
  },
  {
    mmsi: 994160223,
    lng: -105.106372,
    lat: 97.19224,
    lastdyn: 1695585381,
    type: 0,
    shiptype: 'navigation',
    name: '',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994160223,
  },
  {
    mmsi: 994161905,
    lng: 121.281152,
    lat: 25.130305,
    lastdyn: 1719859511,
    type: 30,
    shiptype: 'navigation',
    name: 'LINKOU BUOY NO5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161905,
  },
  {
    mmsi: 994161821,
    lng: 121.408607,
    lat: 25.184577,
    lastdyn: 1719812532,
    type: 1,
    shiptype: 'navigation',
    name: 'DANSHUI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161821,
  },
  {
    mmsi: 994161907,
    lng: 121.29132,
    lat: 25.126987,
    lastdyn: 1719859511,
    type: 30,
    shiptype: 'navigation',
    name: 'LINKOU BUOY NO7',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161907,
  },
  {
    mmsi: 994161909,
    lng: 121.2989,
    lat: 25.130198,
    lastdyn: 1719859505,
    type: 30,
    shiptype: 'navigation',
    name: 'LINKOU BUOY NO9',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161909,
  },
  {
    mmsi: 994161822,
    lng: 121.697525,
    lat: 25.213752,
    lastdyn: 1719859500,
    type: 5,
    shiptype: 'navigation',
    name: 'YELIU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161822,
  },
  {
    mmsi: 999412576,
    lng: 119.353065,
    lat: 25.403893,
    lastdyn: 1719858791,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412576,
  },
  {
    mmsi: 994131436,
    lng: 119.403487,
    lat: 25.404083,
    lastdyn: 1719859865,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131436,
  },
  {
    mmsi: 994131412,
    lng: 119.350787,
    lat: 25.299003,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'SHI DIAN 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131412,
  },
  {
    mmsi: 999412540,
    lng: 119.397978,
    lat: 25.28981,
    lastdyn: 1719859866,
    type: 0,
    shiptype: 'navigation',
    name: 'SHI DIAN 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412540,
  },
  {
    mmsi: 994131482,
    lng: 119.472323,
    lat: 25.264055,
    lastdyn: 1719859504,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST 017',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131482,
  },
  {
    mmsi: 994131438,
    lng: 119.399837,
    lat: 25.383547,
    lastdyn: 1719859871,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131438,
  },
  {
    mmsi: 999412535,
    lng: 119.25206,
    lat: 25.42687,
    lastdyn: 1719859744,
    type: 24,
    shiptype: 'navigation',
    name: 'XINGHUA 15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412535,
  },
  {
    mmsi: 999412585,
    lng: 119.374318,
    lat: 25.436285,
    lastdyn: 1719842939,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 19',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412585,
  },
  {
    mmsi: 999412536,
    lng: 119.3753,
    lat: 25.304545,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'SHI DIAN 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412536,
  },
  {
    mmsi: 999412538,
    lng: 119.259528,
    lat: 25.428665,
    lastdyn: 1719859795,
    type: 19,
    shiptype: 'navigation',
    name: 'MINHAI MATOU 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412538,
  },
  {
    mmsi: 999412449,
    lng: 119.352877,
    lat: 25.319445,
    lastdyn: 1719855191,
    type: 30,
    shiptype: 'navigation',
    name: 'SHI DIAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412449,
  },
  {
    mmsi: 999412534,
    lng: 119.362308,
    lat: 25.312782,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: 'SHI DIAN 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412534,
  },
  {
    mmsi: 999412568,
    lng: 119.455803,
    lat: 25.369737,
    lastdyn: 1719859862,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412568,
  },
  {
    mmsi: 999412572,
    lng: 119.460935,
    lat: 25.396195,
    lastdyn: 1719859507,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412572,
  },
  {
    mmsi: 999412560,
    lng: 119.406267,
    lat: 25.415978,
    lastdyn: 1719859869,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412560,
  },
  {
    mmsi: 999412541,
    lng: 119.390272,
    lat: 25.28316,
    lastdyn: 1719859686,
    type: 0,
    shiptype: 'navigation',
    name: 'SHI DIAN 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412541,
  },
  {
    mmsi: 999412537,
    lng: 119.388202,
    lat: 25.296093,
    lastdyn: 1719859859,
    type: 30,
    shiptype: 'navigation',
    name: 'SHI DIAN 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412537,
  },
  {
    mmsi: 994131437,
    lng: 119.401303,
    lat: 25.391735,
    lastdyn: 1719859873,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131437,
  },
  {
    mmsi: 994131435,
    lng: 119.400822,
    lat: 25.428557,
    lastdyn: 1719859519,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131435,
  },
  {
    mmsi: 999412578,
    lng: 119.359893,
    lat: 25.434215,
    lastdyn: 1719859679,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 18',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412578,
  },
  {
    mmsi: 999412542,
    lng: 119.382037,
    lat: 25.279588,
    lastdyn: 1719859866,
    type: 0,
    shiptype: 'navigation',
    name: 'SHI DIAN 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412542,
  },
  {
    mmsi: 999412574,
    lng: 119.366855,
    lat: 25.397505,
    lastdyn: 1719859505,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412574,
  },
  {
    mmsi: 999412533,
    lng: 119.25818,
    lat: 25.42925,
    lastdyn: 1719859739,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONG JIANG 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412533,
  },
  {
    mmsi: 999412569,
    lng: 119.437138,
    lat: 25.385433,
    lastdyn: 1719858964,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412569,
  },
  {
    mmsi: 999412570,
    lng: 119.44635,
    lat: 25.393148,
    lastdyn: 1719859866,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412570,
  },
  {
    mmsi: 999412566,
    lng: 119.380877,
    lat: 25.39125,
    lastdyn: 1719859685,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412566,
  },
  {
    mmsi: 994131491,
    lng: 119.579842,
    lat: 25.279465,
    lastdyn: 1719859867,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST 008',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131491,
  },
  {
    mmsi: 999412581,
    lng: 119.66353,
    lat: 25.47103,
    lastdyn: 1719859257,
    type: 30,
    shiptype: 'navigation',
    name: 'K 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412581,
  },
  {
    mmsi: 999412529,
    lng: 119.68899,
    lat: 25.25999,
    lastdyn: 1719859838,
    type: 24,
    shiptype: 'navigation',
    name: 'XINGHUA 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412529,
  },
  {
    mmsi: 994136541,
    lng: 119.656945,
    lat: 25.499722,
    lastdyn: 1719859918,
    type: 28,
    shiptype: 'navigation',
    name: 'SHAN YU JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136541,
  },
  {
    mmsi: 999412532,
    lng: 119.557822,
    lat: 25.316437,
    lastdyn: 1719859758,
    type: 0,
    shiptype: 'navigation',
    name: 'BAI FU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412532,
  },
  {
    mmsi: 994131406,
    lng: 119.655562,
    lat: 25.49693,
    lastdyn: 1719859774,
    type: 24,
    shiptype: 'navigation',
    name: 'HTHX 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131406,
  },
  {
    mmsi: 999412531,
    lng: 119.634325,
    lat: 25.3188,
    lastdyn: 1719859760,
    type: 21,
    shiptype: 'navigation',
    name: 'JIAN NANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412531,
  },
  {
    mmsi: 999412530,
    lng: 119.509822,
    lat: 25.319217,
    lastdyn: 1719859773,
    type: 21,
    shiptype: 'navigation',
    name: 'XINGHUA 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412530,
  },
  {
    mmsi: 999412583,
    lng: 119.65738,
    lat: 25.48653,
    lastdyn: 1719820491,
    type: 25,
    shiptype: 'navigation',
    name: 'B1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412583,
  },
  {
    mmsi: 999412582,
    lng: 119.66869,
    lat: 25.4594,
    lastdyn: 1719838745,
    type: 23,
    shiptype: 'navigation',
    name: 'A XIU JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412582,
  },
  {
    mmsi: 994121038,
    lng: 117.948128,
    lat: 38.882547,
    lastdyn: 1719855977,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHA NO228',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121038,
  },
  {
    mmsi: 999412588,
    lng: 119.69357,
    lat: 25.39442,
    lastdyn: 1719859847,
    type: 26,
    shiptype: 'navigation',
    name: 'JIN JING 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412588,
  },
  {
    mmsi: 994126544,
    lng: 119.7418,
    lat: 25.384417,
    lastdyn: 1719859770,
    type: 28,
    shiptype: 'navigation',
    name: 'JJ 1 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126544,
  },
  {
    mmsi: 999412586,
    lng: 119.84051,
    lat: 25.418065,
    lastdyn: 1719859889,
    type: 24,
    shiptype: 'navigation',
    name: 'AO QIAN 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412586,
  },
  {
    mmsi: 994126433,
    lng: 119.719362,
    lat: 25.251667,
    lastdyn: 1719859767,
    type: 28,
    shiptype: 'navigation',
    name: 'F15 WRECKRC',
    length: 0,
    width: 50,
    left: 2,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126433,
  },
  {
    mmsi: 999412589,
    lng: 119.75178,
    lat: 25.37891,
    lastdyn: 1719859437,
    type: 27,
    shiptype: 'navigation',
    name: 'JIN JING 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412589,
  },
  {
    mmsi: 994136397,
    lng: 119.85,
    lat: 25.444967,
    lastdyn: 1719859755,
    type: 28,
    shiptype: 'navigation',
    name: 'XDY WRECK',
    length: 98,
    width: 16,
    left: 8,
    trail: 49,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136397,
  },
  {
    mmsi: 994136552,
    lng: 119.818333,
    lat: 25.444167,
    lastdyn: 1719859758,
    type: 28,
    shiptype: 'navigation',
    name: 'AO QIAN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136552,
  },
  {
    mmsi: 994136305,
    lng: 119.838,
    lat: 25.362333,
    lastdyn: 1719859776,
    type: 28,
    shiptype: 'navigation',
    name: 'HZL WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136305,
  },
  {
    mmsi: 994136396,
    lng: 119.7642,
    lat: 25.301133,
    lastdyn: 1719859773,
    type: 28,
    shiptype: 'navigation',
    name: 'JSL 168 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136396,
  },
  {
    mmsi: 994136358,
    lng: 119.698417,
    lat: 25.618222,
    lastdyn: 1719859848,
    type: 17,
    shiptype: 'navigation',
    name: 'SU AO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136358,
  },
  {
    mmsi: 994131499,
    lng: 119.74837,
    lat: 25.677887,
    lastdyn: 1719859884,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGHFD',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131499,
  },
  {
    mmsi: 994131401,
    lng: 119.674217,
    lat: 25.666802,
    lastdyn: 1719821536,
    type: 25,
    shiptype: 'navigation',
    name: 'FP 305',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131401,
  },
  {
    mmsi: 999412526,
    lng: 119.6373,
    lat: 25.70331,
    lastdyn: 1719853743,
    type: 25,
    shiptype: 'navigation',
    name: 'SONGXIA 11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412526,
  },
  {
    mmsi: 994136519,
    lng: 119.668833,
    lat: 25.628667,
    lastdyn: 1719859842,
    type: 28,
    shiptype: 'navigation',
    name: 'JC 698 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136519,
  },
  {
    mmsi: 994136348,
    lng: 119.692633,
    lat: 25.620033,
    lastdyn: 1719859833,
    type: 28,
    shiptype: 'navigation',
    name: 'WEI LONG 36 WRECK',
    length: 96,
    width: 14,
    left: 7,
    trail: 48,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136348,
  },
  {
    mmsi: 999000030,
    lng: 119.704392,
    lat: 25.61839,
    lastdyn: 1719835857,
    type: 0,
    shiptype: 'navigation',
    name: 'NO NAME',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000030,
  },
  {
    mmsi: 999412525,
    lng: 119.65373,
    lat: 25.73729,
    lastdyn: 1719859814,
    type: 28,
    shiptype: 'navigation',
    name: 'SONGXIA GU 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412525,
  },
  {
    mmsi: 994136455,
    lng: 119.6358,
    lat: 25.715083,
    lastdyn: 1719859907,
    type: 28,
    shiptype: 'navigation',
    name: 'SONGXIA WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136455,
  },
  {
    mmsi: 994126399,
    lng: 119.68326,
    lat: 25.509455,
    lastdyn: 1719859764,
    type: 28,
    shiptype: 'navigation',
    name: 'ZYKC 1 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126399,
  },
  {
    mmsi: 994136400,
    lng: 119.626667,
    lat: 25.711667,
    lastdyn: 1719859866,
    type: 28,
    shiptype: 'navigation',
    name: 'MXYY 05188 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136400,
  },
  {
    mmsi: 999412571,
    lng: 119.624835,
    lat: 25.676013,
    lastdyn: 1719859702,
    type: 5,
    shiptype: 'navigation',
    name: 'KU YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412571,
  },
  {
    mmsi: 994136466,
    lng: 119.640667,
    lat: 25.691,
    lastdyn: 1719859910,
    type: 28,
    shiptype: 'navigation',
    name: 'SH116 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136466,
  },
  {
    mmsi: 994136563,
    lng: 119.656667,
    lat: 25.589167,
    lastdyn: 1719859851,
    type: 28,
    shiptype: 'navigation',
    name: 'XHS 168 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136563,
  },
  {
    mmsi: 994131419,
    lng: 181,
    lat: 91,
    lastdyn: 1719823054,
    type: 25,
    shiptype: 'navigation',
    name: 'SONGXIA 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131419,
  },
  {
    mmsi: 999000003,
    lng: -48.494548,
    lat: -25.498098,
    lastdyn: 1685122146,
    type: 19,
    shiptype: 'navigation',
    name: 'WM3',
    length: 20,
    width: 20,
    left: 10,
    trail: 10,
    offsetstatus: 1,
    atonstatus: 229,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000003,
  },
  {
    mmsi: 999412565,
    lng: 119.66356,
    lat: 25.71433,
    lastdyn: 1719853249,
    type: 21,
    shiptype: 'navigation',
    name: 'SONGXIA102',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412565,
  },
  {
    mmsi: 994131473,
    lng: 119.89968,
    lat: 25.62115,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'CJAFD T5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131473,
  },
  {
    mmsi: 994131494,
    lng: 181,
    lat: 91,
    lastdyn: 1719858517,
    type: 3,
    shiptype: 'navigation',
    name: 'ZGHCFT 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131494,
  },
  {
    mmsi: 994141305,
    lng: 119.996098,
    lat: 25.741292,
    lastdyn: 1719859830,
    type: 30,
    shiptype: 'navigation',
    name: 'CLFD 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141305,
  },
  {
    mmsi: 994131472,
    lng: 119.87919,
    lat: 25.63201,
    lastdyn: 1719859862,
    type: 19,
    shiptype: 'navigation',
    name: 'CJAFD T4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131472,
  },
  {
    mmsi: 994132409,
    lng: 119.977503,
    lat: 25.708015,
    lastdyn: 1719859823,
    type: 30,
    shiptype: 'navigation',
    name: 'PTFD 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132409,
  },
  {
    mmsi: 994126403,
    lng: 119.870222,
    lat: 25.729388,
    lastdyn: 1719859854,
    type: 28,
    shiptype: 'navigation',
    name: 'LIANG SAN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126403,
  },
  {
    mmsi: 994161820,
    lng: 122.080488,
    lat: 25.629457,
    lastdyn: 1719859365,
    type: 6,
    shiptype: 'navigation',
    name: 'PENGJIAYU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161820,
  },
  {
    mmsi: 999412522,
    lng: 119.453395,
    lat: 25.979437,
    lastdyn: 1719859768,
    type: 17,
    shiptype: 'navigation',
    name: 'XIAOMA JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412522,
  },
  {
    mmsi: 999412521,
    lng: 119.46493,
    lat: 25.982478,
    lastdyn: 1719859888,
    type: 22,
    shiptype: 'navigation',
    name: 'YINGQIAN 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412521,
  },
  {
    mmsi: 994126536,
    lng: 119.236808,
    lat: 32.223305,
    lastdyn: 1719859892,
    type: 30,
    shiptype: 'navigation',
    name: 'SYZ3HDXXB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126536,
  },
  {
    mmsi: 994136553,
    lng: 119.658112,
    lat: 25.752612,
    lastdyn: 1719859831,
    type: 17,
    shiptype: 'navigation',
    name: 'ZHU TOU JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136553,
  },
  {
    mmsi: 994126434,
    lng: 119.69015,
    lat: 25.8725,
    lastdyn: 1719859864,
    type: 28,
    shiptype: 'navigation',
    name: 'FH 168 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126434,
  },
  {
    mmsi: 994136557,
    lng: 119.718333,
    lat: 25.990833,
    lastdyn: 1719859791,
    type: 28,
    shiptype: 'navigation',
    name: 'MJ981',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136557,
  },
  {
    mmsi: 994141313,
    lng: 119.949693,
    lat: 25.83963,
    lastdyn: 1719859872,
    type: 0,
    shiptype: 'navigation',
    name: 'CLFD 59',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141313,
  },
  {
    mmsi: 994141306,
    lng: 119.966195,
    lat: 25.756235,
    lastdyn: 1719850771,
    type: 30,
    shiptype: 'navigation',
    name: 'CLFD 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141306,
  },
  {
    mmsi: 994161808,
    lng: 119.985625,
    lat: 25.966982,
    lastdyn: 1719859907,
    type: 1,
    shiptype: 'navigation',
    name: 'TUNGCHU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161808,
  },
  {
    mmsi: 994141314,
    lng: 119.989048,
    lat: 25.861438,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: 'CLFD 61',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141314,
  },
  {
    mmsi: 994141312,
    lng: 119.953048,
    lat: 25.821537,
    lastdyn: 1719859893,
    type: 0,
    shiptype: 'navigation',
    name: 'CLFD 57',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141312,
  },
  {
    mmsi: 994141307,
    lng: 119.955885,
    lat: 25.799975,
    lastdyn: 1716014199,
    type: 30,
    shiptype: 'navigation',
    name: 'CLFD 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141307,
  },
  {
    mmsi: 994141315,
    lng: 120.048718,
    lat: 25.890477,
    lastdyn: 1719859879,
    type: 0,
    shiptype: 'navigation',
    name: 'CLFD 67',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141315,
  },
  {
    mmsi: 994141309,
    lng: 120.0221,
    lat: 25.792547,
    lastdyn: 1719859840,
    type: 30,
    shiptype: 'navigation',
    name: 'CLFD 16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141309,
  },
  {
    mmsi: 994140912,
    lng: 120.1,
    lat: 25.8,
    lastdyn: 1719859806,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140912,
  },
  {
    mmsi: 994141310,
    lng: 120.004037,
    lat: 25.755457,
    lastdyn: 1719859900,
    type: 30,
    shiptype: 'navigation',
    name: 'CLFD 20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141310,
  },
  {
    mmsi: 994141311,
    lng: 120.031133,
    lat: 25.816927,
    lastdyn: 1719859886,
    type: 0,
    shiptype: 'navigation',
    name: 'CLFD 51',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141311,
  },
  {
    mmsi: 994141308,
    lng: 120.022748,
    lat: 25.798065,
    lastdyn: 1719859421,
    type: 29,
    shiptype: 'navigation',
    name: 'CLFD 14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141308,
  },
  {
    mmsi: 994141316,
    lng: 120.04921,
    lat: 25.849475,
    lastdyn: 1719859885,
    type: 0,
    shiptype: 'navigation',
    name: 'CLFD 70',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141316,
  },
  {
    mmsi: 994131461,
    lng: 119.272172,
    lat: 26.042533,
    lastdyn: 1717456441,
    type: 7,
    shiptype: 'navigation',
    name: 'HAI XIA 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131461,
  },
  {
    mmsi: 999412520,
    lng: 119.484875,
    lat: 26.012092,
    lastdyn: 1719859885,
    type: 26,
    shiptype: 'navigation',
    name: 'NIUJIAO W',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412520,
  },
  {
    mmsi: 999412519,
    lng: 119.485437,
    lat: 26.014355,
    lastdyn: 1719859705,
    type: 26,
    shiptype: 'navigation',
    name: 'XQZ 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412519,
  },
  {
    mmsi: 999412510,
    lng: 119.65066,
    lat: 26.12635,
    lastdyn: 1719859691,
    type: 14,
    shiptype: 'navigation',
    name: 'MJK D17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412510,
  },
  {
    mmsi: 999412515,
    lng: 119.57611,
    lat: 26.12925,
    lastdyn: 1719629461,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHONGSHA 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412515,
  },
  {
    mmsi: 999412513,
    lng: 119.6211,
    lat: 26.13355,
    lastdyn: 1719803523,
    type: 24,
    shiptype: 'navigation',
    name: 'MJK D22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412513,
  },
  {
    mmsi: 999412506,
    lng: 119.69337,
    lat: 26.092517,
    lastdyn: 1719731348,
    type: 24,
    shiptype: 'navigation',
    name: 'MJK D10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412506,
  },
  {
    mmsi: 999412503,
    lng: 119.72988,
    lat: 26.08923,
    lastdyn: 1719858284,
    type: 24,
    shiptype: 'navigation',
    name: 'MJK D6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412503,
  },
  {
    mmsi: 994132412,
    lng: 119.3393,
    lat: 25.16211,
    lastdyn: 1719859822,
    type: 21,
    shiptype: 'navigation',
    name: 'JIAN YU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132412,
  },
  {
    mmsi: 999412547,
    lng: 119.58029,
    lat: 26.13158,
    lastdyn: 1717287708,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHONG SHA R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412547,
  },
  {
    mmsi: 999412505,
    lng: 119.692985,
    lat: 26.095518,
    lastdyn: 1719851948,
    type: 25,
    shiptype: 'navigation',
    name: 'MJK D9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412505,
  },
  {
    mmsi: 999412528,
    lng: 119.70208,
    lat: 25.62702,
    lastdyn: 1719828419,
    type: 28,
    shiptype: 'navigation',
    name: 'SUAO N',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412528,
  },
  {
    mmsi: 999412517,
    lng: 119.53296,
    lat: 26.09676,
    lastdyn: 1719740898,
    type: 14,
    shiptype: 'navigation',
    name: 'QIAN YU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412517,
  },
  {
    mmsi: 999412514,
    lng: 119.594402,
    lat: 26.135213,
    lastdyn: 1719859849,
    type: 5,
    shiptype: 'navigation',
    name: 'JIN PAI MEN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412514,
  },
  {
    mmsi: 994131492,
    lng: 119.616923,
    lat: 26.136985,
    lastdyn: 1719849963,
    type: 24,
    shiptype: 'navigation',
    name: 'CHUANZHENG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131492,
  },
  {
    mmsi: 994132427,
    lng: 120.227883,
    lat: 26.198422,
    lastdyn: 1719678382,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132427,
  },
  {
    mmsi: 999412516,
    lng: 119.5631,
    lat: 26.12208,
    lastdyn: 1719279783,
    type: 13,
    shiptype: 'navigation',
    name: 'LANGQI SHA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412516,
  },
  {
    mmsi: 999412512,
    lng: 119.622003,
    lat: 26.134693,
    lastdyn: 1719788429,
    type: 25,
    shiptype: 'navigation',
    name: 'MJK D21',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412512,
  },
  {
    mmsi: 999412580,
    lng: 119.54354,
    lat: 26.116588,
    lastdyn: 1714374453,
    type: 30,
    shiptype: 'navigation',
    name: 'K1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412580,
  },
  {
    mmsi: 994161829,
    lng: 119.991595,
    lat: 26.225317,
    lastdyn: 1719859860,
    type: 1,
    shiptype: 'navigation',
    name: 'BEIGAN',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161829,
  },
  {
    mmsi: 999413207,
    lng: 119.8462,
    lat: 26.1362,
    lastdyn: 1719859740,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHE CANG JI CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413207,
  },
  {
    mmsi: 999413219,
    lng: 119.82132,
    lat: 26.162038,
    lastdyn: 1719859891,
    type: 28,
    shiptype: 'navigation',
    name: 'BAN YANG JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413219,
  },
  {
    mmsi: 994136373,
    lng: 119.784783,
    lat: 26.2448,
    lastdyn: 1719859831,
    type: 28,
    shiptype: 'navigation',
    name: 'FUXING 9 WRECK',
    length: 186,
    width: 32,
    left: 16,
    trail: 93,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136373,
  },
  {
    mmsi: 999412501,
    lng: 119.801923,
    lat: 26.08301,
    lastdyn: 1719858882,
    type: 25,
    shiptype: 'navigation',
    name: 'MJK D1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412501,
  },
  {
    mmsi: 994126474,
    lng: 119.77275,
    lat: 26.004267,
    lastdyn: 1719859857,
    type: 28,
    shiptype: 'navigation',
    name: 'MJK CHEN 15 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126474,
  },
  {
    mmsi: 994126538,
    lng: 119.920933,
    lat: 26.11705,
    lastdyn: 1719859835,
    type: 28,
    shiptype: 'navigation',
    name: 'HYD 58 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126538,
  },
  {
    mmsi: 994136383,
    lng: 119.833333,
    lat: 26.216667,
    lastdyn: 1719859828,
    type: 28,
    shiptype: 'navigation',
    name: 'LIANTAIYU003 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136383,
  },
  {
    mmsi: 994132422,
    lng: 120.155083,
    lat: 26.179117,
    lastdyn: 1719859221,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132422,
  },
  {
    mmsi: 994126337,
    lng: 120.024167,
    lat: 26.00195,
    lastdyn: 1719859838,
    type: 28,
    shiptype: 'navigation',
    name: 'QUAN SHUN FA WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126337,
  },
  {
    mmsi: 999992210,
    lng: 120.179513,
    lat: 26.158955,
    lastdyn: 1719857889,
    type: 31,
    shiptype: 'navigation',
    name: 'ATON 2210',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992210,
  },
  {
    mmsi: 994132426,
    lng: 120.21198,
    lat: 26.165722,
    lastdyn: 1719855501,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132426,
  },
  {
    mmsi: 994132420,
    lng: 120.158712,
    lat: 26.229005,
    lastdyn: 1719859087,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132420,
  },
  {
    mmsi: 994132428,
    lng: 120.243495,
    lat: 26.230998,
    lastdyn: 1719859641,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132428,
  },
  {
    mmsi: 994132421,
    lng: 120.15536,
    lat: 26.209797,
    lastdyn: 1719857901,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132421,
  },
  {
    mmsi: 994132419,
    lng: 120.182893,
    lat: 26.247695,
    lastdyn: 1719857949,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132419,
  },
  {
    mmsi: 999000061,
    lng: 122.503738,
    lat: 26.166743,
    lastdyn: 1719835011,
    type: 31,
    shiptype: 'navigation',
    name: 'TIANAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000061,
  },
  {
    mmsi: 999412544,
    lng: 119.718722,
    lat: 26.363043,
    lastdyn: 1719859902,
    type: 25,
    shiptype: 'navigation',
    name: 'XIA YU 5',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412544,
  },
  {
    mmsi: 999412543,
    lng: 119.741583,
    lat: 26.375925,
    lastdyn: 1719859777,
    type: 25,
    shiptype: 'navigation',
    name: 'XIA YU 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412543,
  },
  {
    mmsi: 999412546,
    lng: 119.88674,
    lat: 26.289102,
    lastdyn: 1719859782,
    type: 5,
    shiptype: 'navigation',
    name: 'SHANG JIAO YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412546,
  },
  {
    mmsi: 994136355,
    lng: 119.974167,
    lat: 26.385,
    lastdyn: 1719859899,
    type: 0,
    shiptype: 'navigation',
    name: 'SHENG XING 6 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136355,
  },
  {
    mmsi: 994136576,
    lng: 119.991833,
    lat: 26.4495,
    lastdyn: 1719859908,
    type: 28,
    shiptype: 'navigation',
    name: 'HX 107 WRECK',
    length: 52,
    width: 8,
    left: 4,
    trail: 26,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136576,
  },
  {
    mmsi: 994131456,
    lng: 119.850308,
    lat: 26.2948,
    lastdyn: 1719859860,
    type: 30,
    shiptype: 'navigation',
    name: 'HANHAI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131456,
  },
  {
    mmsi: 994136545,
    lng: 119.881667,
    lat: 26.312778,
    lastdyn: 1719859819,
    type: 28,
    shiptype: 'navigation',
    name: 'HUANGSHANQIU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136545,
  },
  {
    mmsi: 999412539,
    lng: 119.78881,
    lat: 26.40099,
    lastdyn: 1719859802,
    type: 9,
    shiptype: 'navigation',
    name: 'SHENFU1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412539,
  },
  {
    mmsi: 994141304,
    lng: 119.958983,
    lat: 26.426105,
    lastdyn: 1719859743,
    type: 30,
    shiptype: 'navigation',
    name: 'KEMENPAI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141304,
  },
  {
    mmsi: 994141303,
    lng: 119.954808,
    lat: 26.428898,
    lastdyn: 1719859324,
    type: 30,
    shiptype: 'navigation',
    name: 'KEMENPAI 1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141303,
  },
  {
    mmsi: 994136391,
    lng: 119.7885,
    lat: 26.399472,
    lastdyn: 1719859826,
    type: 23,
    shiptype: 'navigation',
    name: 'SHEN FU 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136391,
  },
  {
    mmsi: 994126461,
    lng: 120.196888,
    lat: 26.418278,
    lastdyn: 1719859745,
    type: 28,
    shiptype: 'navigation',
    name: 'KUI SHAN DONG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126461,
  },
  {
    mmsi: 994132417,
    lng: 120.232508,
    lat: 26.266295,
    lastdyn: 1719848805,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132417,
  },
  {
    mmsi: 994126478,
    lng: 120.1509,
    lat: 26.479883,
    lastdyn: 1719859748,
    type: 28,
    shiptype: 'navigation',
    name: 'TX 855 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126478,
  },
  {
    mmsi: 994132418,
    lng: 120.201443,
    lat: 26.25743,
    lastdyn: 1719859867,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132418,
  },
  {
    mmsi: 994126338,
    lng: 120.195833,
    lat: 26.42,
    lastdyn: 1719859742,
    type: 28,
    shiptype: 'navigation',
    name: 'JH 8699 WRECK',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126338,
  },
  {
    mmsi: 994132429,
    lng: 120.253713,
    lat: 26.251777,
    lastdyn: 1719859845,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132429,
  },
  {
    mmsi: 994161837,
    lng: 120.49014,
    lat: 26.367258,
    lastdyn: 1719859860,
    type: 1,
    shiptype: 'navigation',
    name: 'TUNGYIN CHUNGLIU',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994161837,
  },
  {
    mmsi: 994126326,
    lng: 120.488917,
    lat: 26.286638,
    lastdyn: 1719859752,
    type: 28,
    shiptype: 'navigation',
    name: 'SHUN HANG WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126326,
  },
  {
    mmsi: 994132416,
    lng: 119.792592,
    lat: 26.276748,
    lastdyn: 1719859648,
    type: 30,
    shiptype: 'navigation',
    name: 'LJFD T1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132416,
  },
  {
    mmsi: 999993001,
    lng: 120.620558,
    lat: 26.497018,
    lastdyn: 1719855287,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 3001',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993001,
  },
  {
    mmsi: 994131417,
    lng: 119.645415,
    lat: 26.747465,
    lastdyn: 1719859689,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHANGWAN 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131417,
  },
  {
    mmsi: 994126582,
    lng: 119.662472,
    lat: 26.71825,
    lastdyn: 1719859817,
    type: 24,
    shiptype: 'navigation',
    name: 'SANSHA 610A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126582,
  },
  {
    mmsi: 999412598,
    lng: 119.742332,
    lat: 26.6885,
    lastdyn: 1719859812,
    type: 24,
    shiptype: 'navigation',
    name: 'SANSHA 602',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412598,
  },
  {
    mmsi: 994131403,
    lng: 119.719172,
    lat: 26.696705,
    lastdyn: 1719859857,
    type: 25,
    shiptype: 'navigation',
    name: 'SANSHA 605',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131403,
  },
  {
    mmsi: 994131413,
    lng: 119.63846,
    lat: 26.749343,
    lastdyn: 1719859685,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHANGWAN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131413,
  },
  {
    mmsi: 994126320,
    lng: 119.633167,
    lat: 26.748638,
    lastdyn: 1719859816,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHANGWAN 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126320,
  },
  {
    mmsi: 994132415,
    lng: 119.764238,
    lat: 26.687873,
    lastdyn: 1719859740,
    type: 25,
    shiptype: 'navigation',
    name: 'SAN SHA 501',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132415,
  },
  {
    mmsi: 994126356,
    lng: 119.824195,
    lat: 26.558,
    lastdyn: 1719859814,
    type: 28,
    shiptype: 'navigation',
    name: 'DCK WRECK',
    length: 56,
    width: 10,
    left: 5,
    trail: 28,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126356,
  },
  {
    mmsi: 999412594,
    lng: 119.821245,
    lat: 26.617182,
    lastdyn: 1719859869,
    type: 24,
    shiptype: 'navigation',
    name: 'SANSHA 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412594,
  },
  {
    mmsi: 994132414,
    lng: 119.792118,
    lat: 26.666907,
    lastdyn: 1719859860,
    type: 25,
    shiptype: 'navigation',
    name: 'SAN SHA 401',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994132414,
  },
  {
    mmsi: 999412596,
    lng: 119.808392,
    lat: 26.587592,
    lastdyn: 1719859287,
    type: 14,
    shiptype: 'navigation',
    name: 'SANSHA 101',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412596,
  },
  {
    mmsi: 999412597,
    lng: 119.761252,
    lat: 26.712402,
    lastdyn: 1719859749,
    type: 24,
    shiptype: 'navigation',
    name: 'SANSAH 406',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412597,
  },
  {
    mmsi: 999412595,
    lng: 119.793813,
    lat: 26.655373,
    lastdyn: 1719859866,
    type: 25,
    shiptype: 'navigation',
    name: 'SANSHA 13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412595,
  },
  {
    mmsi: 999412564,
    lng: 120.320532,
    lat: 26.541542,
    lastdyn: 1719859862,
    type: 19,
    shiptype: 'navigation',
    name: 'MDCF 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412564,
  },
  {
    mmsi: 999533002,
    lng: 120.513403,
    lat: 26.699548,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 3002',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999533002,
  },
  {
    mmsi: 999412523,
    lng: 120.245753,
    lat: 26.903318,
    lastdyn: 1719859744,
    type: 25,
    shiptype: 'navigation',
    name: 'SANSHAGANG 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412523,
  },
  {
    mmsi: 999412577,
    lng: 120.2175,
    lat: 26.833342,
    lastdyn: 1719859857,
    type: 30,
    shiptype: 'navigation',
    name: 'XPCF',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412577,
  },
  {
    mmsi: 994131493,
    lng: 120.24347,
    lat: 26.91266,
    lastdyn: 1719859802,
    type: 3,
    shiptype: 'navigation',
    name: 'LAO SHU JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131493,
  },
  {
    mmsi: 994126425,
    lng: 120.267083,
    lat: 26.918112,
    lastdyn: 1719859826,
    type: 28,
    shiptype: 'navigation',
    name: 'CBM 1 WRECK',
    length: 4,
    width: 12,
    left: 6,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126425,
  },
  {
    mmsi: 994126312,
    lng: 120.542,
    lat: 26.856528,
    lastdyn: 1719859851,
    type: 28,
    shiptype: 'navigation',
    name: 'XEJ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126312,
  },
  {
    mmsi: 994131470,
    lng: 181,
    lat: 91,
    lastdyn: 1665982900,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGHFD T55',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131470,
  },
  {
    mmsi: 994131471,
    lng: 181,
    lat: 91,
    lastdyn: 1637821148,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGHFD T56',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131471,
  },
  {
    mmsi: 994131469,
    lng: 119.767088,
    lat: 25.667232,
    lastdyn: 1637561326,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGHFD T54',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131469,
  },
  {
    mmsi: 994126545,
    lng: 120.671,
    lat: 27.198055,
    lastdyn: 1719859767,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126545,
  },
  {
    mmsi: 994126521,
    lng: 120.726388,
    lat: 27.209167,
    lastdyn: 1719859776,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126521,
  },
  {
    mmsi: 994126522,
    lng: 120.692417,
    lat: 27.1675,
    lastdyn: 1719859779,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126522,
  },
  {
    mmsi: 994126311,
    lng: 120.618083,
    lat: 27.048555,
    lastdyn: 1719859848,
    type: 28,
    shiptype: 'navigation',
    name: 'BBYJ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126311,
  },
  {
    mmsi: 999992202,
    lng: 120.743362,
    lat: 27.143547,
    lastdyn: 1719859684,
    type: 19,
    shiptype: 'navigation',
    name: 'ATON 2202',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992202,
  },
  {
    mmsi: 994126513,
    lng: 120.703945,
    lat: 27.238333,
    lastdyn: 1719859764,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126513,
  },
  {
    mmsi: 994131345,
    lng: 120.810083,
    lat: 27.235895,
    lastdyn: 1719859880,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131345,
  },
  {
    mmsi: 994126517,
    lng: 120.755695,
    lat: 27.245,
    lastdyn: 1719859773,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126517,
  },
  {
    mmsi: 994131346,
    lng: 120.764208,
    lat: 27.23602,
    lastdyn: 1719859880,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131346,
  },
  {
    mmsi: 994131344,
    lng: 120.855962,
    lat: 27.235753,
    lastdyn: 1719859879,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131344,
  },
  {
    mmsi: 999413251,
    lng: 121.047778,
    lat: 27.246945,
    lastdyn: 1719859836,
    type: 28,
    shiptype: 'navigation',
    name: 'HELIOS 3 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413251,
  },
  {
    mmsi: 999993021,
    lng: 121.521382,
    lat: 27.126898,
    lastdyn: 1719858060,
    type: 31,
    shiptype: 'navigation',
    name: 'ATON 3021',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993021,
  },
  {
    mmsi: 999412434,
    lng: 120.699465,
    lat: 27.47588,
    lastdyn: 1719859766,
    type: 25,
    shiptype: 'navigation',
    name: 'CANG DIAN 9',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412434,
  },
  {
    mmsi: 994126507,
    lng: 120.737055,
    lat: 27.278888,
    lastdyn: 1719859761,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126507,
  },
  {
    mmsi: 994126336,
    lng: 120.585833,
    lat: 27.296667,
    lastdyn: 1719859755,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHEN GANG 282 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126336,
  },
  {
    mmsi: 994131319,
    lng: 120.824167,
    lat: 27.313612,
    lastdyn: 1719859858,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131319,
  },
  {
    mmsi: 994126502,
    lng: 120.769945,
    lat: 27.319167,
    lastdyn: 1719859758,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126502,
  },
  {
    mmsi: 999412433,
    lng: 120.77783,
    lat: 27.413837,
    lastdyn: 1719859333,
    type: 29,
    shiptype: 'navigation',
    name: 'CANG DIAN 0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412433,
  },
  {
    mmsi: 994131318,
    lng: 120.868362,
    lat: 27.314388,
    lastdyn: 1719859857,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131318,
  },
  {
    mmsi: 994131323,
    lng: 120.918888,
    lat: 27.372528,
    lastdyn: 1719859866,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131323,
  },
  {
    mmsi: 994131314,
    lng: 120.967222,
    lat: 27.372278,
    lastdyn: 1719859852,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131314,
  },
  {
    mmsi: 994131342,
    lng: 120.90768,
    lat: 27.295537,
    lastdyn: 1719859878,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131342,
  },
  {
    mmsi: 994131321,
    lng: 120.855083,
    lat: 27.353055,
    lastdyn: 1719859858,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131321,
  },
  {
    mmsi: 994131349,
    lng: 120.860178,
    lat: 27.292822,
    lastdyn: 1719859884,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131349,
  },
  {
    mmsi: 994131348,
    lng: 120.812572,
    lat: 27.29282,
    lastdyn: 1719859884,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131348,
  },
  {
    mmsi: 994126516,
    lng: 120.788612,
    lat: 27.285278,
    lastdyn: 1719859770,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126516,
  },
  {
    mmsi: 994131322,
    lng: 120.870528,
    lat: 27.372778,
    lastdyn: 1719859859,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131322,
  },
  {
    mmsi: 994131316,
    lng: 120.956778,
    lat: 27.315888,
    lastdyn: 1719859853,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131316,
  },
  {
    mmsi: 994131300,
    lng: 120.871647,
    lat: 27.337928,
    lastdyn: 1719859899,
    type: 3,
    shiptype: 'navigation',
    name: 'CANGCE1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131300,
  },
  {
    mmsi: 994131317,
    lng: 120.912583,
    lat: 27.315138,
    lastdyn: 1719859857,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131317,
  },
  {
    mmsi: 994131324,
    lng: 120.879612,
    lat: 27.331417,
    lastdyn: 1719859866,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131324,
  },
  {
    mmsi: 994131343,
    lng: 120.885358,
    lat: 27.26143,
    lastdyn: 1719859879,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131343,
  },
  {
    mmsi: 994131315,
    lng: 120.961972,
    lat: 27.343862,
    lastdyn: 1719859852,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131315,
  },
  {
    mmsi: 994131320,
    lng: 120.839612,
    lat: 27.333333,
    lastdyn: 1719859858,
    type: 1,
    shiptype: 'navigation',
    name: 'CD1 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131320,
  },
  {
    mmsi: 994131347,
    lng: 120.788383,
    lat: 27.264425,
    lastdyn: 1719859881,
    type: 1,
    shiptype: 'navigation',
    name: 'CD2 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131347,
  },
  {
    mmsi: 999412436,
    lng: 120.606568,
    lat: 27.589237,
    lastdyn: 1719859826,
    type: 25,
    shiptype: 'navigation',
    name: 'AOJIANG 7',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412436,
  },
  {
    mmsi: 999412424,
    lng: 120.670855,
    lat: 27.548213,
    lastdyn: 1719859819,
    type: 29,
    shiptype: 'navigation',
    name: 'AO JIANG 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412424,
  },
  {
    mmsi: 999412437,
    lng: 120.604685,
    lat: 27.587248,
    lastdyn: 1719859886,
    type: 24,
    shiptype: 'navigation',
    name: 'AOJIANG 8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412437,
  },
  {
    mmsi: 994131325,
    lng: 120.639663,
    lat: 27.745758,
    lastdyn: 1719859762,
    type: 14,
    shiptype: 'navigation',
    name: 'YONG NING L1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131325,
  },
  {
    mmsi: 994126339,
    lng: 118.162733,
    lat: 31.255083,
    lastdyn: 1719859774,
    type: 30,
    shiptype: 'navigation',
    name: 'ZCC1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126339,
  },
  {
    mmsi: 999412425,
    lng: 120.764817,
    lat: 27.658317,
    lastdyn: 1719629479,
    type: 29,
    shiptype: 'navigation',
    name: 'FEI YUN JIANG 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412425,
  },
  {
    mmsi: 999413298,
    lng: 120.81,
    lat: 27.623888,
    lastdyn: 1719859897,
    type: 28,
    shiptype: 'navigation',
    name: 'NAN LOU JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413298,
  },
  {
    mmsi: 994131311,
    lng: 120.894197,
    lat: 27.523652,
    lastdyn: 1719859899,
    type: 30,
    shiptype: 'navigation',
    name: 'PING YANG QI XIANG',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131311,
  },
  {
    mmsi: 994131302,
    lng: 121.047348,
    lat: 27.681133,
    lastdyn: 1719859839,
    type: 3,
    shiptype: 'navigation',
    name: 'RUICE1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131302,
  },
  {
    mmsi: 999412402,
    lng: 121.184132,
    lat: 27.713742,
    lastdyn: 1719859879,
    type: 5,
    shiptype: 'navigation',
    name: 'BEI BAI YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412402,
  },
  {
    mmsi: 999412405,
    lng: 121.05204,
    lat: 27.636075,
    lastdyn: 1719859686,
    type: 1,
    shiptype: 'navigation',
    name: 'DONG GUA YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412405,
  },
  {
    mmsi: 999000007,
    lng: 122.487885,
    lat: 27.503922,
    lastdyn: 1719859464,
    type: 0,
    shiptype: 'navigation',
    name: 'QF220',
    length: 10,
    width: 12,
    left: 2,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000007,
  },
  {
    mmsi: 999412430,
    lng: 120.796317,
    lat: 27.97761,
    lastdyn: 1719859888,
    type: 19,
    shiptype: 'navigation',
    name: 'LONG WAN QIAN BA 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412430,
  },
  {
    mmsi: 994100001,
    lng: 120.895383,
    lat: 27.986667,
    lastdyn: 1719859811,
    type: 0,
    shiptype: 'navigation',
    name: 'DZWL 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994100001,
  },
  {
    mmsi: 994100005,
    lng: 120.898953,
    lat: 27.982642,
    lastdyn: 1719859817,
    type: 0,
    shiptype: 'navigation',
    name: 'DZWL 34',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994100005,
  },
  {
    mmsi: 999412412,
    lng: 120.825315,
    lat: 27.980642,
    lastdyn: 1719859829,
    type: 24,
    shiptype: 'navigation',
    name: 'OU JIANG 30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412412,
  },
  {
    mmsi: 994100003,
    lng: 120.9016,
    lat: 27.986667,
    lastdyn: 1719859816,
    type: 0,
    shiptype: 'navigation',
    name: 'DZWL 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994100003,
  },
  {
    mmsi: 994136344,
    lng: 120.882,
    lat: 27.7735,
    lastdyn: 1719859805,
    type: 28,
    shiptype: 'navigation',
    name: 'WM WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136344,
  },
  {
    mmsi: 999412411,
    lng: 120.959218,
    lat: 27.964595,
    lastdyn: 1719859752,
    type: 25,
    shiptype: 'navigation',
    name: 'OU JIANG 17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412411,
  },
  {
    mmsi: 994100004,
    lng: 120.9016,
    lat: 27.982833,
    lastdyn: 1719859817,
    type: 0,
    shiptype: 'navigation',
    name: 'DZWL 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994100004,
  },
  {
    mmsi: 994100002,
    lng: 120.898753,
    lat: 27.987297,
    lastdyn: 1719859809,
    type: 0,
    shiptype: 'navigation',
    name: 'DZWL 12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994100002,
  },
  {
    mmsi: 999412428,
    lng: 121.099873,
    lat: 27.877642,
    lastdyn: 1719859828,
    type: 0,
    shiptype: 'navigation',
    name: 'ZW5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412428,
  },
  {
    mmsi: 994136530,
    lng: 121.233,
    lat: 27.898583,
    lastdyn: 1719859833,
    type: 26,
    shiptype: 'navigation',
    name: 'WEN D 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136530,
  },
  {
    mmsi: 999412406,
    lng: 121.172663,
    lat: 27.956275,
    lastdyn: 1719851946,
    type: 25,
    shiptype: 'navigation',
    name: 'W1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412406,
  },
  {
    mmsi: 994136540,
    lng: 121.210055,
    lat: 27.9185,
    lastdyn: 1719859836,
    type: 26,
    shiptype: 'navigation',
    name: 'WEN D 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136540,
  },
  {
    mmsi: 994126415,
    lng: 121.177667,
    lat: 27.958222,
    lastdyn: 1719859818,
    type: 28,
    shiptype: 'navigation',
    name: 'BAI MU TIAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126415,
  },
  {
    mmsi: 994126325,
    lng: 121.020555,
    lat: 27.941333,
    lastdyn: 1719859833,
    type: 25,
    shiptype: 'navigation',
    name: 'OU JIANG 11A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126325,
  },
  {
    mmsi: 999412403,
    lng: 121.192347,
    lat: 27.926053,
    lastdyn: 1719859806,
    type: 0,
    shiptype: 'navigation',
    name: 'ZHUANG YUAN AO Z0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412403,
  },
  {
    mmsi: 994131327,
    lng: 121.084638,
    lat: 27.833832,
    lastdyn: 1719859822,
    type: 13,
    shiptype: 'navigation',
    name: 'DTXQ L4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131327,
  },
  {
    mmsi: 999412408,
    lng: 121.076647,
    lat: 27.936653,
    lastdyn: 1719859879,
    type: 24,
    shiptype: 'navigation',
    name: 'OU JIANG 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412408,
  },
  {
    mmsi: 994136544,
    lng: 121.312222,
    lat: 27.82975,
    lastdyn: 1719859824,
    type: 26,
    shiptype: 'navigation',
    name: 'WEN D 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136544,
  },
  {
    mmsi: 994136529,
    lng: 121.258805,
    lat: 27.876167,
    lastdyn: 1719859830,
    type: 26,
    shiptype: 'navigation',
    name: 'WEN D 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136529,
  },
  {
    mmsi: 994136536,
    lng: 121.28461,
    lat: 27.85375,
    lastdyn: 1719859827,
    type: 26,
    shiptype: 'navigation',
    name: 'WEN D 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136536,
  },
  {
    mmsi: 994126510,
    lng: 121.419333,
    lat: 27.8435,
    lastdyn: 1719859821,
    type: 29,
    shiptype: 'navigation',
    name: 'YUE QING WAN Y1 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126510,
  },
  {
    mmsi: 994126475,
    lng: 121.591555,
    lat: 27.933333,
    lastdyn: 1719859800,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG HANG LU 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126475,
  },
  {
    mmsi: 994126495,
    lng: 121.716945,
    lat: 27.983612,
    lastdyn: 1719859806,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HANG LU 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126495,
  },
  {
    mmsi: 994126496,
    lng: 121.678055,
    lat: 27.934445,
    lastdyn: 1719859809,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HANG LU 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126496,
  },
  {
    mmsi: 994126497,
    lng: 121.640862,
    lat: 27.8875,
    lastdyn: 1719859812,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HANG LU 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126497,
  },
  {
    mmsi: 994126494,
    lng: 121.555972,
    lat: 27.891945,
    lastdyn: 1719859803,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG HANG LU 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126494,
  },
  {
    mmsi: 994126472,
    lng: 121.621778,
    lat: 27.973612,
    lastdyn: 1719859797,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG HANG LU 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126472,
  },
  {
    mmsi: 994126498,
    lng: 121.599722,
    lat: 27.835555,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HANG LU 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126498,
  },
  {
    mmsi: 999413206,
    lng: 121.749833,
    lat: 27.978333,
    lastdyn: 1719859792,
    type: 28,
    shiptype: 'navigation',
    name: 'XUAN MEN WAI CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413206,
  },
  {
    mmsi: 994131303,
    lng: 122.056247,
    lat: 27.831857,
    lastdyn: 1719854495,
    type: 31,
    shiptype: 'navigation',
    name: 'HDEC DT1',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131303,
  },
  {
    mmsi: 994131053,
    lng: 119.275967,
    lat: 38.9913,
    lastdyn: 1719858122,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131053,
  },
  {
    mmsi: 994131052,
    lng: 119.272967,
    lat: 38.9888,
    lastdyn: 1719858422,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131052,
  },
  {
    mmsi: 999412427,
    lng: 120.734333,
    lat: 28.026835,
    lastdyn: 1719859888,
    type: 19,
    shiptype: 'navigation',
    name: 'LAO HU YAN NAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412427,
  },
  {
    mmsi: 994126512,
    lng: 120.620888,
    lat: 28.025472,
    lastdyn: 1719859832,
    type: 17,
    shiptype: 'navigation',
    name: 'DONG OU DAQIAO 1HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126512,
  },
  {
    mmsi: 999412422,
    lng: 121.10757,
    lat: 28.13694,
    lastdyn: 1719858168,
    type: 24,
    shiptype: 'navigation',
    name: 'YUE QING WAN Y20',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412422,
  },
  {
    mmsi: 999412448,
    lng: 121.138477,
    lat: 28.244708,
    lastdyn: 1719819375,
    type: 24,
    shiptype: 'navigation',
    name: 'LIANG HAO QIAO 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412448,
  },
  {
    mmsi: 999412413,
    lng: 121.133092,
    lat: 28.048945,
    lastdyn: 1719856519,
    type: 25,
    shiptype: 'navigation',
    name: 'YUE QING WAN Y13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412413,
  },
  {
    mmsi: 999412414,
    lng: 121.125587,
    lat: 28.055387,
    lastdyn: 1719859459,
    type: 24,
    shiptype: 'navigation',
    name: 'YUE QING WAN Y14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412414,
  },
  {
    mmsi: 994136584,
    lng: 121.374167,
    lat: 28.124167,
    lastdyn: 1719859819,
    type: 28,
    shiptype: 'navigation',
    name: 'QIXING JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136584,
  },
  {
    mmsi: 999412404,
    lng: 121.483132,
    lat: 28.131442,
    lastdyn: 1719859692,
    type: 0,
    shiptype: 'navigation',
    name: 'DA DONG JING DAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412404,
  },
  {
    mmsi: 994131328,
    lng: 121.494658,
    lat: 28.217053,
    lastdyn: 1719859862,
    type: 30,
    shiptype: 'navigation',
    name: 'YH FD1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131328,
  },
  {
    mmsi: 994131330,
    lng: 121.480927,
    lat: 28.18193,
    lastdyn: 1719859918,
    type: 30,
    shiptype: 'navigation',
    name: 'YH FD5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131330,
  },
  {
    mmsi: 999412429,
    lng: 121.588302,
    lat: 28.144897,
    lastdyn: 1719859752,
    type: 1,
    shiptype: 'navigation',
    name: 'YUHUAN CEFENGTA 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412429,
  },
  {
    mmsi: 994126471,
    lng: 121.65375,
    lat: 28.014445,
    lastdyn: 1719859794,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG HANG LU 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126471,
  },
  {
    mmsi: 994126364,
    lng: 121.73975,
    lat: 28.246555,
    lastdyn: 1719859825,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU W7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126364,
  },
  {
    mmsi: 994131329,
    lng: 121.5245,
    lat: 28.181555,
    lastdyn: 1719859863,
    type: 30,
    shiptype: 'navigation',
    name: 'YH FD3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131329,
  },
  {
    mmsi: 994126365,
    lng: 121.776862,
    lat: 28.240195,
    lastdyn: 1719859828,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU E8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126365,
  },
  {
    mmsi: 994131357,
    lng: 121.924653,
    lat: 28.144528,
    lastdyn: 1719834307,
    type: 30,
    shiptype: 'navigation',
    name: 'YH FD2 L11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131357,
  },
  {
    mmsi: 994131356,
    lng: 121.838402,
    lat: 28.03734,
    lastdyn: 1719838927,
    type: 30,
    shiptype: 'navigation',
    name: 'YH FD2 L7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131356,
  },
  {
    mmsi: 994131355,
    lng: 121.905177,
    lat: 28.037208,
    lastdyn: 1719839947,
    type: 30,
    shiptype: 'navigation',
    name: 'YH FD2 L5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131355,
  },
  {
    mmsi: 994131354,
    lng: 121.996913,
    lat: 28.144513,
    lastdyn: 1719836456,
    type: 30,
    shiptype: 'navigation',
    name: 'YH FD2 L1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131354,
  },
  {
    mmsi: 999992519,
    lng: 122.21612,
    lat: 28.133237,
    lastdyn: 1719831238,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2519',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992519,
  },
  {
    mmsi: 999413237,
    lng: 122.096862,
    lat: 28.157612,
    lastdyn: 1719859798,
    type: 28,
    shiptype: 'navigation',
    name: 'XIN HANG ZHOU CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413237,
  },
  {
    mmsi: 994131122,
    lng: 122.303567,
    lat: 28.217137,
    lastdyn: 1719826563,
    type: 30,
    shiptype: 'navigation',
    name: 'DANDONG ANEMOMETER T',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131122,
  },
  {
    mmsi: 994126525,
    lng: 121.648,
    lat: 28.368888,
    lastdyn: 1719859861,
    type: 24,
    shiptype: 'navigation',
    name: 'YANG JIAO JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126525,
  },
  {
    mmsi: 994136446,
    lng: 121.719833,
    lat: 28.384112,
    lastdyn: 1719859843,
    type: 28,
    shiptype: 'navigation',
    name: 'ZPYY 48330 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136446,
  },
  {
    mmsi: 994131310,
    lng: 121.680942,
    lat: 28.400393,
    lastdyn: 1719859754,
    type: 25,
    shiptype: 'navigation',
    name: 'LONG MEN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131310,
  },
  {
    mmsi: 994126355,
    lng: 121.852667,
    lat: 28.496667,
    lastdyn: 1719859810,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU E2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126355,
  },
  {
    mmsi: 994126366,
    lng: 121.981167,
    lat: 28.492388,
    lastdyn: 1719859651,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG HANG LU W1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126366,
  },
  {
    mmsi: 994126394,
    lng: 121.923362,
    lat: 28.351638,
    lastdyn: 1719859843,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG HANG LU W5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126394,
  },
  {
    mmsi: 994126357,
    lng: 121.788805,
    lat: 28.469362,
    lastdyn: 1719859813,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU W3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126357,
  },
  {
    mmsi: 994126398,
    lng: 121.985555,
    lat: 28.313305,
    lastdyn: 1719859666,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HANG LU E6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126398,
  },
  {
    mmsi: 994126358,
    lng: 121.824388,
    lat: 28.457222,
    lastdyn: 1719859636,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU E4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126358,
  },
  {
    mmsi: 994126360,
    lng: 121.815278,
    lat: 28.414195,
    lastdyn: 1719859822,
    type: 24,
    shiptype: 'navigation',
    name: 'XI HANG LU E6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126360,
  },
  {
    mmsi: 994126359,
    lng: 121.778,
    lat: 28.420528,
    lastdyn: 1719859819,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU W5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126359,
  },
  {
    mmsi: 994126369,
    lng: 121.971945,
    lat: 28.412305,
    lastdyn: 1719859837,
    type: 25,
    shiptype: 'navigation',
    name: 'DONG HANG LU W3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126369,
  },
  {
    mmsi: 994131306,
    lng: 121.893068,
    lat: 28.455672,
    lastdyn: 1719859825,
    type: 5,
    shiptype: 'navigation',
    name: 'DA CHEN DAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131306,
  },
  {
    mmsi: 994126393,
    lng: 122.044722,
    lat: 28.388222,
    lastdyn: 1719859840,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HANG LU E4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126393,
  },
  {
    mmsi: 994126367,
    lng: 122.056667,
    lat: 28.485417,
    lastdyn: 1719859834,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HANG LU E2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126367,
  },
  {
    mmsi: 994136405,
    lng: 122.316943,
    lat: 28.488055,
    lastdyn: 1719859855,
    type: 28,
    shiptype: 'navigation',
    name: 'WHL 1 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136405,
  },
  {
    mmsi: 994148168,
    lng: 105.082692,
    lat: 28.72952,
    lastdyn: 1719859887,
    type: 26,
    shiptype: 'navigation',
    name: 'JADQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148168,
  },
  {
    mmsi: 994148164,
    lng: 105.14744,
    lat: 28.710443,
    lastdyn: 1719859843,
    type: 26,
    shiptype: 'navigation',
    name: 'JEQ4R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148164,
  },
  {
    mmsi: 994148162,
    lng: 105.159213,
    lat: 28.716735,
    lastdyn: 1719859813,
    type: 26,
    shiptype: 'navigation',
    name: 'JEQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148162,
  },
  {
    mmsi: 994148163,
    lng: 105.15222,
    lat: 28.712363,
    lastdyn: 1719859828,
    type: 26,
    shiptype: 'navigation',
    name: 'JEQ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148163,
  },
  {
    mmsi: 994148161,
    lng: 105.164442,
    lat: 28.720907,
    lastdyn: 1719859798,
    type: 26,
    shiptype: 'navigation',
    name: 'JEQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148161,
  },
  {
    mmsi: 994148165,
    lng: 105.142997,
    lat: 28.70975,
    lastdyn: 1719859861,
    type: 26,
    shiptype: 'navigation',
    name: 'JRQ5R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148165,
  },
  {
    mmsi: 994148169,
    lng: 105.07933,
    lat: 28.733272,
    lastdyn: 1719859910,
    type: 26,
    shiptype: 'navigation',
    name: 'JADQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148169,
  },
  {
    mmsi: 994148166,
    lng: 105.148902,
    lat: 28.711933,
    lastdyn: 1719859872,
    type: 25,
    shiptype: 'navigation',
    name: 'JEQ4L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148166,
  },
  {
    mmsi: 994126527,
    lng: 121.401055,
    lat: 28.69725,
    lastdyn: 1719859717,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG SHUN BA BEI 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126527,
  },
  {
    mmsi: 999412420,
    lng: 121.434133,
    lat: 28.691082,
    lastdyn: 1719859872,
    type: 19,
    shiptype: 'navigation',
    name: 'CHANG SHUN BA 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412420,
  },
  {
    mmsi: 994136387,
    lng: 121.396472,
    lat: 28.693333,
    lastdyn: 1719859886,
    type: 17,
    shiptype: 'navigation',
    name: 'JJDQ 13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136387,
  },
  {
    mmsi: 999412435,
    lng: 121.482307,
    lat: 28.68673,
    lastdyn: 1719859743,
    type: 0,
    shiptype: 'navigation',
    name: 'HAI MEN 11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412435,
  },
  {
    mmsi: 994126508,
    lng: 121.421333,
    lat: 28.694527,
    lastdyn: 1719859892,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG SHUN BA BEI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126508,
  },
  {
    mmsi: 994126523,
    lng: 121.414417,
    lat: 28.695527,
    lastdyn: 1719859895,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG SHUN BA BEI 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126523,
  },
  {
    mmsi: 994126026,
    lng: 121.699247,
    lat: 28.513762,
    lastdyn: 1719205520,
    type: 0,
    shiptype: 'navigation',
    name: '26',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126026,
  },
  {
    mmsi: 999412419,
    lng: 121.520568,
    lat: 28.679047,
    lastdyn: 1719859449,
    type: 24,
    shiptype: 'navigation',
    name: 'HAI MEN GANG 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412419,
  },
  {
    mmsi: 994126029,
    lng: 121.644432,
    lat: 28.529922,
    lastdyn: 1719205496,
    type: 0,
    shiptype: 'navigation',
    name: '29',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126029,
  },
  {
    mmsi: 999412418,
    lng: 121.63316,
    lat: 28.671412,
    lastdyn: 1719859752,
    type: 25,
    shiptype: 'navigation',
    name: 'HAI MEN GANG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412418,
  },
  {
    mmsi: 999412417,
    lng: 121.58787,
    lat: 28.672358,
    lastdyn: 1719859812,
    type: 24,
    shiptype: 'navigation',
    name: 'HAI MEN GANG 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412417,
  },
  {
    mmsi: 994126027,
    lng: 121.67676,
    lat: 28.518245,
    lastdyn: 1719205052,
    type: 0,
    shiptype: 'navigation',
    name: '27',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126027,
  },
  {
    mmsi: 994126030,
    lng: 121.625732,
    lat: 28.534007,
    lastdyn: 1719205136,
    type: 0,
    shiptype: 'navigation',
    name: '30',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126030,
  },
  {
    mmsi: 994126028,
    lng: 121.654217,
    lat: 28.528198,
    lastdyn: 1719204962,
    type: 0,
    shiptype: 'navigation',
    name: '28',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126028,
  },
  {
    mmsi: 994126353,
    lng: 121.820388,
    lat: 28.514167,
    lastdyn: 1719859627,
    type: 25,
    shiptype: 'navigation',
    name: 'XI HANG LU W1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126353,
  },
  {
    mmsi: 999412401,
    lng: 121.85687,
    lat: 28.690147,
    lastdyn: 1719858612,
    type: 1,
    shiptype: 'navigation',
    name: 'LU YU JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412401,
  },
  {
    mmsi: 999412416,
    lng: 121.750668,
    lat: 28.661185,
    lastdyn: 1719859752,
    type: 30,
    shiptype: 'navigation',
    name: 'HAI MEN JIAN YI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412416,
  },
  {
    mmsi: 994136403,
    lng: 121.933417,
    lat: 28.644278,
    lastdyn: 1719859849,
    type: 29,
    shiptype: 'navigation',
    name: 'TOU MEN GANG D0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136403,
  },
  {
    mmsi: 999412439,
    lng: 121.830047,
    lat: 28.645737,
    lastdyn: 1719858724,
    type: 25,
    shiptype: 'navigation',
    name: 'TOU MEN GANG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412439,
  },
  {
    mmsi: 994131305,
    lng: 121.772653,
    lat: 28.67764,
    lastdyn: 1719859803,
    type: 26,
    shiptype: 'navigation',
    name: 'TOU MEN GANG D10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131305,
  },
  {
    mmsi: 994136404,
    lng: 121.806667,
    lat: 28.673195,
    lastdyn: 1719859492,
    type: 24,
    shiptype: 'navigation',
    name: 'TOU MEN GANG D8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136404,
  },
  {
    mmsi: 994126447,
    lng: 122.017667,
    lat: 28.5,
    lastdyn: 1719859801,
    type: 28,
    shiptype: 'navigation',
    name: 'ZLY 46055 WRECK',
    length: 32,
    width: 6,
    left: 3,
    trail: 16,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126447,
  },
  {
    mmsi: 994126518,
    lng: 122.000167,
    lat: 28.668167,
    lastdyn: 1719859866,
    type: 28,
    shiptype: 'navigation',
    name: 'DJD OBSTRUCTION',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126518,
  },
  {
    mmsi: 994136395,
    lng: 122.502222,
    lat: 28.59111,
    lastdyn: 1719859871,
    type: 28,
    shiptype: 'navigation',
    name: 'WHL 2 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136395,
  },
  {
    mmsi: 994126438,
    lng: 122.649443,
    lat: 28.69361,
    lastdyn: 1719859871,
    type: 28,
    shiptype: 'navigation',
    name: 'WHL 3 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126438,
  },
  {
    mmsi: 999999913,
    lng: -40.983057,
    lat: -21.810433,
    lastdyn: 1718040263,
    type: 25,
    shiptype: 'navigation',
    name: 'BAT113',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999913,
  },
  {
    mmsi: 994148101,
    lng: 104.739303,
    lat: 28.7752,
    lastdyn: 1719859831,
    type: 25,
    shiptype: 'navigation',
    name: 'LGQS1L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994148101,
  },
  {
    mmsi: 994148104,
    lng: 104.721795,
    lat: 28.780707,
    lastdyn: 1719859860,
    type: 26,
    shiptype: 'navigation',
    name: 'LGQS3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994148104,
  },
  {
    mmsi: 994148103,
    lng: 104.728852,
    lat: 28.77664,
    lastdyn: 1719859845,
    type: 26,
    shiptype: 'navigation',
    name: 'LGQS2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994148103,
  },
  {
    mmsi: 994148208,
    lng: 105.457042,
    lat: 28.886135,
    lastdyn: 1719859854,
    type: 24,
    shiptype: 'navigation',
    name: 'GJDQY2R',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148208,
  },
  {
    mmsi: 994148207,
    lng: 105.455475,
    lat: 28.893563,
    lastdyn: 1719859833,
    type: 24,
    shiptype: 'navigation',
    name: 'GJDQY1R',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148207,
  },
  {
    mmsi: 994148209,
    lng: 105.455155,
    lat: 28.876483,
    lastdyn: 1719859868,
    type: 25,
    shiptype: 'navigation',
    name: 'HJQ1L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148209,
  },
  {
    mmsi: 994148205,
    lng: 105.454572,
    lat: 28.888805,
    lastdyn: 1719859826,
    type: 25,
    shiptype: 'navigation',
    name: 'GJDQZ1L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148205,
  },
  {
    mmsi: 994148210,
    lng: 105.43524,
    lat: 28.866298,
    lastdyn: 1719859882,
    type: 24,
    shiptype: 'navigation',
    name: 'QCLDR',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148210,
  },
  {
    mmsi: 994148212,
    lng: 105.411167,
    lat: 28.863257,
    lastdyn: 1719859895,
    type: 24,
    shiptype: 'navigation',
    name: 'HJB2R',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148212,
  },
  {
    mmsi: 994148298,
    lng: 105.4639,
    lat: 28.912493,
    lastdyn: 1719859909,
    type: 30,
    shiptype: 'navigation',
    name: 'BJSCZYBCESHI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148298,
  },
  {
    mmsi: 994148273,
    lng: 105.595903,
    lat: 28.955258,
    lastdyn: 1719859914,
    type: 24,
    shiptype: 'navigation',
    name: 'PXQ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148273,
  },
  {
    mmsi: 994148235,
    lng: 105.632802,
    lat: 28.873657,
    lastdyn: 1719859873,
    type: 25,
    shiptype: 'navigation',
    name: 'SBZCGQ2L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148235,
  },
  {
    mmsi: 994148253,
    lng: 105.647038,
    lat: 28.917192,
    lastdyn: 1719859917,
    type: 25,
    shiptype: 'navigation',
    name: 'HHSL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148253,
  },
  {
    mmsi: 994148255,
    lng: 105.645552,
    lat: 28.922085,
    lastdyn: 1719859725,
    type: 25,
    shiptype: 'navigation',
    name: 'DDSL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148255,
  },
  {
    mmsi: 994148266,
    lng: 105.711578,
    lat: 28.876255,
    lastdyn: 1719859785,
    type: 25,
    shiptype: 'navigation',
    name: 'LDQ3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148266,
  },
  {
    mmsi: 994148275,
    lng: 105.588675,
    lat: 28.960068,
    lastdyn: 1719859716,
    type: 25,
    shiptype: 'navigation',
    name: 'MZS2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148275,
  },
  {
    mmsi: 994148272,
    lng: 105.599055,
    lat: 28.952842,
    lastdyn: 1719859901,
    type: 24,
    shiptype: 'navigation',
    name: 'PXQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148272,
  },
  {
    mmsi: 994148262,
    lng: 105.616815,
    lat: 28.931685,
    lastdyn: 1719859794,
    type: 25,
    shiptype: 'navigation',
    name: 'NCZL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148262,
  },
  {
    mmsi: 994148249,
    lng: 105.700712,
    lat: 28.87071,
    lastdyn: 1719859744,
    type: 24,
    shiptype: 'navigation',
    name: 'SBCDQY1R',
    length: 0,
    width: 10,
    left: 7,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148249,
  },
  {
    mmsi: 994148284,
    lng: 105.730182,
    lat: 28.895187,
    lastdyn: 1719859840,
    type: 25,
    shiptype: 'navigation',
    name: 'LHYL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148284,
  },
  {
    mmsi: 994148286,
    lng: 105.54888,
    lat: 28.941257,
    lastdyn: 1719859827,
    type: 24,
    shiptype: 'navigation',
    name: 'DKZ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148286,
  },
  {
    mmsi: 994148259,
    lng: 105.63658,
    lat: 28.925498,
    lastdyn: 1719859753,
    type: 25,
    shiptype: 'navigation',
    name: 'XLQ3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148259,
  },
  {
    mmsi: 994148233,
    lng: 105.640135,
    lat: 28.875792,
    lastdyn: 1719859846,
    type: 25,
    shiptype: 'navigation',
    name: 'SBZCGQ1L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148233,
  },
  {
    mmsi: 994148258,
    lng: 105.636468,
    lat: 28.92403,
    lastdyn: 1719859739,
    type: 24,
    shiptype: 'navigation',
    name: 'BPQ6R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148258,
  },
  {
    mmsi: 994148237,
    lng: 105.624,
    lat: 28.879175,
    lastdyn: 1719859675,
    type: 25,
    shiptype: 'navigation',
    name: 'SBZ2L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148237,
  },
  {
    mmsi: 994148279,
    lng: 105.575808,
    lat: 28.961045,
    lastdyn: 1719859758,
    type: 24,
    shiptype: 'navigation',
    name: 'GDQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148279,
  },
  {
    mmsi: 994148296,
    lng: 105.678982,
    lat: 28.868522,
    lastdyn: 1719859504,
    type: 24,
    shiptype: 'navigation',
    name: 'WBR',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148296,
  },
  {
    mmsi: 994148232,
    lng: 105.64422,
    lat: 28.876375,
    lastdyn: 1719859824,
    type: 25,
    shiptype: 'navigation',
    name: 'GFCL',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148232,
  },
  {
    mmsi: 994148247,
    lng: 105.693897,
    lat: 28.869682,
    lastdyn: 1719859716,
    type: 24,
    shiptype: 'navigation',
    name: 'SBCDQY2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148247,
  },
  {
    mmsi: 994148265,
    lng: 105.709827,
    lat: 28.874112,
    lastdyn: 1719859771,
    type: 24,
    shiptype: 'navigation',
    name: 'BLTR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148265,
  },
  {
    mmsi: 994148264,
    lng: 105.609053,
    lat: 28.93827,
    lastdyn: 1719859808,
    type: 25,
    shiptype: 'navigation',
    name: 'SXQL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148264,
  },
  {
    mmsi: 994148248,
    lng: 105.69919,
    lat: 28.871845,
    lastdyn: 1719859730,
    type: 25,
    shiptype: 'navigation',
    name: 'SBCDQZ1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148248,
  },
  {
    mmsi: 994148281,
    lng: 105.568582,
    lat: 28.960057,
    lastdyn: 1719859785,
    type: 24,
    shiptype: 'navigation',
    name: 'GDQ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148281,
  },
  {
    mmsi: 994148289,
    lng: 105.679757,
    lat: 28.869497,
    lastdyn: 1719859511,
    type: 25,
    shiptype: 'navigation',
    name: 'LJZ1L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148289,
  },
  {
    mmsi: 994148238,
    lng: 105.628235,
    lat: 28.885867,
    lastdyn: 1719859907,
    type: 25,
    shiptype: 'navigation',
    name: 'SZQ1L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148238,
  },
  {
    mmsi: 994148276,
    lng: 105.589242,
    lat: 28.958695,
    lastdyn: 1719859730,
    type: 24,
    shiptype: 'navigation',
    name: 'PXQ4R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148276,
  },
  {
    mmsi: 994148277,
    lng: 105.584127,
    lat: 28.961227,
    lastdyn: 1719859744,
    type: 25,
    shiptype: 'navigation',
    name: 'TLL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148277,
  },
  {
    mmsi: 994148280,
    lng: 105.568472,
    lat: 28.96147,
    lastdyn: 1719859772,
    type: 25,
    shiptype: 'navigation',
    name: 'GCSL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148280,
  },
  {
    mmsi: 994148295,
    lng: 105.629282,
    lat: 28.925147,
    lastdyn: 1719859822,
    type: 24,
    shiptype: 'navigation',
    name: 'TJTR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148295,
  },
  {
    mmsi: 994148285,
    lng: 105.549125,
    lat: 28.94664,
    lastdyn: 1719859813,
    type: 24,
    shiptype: 'navigation',
    name: 'DKZ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148285,
  },
  {
    mmsi: 994148294,
    lng: 105.706807,
    lat: 28.874205,
    lastdyn: 1719859757,
    type: 25,
    shiptype: 'navigation',
    name: 'LDQ4L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148294,
  },
  {
    mmsi: 994148274,
    lng: 105.595157,
    lat: 28.9566,
    lastdyn: 1719859713,
    type: 25,
    shiptype: 'navigation',
    name: 'MZS1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148274,
  },
  {
    mmsi: 994148246,
    lng: 105.69219,
    lat: 28.870682,
    lastdyn: 1719859914,
    type: 25,
    shiptype: 'navigation',
    name: 'SBCDQZ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148246,
  },
  {
    mmsi: 994148231,
    lng: 105.646753,
    lat: 28.875538,
    lastdyn: 1719859818,
    type: 24,
    shiptype: 'navigation',
    name: 'XNQ2R',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148231,
  },
  {
    mmsi: 994148234,
    lng: 105.640947,
    lat: 28.87467,
    lastdyn: 1719859852,
    type: 24,
    shiptype: 'navigation',
    name: 'DZB1R',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148234,
  },
  {
    mmsi: 994148254,
    lng: 105.645135,
    lat: 28.920133,
    lastdyn: 1719859712,
    type: 24,
    shiptype: 'navigation',
    name: 'BPQ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148254,
  },
  {
    mmsi: 994148283,
    lng: 105.560527,
    lat: 28.956508,
    lastdyn: 1719859799,
    type: 24,
    shiptype: 'navigation',
    name: 'GDQ4R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148283,
  },
  {
    mmsi: 994148252,
    lng: 105.646493,
    lat: 28.914268,
    lastdyn: 1719859910,
    type: 24,
    shiptype: 'navigation',
    name: 'BPQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148252,
  },
  {
    mmsi: 994148292,
    lng: 105.669802,
    lat: 28.871777,
    lastdyn: 1719859470,
    type: 24,
    shiptype: 'navigation',
    name: 'CYQR',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148292,
  },
  {
    mmsi: 994148261,
    lng: 105.624357,
    lat: 28.929297,
    lastdyn: 1719859780,
    type: 25,
    shiptype: 'navigation',
    name: 'STB2L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148261,
  },
  {
    mmsi: 994148236,
    lng: 105.623825,
    lat: 28.873935,
    lastdyn: 1719859653,
    type: 25,
    shiptype: 'navigation',
    name: 'SBZ1L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148236,
  },
  {
    mmsi: 994148290,
    lng: 105.674933,
    lat: 28.870898,
    lastdyn: 1719859491,
    type: 25,
    shiptype: 'navigation',
    name: 'LJZ2L',
    length: 0,
    width: 2,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148290,
  },
  {
    mmsi: 994148260,
    lng: 105.629775,
    lat: 28.92764,
    lastdyn: 1719859767,
    type: 25,
    shiptype: 'navigation',
    name: 'STB1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148260,
  },
  {
    mmsi: 994148269,
    lng: 105.725162,
    lat: 28.888988,
    lastdyn: 1719859826,
    type: 25,
    shiptype: 'navigation',
    name: 'DBXL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148269,
  },
  {
    mmsi: 994148267,
    lng: 105.7155,
    lat: 28.879987,
    lastdyn: 1719859799,
    type: 25,
    shiptype: 'navigation',
    name: 'LDQ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148267,
  },
  {
    mmsi: 994148251,
    lng: 105.645102,
    lat: 28.908107,
    lastdyn: 1719859836,
    type: 24,
    shiptype: 'navigation',
    name: 'BPQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148251,
  },
  {
    mmsi: 994148268,
    lng: 105.721422,
    lat: 28.884112,
    lastdyn: 1719859813,
    type: 25,
    shiptype: 'navigation',
    name: 'LDQ1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148268,
  },
  {
    mmsi: 999999926,
    lng: 181,
    lat: 91,
    lastdyn: 1685944805,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 1,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999926,
  },
  {
    mmsi: 994131352,
    lng: 121.816375,
    lat: 28.827337,
    lastdyn: 1719819177,
    type: 19,
    shiptype: 'navigation',
    name: 'TZ FENG DIAN 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131352,
  },
  {
    mmsi: 994131340,
    lng: 121.813562,
    lat: 28.825928,
    lastdyn: 1719820295,
    type: 1,
    shiptype: 'navigation',
    name: 'TZ LH FD XN6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131340,
  },
  {
    mmsi: 994131351,
    lng: 121.88126,
    lat: 28.817747,
    lastdyn: 1719828837,
    type: 19,
    shiptype: 'navigation',
    name: 'TZ FENG DIAN 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131351,
  },
  {
    mmsi: 994131350,
    lng: 121.898037,
    lat: 28.849227,
    lastdyn: 1719820503,
    type: 19,
    shiptype: 'navigation',
    name: 'TZ FENG DIAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131350,
  },
  {
    mmsi: 994131337,
    lng: 121.901208,
    lat: 28.85095,
    lastdyn: 1719825160,
    type: 1,
    shiptype: 'navigation',
    name: 'TZ LH FD XN3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131337,
  },
  {
    mmsi: 994131338,
    lng: 121.882478,
    lat: 28.815787,
    lastdyn: 1719822454,
    type: 1,
    shiptype: 'navigation',
    name: 'TZ LH FD XN4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131338,
  },
  {
    mmsi: 994131339,
    lng: 121.848022,
    lat: 28.820862,
    lastdyn: 1719669289,
    type: 1,
    shiptype: 'navigation',
    name: 'TZ LH FD XN5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131339,
  },
  {
    mmsi: 994131353,
    lng: 121.826332,
    lat: 28.849127,
    lastdyn: 1719859024,
    type: 19,
    shiptype: 'navigation',
    name: 'TZ FENG DIAN 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131353,
  },
  {
    mmsi: 994131336,
    lng: 121.863087,
    lat: 28.850942,
    lastdyn: 1719825160,
    type: 1,
    shiptype: 'navigation',
    name: 'TZ LH FD XN2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131336,
  },
  {
    mmsi: 994131335,
    lng: 121.824953,
    lat: 28.850922,
    lastdyn: 1719825155,
    type: 1,
    shiptype: 'navigation',
    name: 'TZ LH FD XN1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994131335,
  },
  {
    mmsi: 994126404,
    lng: 122.243612,
    lat: 28.873447,
    lastdyn: 1719859859,
    type: 28,
    shiptype: 'navigation',
    name: 'YSCC01 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126404,
  },
  {
    mmsi: 994121592,
    lng: 122.03468,
    lat: 28.95535,
    lastdyn: 1719499090,
    type: 30,
    shiptype: 'navigation',
    name: 'XS FENG DIAN L40',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121592,
  },
  {
    mmsi: 994126414,
    lng: 122.557058,
    lat: 28.94103,
    lastdyn: 1719859862,
    type: 28,
    shiptype: 'navigation',
    name: 'YSCC02 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126414,
  },
  {
    mmsi: 999999909,
    lng: -40.866587,
    lat: -21.825065,
    lastdyn: 1719859331,
    type: 25,
    shiptype: 'navigation',
    name: 'BAT109',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999909,
  },
  {
    mmsi: 994148243,
    lng: 105.98755,
    lat: 29.0587,
    lastdyn: 1719859800,
    type: 24,
    shiptype: 'navigation',
    name: 'JZN2R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148243,
  },
  {
    mmsi: 994148245,
    lng: 105.855032,
    lat: 29.012532,
    lastdyn: 1719859803,
    type: 24,
    shiptype: 'navigation',
    name: 'JMSR',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148245,
  },
  {
    mmsi: 994148244,
    lng: 105.878583,
    lat: 29.03275,
    lastdyn: 1719859882,
    type: 25,
    shiptype: 'navigation',
    name: 'WZB2L',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148244,
  },
  {
    mmsi: 994148202,
    lng: 106.121617,
    lat: 29.070433,
    lastdyn: 1719859859,
    type: 25,
    shiptype: 'navigation',
    name: 'SYZL',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148202,
  },
  {
    mmsi: 994148242,
    lng: 106.151732,
    lat: 29.221732,
    lastdyn: 1719859802,
    type: 24,
    shiptype: 'navigation',
    name: 'HZQ1R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148242,
  },
  {
    mmsi: 994126448,
    lng: 121.688388,
    lat: 29.043138,
    lastdyn: 1719859651,
    type: 28,
    shiptype: 'navigation',
    name: 'DA JIAO LUAN ZI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126448,
  },
  {
    mmsi: 994136402,
    lng: 121.703167,
    lat: 29.066,
    lastdyn: 1719859846,
    type: 28,
    shiptype: 'navigation',
    name: 'ZSY 06503 WRECK',
    length: 12,
    width: 2,
    left: 1,
    trail: 6,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136402,
  },
  {
    mmsi: 999412374,
    lng: 121.975445,
    lat: 29.158787,
    lastdyn: 1719859739,
    type: 19,
    shiptype: 'navigation',
    name: 'SHAN LAN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412374,
  },
  {
    mmsi: 994136535,
    lng: 121.967805,
    lat: 29.195388,
    lastdyn: 1719859853,
    type: 28,
    shiptype: 'navigation',
    name: 'LAO HU JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136535,
  },
  {
    mmsi: 994136390,
    lng: 121.990167,
    lat: 29.015805,
    lastdyn: 1719859850,
    type: 28,
    shiptype: 'navigation',
    name: 'NYJ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136390,
  },
  {
    mmsi: 994121557,
    lng: 121.991455,
    lat: 29.032875,
    lastdyn: 1719859862,
    type: 19,
    shiptype: 'navigation',
    name: 'XS FENG DIAN 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121557,
  },
  {
    mmsi: 994126314,
    lng: 121.985,
    lat: 29.196667,
    lastdyn: 1719859876,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL07',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126314,
  },
  {
    mmsi: 994126315,
    lng: 122.006,
    lat: 29.097333,
    lastdyn: 1719859879,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL08',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126315,
  },
  {
    mmsi: 994121555,
    lng: 122.059797,
    lat: 29.09917,
    lastdyn: 1719859864,
    type: 19,
    shiptype: 'navigation',
    name: 'XS FENG DIAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121555,
  },
  {
    mmsi: 994136487,
    lng: 122.15275,
    lat: 29.087138,
    lastdyn: 1719859856,
    type: 28,
    shiptype: 'navigation',
    name: 'YI HE JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136487,
  },
  {
    mmsi: 994136569,
    lng: 122.157167,
    lat: 29.177167,
    lastdyn: 1719859865,
    type: 28,
    shiptype: 'navigation',
    name: 'ZLY 88808 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136569,
  },
  {
    mmsi: 999412375,
    lng: 122.080765,
    lat: 29.189892,
    lastdyn: 1719859741,
    type: 1,
    shiptype: 'navigation',
    name: 'WU JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412375,
  },
  {
    mmsi: 994136379,
    lng: 122.07055,
    lat: 29.235867,
    lastdyn: 1719859855,
    type: 28,
    shiptype: 'navigation',
    name: 'JLJ WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136379,
  },
  {
    mmsi: 994126313,
    lng: 122.021667,
    lat: 29.231667,
    lastdyn: 1719859873,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL06',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126313,
  },
  {
    mmsi: 994121556,
    lng: 122.015002,
    lat: 29.102243,
    lastdyn: 1719859770,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN TIAN 3',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121556,
  },
  {
    mmsi: 994121558,
    lng: 122.038787,
    lat: 29.03709,
    lastdyn: 1719859909,
    type: 19,
    shiptype: 'navigation',
    name: 'XS FENG DIAN 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121558,
  },
  {
    mmsi: 994136331,
    lng: 122.46763,
    lat: 29.15338,
    lastdyn: 1719859868,
    type: 28,
    shiptype: 'navigation',
    name: 'ZXY 49055 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136331,
  },
  {
    mmsi: 994126301,
    lng: 122.261112,
    lat: 29.155833,
    lastdyn: 1719859867,
    type: 28,
    shiptype: 'navigation',
    name: 'TTSD WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126301,
  },
  {
    mmsi: 994121587,
    lng: 122.50681,
    lat: 29.06237,
    lastdyn: 1719813250,
    type: 30,
    shiptype: 'navigation',
    name: 'XS CE FENG 3',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121587,
  },
  {
    mmsi: 994146304,
    lng: 106.313417,
    lat: 29.2611,
    lastdyn: 1719859802,
    type: 30,
    shiptype: 'navigation',
    name: 'HQS2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146304,
  },
  {
    mmsi: 999999916,
    lng: -40.919367,
    lat: -21.813875,
    lastdyn: 1719859340,
    type: 24,
    shiptype: 'navigation',
    name: 'BAT116',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999916,
  },
  {
    mmsi: 994126323,
    lng: 122.049917,
    lat: 29.461888,
    lastdyn: 1719859882,
    type: 28,
    shiptype: 'navigation',
    name: 'PAO LU JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126323,
  },
  {
    mmsi: 994136599,
    lng: 122.042612,
    lat: 29.3745,
    lastdyn: 1719859837,
    type: 28,
    shiptype: 'navigation',
    name: 'W M WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136599,
  },
  {
    mmsi: 994121575,
    lng: 122.04273,
    lat: 29.474447,
    lastdyn: 1719859869,
    type: 30,
    shiptype: 'navigation',
    name: 'XS TC FENG DIAN L5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121575,
  },
  {
    mmsi: 994126306,
    lng: 122.0275,
    lat: 29.4725,
    lastdyn: 1719859915,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL03',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126306,
  },
  {
    mmsi: 994126309,
    lng: 122.016667,
    lat: 29.295,
    lastdyn: 1719859870,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL05',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126309,
  },
  {
    mmsi: 994126307,
    lng: 122.04275,
    lat: 29.348888,
    lastdyn: 1719859918,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL04',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126307,
  },
  {
    mmsi: 994121574,
    lng: 122.085447,
    lat: 29.47419,
    lastdyn: 1719859885,
    type: 30,
    shiptype: 'navigation',
    name: 'XS TC FENG DIAN L4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121574,
  },
  {
    mmsi: 999412372,
    lng: 122.135053,
    lat: 29.272393,
    lastdyn: 1719859742,
    type: 17,
    shiptype: 'navigation',
    name: 'BAN YANG JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412372,
  },
  {
    mmsi: 994121505,
    lng: 122.080552,
    lat: 29.478638,
    lastdyn: 1719859649,
    type: 19,
    shiptype: 'navigation',
    name: 'TC FENG DIAN 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121505,
  },
  {
    mmsi: 994121506,
    lng: 122.047125,
    lat: 29.478607,
    lastdyn: 1719859777,
    type: 19,
    shiptype: 'navigation',
    name: 'TC FENG DIAN 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121506,
  },
  {
    mmsi: 994136343,
    lng: 122.317778,
    lat: 29.426167,
    lastdyn: 1719859852,
    type: 28,
    shiptype: 'navigation',
    name: 'ZXY 95007 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136343,
  },
  {
    mmsi: 994126532,
    lng: 122.506583,
    lat: 29.323817,
    lastdyn: 1719859885,
    type: 28,
    shiptype: 'navigation',
    name: 'MLH 6 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126532,
  },
  {
    mmsi: 994146303,
    lng: 106.574067,
    lat: 29.5661,
    lastdyn: 1719859802,
    type: 24,
    shiptype: 'navigation',
    name: 'QSMQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146303,
  },
  {
    mmsi: 994146302,
    lng: 106.57835,
    lat: 29.5674,
    lastdyn: 1719859420,
    type: 24,
    shiptype: 'navigation',
    name: 'QSMQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146302,
  },
  {
    mmsi: 994148301,
    lng: 106.787167,
    lat: 29.6082,
    lastdyn: 1719859803,
    type: 25,
    shiptype: 'navigation',
    name: 'SESL',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148301,
  },
  {
    mmsi: 999999996,
    lng: 28.63198,
    lat: 44.163828,
    lastdyn: 1703080264,
    type: 24,
    shiptype: 'navigation',
    name: 'RED MM19950 SL',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999996,
  },
  {
    mmsi: 994121546,
    lng: 121.948053,
    lat: 29.645182,
    lastdyn: 1719858779,
    type: 24,
    shiptype: 'navigation',
    name: 'WAI GAN MEN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121546,
  },
  {
    mmsi: 994121596,
    lng: 121.995623,
    lat: 29.733172,
    lastdyn: 1719859220,
    type: 30,
    shiptype: 'navigation',
    name: 'QLMDAQIAOL34',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121596,
  },
  {
    mmsi: 994121593,
    lng: 121.984062,
    lat: 29.730683,
    lastdyn: 1719858968,
    type: 30,
    shiptype: 'navigation',
    name: 'QLMDAQIAOL9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121593,
  },
  {
    mmsi: 999412350,
    lng: 121.80952,
    lat: 29.623643,
    lastdyn: 1719859577,
    type: 1,
    shiptype: 'navigation',
    name: 'XIANG QIAO 113 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412350,
  },
  {
    mmsi: 994121502,
    lng: 121.9974,
    lat: 29.65427,
    lastdyn: 1719857574,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANG SHAN GANG 8',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121502,
  },
  {
    mmsi: 999412353,
    lng: 121.827483,
    lat: 29.629278,
    lastdyn: 1719859744,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANG QIAO 2 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412353,
  },
  {
    mmsi: 994121594,
    lng: 121.991358,
    lat: 29.741808,
    lastdyn: 1719857651,
    type: 30,
    shiptype: 'navigation',
    name: 'QLMDAQIAOL10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121594,
  },
  {
    mmsi: 994121595,
    lng: 121.981788,
    lat: 29.739493,
    lastdyn: 1719858905,
    type: 30,
    shiptype: 'navigation',
    name: 'QLMDAQIAOL30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121595,
  },
  {
    mmsi: 999412351,
    lng: 121.79519,
    lat: 29.61483,
    lastdyn: 1719859809,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANG QIAO 8 HAO',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412351,
  },
  {
    mmsi: 999412352,
    lng: 121.791018,
    lat: 29.618012,
    lastdyn: 1719859804,
    type: 25,
    shiptype: 'navigation',
    name: 'XIANG QIAO 7 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412352,
  },
  {
    mmsi: 999412354,
    lng: 121.82362,
    lat: 29.63261,
    lastdyn: 1719859741,
    type: 25,
    shiptype: 'navigation',
    name: 'XIANG QIAO 1 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412354,
  },
  {
    mmsi: 994136580,
    lng: 122.107362,
    lat: 29.611972,
    lastdyn: 1719859893,
    type: 25,
    shiptype: 'navigation',
    name: 'XSG 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136580,
  },
  {
    mmsi: 994121507,
    lng: 122.02918,
    lat: 29.58564,
    lastdyn: 1719859812,
    type: 19,
    shiptype: 'navigation',
    name: 'TC FENG DIAN 10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121507,
  },
  {
    mmsi: 994136581,
    lng: 122.051445,
    lat: 29.635417,
    lastdyn: 1719859897,
    type: 25,
    shiptype: 'navigation',
    name: 'XSG 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136581,
  },
  {
    mmsi: 999412376,
    lng: 122.21675,
    lat: 29.55525,
    lastdyn: 1719859876,
    type: 1,
    shiptype: 'navigation',
    name: 'DONG MO PAN JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412376,
  },
  {
    mmsi: 994121514,
    lng: 122.174637,
    lat: 29.561585,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'PU TUO FENG DIAN 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121514,
  },
  {
    mmsi: 994136588,
    lng: 122.232417,
    lat: 29.725778,
    lastdyn: 1719859746,
    type: 29,
    shiptype: 'navigation',
    name: 'D16',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136588,
  },
  {
    mmsi: 994121501,
    lng: 122.04509,
    lat: 29.63435,
    lastdyn: 1719859148,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANG SHAN GANG 6',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121501,
  },
  {
    mmsi: 994121573,
    lng: 122.078765,
    lat: 29.573825,
    lastdyn: 1719859913,
    type: 30,
    shiptype: 'navigation',
    name: 'XS TC FENG DIAN L1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121573,
  },
  {
    mmsi: 999412358,
    lng: 122.169643,
    lat: 29.746015,
    lastdyn: 1719859557,
    type: 23,
    shiptype: 'navigation',
    name: 'WU GANG 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412358,
  },
  {
    mmsi: 994126305,
    lng: 122.013333,
    lat: 29.628333,
    lastdyn: 1719859911,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL02',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126305,
  },
  {
    mmsi: 994136589,
    lng: 122.203612,
    lat: 29.738612,
    lastdyn: 1719859749,
    type: 29,
    shiptype: 'navigation',
    name: 'D17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136589,
  },
  {
    mmsi: 994121576,
    lng: 122.023787,
    lat: 29.590787,
    lastdyn: 1719859869,
    type: 30,
    shiptype: 'navigation',
    name: 'XS TC FENG DIAN L8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121576,
  },
  {
    mmsi: 994136582,
    lng: 122.003612,
    lat: 29.655362,
    lastdyn: 1719859899,
    type: 25,
    shiptype: 'navigation',
    name: 'XSG 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136582,
  },
  {
    mmsi: 999412341,
    lng: 122.021,
    lat: 29.629107,
    lastdyn: 1719859887,
    type: 1,
    shiptype: 'navigation',
    name: 'XIAO DONG YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412341,
  },
  {
    mmsi: 999412356,
    lng: 122.186903,
    lat: 29.729367,
    lastdyn: 1719833529,
    type: 24,
    shiptype: 'navigation',
    name: 'WU GANG 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412356,
  },
  {
    mmsi: 994121500,
    lng: 122.101172,
    lat: 29.611048,
    lastdyn: 1719859766,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANG SHAN GANG 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121500,
  },
  {
    mmsi: 994121504,
    lng: 122.074583,
    lat: 29.570353,
    lastdyn: 1719859799,
    type: 19,
    shiptype: 'navigation',
    name: 'TC FENG DIAN 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121504,
  },
  {
    mmsi: 994126303,
    lng: 122.030333,
    lat: 29.71,
    lastdyn: 1719859908,
    type: 1,
    shiptype: 'navigation',
    name: 'XGHL01',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126303,
  },
  {
    mmsi: 999412357,
    lng: 122.170728,
    lat: 29.738313,
    lastdyn: 1719859746,
    type: 24,
    shiptype: 'navigation',
    name: 'WU GANG 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412357,
  },
  {
    mmsi: 999412364,
    lng: 122.493427,
    lat: 29.692657,
    lastdyn: 1719858853,
    type: 24,
    shiptype: 'navigation',
    name: 'XIA ZHI 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412364,
  },
  {
    mmsi: 999412359,
    lng: 122.360622,
    lat: 29.727252,
    lastdyn: 1719859561,
    type: 24,
    shiptype: 'navigation',
    name: 'XIA ZHI 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412359,
  },
  {
    mmsi: 994121512,
    lng: 122.294543,
    lat: 29.595272,
    lastdyn: 1719859862,
    type: 19,
    shiptype: 'navigation',
    name: 'PT FENG DIAN 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121512,
  },
  {
    mmsi: 999412362,
    lng: 122.449452,
    lat: 29.704673,
    lastdyn: 1719837194,
    type: 24,
    shiptype: 'navigation',
    name: 'XIA ZHI 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412362,
  },
  {
    mmsi: 994136587,
    lng: 122.256388,
    lat: 29.715,
    lastdyn: 1719859743,
    type: 29,
    shiptype: 'navigation',
    name: 'D15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136587,
  },
  {
    mmsi: 999412363,
    lng: 122.460743,
    lat: 29.706358,
    lastdyn: 1719858893,
    type: 25,
    shiptype: 'navigation',
    name: 'XIA ZHI 3',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412363,
  },
  {
    mmsi: 999412361,
    lng: 122.411983,
    lat: 29.719132,
    lastdyn: 1719857218,
    type: 25,
    shiptype: 'navigation',
    name: 'XIA ZHI 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412361,
  },
  {
    mmsi: 999413233,
    lng: 122.331167,
    lat: 29.7375,
    lastdyn: 1719859872,
    type: 29,
    shiptype: 'navigation',
    name: 'D1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413233,
  },
  {
    mmsi: 994136354,
    lng: 122.368222,
    lat: 29.731305,
    lastdyn: 1719859911,
    type: 25,
    shiptype: 'navigation',
    name: 'XIA ZHI 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136354,
  },
  {
    mmsi: 994136422,
    lng: 122.743333,
    lat: 29.621667,
    lastdyn: 1719859898,
    type: 28,
    shiptype: 'navigation',
    name: 'HF 1003 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136422,
  },
  {
    mmsi: 999412301,
    lng: 122.550295,
    lat: 29.680903,
    lastdyn: 1719859338,
    type: 31,
    shiptype: 'navigation',
    name: 'XIA ZHI MEN',
    length: 28,
    width: 12,
    left: 6,
    trail: 14,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412301,
  },
  {
    mmsi: 999412365,
    lng: 122.505133,
    lat: 29.695247,
    lastdyn: 1719855556,
    type: 25,
    shiptype: 'navigation',
    name: 'XIA ZHI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412365,
  },
  {
    mmsi: 994138203,
    lng: 112.422617,
    lat: 29.964882,
    lastdyn: 1719859823,
    type: 25,
    shiptype: 'navigation',
    name: 'ZGD3L',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138203,
  },
  {
    mmsi: 994138202,
    lng: 112.4483,
    lat: 29.7735,
    lastdyn: 1719859891,
    type: 24,
    shiptype: 'navigation',
    name: 'NZW6R',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138202,
  },
  {
    mmsi: 994138201,
    lng: 112.652333,
    lat: 29.757133,
    lastdyn: 1719859825,
    type: 24,
    shiptype: 'navigation',
    name: 'LJP9R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138201,
  },
  {
    mmsi: 994126191,
    lng: 115.405242,
    lat: 29.949507,
    lastdyn: 1719859918,
    type: 30,
    shiptype: 'navigation',
    name: 'FQS1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126191,
  },
  {
    mmsi: 994126194,
    lng: 115.380222,
    lat: 29.972268,
    lastdyn: 1719859844,
    type: 30,
    shiptype: 'navigation',
    name: 'TSLS2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126194,
  },
  {
    mmsi: 994126184,
    lng: 115.430498,
    lat: 29.890682,
    lastdyn: 1719859831,
    type: 24,
    shiptype: 'navigation',
    name: 'FC2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126184,
  },
  {
    mmsi: 994126193,
    lng: 115.432905,
    lat: 29.897445,
    lastdyn: 1719859816,
    type: 30,
    shiptype: 'navigation',
    name: 'HPS2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126193,
  },
  {
    mmsi: 994126105,
    lng: 115.475102,
    lat: 29.856095,
    lastdyn: 1719859775,
    type: 30,
    shiptype: 'navigation',
    name: 'PTS1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126105,
  },
  {
    mmsi: 994121554,
    lng: 121.58197,
    lat: 29.897105,
    lastdyn: 1719859807,
    type: 1,
    shiptype: 'navigation',
    name: 'ZHONGXINGQIAO 3HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121554,
  },
  {
    mmsi: 994121553,
    lng: 121.61714,
    lat: 29.907488,
    lastdyn: 1719859862,
    type: 1,
    shiptype: 'navigation',
    name: 'SAN GUAN TANG 3 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121553,
  },
  {
    mmsi: 999412369,
    lng: 121.65054,
    lat: 29.914398,
    lastdyn: 1719859870,
    type: 1,
    shiptype: 'navigation',
    name: 'MING ZHOU DA QIAO 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412369,
  },
  {
    mmsi: 994121572,
    lng: 122.032573,
    lat: 28.946387,
    lastdyn: 1680316748,
    type: 30,
    shiptype: 'navigation',
    name: 'XS FENG DIAN S L7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121572,
  },
  {
    mmsi: 999412377,
    lng: 121.755852,
    lat: 29.977893,
    lastdyn: 1719859751,
    type: 1,
    shiptype: 'navigation',
    name: 'BEI DAO DI DI TOU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412377,
  },
  {
    mmsi: 994136547,
    lng: 121.8005,
    lat: 29.9805,
    lastdyn: 1719859740,
    type: 28,
    shiptype: 'navigation',
    name: 'XYL 6 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136547,
  },
  {
    mmsi: 994121538,
    lng: 121.91511,
    lat: 29.936187,
    lastdyn: 1719859683,
    type: 25,
    shiptype: 'navigation',
    name: 'CHUAN SHAN XI KOU 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121538,
  },
  {
    mmsi: 994121539,
    lng: 121.914692,
    lat: 29.931137,
    lastdyn: 1719859863,
    type: 25,
    shiptype: 'navigation',
    name: 'DA XIE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121539,
  },
  {
    mmsi: 999412378,
    lng: 121.805473,
    lat: 29.98286,
    lastdyn: 1719859870,
    type: 17,
    shiptype: 'navigation',
    name: 'E JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412378,
  },
  {
    mmsi: 994121508,
    lng: 121.925953,
    lat: 29.767245,
    lastdyn: 1718503324,
    type: 1,
    shiptype: 'navigation',
    name: 'CHUN XIAO DA QIAO 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121508,
  },
  {
    mmsi: 999413254,
    lng: 121.9625,
    lat: 29.992362,
    lastdyn: 1719859795,
    type: 29,
    shiptype: 'navigation',
    name: 'D13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413254,
  },
  {
    mmsi: 999413252,
    lng: 121.807333,
    lat: 29.9965,
    lastdyn: 1719859792,
    type: 29,
    shiptype: 'navigation',
    name: 'D12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413252,
  },
  {
    mmsi: 994136590,
    lng: 122.178333,
    lat: 29.750667,
    lastdyn: 1719859752,
    type: 29,
    shiptype: 'navigation',
    name: 'D18',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136590,
  },
  {
    mmsi: 999413245,
    lng: 122.0275,
    lat: 29.923667,
    lastdyn: 1719859786,
    type: 29,
    shiptype: 'navigation',
    name: 'D9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413245,
  },
  {
    mmsi: 994121523,
    lng: 122.174593,
    lat: 29.963475,
    lastdyn: 1719010190,
    type: 0,
    shiptype: 'navigation',
    name: 'WU SHUI JIAN CE 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121523,
  },
  {
    mmsi: 999413222,
    lng: 122.146278,
    lat: 29.8015,
    lastdyn: 1719859865,
    type: 28,
    shiptype: 'navigation',
    name: 'XI BAI LIAN XI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413222,
  },
  {
    mmsi: 999413247,
    lng: 122,
    lat: 29.9475,
    lastdyn: 1719859789,
    type: 29,
    shiptype: 'navigation',
    name: 'D10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413247,
  },
  {
    mmsi: 994121582,
    lng: 122.03377,
    lat: 29.82807,
    lastdyn: 1719859865,
    type: 30,
    shiptype: 'navigation',
    name: 'MEISHANL6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121582,
  },
  {
    mmsi: 999413279,
    lng: 122.109917,
    lat: 29.802083,
    lastdyn: 1719859899,
    type: 24,
    shiptype: 'navigation',
    name: 'FO DU 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413279,
  },
  {
    mmsi: 994121578,
    lng: 122.074882,
    lat: 29.81536,
    lastdyn: 1719859864,
    type: 30,
    shiptype: 'navigation',
    name: 'MEI SHAN L2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121578,
  },
  {
    mmsi: 994121581,
    lng: 122.04767,
    lat: 29.8314,
    lastdyn: 1719859681,
    type: 30,
    shiptype: 'navigation',
    name: 'MEI SHAN L5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121581,
  },
  {
    mmsi: 994126351,
    lng: 122.04,
    lat: 29.973333,
    lastdyn: 1719854160,
    type: 28,
    shiptype: 'navigation',
    name: 'HD 186 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126351,
  },
  {
    mmsi: 994121577,
    lng: 122.054633,
    lat: 29.798852,
    lastdyn: 1719859553,
    type: 30,
    shiptype: 'navigation',
    name: 'MEI SHAN L1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121577,
  },
  {
    mmsi: 999413259,
    lng: 122.170722,
    lat: 29.905833,
    lastdyn: 1719859896,
    type: 31,
    shiptype: 'navigation',
    name: 'XIAO YANG MAO BEI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413259,
  },
  {
    mmsi: 999413242,
    lng: 122.12,
    lat: 29.922917,
    lastdyn: 1719859890,
    type: 29,
    shiptype: 'navigation',
    name: 'D7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413242,
  },
  {
    mmsi: 999413244,
    lng: 122.072,
    lat: 29.922667,
    lastdyn: 1719859893,
    type: 29,
    shiptype: 'navigation',
    name: 'D8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413244,
  },
  {
    mmsi: 999412387,
    lng: 122.166668,
    lat: 29.828483,
    lastdyn: 1719859386,
    type: 24,
    shiptype: 'navigation',
    name: 'FO DU 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412387,
  },
  {
    mmsi: 994136381,
    lng: 122.2102,
    lat: 29.882233,
    lastdyn: 1719859905,
    type: 28,
    shiptype: 'navigation',
    name: 'JIANHONG 18 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136381,
  },
  {
    mmsi: 994131802,
    lng: 181,
    lat: 91,
    lastdyn: 1694388502,
    type: 0,
    shiptype: 'navigation',
    name: 'LANG HUA JIAO DENG T',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131802,
  },
  {
    mmsi: 994121579,
    lng: 122.07066,
    lat: 29.83068,
    lastdyn: 1719859277,
    type: 30,
    shiptype: 'navigation',
    name: 'MEISHANL3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121579,
  },
  {
    mmsi: 999990011,
    lng: 122.174497,
    lat: 29.963508,
    lastdyn: 1719859013,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST 011',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990011,
  },
  {
    mmsi: 994126473,
    lng: 122.21936,
    lat: 29.805555,
    lastdyn: 1719859905,
    type: 28,
    shiptype: 'navigation',
    name: 'QS 866 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126473,
  },
  {
    mmsi: 999413241,
    lng: 122.185667,
    lat: 29.88,
    lastdyn: 1719859887,
    type: 29,
    shiptype: 'navigation',
    name: 'D6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413241,
  },
  {
    mmsi: 994121580,
    lng: 122.0605,
    lat: 29.83589,
    lastdyn: 1719858739,
    type: 30,
    shiptype: 'navigation',
    name: 'MEISHANL4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121580,
  },
  {
    mmsi: 999412348,
    lng: 122.34736,
    lat: 29.843305,
    lastdyn: 1719859802,
    type: 21,
    shiptype: 'navigation',
    name: 'TONG QIAN JIAO AIS',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412348,
  },
  {
    mmsi: 999413235,
    lng: 122.294667,
    lat: 29.765833,
    lastdyn: 1719859875,
    type: 29,
    shiptype: 'navigation',
    name: 'D2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413235,
  },
  {
    mmsi: 994126418,
    lng: 122.335683,
    lat: 29.834383,
    lastdyn: 1719859895,
    type: 28,
    shiptype: 'navigation',
    name: 'XUAN BO GU DONG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126418,
  },
  {
    mmsi: 994126500,
    lng: 122.410333,
    lat: 29.831112,
    lastdyn: 1719859893,
    type: 17,
    shiptype: 'navigation',
    name: 'QING SHAN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126500,
  },
  {
    mmsi: 999413215,
    lng: 122.459167,
    lat: 29.845,
    lastdyn: 1719859905,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHU JIA JIAN DONG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413215,
  },
  {
    mmsi: 994121586,
    lng: 121.89478,
    lat: 30.27468,
    lastdyn: 1719858624,
    type: 24,
    shiptype: 'navigation',
    name: 'YU SHAN Y18',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121586,
  },
  {
    mmsi: 999413238,
    lng: 122.266638,
    lat: 29.786333,
    lastdyn: 1719859878,
    type: 29,
    shiptype: 'navigation',
    name: 'D3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413238,
  },
  {
    mmsi: 999413275,
    lng: 122.503167,
    lat: 29.76925,
    lastdyn: 1719859866,
    type: 28,
    shiptype: 'navigation',
    name: 'XING BI HAI 58 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413275,
  },
  {
    mmsi: 994136518,
    lng: 122.548055,
    lat: 29.995278,
    lastdyn: 1719859914,
    type: 28,
    shiptype: 'navigation',
    name: 'MIN HENG 69 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136518,
  },
  {
    mmsi: 999413284,
    lng: 122.565833,
    lat: 29.918333,
    lastdyn: 1719859869,
    type: 28,
    shiptype: 'navigation',
    name: 'QUANXING98 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413284,
  },
  {
    mmsi: 994126530,
    lng: 122.653333,
    lat: 29.803333,
    lastdyn: 1719859849,
    type: 28,
    shiptype: 'navigation',
    name: 'ZPY 71331 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126530,
  },
  {
    mmsi: 999412379,
    lng: 122.522927,
    lat: 29.985138,
    lastdyn: 1719859681,
    type: 1,
    shiptype: 'navigation',
    name: 'CHUAN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412379,
  },
  {
    mmsi: 994136442,
    lng: 122.556667,
    lat: 29.926667,
    lastdyn: 1719859917,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHE PU YU YUN 48797',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136442,
  },
  {
    mmsi: 999992403,
    lng: 123.10793,
    lat: 29.80891,
    lastdyn: 1719857998,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2403',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992403,
  },
  {
    mmsi: 994148401,
    lng: 108.00375,
    lat: 30.23435,
    lastdyn: 1719859803,
    type: 25,
    shiptype: 'navigation',
    name: 'ZZQ2L',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148401,
  },
  {
    mmsi: 994126181,
    lng: 115.174142,
    lat: 30.215962,
    lastdyn: 1719859879,
    type: 24,
    shiptype: 'navigation',
    name: 'DSF4R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126181,
  },
  {
    mmsi: 994126180,
    lng: 115.261948,
    lat: 30.151948,
    lastdyn: 1719859761,
    type: 30,
    shiptype: 'navigation',
    name: 'YQ10HB2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126180,
  },
  {
    mmsi: 999413002,
    lng: 120,
    lat: 30,
    lastdyn: 1719859854,
    type: 25,
    shiptype: 'navigation',
    name: 'VIRTUAL ATON 002',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413002,
  },
  {
    mmsi: 999413001,
    lng: 120,
    lat: 30,
    lastdyn: 1719859853,
    type: 25,
    shiptype: 'navigation',
    name: 'VIRTUAL ATON 001',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413001,
  },
  {
    mmsi: 999413005,
    lng: 120,
    lat: 30,
    lastdyn: 1719859854,
    type: 25,
    shiptype: 'navigation',
    name: 'VIRTUAL ATON 005',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413005,
  },
  {
    mmsi: 999413003,
    lng: 120.27855,
    lat: 36.032167,
    lastdyn: 1719859911,
    type: 29,
    shiptype: 'navigation',
    name: 'PRECAUTION AREA SAFE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413003,
  },
  {
    mmsi: 999413004,
    lng: 120,
    lat: 30,
    lastdyn: 1719859854,
    type: 25,
    shiptype: 'navigation',
    name: 'VIRTUAL ATON 004',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413004,
  },
  {
    mmsi: 999412367,
    lng: 120.77674,
    lat: 30.24038,
    lastdyn: 1719859864,
    type: 1,
    shiptype: 'navigation',
    name: 'I91117AIS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412367,
  },
  {
    mmsi: 994136371,
    lng: 121.706912,
    lat: 30.053153,
    lastdyn: 1719859823,
    type: 1,
    shiptype: 'navigation',
    name: 'CZGD 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136371,
  },
  {
    mmsi: 994136338,
    lng: 121.699333,
    lat: 30.038695,
    lastdyn: 1719859750,
    type: 30,
    shiptype: 'navigation',
    name: 'JTDQ 443',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136338,
  },
  {
    mmsi: 994121524,
    lng: 121.683482,
    lat: 30.116527,
    lastdyn: 1719859794,
    type: 29,
    shiptype: 'navigation',
    name: 'ZH DIAN CHANG',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121524,
  },
  {
    mmsi: 999412349,
    lng: 121.80125,
    lat: 30.167692,
    lastdyn: 1719859863,
    type: 24,
    shiptype: 'navigation',
    name: 'DONG HUO SHAN 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412349,
  },
  {
    mmsi: 994121518,
    lng: 121.995565,
    lat: 30.2389,
    lastdyn: 1719859899,
    type: 25,
    shiptype: 'navigation',
    name: 'DAI QIAO 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121518,
  },
  {
    mmsi: 994136372,
    lng: 121.948183,
    lat: 30.141417,
    lastdyn: 1719859812,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHE DING 45178 WRECK',
    length: 54,
    width: 10,
    left: 5,
    trail: 27,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136372,
  },
  {
    mmsi: 999412393,
    lng: 121.873355,
    lat: 30.194905,
    lastdyn: 1719859681,
    type: 25,
    shiptype: 'navigation',
    name: 'YAN DUN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412393,
  },
  {
    mmsi: 994121521,
    lng: 121.942267,
    lat: 30.247593,
    lastdyn: 1719859624,
    type: 30,
    shiptype: 'navigation',
    name: 'YU SHAN HAI LAN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121521,
  },
  {
    mmsi: 994136377,
    lng: 121.830055,
    lat: 30.159278,
    lastdyn: 1719859823,
    type: 1,
    shiptype: 'navigation',
    name: 'CZGD 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136377,
  },
  {
    mmsi: 999412303,
    lng: 121.801742,
    lat: 30.028075,
    lastdyn: 1719859878,
    type: 25,
    shiptype: 'navigation',
    name: 'JIN TANG DA QIAO 11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412303,
  },
  {
    mmsi: 999412398,
    lng: 121.804613,
    lat: 30.06087,
    lastdyn: 1719859878,
    type: 2,
    shiptype: 'navigation',
    name: 'JIN TANG DA QIAO 14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412398,
  },
  {
    mmsi: 994126541,
    lng: 121.93565,
    lat: 30.200917,
    lastdyn: 1719859819,
    type: 23,
    shiptype: 'navigation',
    name: 'GLSX',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126541,
  },
  {
    mmsi: 994121519,
    lng: 121.99304,
    lat: 30.2295,
    lastdyn: 1719859861,
    type: 24,
    shiptype: 'navigation',
    name: 'DAI QIAO 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121519,
  },
  {
    mmsi: 999412392,
    lng: 121.912118,
    lat: 30.166012,
    lastdyn: 1719859811,
    type: 25,
    shiptype: 'navigation',
    name: 'YAN DUN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412392,
  },
  {
    mmsi: 999412388,
    lng: 121.809937,
    lat: 30.028418,
    lastdyn: 1719859901,
    type: 24,
    shiptype: 'navigation',
    name: 'JIN TANG DA QIAO 12',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412388,
  },
  {
    mmsi: 999412302,
    lng: 121.80256,
    lat: 30.11774,
    lastdyn: 1719859801,
    type: 29,
    shiptype: 'navigation',
    name: 'JIN TANG BEI KOU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412302,
  },
  {
    mmsi: 994121560,
    lng: 121.980802,
    lat: 30.178788,
    lastdyn: 1719859866,
    type: 1,
    shiptype: 'navigation',
    name: 'DAI QIAO 407',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121560,
  },
  {
    mmsi: 999413255,
    lng: 121.939333,
    lat: 30.038,
    lastdyn: 1719859800,
    type: 29,
    shiptype: 'navigation',
    name: 'D14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413255,
  },
  {
    mmsi: 994136378,
    lng: 121.886328,
    lat: 30.157853,
    lastdyn: 1719859827,
    type: 1,
    shiptype: 'navigation',
    name: 'CZGD 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136378,
  },
  {
    mmsi: 999412390,
    lng: 121.799402,
    lat: 30.09274,
    lastdyn: 1719859752,
    type: 24,
    shiptype: 'navigation',
    name: 'JIN TANG DA QIAO 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412390,
  },
  {
    mmsi: 999412389,
    lng: 121.80769,
    lat: 30.09328,
    lastdyn: 1719859680,
    type: 24,
    shiptype: 'navigation',
    name: 'JIN TANG DA QIAO 2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412389,
  },
  {
    mmsi: 999412397,
    lng: 121.9595,
    lat: 30.1004,
    lastdyn: 1719859740,
    type: 1,
    shiptype: 'navigation',
    name: 'TAOYAOMEN DA QIAO',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412397,
  },
  {
    mmsi: 999412399,
    lng: 121.918468,
    lat: 30.064365,
    lastdyn: 1719859888,
    type: 2,
    shiptype: 'navigation',
    name: 'XI HOU MEN 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412399,
  },
  {
    mmsi: 994136520,
    lng: 121.975833,
    lat: 30.089943,
    lastdyn: 1719859821,
    type: 28,
    shiptype: 'navigation',
    name: 'XJMDQ 6 H',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136520,
  },
  {
    mmsi: 994126511,
    lng: 121.973945,
    lat: 30.088778,
    lastdyn: 1719859816,
    type: 17,
    shiptype: 'navigation',
    name: 'XJMDQ 5 H',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126511,
  },
  {
    mmsi: 994121520,
    lng: 121.918402,
    lat: 30.21723,
    lastdyn: 1719859527,
    type: 30,
    shiptype: 'navigation',
    name: 'YU SHAN HAI LAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121520,
  },
  {
    mmsi: 994136375,
    lng: 121.76885,
    lat: 30.106542,
    lastdyn: 1719859823,
    type: 1,
    shiptype: 'navigation',
    name: 'CZGD 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136375,
  },
  {
    mmsi: 994121537,
    lng: 121.982005,
    lat: 30.091742,
    lastdyn: 1719859862,
    type: 1,
    shiptype: 'navigation',
    name: 'FU CHI MEN QIAO 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121537,
  },
  {
    mmsi: 994136488,
    lng: 121.856,
    lat: 30.203333,
    lastdyn: 1719859802,
    type: 28,
    shiptype: 'navigation',
    name: 'XZJJH 0009 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136488,
  },
  {
    mmsi: 994126436,
    lng: 122.085333,
    lat: 30.160055,
    lastdyn: 1719859760,
    type: 21,
    shiptype: 'navigation',
    name: 'MA AO DONG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126436,
  },
  {
    mmsi: 994136401,
    lng: 122.163333,
    lat: 30.22,
    lastdyn: 1719859762,
    type: 28,
    shiptype: 'navigation',
    name: 'ZD 66395 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136401,
  },
  {
    mmsi: 994121517,
    lng: 122.027425,
    lat: 30.215265,
    lastdyn: 1719859896,
    type: 24,
    shiptype: 'navigation',
    name: 'DAI QIAO 2 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121517,
  },
  {
    mmsi: 994121527,
    lng: 122.075358,
    lat: 30.200998,
    lastdyn: 1719859731,
    type: 0,
    shiptype: 'navigation',
    name: 'ZHI ZHONG NAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121527,
  },
  {
    mmsi: 999412346,
    lng: 122.202792,
    lat: 30.224025,
    lastdyn: 1719859743,
    type: 1,
    shiptype: 'navigation',
    name: 'GUAN SHAN DA QIAO 3',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412346,
  },
  {
    mmsi: 994136506,
    lng: 122.228667,
    lat: 30.2355,
    lastdyn: 1719859765,
    type: 28,
    shiptype: 'navigation',
    name: 'RZ 688 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136506,
  },
  {
    mmsi: 999412368,
    lng: 122.083328,
    lat: 30.161037,
    lastdyn: 1719859907,
    type: 20,
    shiptype: 'navigation',
    name: 'MA AO 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412368,
  },
  {
    mmsi: 994126302,
    lng: 122.085167,
    lat: 30.159305,
    lastdyn: 1719859762,
    type: 22,
    shiptype: 'navigation',
    name: 'MA AO NAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126302,
  },
  {
    mmsi: 994121559,
    lng: 122.185347,
    lat: 30.211717,
    lastdyn: 1719859862,
    type: 1,
    shiptype: 'navigation',
    name: 'XIU SHAN DA QIAO 30',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121559,
  },
  {
    mmsi: 994121516,
    lng: 122.03199,
    lat: 30.22357,
    lastdyn: 1719859808,
    type: 25,
    shiptype: 'navigation',
    name: 'DAI QIAO 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121516,
  },
  {
    mmsi: 994126310,
    lng: 122.488333,
    lat: 30.188333,
    lastdyn: 1719859750,
    type: 28,
    shiptype: 'navigation',
    name: 'JS 16 WRECK',
    length: 90,
    width: 14,
    left: 7,
    trail: 45,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126310,
  },
  {
    mmsi: 999993364,
    lng: 122.408338,
    lat: 30.039302,
    lastdyn: 1719858065,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 3364',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993364,
  },
  {
    mmsi: 994126509,
    lng: 122.394167,
    lat: 30.0625,
    lastdyn: 1719859844,
    type: 28,
    shiptype: 'navigation',
    name: 'ZXYY 01158 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126509,
  },
  {
    mmsi: 994121545,
    lng: 122.407068,
    lat: 30.036698,
    lastdyn: 1719858398,
    type: 30,
    shiptype: 'navigation',
    name: 'ZS CHAO LIU NENG 6',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121545,
  },
  {
    mmsi: 994121526,
    lng: 122.329605,
    lat: 30.137425,
    lastdyn: 1719855234,
    type: 25,
    shiptype: 'navigation',
    name: 'GUI SHAN 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121526,
  },
  {
    mmsi: 999412386,
    lng: 122.455063,
    lat: 30.064258,
    lastdyn: 1719859882,
    type: 1,
    shiptype: 'navigation',
    name: 'WAI HUO YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412386,
  },
  {
    mmsi: 994126004,
    lng: 122.622812,
    lat: 30.143182,
    lastdyn: 1719859775,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126004,
  },
  {
    mmsi: 994126021,
    lng: 122.74176,
    lat: 30.222877,
    lastdyn: 1719859873,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126021,
  },
  {
    mmsi: 994126011,
    lng: 122.73706,
    lat: 30.109655,
    lastdyn: 1719859814,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126011,
  },
  {
    mmsi: 994126006,
    lng: 122.624667,
    lat: 30.109667,
    lastdyn: 1719859786,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126006,
  },
  {
    mmsi: 994126001,
    lng: 122.619667,
    lat: 30.2025,
    lastdyn: 1719859757,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126001,
  },
  {
    mmsi: 994126009,
    lng: 122.689362,
    lat: 30.109662,
    lastdyn: 1719859804,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126009,
  },
  {
    mmsi: 994136572,
    lng: 122.619167,
    lat: 30.178888,
    lastdyn: 1719859918,
    type: 28,
    shiptype: 'navigation',
    name: 'FU YANG 77 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136572,
  },
  {
    mmsi: 994126008,
    lng: 122.669807,
    lat: 30.109622,
    lastdyn: 1719859797,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126008,
  },
  {
    mmsi: 994126023,
    lng: 122.685567,
    lat: 30.222927,
    lastdyn: 1719859877,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126023,
  },
  {
    mmsi: 994126002,
    lng: 122.620755,
    lat: 30.185065,
    lastdyn: 1719859764,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126002,
  },
  {
    mmsi: 994126025,
    lng: 122.619667,
    lat: 30.222667,
    lastdyn: 1719859893,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126025,
  },
  {
    mmsi: 994126003,
    lng: 122.621767,
    lat: 30.176532,
    lastdyn: 1719859780,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126003,
  },
  {
    mmsi: 994126010,
    lng: 122.709302,
    lat: 30.109655,
    lastdyn: 1719859809,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126010,
  },
  {
    mmsi: 994126503,
    lng: 122.58195,
    lat: 30.1315,
    lastdyn: 1719859841,
    type: 28,
    shiptype: 'navigation',
    name: 'XS 1588 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126503,
  },
  {
    mmsi: 994136359,
    lng: 122.63361,
    lat: 30.148055,
    lastdyn: 1719859846,
    type: 28,
    shiptype: 'navigation',
    name: 'ZDY 04210 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136359,
  },
  {
    mmsi: 994126007,
    lng: 122.654282,
    lat: 30.109677,
    lastdyn: 1719859791,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126007,
  },
  {
    mmsi: 994136420,
    lng: 122.57845,
    lat: 30.0759,
    lastdyn: 1719859832,
    type: 28,
    shiptype: 'navigation',
    name: 'ZCY 06157 WRECK',
    length: 40,
    width: 6,
    left: 3,
    trail: 20,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136420,
  },
  {
    mmsi: 994126022,
    lng: 122.709522,
    lat: 30.222947,
    lastdyn: 1719859883,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126022,
  },
  {
    mmsi: 994126024,
    lng: 122.66645,
    lat: 30.22296,
    lastdyn: 1719859887,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126024,
  },
  {
    mmsi: 994126005,
    lng: 122.623805,
    lat: 30.126022,
    lastdyn: 1719859771,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126005,
  },
  {
    mmsi: 994126014,
    lng: 122.806,
    lat: 30.109667,
    lastdyn: 1719859831,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126014,
  },
  {
    mmsi: 994126018,
    lng: 122.806,
    lat: 30.20945,
    lastdyn: 1719859854,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126018,
  },
  {
    mmsi: 994126020,
    lng: 122.773612,
    lat: 30.222857,
    lastdyn: 1719859865,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126020,
  },
  {
    mmsi: 994126327,
    lng: 122.767888,
    lat: 30.188777,
    lastdyn: 1719859768,
    type: 28,
    shiptype: 'navigation',
    name: 'ZYY 11166 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126327,
  },
  {
    mmsi: 994126016,
    lng: 122.80588,
    lat: 30.16255,
    lastdyn: 1719859843,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126016,
  },
  {
    mmsi: 994126015,
    lng: 122.805867,
    lat: 30.138332,
    lastdyn: 1719859839,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126015,
  },
  {
    mmsi: 994126017,
    lng: 122.80588,
    lat: 30.171775,
    lastdyn: 1719859848,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126017,
  },
  {
    mmsi: 994126012,
    lng: 122.757822,
    lat: 30.109572,
    lastdyn: 1719859820,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126012,
  },
  {
    mmsi: 994136453,
    lng: 122.88,
    lat: 30.151667,
    lastdyn: 1719859775,
    type: 28,
    shiptype: 'navigation',
    name: 'HDL7 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136453,
  },
  {
    mmsi: 999412382,
    lng: 122.944655,
    lat: 30.170113,
    lastdyn: 1719858969,
    type: 1,
    shiptype: 'navigation',
    name: 'LIANG XIONG DI YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412382,
  },
  {
    mmsi: 994126019,
    lng: 122.806,
    lat: 30.222667,
    lastdyn: 1719859859,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126019,
  },
  {
    mmsi: 994126013,
    lng: 122.796317,
    lat: 30.10968,
    lastdyn: 1719859825,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIESHANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126013,
  },
  {
    mmsi: 994136104,
    lng: 111.50415,
    lat: 30.314783,
    lastdyn: 1719859792,
    type: 30,
    shiptype: 'navigation',
    name: 'SQPMD2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136104,
  },
  {
    mmsi: 994136103,
    lng: 111.507367,
    lat: 30.311233,
    lastdyn: 1719859705,
    type: 30,
    shiptype: 'navigation',
    name: 'SQPMD1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136103,
  },
  {
    mmsi: 994136101,
    lng: 111.613967,
    lat: 30.30255,
    lastdyn: 1719859895,
    type: 30,
    shiptype: 'navigation',
    name: 'LJHMD1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136101,
  },
  {
    mmsi: 994136102,
    lng: 111.611017,
    lat: 30.297783,
    lastdyn: 1719859823,
    type: 30,
    shiptype: 'navigation',
    name: 'LJHMD2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136102,
  },
  {
    mmsi: 994138204,
    lng: 111.924617,
    lat: 30.362267,
    lastdyn: 1719859826,
    type: 24,
    shiptype: 'navigation',
    name: 'DBJ4R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138204,
  },
  {
    mmsi: 994138206,
    lng: 112.243867,
    lat: 30.2954,
    lastdyn: 1719859622,
    type: 30,
    shiptype: 'navigation',
    name: 'YNLSMD2Z',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138206,
  },
  {
    mmsi: 994138205,
    lng: 112.25595,
    lat: 30.287232,
    lastdyn: 1719859823,
    type: 0,
    shiptype: 'navigation',
    name: 'YNLSMD1Z',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138205,
  },
  {
    mmsi: 999999932,
    lng: 118.057477,
    lat: -80.444388,
    lastdyn: 1704061395,
    type: 26,
    shiptype: 'navigation',
    name: 'AD',
    length: 214,
    width: 8,
    left: 7,
    trail: 208,
    offsetstatus: 1,
    atonstatus: 236,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999932,
  },
  {
    mmsi: 994128310,
    lng: 116.897267,
    lat: 30.439,
    lastdyn: 1719858697,
    type: 25,
    shiptype: 'navigation',
    name: 'GZ4R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128310,
  },
  {
    mmsi: 994128311,
    lng: 116.888567,
    lat: 30.434232,
    lastdyn: 1719859914,
    type: 25,
    shiptype: 'navigation',
    name: 'GZ5R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128311,
  },
  {
    mmsi: 994128312,
    lng: 116.884133,
    lat: 30.422833,
    lastdyn: 1719859914,
    type: 25,
    shiptype: 'navigation',
    name: 'GZ6R',
    length: 10,
    width: 0,
    left: 0,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128312,
  },
  {
    mmsi: 994128314,
    lng: 117.104832,
    lat: 30.49845,
    lastdyn: 1719859916,
    type: 25,
    shiptype: 'navigation',
    name: 'AQWLMXR',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128314,
  },
  {
    mmsi: 994128313,
    lng: 117.09115,
    lat: 30.497532,
    lastdyn: 1719859913,
    type: 25,
    shiptype: 'navigation',
    name: 'AQWLMSR',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128313,
  },
  {
    mmsi: 999999921,
    lng: -40.971283,
    lat: -21.797502,
    lastdyn: 1719859347,
    type: 25,
    shiptype: 'navigation',
    name: 'BAT121',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999921,
  },
  {
    mmsi: 999999929,
    lng: -40.982982,
    lat: -21.810348,
    lastdyn: 1718890603,
    type: 25,
    shiptype: 'navigation',
    name: 'BAT125',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999929,
  },
  {
    mmsi: 999999918,
    lng: -40.936687,
    lat: -21.809238,
    lastdyn: 1719858627,
    type: 24,
    shiptype: 'navigation',
    name: 'BAT118',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999918,
  },
  {
    mmsi: 994126330,
    lng: 120.95011,
    lat: 30.499222,
    lastdyn: 1719859759,
    type: 24,
    shiptype: 'navigation',
    name: 'HE DIAN 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126330,
  },
  {
    mmsi: 994126435,
    lng: 120.948,
    lat: 30.499805,
    lastdyn: 1719859756,
    type: 25,
    shiptype: 'navigation',
    name: 'HE DIAN 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126435,
  },
  {
    mmsi: 994136583,
    lng: 121.0915,
    lat: 30.469333,
    lastdyn: 1719859741,
    type: 28,
    shiptype: 'navigation',
    name: 'MNDH 0520 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136583,
  },
  {
    mmsi: 994121563,
    lng: 121.497007,
    lat: 30.393923,
    lastdyn: 1719859746,
    type: 30,
    shiptype: 'navigation',
    name: 'JX FENG DIAN 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121563,
  },
  {
    mmsi: 999412396,
    lng: 121.738192,
    lat: 30.341353,
    lastdyn: 1719856988,
    type: 19,
    shiptype: 'navigation',
    name: 'DS FENG DIAN L25',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412396,
  },
  {
    mmsi: 994121550,
    lng: 121.8976,
    lat: 30.41866,
    lastdyn: 1719859756,
    type: 30,
    shiptype: 'navigation',
    name: 'DS FENG DIAN 4 AIS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121550,
  },
  {
    mmsi: 999412383,
    lng: 121.85997,
    lat: 30.346895,
    lastdyn: 1719859810,
    type: 1,
    shiptype: 'navigation',
    name: 'YU XIN NAO DAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412383,
  },
  {
    mmsi: 994121551,
    lng: 121.85373,
    lat: 30.47878,
    lastdyn: 1719859742,
    type: 30,
    shiptype: 'navigation',
    name: 'DS FENG DIAN 9 AIS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121551,
  },
  {
    mmsi: 994121522,
    lng: 121.963222,
    lat: 30.274882,
    lastdyn: 1719859895,
    type: 30,
    shiptype: 'navigation',
    name: 'YU SHAN HAI LAN 3',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121522,
  },
  {
    mmsi: 999992413,
    lng: 121.98368,
    lat: 30.354997,
    lastdyn: 1719858969,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2413',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992413,
  },
  {
    mmsi: 994121583,
    lng: 122.015425,
    lat: 30.377302,
    lastdyn: 1719859794,
    type: 24,
    shiptype: 'navigation',
    name: 'YU SHAN Y2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121583,
  },
  {
    mmsi: 994121567,
    lng: 122.152728,
    lat: 30.346952,
    lastdyn: 1719859876,
    type: 25,
    shiptype: 'navigation',
    name: 'YAN WO SHAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121567,
  },
  {
    mmsi: 994121561,
    lng: 122.054062,
    lat: 30.284697,
    lastdyn: 1719859868,
    type: 1,
    shiptype: 'navigation',
    name: 'DAI QIAO 441',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121561,
  },
  {
    mmsi: 999412380,
    lng: 122.079207,
    lat: 30.438578,
    lastdyn: 1719859876,
    type: 28,
    shiptype: 'navigation',
    name: 'DAQU BAIMUTIAO JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412380,
  },
  {
    mmsi: 994136399,
    lng: 122.102027,
    lat: 30.273833,
    lastdyn: 1719859756,
    type: 28,
    shiptype: 'navigation',
    name: 'DP 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136399,
  },
  {
    mmsi: 994121509,
    lng: 122.051697,
    lat: 30.280143,
    lastdyn: 1719859885,
    type: 1,
    shiptype: 'navigation',
    name: 'DAI QIAO SHI ZHUANG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121509,
  },
  {
    mmsi: 999412342,
    lng: 122.443313,
    lat: 30.448982,
    lastdyn: 1719859897,
    type: 24,
    shiptype: 'navigation',
    name: 'SHE YI MEN 0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412342,
  },
  {
    mmsi: 994126328,
    lng: 122.481795,
    lat: 30.302207,
    lastdyn: 1719859756,
    type: 28,
    shiptype: 'navigation',
    name: 'ZSY 07713 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126328,
  },
  {
    mmsi: 999413271,
    lng: 122.475417,
    lat: 30.466667,
    lastdyn: 1719859772,
    type: 30,
    shiptype: 'navigation',
    name: 'YANG SHAN GANG 1D',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413271,
  },
  {
    mmsi: 999412343,
    lng: 122.43205,
    lat: 30.48131,
    lastdyn: 1719859202,
    type: 21,
    shiptype: 'navigation',
    name: 'XIA HAI SHAN DONG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412343,
  },
  {
    mmsi: 999992208,
    lng: 122.279595,
    lat: 30.44218,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2208',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992208,
  },
  {
    mmsi: 999413278,
    lng: 122.250333,
    lat: 30.303667,
    lastdyn: 1719859875,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHE DAI 82267 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413278,
  },
  {
    mmsi: 999413268,
    lng: 122.506667,
    lat: 30.466667,
    lastdyn: 1719859763,
    type: 30,
    shiptype: 'navigation',
    name: 'YANG SHAN GANG 1A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413268,
  },
  {
    mmsi: 999412381,
    lng: 122.687555,
    lat: 30.371957,
    lastdyn: 1719859692,
    type: 1,
    shiptype: 'navigation',
    name: 'FENG CHAO YAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412381,
  },
  {
    mmsi: 999990002,
    lng: 181,
    lat: 91,
    lastdyn: 1717137636,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 0002',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990002,
  },
  {
    mmsi: 994138101,
    lng: 111.386632,
    lat: 30.585817,
    lastdyn: 1719859813,
    type: 25,
    shiptype: 'navigation',
    name: 'LJP1L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138101,
  },
  {
    mmsi: 994138103,
    lng: 111.3677,
    lat: 30.610567,
    lastdyn: 1719859599,
    type: 25,
    shiptype: 'navigation',
    name: 'LJP3L',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138103,
  },
  {
    mmsi: 994138102,
    lng: 111.3784,
    lat: 30.598832,
    lastdyn: 1719859811,
    type: 25,
    shiptype: 'navigation',
    name: 'LJP2L',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994138102,
  },
  {
    mmsi: 994136157,
    lng: 111.399933,
    lat: 30.54635,
    lastdyn: 1719859741,
    type: 30,
    shiptype: 'navigation',
    name: 'FJTMD2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136157,
  },
  {
    mmsi: 994136156,
    lng: 111.401883,
    lat: 30.53935,
    lastdyn: 1719859897,
    type: 30,
    shiptype: 'navigation',
    name: 'FJTMD1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136156,
  },
  {
    mmsi: 994128317,
    lng: 117.341217,
    lat: 30.691917,
    lastdyn: 1719859912,
    type: 25,
    shiptype: 'navigation',
    name: 'TZJCZQ2R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128317,
  },
  {
    mmsi: 999999923,
    lng: -40.918763,
    lat: -21.811447,
    lastdyn: 1719859350,
    type: 25,
    shiptype: 'navigation',
    name: 'BAT115',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999923,
  },
  {
    mmsi: 999999908,
    lng: 56.811737,
    lat: 7.10145,
    lastdyn: 1704510310,
    type: 0,
    shiptype: 'navigation',
    name: '',
    length: 322,
    width: 56,
    left: 40,
    trail: 65,
    offsetstatus: 1,
    atonstatus: 184,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999999908,
  },
  {
    mmsi: 999999994,
    lng: -76.36052,
    lat: 36.882647,
    lastdyn: 1711251313,
    type: 5,
    shiptype: 'navigation',
    name: 'AISYEL1752929',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 229,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999994,
  },
  {
    mmsi: 999999888,
    lng: 30.226008,
    lat: 41.168222,
    lastdyn: 1712424395,
    type: 0,
    shiptype: 'navigation',
    name: 'KEFKEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999888,
  },
  {
    mmsi: 999999907,
    lng: -40.854878,
    lat: -21.827887,
    lastdyn: 1719859329,
    type: 25,
    shiptype: 'navigation',
    name: 'BAT107',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999907,
  },
  {
    mmsi: 994126520,
    lng: 121.206583,
    lat: 30.601067,
    lastdyn: 1719859753,
    type: 28,
    shiptype: 'navigation',
    name: 'DSGN 1 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126520,
  },
  {
    mmsi: 999991019,
    lng: 121.151505,
    lat: 30.60158,
    lastdyn: 1719859884,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 1019',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991019,
  },
  {
    mmsi: 994121562,
    lng: 121.498617,
    lat: 30.507773,
    lastdyn: 1719859914,
    type: 30,
    shiptype: 'navigation',
    name: 'JX FENG DIAN 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121562,
  },
  {
    mmsi: 994121409,
    lng: 121.445273,
    lat: 30.639617,
    lastdyn: 1719859755,
    type: 19,
    shiptype: 'navigation',
    name: 'HJD6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121409,
  },
  {
    mmsi: 999412266,
    lng: 121.371987,
    lat: 30.70939,
    lastdyn: 1719859820,
    type: 30,
    shiptype: 'navigation',
    name: 'JINPAI1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412266,
  },
  {
    mmsi: 994121565,
    lng: 121.455298,
    lat: 30.515167,
    lastdyn: 1719859774,
    type: 30,
    shiptype: 'navigation',
    name: 'JX FENG DIAN 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121565,
  },
  {
    mmsi: 994121411,
    lng: 121.445512,
    lat: 30.573848,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'HJD4',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121411,
  },
  {
    mmsi: 994121410,
    lng: 121.434997,
    lat: 30.67957,
    lastdyn: 1719859842,
    type: 30,
    shiptype: 'navigation',
    name: 'JIN BAO 5',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121410,
  },
  {
    mmsi: 994121408,
    lng: 121.443627,
    lat: 30.602382,
    lastdyn: 1719859872,
    type: 19,
    shiptype: 'navigation',
    name: 'HJD5',
    length: 20,
    width: 20,
    left: 10,
    trail: 10,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121408,
  },
  {
    mmsi: 994121405,
    lng: 121.500073,
    lat: 30.653512,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'HJD9',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121405,
  },
  {
    mmsi: 994121427,
    lng: 121.737767,
    lat: 30.601972,
    lastdyn: 1719859875,
    type: 30,
    shiptype: 'navigation',
    name: 'ZSD 19',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121427,
  },
  {
    mmsi: 994121425,
    lng: 121.613072,
    lat: 30.632977,
    lastdyn: 1719859916,
    type: 30,
    shiptype: 'navigation',
    name: 'ZSD 13',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121425,
  },
  {
    mmsi: 994121422,
    lng: 121.621228,
    lat: 30.661793,
    lastdyn: 1719859693,
    type: 19,
    shiptype: 'navigation',
    name: 'ZSD 6',
    length: 15,
    width: 15,
    left: 7,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121422,
  },
  {
    mmsi: 999412300,
    lng: 121.5001,
    lat: 30.563258,
    lastdyn: 1719859515,
    type: 19,
    shiptype: 'navigation',
    name: 'HJD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412300,
  },
  {
    mmsi: 994121424,
    lng: 121.552662,
    lat: 30.646062,
    lastdyn: 1719859877,
    type: 30,
    shiptype: 'navigation',
    name: 'ZSD 10',
    length: 15,
    width: 15,
    left: 7,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121424,
  },
  {
    mmsi: 994121426,
    lng: 121.656148,
    lat: 30.625367,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'ZSD 16',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121426,
  },
  {
    mmsi: 994121420,
    lng: 121.738538,
    lat: 30.627983,
    lastdyn: 1719859760,
    type: 30,
    shiptype: 'navigation',
    name: 'ZSD 1',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121420,
  },
  {
    mmsi: 994121421,
    lng: 121.647517,
    lat: 30.657223,
    lastdyn: 1719859872,
    type: 30,
    shiptype: 'navigation',
    name: 'ZSD 5',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121421,
  },
  {
    mmsi: 994121423,
    lng: 121.552675,
    lat: 30.673937,
    lastdyn: 1719859872,
    type: 19,
    shiptype: 'navigation',
    name: 'ZSD 9',
    length: 15,
    width: 15,
    left: 7,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121423,
  },
  {
    mmsi: 999412210,
    lng: 121.975017,
    lat: 30.724818,
    lastdyn: 1719859875,
    type: 18,
    shiptype: 'navigation',
    name: 'C3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412210,
  },
  {
    mmsi: 994121439,
    lng: 121.790978,
    lat: 30.715837,
    lastdyn: 1719859749,
    type: 19,
    shiptype: 'navigation',
    name: 'FFD8',
    length: 15,
    width: 15,
    left: 7,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121439,
  },
  {
    mmsi: 999412313,
    lng: 121.851937,
    lat: 30.60152,
    lastdyn: 1719859392,
    type: 24,
    shiptype: 'navigation',
    name: 'K106',
    length: 1,
    width: 1,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412313,
  },
  {
    mmsi: 994121435,
    lng: 121.83778,
    lat: 30.732622,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'FFD2',
    length: 15,
    width: 15,
    left: 7,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121435,
  },
  {
    mmsi: 999412312,
    lng: 121.89643,
    lat: 30.528358,
    lastdyn: 1719859873,
    type: 25,
    shiptype: 'navigation',
    name: 'K101',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412312,
  },
  {
    mmsi: 994126459,
    lng: 121.828333,
    lat: 30.683333,
    lastdyn: 1719859849,
    type: 28,
    shiptype: 'navigation',
    name: 'SSCFTL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126459,
  },
  {
    mmsi: 999412225,
    lng: 121.875565,
    lat: 30.63105,
    lastdyn: 1719859870,
    type: 29,
    shiptype: 'navigation',
    name: 'LIN GANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412225,
  },
  {
    mmsi: 994121442,
    lng: 121.958933,
    lat: 30.656545,
    lastdyn: 1719859893,
    type: 30,
    shiptype: 'navigation',
    name: 'HYYJ5',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121442,
  },
  {
    mmsi: 994121440,
    lng: 121.768502,
    lat: 30.714237,
    lastdyn: 1719859698,
    type: 30,
    shiptype: 'navigation',
    name: 'FFD9',
    length: 40,
    width: 40,
    left: 20,
    trail: 20,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121440,
  },
  {
    mmsi: 999412246,
    lng: 122.098515,
    lat: 30.585085,
    lastdyn: 1719859903,
    type: 30,
    shiptype: 'navigation',
    name: 'DYSDD1',
    length: 3,
    width: 3,
    left: 2,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412246,
  },
  {
    mmsi: 999412317,
    lng: 122.21166,
    lat: 30.553022,
    lastdyn: 1719859884,
    type: 24,
    shiptype: 'navigation',
    name: 'Y8',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412317,
  },
  {
    mmsi: 994136514,
    lng: 122.156195,
    lat: 30.573112,
    lastdyn: 1719859884,
    type: 25,
    shiptype: 'navigation',
    name: 'Y11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136514,
  },
  {
    mmsi: 999413209,
    lng: 122.081833,
    lat: 30.569333,
    lastdyn: 1719859878,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHE PU 01117',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413209,
  },
  {
    mmsi: 994136450,
    lng: 122.035555,
    lat: 30.63175,
    lastdyn: 1719859906,
    type: 30,
    shiptype: 'navigation',
    name: 'H57',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136450,
  },
  {
    mmsi: 994136515,
    lng: 122.127888,
    lat: 30.58575,
    lastdyn: 1719859887,
    type: 25,
    shiptype: 'navigation',
    name: 'Y13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136515,
  },
  {
    mmsi: 994136516,
    lng: 122.095472,
    lat: 30.594528,
    lastdyn: 1719859890,
    type: 24,
    shiptype: 'navigation',
    name: 'Y14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136516,
  },
  {
    mmsi: 999412215,
    lng: 122.085293,
    lat: 30.593715,
    lastdyn: 1719859844,
    type: 3,
    shiptype: 'navigation',
    name: 'GONG SHAN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412215,
  },
  {
    mmsi: 994121433,
    lng: 122.156013,
    lat: 30.588198,
    lastdyn: 1719859198,
    type: 30,
    shiptype: 'navigation',
    name: 'HYYJ 11',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121433,
  },
  {
    mmsi: 994136382,
    lng: 122.0505,
    lat: 30.617055,
    lastdyn: 1719859794,
    type: 30,
    shiptype: 'navigation',
    name: 'H51',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136382,
  },
  {
    mmsi: 994121454,
    lng: 122.01568,
    lat: 30.71222,
    lastdyn: 1719859764,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGSD 5',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121454,
  },
  {
    mmsi: 999412316,
    lng: 122.22025,
    lat: 30.55905,
    lastdyn: 1719859811,
    type: 25,
    shiptype: 'navigation',
    name: 'Y7',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412316,
  },
  {
    mmsi: 994121453,
    lng: 122.009745,
    lat: 30.735895,
    lastdyn: 1719859689,
    type: 19,
    shiptype: 'navigation',
    name: 'ZHONGSD 2',
    length: 20,
    width: 20,
    left: 10,
    trail: 10,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121453,
  },
  {
    mmsi: 994136517,
    lng: 122.098083,
    lat: 30.598945,
    lastdyn: 1719859893,
    type: 25,
    shiptype: 'navigation',
    name: 'Y15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136517,
  },
  {
    mmsi: 994121452,
    lng: 122.02481,
    lat: 30.74593,
    lastdyn: 1719859800,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGSD 1',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121452,
  },
  {
    mmsi: 999412237,
    lng: 122.045765,
    lat: 30.613552,
    lastdyn: 1719859872,
    type: 30,
    shiptype: 'navigation',
    name: 'Q51',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412237,
  },
  {
    mmsi: 994136451,
    lng: 122.014278,
    lat: 30.645417,
    lastdyn: 1719859763,
    type: 30,
    shiptype: 'navigation',
    name: 'H58',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136451,
  },
  {
    mmsi: 994121455,
    lng: 122.03865,
    lat: 30.71131,
    lastdyn: 1719859813,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGSD 6',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121455,
  },
  {
    mmsi: 999412247,
    lng: 122.08334,
    lat: 30.579543,
    lastdyn: 1719859884,
    type: 30,
    shiptype: 'navigation',
    name: 'DYSDD3',
    length: 3,
    width: 3,
    left: 2,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412247,
  },
  {
    mmsi: 994136513,
    lng: 122.191367,
    lat: 30.559533,
    lastdyn: 1719859872,
    type: 29,
    shiptype: 'navigation',
    name: 'Y9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136513,
  },
  {
    mmsi: 999412226,
    lng: 122.101993,
    lat: 30.588953,
    lastdyn: 1719859752,
    type: 24,
    shiptype: 'navigation',
    name: 'Y12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412226,
  },
  {
    mmsi: 999412203,
    lng: 122.051012,
    lat: 30.712848,
    lastdyn: 1719859862,
    type: 19,
    shiptype: 'navigation',
    name: 'XIAO JI SHAN',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412203,
  },
  {
    mmsi: 994121456,
    lng: 122.05803,
    lat: 30.68115,
    lastdyn: 1719859740,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGSD 8',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121456,
  },
  {
    mmsi: 994121401,
    lng: 122.14985,
    lat: 30.57936,
    lastdyn: 1719859872,
    type: 14,
    shiptype: 'navigation',
    name: 'SHE DAN JIAO',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121401,
  },
  {
    mmsi: 999412310,
    lng: 122.330705,
    lat: 30.543592,
    lastdyn: 1719859871,
    type: 25,
    shiptype: 'navigation',
    name: 'Y1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412310,
  },
  {
    mmsi: 999412311,
    lng: 122.321332,
    lat: 30.537957,
    lastdyn: 1719859568,
    type: 24,
    shiptype: 'navigation',
    name: 'Y2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412311,
  },
  {
    mmsi: 994136511,
    lng: 122.486667,
    lat: 30.514472,
    lastdyn: 1719859778,
    type: 29,
    shiptype: 'navigation',
    name: 'Y0A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136511,
  },
  {
    mmsi: 994121547,
    lng: 122.344453,
    lat: 30.504343,
    lastdyn: 1719859861,
    type: 25,
    shiptype: 'navigation',
    name: 'HUANG ZE SHAN 1',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121547,
  },
  {
    mmsi: 999413270,
    lng: 122.475417,
    lat: 30.5,
    lastdyn: 1719859769,
    type: 30,
    shiptype: 'navigation',
    name: 'YANG SHAN GANG 1C',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413270,
  },
  {
    mmsi: 999412309,
    lng: 122.425282,
    lat: 30.526732,
    lastdyn: 1719859871,
    type: 29,
    shiptype: 'navigation',
    name: 'Y0',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412309,
  },
  {
    mmsi: 994136512,
    lng: 122.253945,
    lat: 30.554333,
    lastdyn: 1719859881,
    type: 25,
    shiptype: 'navigation',
    name: 'Y5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136512,
  },
  {
    mmsi: 994126547,
    lng: 122.553167,
    lat: 30.696333,
    lastdyn: 1719859751,
    type: 28,
    shiptype: 'navigation',
    name: 'ZSY 05612 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126547,
  },
  {
    mmsi: 999413269,
    lng: 122.506667,
    lat: 30.5,
    lastdyn: 1719859766,
    type: 30,
    shiptype: 'navigation',
    name: 'YANG SHAN GANG 1B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413269,
  },
  {
    mmsi: 999412201,
    lng: 122.54764,
    lat: 30.503492,
    lastdyn: 1719859686,
    type: 31,
    shiptype: 'navigation',
    name: 'HUANGZEYANG',
    length: 24,
    width: 6,
    left: 3,
    trail: 12,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412201,
  },
  {
    mmsi: 994126492,
    lng: 122.545305,
    lat: 30.706833,
    lastdyn: 1719859753,
    type: 28,
    shiptype: 'navigation',
    name: 'XIAO DAN CAI YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126492,
  },
  {
    mmsi: 994136562,
    lng: 122.5265,
    lat: 30.744167,
    lastdyn: 1719859816,
    type: 28,
    shiptype: 'navigation',
    name: 'LHQR WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136562,
  },
  {
    mmsi: 999412384,
    lng: 122.544718,
    lat: 30.731,
    lastdyn: 1719859748,
    type: 28,
    shiptype: 'navigation',
    name: 'BAI MU AN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412384,
  },
  {
    mmsi: 994126342,
    lng: 122.848138,
    lat: 30.615388,
    lastdyn: 1719859745,
    type: 28,
    shiptype: 'navigation',
    name: 'DBYJ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126342,
  },
  {
    mmsi: 994126493,
    lng: 122.775222,
    lat: 30.690833,
    lastdyn: 1719859748,
    type: 28,
    shiptype: 'navigation',
    name: 'MEN QIAN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126493,
  },
  {
    mmsi: 999993384,
    lng: 122.841548,
    lat: 30.70795,
    lastdyn: 1719821350,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 3384',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993384,
  },
  {
    mmsi: 999413202,
    lng: 123.1625,
    lat: 30.725,
    lastdyn: 1719859774,
    type: 17,
    shiptype: 'navigation',
    name: 'DONG NAN JIAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413202,
  },
  {
    mmsi: 994126316,
    lng: 123.151667,
    lat: 30.723333,
    lastdyn: 1719859742,
    type: 28,
    shiptype: 'navigation',
    name: 'LDY 23616 WRECK',
    length: 36,
    width: 6,
    left: 3,
    trail: 18,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126316,
  },
  {
    mmsi: 999413217,
    lng: 123.261717,
    lat: 30.544483,
    lastdyn: 1719859780,
    type: 28,
    shiptype: 'navigation',
    name: 'HUI RONG CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413217,
  },
  {
    mmsi: 994148509,
    lng: 108.41755,
    lat: 30.7621,
    lastdyn: 1719859815,
    type: 25,
    shiptype: 'navigation',
    name: 'WXQZ1L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148509,
  },
  {
    mmsi: 994148510,
    lng: 108.420432,
    lat: 30.762932,
    lastdyn: 1719859440,
    type: 24,
    shiptype: 'navigation',
    name: 'WXQY1R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148510,
  },
  {
    mmsi: 994148504,
    lng: 108.3985,
    lat: 30.7928,
    lastdyn: 1719859812,
    type: 24,
    shiptype: 'navigation',
    name: 'WSQY1R',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148504,
  },
  {
    mmsi: 994148503,
    lng: 108.3924,
    lat: 30.7928,
    lastdyn: 1719859802,
    type: 25,
    shiptype: 'navigation',
    name: 'WSQZ1L',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148503,
  },
  {
    mmsi: 994148505,
    lng: 108.4147,
    lat: 30.8322,
    lastdyn: 1719859811,
    type: 25,
    shiptype: 'navigation',
    name: 'WZEQZ1L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148505,
  },
  {
    mmsi: 994148508,
    lng: 108.4177,
    lat: 30.7713,
    lastdyn: 1719859816,
    type: 24,
    shiptype: 'navigation',
    name: 'WZTQY1R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148508,
  },
  {
    mmsi: 994148507,
    lng: 108.4152,
    lat: 30.7695,
    lastdyn: 1719859813,
    type: 25,
    shiptype: 'navigation',
    name: 'WZTQZ1L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148507,
  },
  {
    mmsi: 994148512,
    lng: 108.42265,
    lat: 30.754067,
    lastdyn: 1719859445,
    type: 24,
    shiptype: 'navigation',
    name: 'WXQY3R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148512,
  },
  {
    mmsi: 994148501,
    lng: 108.4059,
    lat: 30.8291,
    lastdyn: 1719859812,
    type: 25,
    shiptype: 'navigation',
    name: 'WZEQZ2L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148501,
  },
  {
    mmsi: 994148511,
    lng: 108.419217,
    lat: 30.753817,
    lastdyn: 1719859820,
    type: 25,
    shiptype: 'navigation',
    name: 'WXQY3L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148511,
  },
  {
    mmsi: 994148506,
    lng: 108.409,
    lat: 30.8268,
    lastdyn: 1719859802,
    type: 24,
    shiptype: 'navigation',
    name: 'WZEQY1R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148506,
  },
  {
    mmsi: 994148502,
    lng: 108.4029,
    lat: 30.8227,
    lastdyn: 1719859805,
    type: 24,
    shiptype: 'navigation',
    name: 'WZEQY2R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994148502,
  },
  {
    mmsi: 994126334,
    lng: 117.722117,
    lat: 30.848632,
    lastdyn: 1719859889,
    type: 24,
    shiptype: 'navigation',
    name: 'G3QS2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126334,
  },
  {
    mmsi: 994126335,
    lng: 117.724717,
    lat: 30.851867,
    lastdyn: 1719859468,
    type: 25,
    shiptype: 'navigation',
    name: 'G3QS1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126335,
  },
  {
    mmsi: 994128328,
    lng: 117.750567,
    lat: 30.9106,
    lastdyn: 1719859764,
    type: 30,
    shiptype: 'navigation',
    name: 'XGS1Z',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128328,
  },
  {
    mmsi: 999999900,
    lng: -93.2044,
    lat: 18.4361,
    lastdyn: 1719858598,
    type: 1,
    shiptype: 'navigation',
    name: 'BOYA NO 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999999900,
  },
  {
    mmsi: 999412324,
    lng: 121.438223,
    lat: 30.766127,
    lastdyn: 1719859869,
    type: 30,
    shiptype: 'navigation',
    name: 'LV JIAN 1',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412324,
  },
  {
    mmsi: 994136345,
    lng: 121.642027,
    lat: 30.831,
    lastdyn: 1719859775,
    type: 28,
    shiptype: 'navigation',
    name: 'XINGHUO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136345,
  },
  {
    mmsi: 994121447,
    lng: 121.902573,
    lat: 30.812613,
    lastdyn: 1719858250,
    type: 19,
    shiptype: 'navigation',
    name: 'FD K3',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121447,
  },
  {
    mmsi: 994121437,
    lng: 121.806948,
    lat: 30.763913,
    lastdyn: 1719859693,
    type: 19,
    shiptype: 'navigation',
    name: 'FFD5',
    length: 15,
    width: 15,
    left: 7,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121437,
  },
  {
    mmsi: 994121438,
    lng: 121.784977,
    lat: 30.763217,
    lastdyn: 1719859813,
    type: 19,
    shiptype: 'navigation',
    name: 'FFD6',
    length: 15,
    width: 15,
    left: 7,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121438,
  },
  {
    mmsi: 999412322,
    lng: 121.844613,
    lat: 30.818522,
    lastdyn: 1719845709,
    type: 25,
    shiptype: 'navigation',
    name: 'L11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412322,
  },
  {
    mmsi: 994121448,
    lng: 121.909573,
    lat: 30.77069,
    lastdyn: 1719859752,
    type: 19,
    shiptype: 'navigation',
    name: 'FD K7',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121448,
  },
  {
    mmsi: 999412337,
    lng: 121.91344,
    lat: 30.753987,
    lastdyn: 1719859812,
    type: 19,
    shiptype: 'navigation',
    name: 'FJT51',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412337,
  },
  {
    mmsi: 994121446,
    lng: 121.889338,
    lat: 30.809568,
    lastdyn: 1719859470,
    type: 19,
    shiptype: 'navigation',
    name: 'FD K1',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121446,
  },
  {
    mmsi: 999412338,
    lng: 121.904048,
    lat: 30.776998,
    lastdyn: 1719859330,
    type: 19,
    shiptype: 'navigation',
    name: 'FJT59',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412338,
  },
  {
    mmsi: 999412287,
    lng: 122.09471,
    lat: 30.883373,
    lastdyn: 1719859806,
    type: 30,
    shiptype: 'navigation',
    name: 'FENG DIAN 65',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412287,
  },
  {
    mmsi: 999412240,
    lng: 122.09914,
    lat: 30.797797,
    lastdyn: 1719859872,
    type: 30,
    shiptype: 'navigation',
    name: 'JIN0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412240,
  },
  {
    mmsi: 999412283,
    lng: 122.131698,
    lat: 30.890528,
    lastdyn: 1719859854,
    type: 30,
    shiptype: 'navigation',
    name: 'FENG DIAN 64',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412283,
  },
  {
    mmsi: 999412235,
    lng: 122.152678,
    lat: 30.8101,
    lastdyn: 1719859751,
    type: 29,
    shiptype: 'navigation',
    name: 'A0',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412235,
  },
  {
    mmsi: 999412220,
    lng: 122.0265,
    lat: 30.7615,
    lastdyn: 1719859770,
    type: 3,
    shiptype: 'navigation',
    name: 'FENG JI TA 34',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999412220,
  },
  {
    mmsi: 999412229,
    lng: 122.129125,
    lat: 30.983647,
    lastdyn: 1719859326,
    type: 30,
    shiptype: 'navigation',
    name: 'FENG DIAN 55',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412229,
  },
  {
    mmsi: 999412232,
    lng: 122.144493,
    lat: 30.92641,
    lastdyn: 1719859193,
    type: 30,
    shiptype: 'navigation',
    name: 'FENG DIAN 60',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412232,
  },
  {
    mmsi: 999412230,
    lng: 122.162033,
    lat: 30.97009,
    lastdyn: 1719859240,
    type: 30,
    shiptype: 'navigation',
    name: 'FENG DIAN 56',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412230,
  },
  {
    mmsi: 999412231,
    lng: 122.104997,
    lat: 30.935025,
    lastdyn: 1719859446,
    type: 30,
    shiptype: 'navigation',
    name: 'FENG DIAN 59',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412231,
  },
  {
    mmsi: 999412241,
    lng: 122.161355,
    lat: 30.963947,
    lastdyn: 1719858068,
    type: 30,
    shiptype: 'navigation',
    name: 'JIN 10',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412241,
  },
  {
    mmsi: 999412272,
    lng: 122.160365,
    lat: 30.777958,
    lastdyn: 1719859879,
    type: 29,
    shiptype: 'navigation',
    name: 'Y36',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412272,
  },
  {
    mmsi: 999412254,
    lng: 122.027047,
    lat: 30.856378,
    lastdyn: 1719859854,
    type: 30,
    shiptype: 'navigation',
    name: 'NHZ SHUI WEN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412254,
  },
  {
    mmsi: 999412228,
    lng: 122.164822,
    lat: 30.972802,
    lastdyn: 1719859693,
    type: 30,
    shiptype: 'navigation',
    name: 'JIN 11',
    length: 2,
    width: 4,
    left: 2,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412228,
  },
  {
    mmsi: 999412282,
    lng: 122.084688,
    lat: 30.89513,
    lastdyn: 1719859668,
    type: 30,
    shiptype: 'navigation',
    name: 'FENG DIAN 63',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412282,
  },
  {
    mmsi: 999412299,
    lng: 122.29998,
    lat: 30.96463,
    lastdyn: 1719858632,
    type: 30,
    shiptype: 'navigation',
    name: 'HYYJ4',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412299,
  },
  {
    mmsi: 999412370,
    lng: 122.583563,
    lat: 30.833828,
    lastdyn: 1719857741,
    type: 23,
    shiptype: 'navigation',
    name: 'MAO ZHUA JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412370,
  },
  {
    mmsi: 999412394,
    lng: 122.60686,
    lat: 30.807192,
    lastdyn: 1719859860,
    type: 1,
    shiptype: 'navigation',
    name: 'MAN TOU SHAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412394,
  },
  {
    mmsi: 999412204,
    lng: 122.533678,
    lat: 30.99189,
    lastdyn: 1719858781,
    type: 31,
    shiptype: 'navigation',
    name: 'NAN CAO',
    length: 24,
    width: 8,
    left: 4,
    trail: 12,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412204,
  },
  {
    mmsi: 999000009,
    lng: 120.134367,
    lat: 31.952267,
    lastdyn: 1710617360,
    type: 3,
    shiptype: 'navigation',
    name: 'JIN7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999000009,
  },
  {
    mmsi: 999412260,
    lng: 122.755862,
    lat: 30.896073,
    lastdyn: 1719859012,
    type: 30,
    shiptype: 'navigation',
    name: 'HYYJ2',
    length: 1,
    width: 1,
    left: 1,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412260,
  },
  {
    mmsi: 999413203,
    lng: 123.149833,
    lat: 30.764167,
    lastdyn: 1719859597,
    type: 17,
    shiptype: 'navigation',
    name: 'HAI JIAO BEI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413203,
  },
  {
    mmsi: 994136341,
    lng: 123.143333,
    lat: 30.821667,
    lastdyn: 1719859754,
    type: 28,
    shiptype: 'navigation',
    name: 'SQY 05108 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136341,
  },
  {
    mmsi: 994128305,
    lng: 117.9999,
    lat: 31.169417,
    lastdyn: 1719859755,
    type: 25,
    shiptype: 'navigation',
    name: 'HSZN206L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128305,
  },
  {
    mmsi: 994128302,
    lng: 118.041567,
    lat: 31.181082,
    lastdyn: 1719859742,
    type: 24,
    shiptype: 'navigation',
    name: 'HSZN204R',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128302,
  },
  {
    mmsi: 994128303,
    lng: 118.042882,
    lat: 31.184767,
    lastdyn: 1719859748,
    type: 25,
    shiptype: 'navigation',
    name: 'HSZN204L',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128303,
  },
  {
    mmsi: 994126386,
    lng: 121.9425,
    lat: 31.113583,
    lastdyn: 1719859834,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 18',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126386,
  },
  {
    mmsi: 994126382,
    lng: 121.984388,
    lat: 31.091112,
    lastdyn: 1719859817,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126382,
  },
  {
    mmsi: 994121402,
    lng: 121.929963,
    lat: 31.107487,
    lastdyn: 1719858682,
    type: 19,
    shiptype: 'navigation',
    name: 'HAI BIN PAI 4',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121402,
  },
  {
    mmsi: 994126383,
    lng: 121.977055,
    lat: 31.101445,
    lastdyn: 1719859766,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126383,
  },
  {
    mmsi: 994126381,
    lng: 121.998333,
    lat: 31.092028,
    lastdyn: 1719859813,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126381,
  },
  {
    mmsi: 994126389,
    lng: 121.916028,
    lat: 31.134445,
    lastdyn: 1719859849,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 21',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126389,
  },
  {
    mmsi: 994126387,
    lng: 121.941862,
    lat: 31.120305,
    lastdyn: 1719859879,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 19',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126387,
  },
  {
    mmsi: 999412244,
    lng: 121.988062,
    lat: 31.034718,
    lastdyn: 1719859573,
    type: 30,
    shiptype: 'navigation',
    name: 'DAZHIHE1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412244,
  },
  {
    mmsi: 999412294,
    lng: 121.895597,
    lat: 31.163933,
    lastdyn: 1719858698,
    type: 30,
    shiptype: 'navigation',
    name: 'JIANG YA NAN SHA',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412294,
  },
  {
    mmsi: 994126388,
    lng: 121.916333,
    lat: 31.127612,
    lastdyn: 1719859823,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 20',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126388,
  },
  {
    mmsi: 994136489,
    lng: 121.996528,
    lat: 31.245083,
    lastdyn: 1719859871,
    type: 24,
    shiptype: 'navigation',
    name: 'D30',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136489,
  },
  {
    mmsi: 994121444,
    lng: 121.92919,
    lat: 31.107792,
    lastdyn: 1719859886,
    type: 19,
    shiptype: 'navigation',
    name: 'PU NENG PAI',
    length: 5,
    width: 5,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121444,
  },
  {
    mmsi: 994126385,
    lng: 121.970305,
    lat: 31.105055,
    lastdyn: 1719859832,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126385,
  },
  {
    mmsi: 999412227,
    lng: 121.910332,
    lat: 31.115388,
    lastdyn: 1719859800,
    type: 19,
    shiptype: 'navigation',
    name: 'ZHONG JUN 2',
    length: 15,
    width: 6,
    left: 3,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412227,
  },
  {
    mmsi: 999412253,
    lng: 121.775012,
    lat: 31.232902,
    lastdyn: 1719859855,
    type: 30,
    shiptype: 'navigation',
    name: 'SJG SHUI WEN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412253,
  },
  {
    mmsi: 999412296,
    lng: 121.868708,
    lat: 31.171445,
    lastdyn: 1719857375,
    type: 30,
    shiptype: 'navigation',
    name: 'H182',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412296,
  },
  {
    mmsi: 994126384,
    lng: 121.967278,
    lat: 31.100305,
    lastdyn: 1719859794,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 16',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126384,
  },
  {
    mmsi: 994126519,
    lng: 122.243195,
    lat: 31.16325,
    lastdyn: 1719859853,
    type: 28,
    shiptype: 'navigation',
    name: 'BEI BA 9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126519,
  },
  {
    mmsi: 994136467,
    lng: 122.236945,
    lat: 31.141112,
    lastdyn: 1719855995,
    type: 24,
    shiptype: 'navigation',
    name: 'D16',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136467,
  },
  {
    mmsi: 994136394,
    lng: 122.205583,
    lat: 31.196667,
    lastdyn: 1719859818,
    type: 28,
    shiptype: 'navigation',
    name: 'BDWM WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136394,
  },
  {
    mmsi: 994136472,
    lng: 122.168417,
    lat: 31.182722,
    lastdyn: 1719857760,
    type: 24,
    shiptype: 'navigation',
    name: 'D20',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136472,
  },
  {
    mmsi: 994136471,
    lng: 122.196528,
    lat: 31.169195,
    lastdyn: 1719859192,
    type: 25,
    shiptype: 'navigation',
    name: 'D19',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136471,
  },
  {
    mmsi: 994136476,
    lng: 122.105445,
    lat: 31.221695,
    lastdyn: 1719859832,
    type: 24,
    shiptype: 'navigation',
    name: 'D24',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136476,
  },
  {
    mmsi: 994136469,
    lng: 122.202445,
    lat: 31.161638,
    lastdyn: 1719853649,
    type: 24,
    shiptype: 'navigation',
    name: 'D18',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136469,
  },
  {
    mmsi: 994136480,
    lng: 122.050638,
    lat: 31.239305,
    lastdyn: 1719859860,
    type: 25,
    shiptype: 'navigation',
    name: 'D27',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136480,
  },
  {
    mmsi: 994126370,
    lng: 122.174917,
    lat: 31.051778,
    lastdyn: 1719859848,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126370,
  },
  {
    mmsi: 999413253,
    lng: 122.146612,
    lat: 31.002722,
    lastdyn: 1719859839,
    type: 28,
    shiptype: 'navigation',
    name: 'NAN ZHI CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413253,
  },
  {
    mmsi: 994126377,
    lng: 122.066388,
    lat: 31.067528,
    lastdyn: 1719859818,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126377,
  },
  {
    mmsi: 994136479,
    lng: 122.079388,
    lat: 31.231305,
    lastdyn: 1719859865,
    type: 24,
    shiptype: 'navigation',
    name: 'D26',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136479,
  },
  {
    mmsi: 994136411,
    lng: 122.060722,
    lat: 31.065,
    lastdyn: 1719859868,
    type: 24,
    shiptype: 'navigation',
    name: 'S18',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136411,
  },
  {
    mmsi: 994136477,
    lng: 122.095195,
    lat: 31.231888,
    lastdyn: 1719859835,
    type: 25,
    shiptype: 'navigation',
    name: 'D25',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136477,
  },
  {
    mmsi: 994136486,
    lng: 122.009612,
    lat: 31.246112,
    lastdyn: 1719859875,
    type: 25,
    shiptype: 'navigation',
    name: 'D29',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136486,
  },
  {
    mmsi: 994136504,
    lng: 122.087825,
    lat: 31.036263,
    lastdyn: 1719859886,
    type: 28,
    shiptype: 'navigation',
    name: 'QIAN DIAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136504,
  },
  {
    mmsi: 999412250,
    lng: 122.074625,
    lat: 31.230977,
    lastdyn: 1719858908,
    type: 24,
    shiptype: 'navigation',
    name: '26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412250,
  },
  {
    mmsi: 994126380,
    lng: 122.006083,
    lat: 31.084195,
    lastdyn: 1719859810,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126380,
  },
  {
    mmsi: 994126373,
    lng: 122.134638,
    lat: 31.048583,
    lastdyn: 1719859886,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126373,
  },
  {
    mmsi: 994136475,
    lng: 122.128445,
    lat: 31.211333,
    lastdyn: 1719859862,
    type: 25,
    shiptype: 'navigation',
    name: 'D23',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136475,
  },
  {
    mmsi: 994126371,
    lng: 122.168417,
    lat: 31.046695,
    lastdyn: 1719859775,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126371,
  },
  {
    mmsi: 994126372,
    lng: 122.138083,
    lat: 31.053583,
    lastdyn: 1719859779,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126372,
  },
  {
    mmsi: 994126375,
    lng: 122.100805,
    lat: 31.057972,
    lastdyn: 1719859831,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126375,
  },
  {
    mmsi: 994136481,
    lng: 122.037555,
    lat: 31.238278,
    lastdyn: 1719859868,
    type: 24,
    shiptype: 'navigation',
    name: 'D28',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136481,
  },
  {
    mmsi: 994126504,
    lng: 122.225612,
    lat: 31.098555,
    lastdyn: 1719858006,
    type: 28,
    shiptype: 'navigation',
    name: 'NAN DI TOU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126504,
  },
  {
    mmsi: 999412329,
    lng: 122.155277,
    lat: 31.0419,
    lastdyn: 1719858669,
    type: 24,
    shiptype: 'navigation',
    name: 'S12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412329,
  },
  {
    mmsi: 994126376,
    lng: 122.068528,
    lat: 31.072612,
    lastdyn: 1719859862,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126376,
  },
  {
    mmsi: 994126379,
    lng: 122.036388,
    lat: 31.075805,
    lastdyn: 1719859909,
    type: 24,
    shiptype: 'navigation',
    name: 'NAN CAO 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126379,
  },
  {
    mmsi: 994126374,
    lng: 122.105472,
    lat: 31.062362,
    lastdyn: 1719859895,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126374,
  },
  {
    mmsi: 999412251,
    lng: 122.211975,
    lat: 31.047325,
    lastdyn: 1719858489,
    type: 29,
    shiptype: 'navigation',
    name: 'S10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412251,
  },
  {
    mmsi: 994126378,
    lng: 122.038583,
    lat: 31.080888,
    lastdyn: 1719859908,
    type: 25,
    shiptype: 'navigation',
    name: 'NAN CAO 9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126378,
  },
  {
    mmsi: 999412239,
    lng: 122.476257,
    lat: 31.100103,
    lastdyn: 1719858958,
    type: 24,
    shiptype: 'navigation',
    name: '4',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412239,
  },
  {
    mmsi: 994136502,
    lng: 122.400583,
    lat: 31.105195,
    lastdyn: 1719856908,
    type: 25,
    shiptype: 'navigation',
    name: '7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136502,
  },
  {
    mmsi: 999412259,
    lng: 122.267263,
    lat: 31.06741,
    lastdyn: 1719859761,
    type: 30,
    shiptype: 'navigation',
    name: 'JDS SHUI WEN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412259,
  },
  {
    mmsi: 994136367,
    lng: 122.357722,
    lat: 31.100472,
    lastdyn: 1719859183,
    type: 24,
    shiptype: 'navigation',
    name: 'D10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136367,
  },
  {
    mmsi: 994136462,
    lng: 122.295055,
    lat: 31.110555,
    lastdyn: 1719857243,
    type: 25,
    shiptype: 'navigation',
    name: 'D13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136462,
  },
  {
    mmsi: 994126416,
    lng: 122.265833,
    lat: 31.145,
    lastdyn: 1719859824,
    type: 28,
    shiptype: 'navigation',
    name: 'XSY 10001 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126416,
  },
  {
    mmsi: 994136503,
    lng: 122.348445,
    lat: 31.099528,
    lastdyn: 1719859607,
    type: 24,
    shiptype: 'navigation',
    name: '10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136503,
  },
  {
    mmsi: 994136459,
    lng: 122.367083,
    lat: 31.104138,
    lastdyn: 1719858322,
    type: 25,
    shiptype: 'navigation',
    name: 'D9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136459,
  },
  {
    mmsi: 994136509,
    lng: 122.485083,
    lat: 31.101055,
    lastdyn: 1719856685,
    type: 24,
    shiptype: 'navigation',
    name: 'D4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136509,
  },
  {
    mmsi: 999412238,
    lng: 122.485978,
    lat: 31.105227,
    lastdyn: 1719853749,
    type: 25,
    shiptype: 'navigation',
    name: '3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412238,
  },
  {
    mmsi: 994126506,
    lng: 122.258167,
    lat: 31.164717,
    lastdyn: 1719859850,
    type: 28,
    shiptype: 'navigation',
    name: 'ZDY 15381 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126506,
  },
  {
    mmsi: 994136461,
    lng: 122.306055,
    lat: 31.100222,
    lastdyn: 1719858318,
    type: 24,
    shiptype: 'navigation',
    name: 'D12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136461,
  },
  {
    mmsi: 999412330,
    lng: 122.291103,
    lat: 31.113618,
    lastdyn: 1719858960,
    type: 25,
    shiptype: 'navigation',
    name: '13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412330,
  },
  {
    mmsi: 999412221,
    lng: 122.462382,
    lat: 31.037618,
    lastdyn: 1719840049,
    type: 19,
    shiptype: 'navigation',
    name: 'CJK TIDE STATION',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412221,
  },
  {
    mmsi: 999412286,
    lng: 122.470055,
    lat: 31.004642,
    lastdyn: 1719858012,
    type: 29,
    shiptype: 'navigation',
    name: 'S1',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412286,
  },
  {
    mmsi: 994136458,
    lng: 122.400167,
    lat: 31.100695,
    lastdyn: 1719857238,
    type: 24,
    shiptype: 'navigation',
    name: 'D8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136458,
  },
  {
    mmsi: 999413296,
    lng: 122.452222,
    lat: 31.104528,
    lastdyn: 1719858292,
    type: 25,
    shiptype: 'navigation',
    name: 'D5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413296,
  },
  {
    mmsi: 994136463,
    lng: 122.2715,
    lat: 31.120667,
    lastdyn: 1719856339,
    type: 24,
    shiptype: 'navigation',
    name: 'D14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136463,
  },
  {
    mmsi: 999412245,
    lng: 122.322645,
    lat: 31.128553,
    lastdyn: 1719858791,
    type: 30,
    shiptype: 'navigation',
    name: 'BEIDIJING1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412245,
  },
  {
    mmsi: 999413261,
    lng: 122.574722,
    lat: 31.219555,
    lastdyn: 1719859805,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 1B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413261,
  },
  {
    mmsi: 999413260,
    lng: 122.574722,
    lat: 31.136195,
    lastdyn: 1719859802,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 1A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413260,
  },
  {
    mmsi: 999413262,
    lng: 122.666667,
    lat: 31.219555,
    lastdyn: 1719859808,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 1C',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413262,
  },
  {
    mmsi: 999413265,
    lng: 122.574722,
    lat: 31.069417,
    lastdyn: 1719859786,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 2B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413265,
  },
  {
    mmsi: 994126548,
    lng: 122.638,
    lat: 31.156833,
    lastdyn: 1719851870,
    type: 28,
    shiptype: 'navigation',
    name: 'OMEGA WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126548,
  },
  {
    mmsi: 999413264,
    lng: 122.574722,
    lat: 31.004888,
    lastdyn: 1719859783,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 2A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413264,
  },
  {
    mmsi: 999412205,
    lng: 122.534095,
    lat: 31.103145,
    lastdyn: 1719859334,
    type: 31,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU',
    length: 24,
    width: 6,
    left: 3,
    trail: 12,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412205,
  },
  {
    mmsi: 999413267,
    lng: 122.666667,
    lat: 31.004888,
    lastdyn: 1719859612,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 2D',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413267,
  },
  {
    mmsi: 999413266,
    lng: 122.666667,
    lat: 31.069417,
    lastdyn: 1719859429,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 2C',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413266,
  },
  {
    mmsi: 999413263,
    lng: 122.666667,
    lat: 31.136195,
    lastdyn: 1719859811,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANG JIANG KOU 1D',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413263,
  },
  {
    mmsi: 994136561,
    lng: 122.668808,
    lat: 31.036497,
    lastdyn: 1719859615,
    type: 28,
    shiptype: 'navigation',
    name: 'ZRY 12168 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136561,
  },
  {
    mmsi: 994136364,
    lng: 122.945,
    lat: 31.015,
    lastdyn: 1719859633,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHE DAI YU 10305',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136364,
  },
  {
    mmsi: 994128325,
    lng: 118.21465,
    lat: 31.2894,
    lastdyn: 1719859891,
    type: 30,
    shiptype: 'navigation',
    name: 'SSWM2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128325,
  },
  {
    mmsi: 994128327,
    lng: 118.207732,
    lat: 31.284467,
    lastdyn: 1719859890,
    type: 30,
    shiptype: 'navigation',
    name: 'SSWM6Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128327,
  },
  {
    mmsi: 994128326,
    lng: 118.209082,
    lat: 31.286817,
    lastdyn: 1719859888,
    type: 30,
    shiptype: 'navigation',
    name: 'SSWM4Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128326,
  },
  {
    mmsi: 994128306,
    lng: 118.342232,
    lat: 31.43015,
    lastdyn: 1719859889,
    type: 25,
    shiptype: 'navigation',
    name: 'XH178L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128306,
  },
  {
    mmsi: 994128301,
    lng: 118.3217,
    lat: 31.418832,
    lastdyn: 1719859889,
    type: 25,
    shiptype: 'navigation',
    name: 'YXK5L',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128301,
  },
  {
    mmsi: 999992515,
    lng: 119.878252,
    lat: 26.307505,
    lastdyn: 1719559128,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2515',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992515,
  },
  {
    mmsi: 999992501,
    lng: 120.528175,
    lat: 31.449225,
    lastdyn: 1707015603,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2501',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992501,
  },
  {
    mmsi: 999992502,
    lng: 181,
    lat: 91,
    lastdyn: 1709444070,
    type: 19,
    shiptype: 'navigation',
    name: 'HHW3',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992502,
  },
  {
    mmsi: 999412270,
    lng: 121.444702,
    lat: 31.452422,
    lastdyn: 1719859885,
    type: 19,
    shiptype: 'navigation',
    name: 'BAO DIAN 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412270,
  },
  {
    mmsi: 994136309,
    lng: 121.456695,
    lat: 31.470917,
    lastdyn: 1719859886,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136309,
  },
  {
    mmsi: 994136324,
    lng: 121.42325,
    lat: 31.496722,
    lastdyn: 1719859890,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NANJIE 10A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136324,
  },
  {
    mmsi: 999412278,
    lng: 121.424055,
    lat: 31.493115,
    lastdyn: 1719859746,
    type: 24,
    shiptype: 'navigation',
    name: '78',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412278,
  },
  {
    mmsi: 994136322,
    lng: 119.363333,
    lat: 39.342833,
    lastdyn: 1719859894,
    type: 28,
    shiptype: 'navigation',
    name: 'ZHONGWEIJI 9088 WREC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136322,
  },
  {
    mmsi: 999412279,
    lng: 121.43077,
    lat: 31.499998,
    lastdyn: 1719859816,
    type: 24,
    shiptype: 'navigation',
    name: '79',
    length: 5,
    width: 5,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412279,
  },
  {
    mmsi: 994136308,
    lng: 121.470638,
    lat: 31.457388,
    lastdyn: 1719859883,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136308,
  },
  {
    mmsi: 994136320,
    lng: 121.497638,
    lat: 31.424917,
    lastdyn: 1719859872,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NAN JIE 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136320,
  },
  {
    mmsi: 999412242,
    lng: 121.467118,
    lat: 31.447032,
    lastdyn: 1719859513,
    type: 24,
    shiptype: 'navigation',
    name: '72',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412242,
  },
  {
    mmsi: 999412273,
    lng: 121.49562,
    lat: 31.42264,
    lastdyn: 1719859521,
    type: 24,
    shiptype: 'navigation',
    name: '68',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412273,
  },
  {
    mmsi: 994126437,
    lng: 121.411583,
    lat: 31.475638,
    lastdyn: 1719859828,
    type: 30,
    shiptype: 'navigation',
    name: 'SHIDIAN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126437,
  },
  {
    mmsi: 999412276,
    lng: 121.445367,
    lat: 31.485675,
    lastdyn: 1719859806,
    type: 25,
    shiptype: 'navigation',
    name: '77',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412276,
  },
  {
    mmsi: 994136323,
    lng: 121.427805,
    lat: 31.493388,
    lastdyn: 1719859890,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NAN JIE 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136323,
  },
  {
    mmsi: 994136321,
    lng: 121.466417,
    lat: 31.455222,
    lastdyn: 1719859890,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NAN JIE 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136321,
  },
  {
    mmsi: 994126546,
    lng: 121.499722,
    lat: 31.3825,
    lastdyn: 1719859828,
    type: 30,
    shiptype: 'navigation',
    name: 'H63',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126546,
  },
  {
    mmsi: 999412219,
    lng: 121.494088,
    lat: 31.451747,
    lastdyn: 1719859567,
    type: 30,
    shiptype: 'navigation',
    name: 'XIANQIAN31A',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412219,
  },
  {
    mmsi: 999413227,
    lng: 121.482312,
    lat: 31.429372,
    lastdyn: 1719859792,
    type: 25,
    shiptype: 'navigation',
    name: 'A75A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413227,
  },
  {
    mmsi: 994136310,
    lng: 121.428278,
    lat: 31.497805,
    lastdyn: 1719859763,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136310,
  },
  {
    mmsi: 999412275,
    lng: 121.45115,
    lat: 31.466217,
    lastdyn: 1719859518,
    type: 21,
    shiptype: 'navigation',
    name: '74',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412275,
  },
  {
    mmsi: 999412212,
    lng: 121.519043,
    lat: 31.396395,
    lastdyn: 1719859775,
    type: 3,
    shiptype: 'navigation',
    name: 'WU SONG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412212,
  },
  {
    mmsi: 999413201,
    lng: 121.720472,
    lat: 31.319083,
    lastdyn: 1719859758,
    type: 24,
    shiptype: 'navigation',
    name: 'D46',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413201,
  },
  {
    mmsi: 999412207,
    lng: 121.713777,
    lat: 31.316128,
    lastdyn: 1719859845,
    type: 31,
    shiptype: 'navigation',
    name: 'YUAN YUAN SHA',
    length: 25,
    width: 5,
    left: 2,
    trail: 12,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412207,
  },
  {
    mmsi: 994121407,
    lng: 117.547588,
    lat: 39.747268,
    lastdyn: 1718481630,
    type: 30,
    shiptype: 'navigation',
    name: 'NAN HUI CE FENG 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121407,
  },
  {
    mmsi: 994136307,
    lng: 121.500695,
    lat: 31.428195,
    lastdyn: 1719859878,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136307,
  },
  {
    mmsi: 994136316,
    lng: 119.544983,
    lat: 39.3592,
    lastdyn: 1719859884,
    type: 30,
    shiptype: 'navigation',
    name: 'YANGZHIQU5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136316,
  },
  {
    mmsi: 999412318,
    lng: 121.712368,
    lat: 31.468167,
    lastdyn: 1719858905,
    type: 29,
    shiptype: 'navigation',
    name: 'C J DA QIAO XI',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412318,
  },
  {
    mmsi: 994136314,
    lng: 119.379333,
    lat: 39.204133,
    lastdyn: 1719859879,
    type: 30,
    shiptype: 'navigation',
    name: 'YANGZHIQU3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136314,
  },
  {
    mmsi: 994136328,
    lng: 121.514722,
    lat: 31.407778,
    lastdyn: 1719859896,
    type: 24,
    shiptype: 'navigation',
    name: 'A72',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136328,
  },
  {
    mmsi: 994136525,
    lng: 121.657417,
    lat: 31.352528,
    lastdyn: 1719859812,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136525,
  },
  {
    mmsi: 994136302,
    lng: 121.632917,
    lat: 31.364638,
    lastdyn: 1719859767,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136302,
  },
  {
    mmsi: 994136478,
    lng: 121.72475,
    lat: 31.320945,
    lastdyn: 1719859749,
    type: 25,
    shiptype: 'navigation',
    name: 'D45',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136478,
  },
  {
    mmsi: 994136368,
    lng: 121.749583,
    lat: 31.311833,
    lastdyn: 1719859746,
    type: 25,
    shiptype: 'navigation',
    name: 'D43',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136368,
  },
  {
    mmsi: 994136317,
    lng: 119.320978,
    lat: 39.426188,
    lastdyn: 1719859887,
    type: 30,
    shiptype: 'navigation',
    name: 'YANGZHIQU6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136317,
  },
  {
    mmsi: 994136318,
    lng: 119.507055,
    lat: 39.295888,
    lastdyn: 1719859858,
    type: 30,
    shiptype: 'navigation',
    name: 'ANEMOMETER TOWER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136318,
  },
  {
    mmsi: 994136301,
    lng: 121.682222,
    lat: 31.340388,
    lastdyn: 1719859764,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136301,
  },
  {
    mmsi: 994136526,
    lng: 121.655362,
    lat: 31.349862,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NAN JIE 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136526,
  },
  {
    mmsi: 994136306,
    lng: 121.517917,
    lat: 31.420028,
    lastdyn: 1719859792,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136306,
  },
  {
    mmsi: 994126300,
    lng: 121.648333,
    lat: 31.488333,
    lastdyn: 1719859758,
    type: 24,
    shiptype: 'navigation',
    name: '206D',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126300,
  },
  {
    mmsi: 994136303,
    lng: 118.969055,
    lat: 38.901193,
    lastdyn: 1719859870,
    type: 30,
    shiptype: 'navigation',
    name: 'NO 5 WIND MEASUREMEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136303,
  },
  {
    mmsi: 999412265,
    lng: 121.684407,
    lat: 31.34291,
    lastdyn: 1719858860,
    type: 25,
    shiptype: 'navigation',
    name: '47',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412265,
  },
  {
    mmsi: 994136304,
    lng: 121.581805,
    lat: 31.389722,
    lastdyn: 1719859792,
    type: 25,
    shiptype: 'navigation',
    name: 'SHEN SHUI BEI JIE 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136304,
  },
  {
    mmsi: 994136315,
    lng: 119.495117,
    lat: 39.276883,
    lastdyn: 1719859881,
    type: 30,
    shiptype: 'navigation',
    name: 'YANGZHIQU4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136315,
  },
  {
    mmsi: 994136319,
    lng: 118.882163,
    lat: 39.131065,
    lastdyn: 1719859891,
    type: 28,
    shiptype: 'navigation',
    name: 'DAQINGHE NAMELESS WR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136319,
  },
  {
    mmsi: 994126543,
    lng: 121.7,
    lat: 31.309805,
    lastdyn: 1719859836,
    type: 24,
    shiptype: 'navigation',
    name: 'S50',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126543,
  },
  {
    mmsi: 994136370,
    lng: 121.721667,
    lat: 31.294667,
    lastdyn: 1719859830,
    type: 24,
    shiptype: 'navigation',
    name: 'S48A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136370,
  },
  {
    mmsi: 994136376,
    lng: 121.556112,
    lat: 31.317778,
    lastdyn: 1719859765,
    type: 25,
    shiptype: 'navigation',
    name: '110B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136376,
  },
  {
    mmsi: 994136300,
    lng: 121.713528,
    lat: 31.325055,
    lastdyn: 1719859843,
    type: 25,
    shiptype: 'navigation',
    name: 'YUAN YUAN SHA 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136300,
  },
  {
    mmsi: 999412213,
    lng: 121.847853,
    lat: -69.905037,
    lastdyn: 1719859786,
    type: 3,
    shiptype: 'navigation',
    name: 'HENG SHA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412213,
  },
  {
    mmsi: 999412319,
    lng: 121.77492,
    lat: 31.413183,
    lastdyn: 1719859872,
    type: 29,
    shiptype: 'navigation',
    name: 'CHANGJIANGDAQIAODONG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412319,
  },
  {
    mmsi: 994136499,
    lng: 121.795888,
    lat: 31.291445,
    lastdyn: 1719859779,
    type: 24,
    shiptype: 'navigation',
    name: 'D40',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136499,
  },
  {
    mmsi: 999412267,
    lng: 121.834762,
    lat: 31.416698,
    lastdyn: 1719859780,
    type: 30,
    shiptype: 'navigation',
    name: 'HU XUN BAO 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412267,
  },
  {
    mmsi: 994136493,
    lng: 121.9145,
    lat: 31.258638,
    lastdyn: 1719859800,
    type: 24,
    shiptype: 'navigation',
    name: 'D34',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136493,
  },
  {
    mmsi: 994136496,
    lng: 121.859417,
    lat: 31.271528,
    lastdyn: 1719859776,
    type: 25,
    shiptype: 'navigation',
    name: 'D37',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136496,
  },
  {
    mmsi: 999412320,
    lng: 121.7955,
    lat: 31.307983,
    lastdyn: 1719859688,
    type: 24,
    shiptype: 'navigation',
    name: '600',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412320,
  },
  {
    mmsi: 994136492,
    lng: 121.927555,
    lat: 31.259695,
    lastdyn: 1719859805,
    type: 25,
    shiptype: 'navigation',
    name: 'D33',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136492,
  },
  {
    mmsi: 994136495,
    lng: 121.861278,
    lat: 31.267417,
    lastdyn: 1719859788,
    type: 24,
    shiptype: 'navigation',
    name: 'D36',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136495,
  },
  {
    mmsi: 999412269,
    lng: 121.882688,
    lat: 31.402177,
    lastdyn: 1719859716,
    type: 30,
    shiptype: 'navigation',
    name: 'HU XUN BAO 2',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412269,
  },
  {
    mmsi: 999412261,
    lng: 121.854213,
    lat: 31.27465,
    lastdyn: 1719859856,
    type: 25,
    shiptype: 'navigation',
    name: '37',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412261,
  },
  {
    mmsi: 994136497,
    lng: 121.834528,
    lat: 31.27725,
    lastdyn: 1719859782,
    type: 24,
    shiptype: 'navigation',
    name: 'D38',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136497,
  },
  {
    mmsi: 994136500,
    lng: 121.788278,
    lat: 31.297667,
    lastdyn: 1719859791,
    type: 25,
    shiptype: 'navigation',
    name: 'D41',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136500,
  },
  {
    mmsi: 994136393,
    lng: 121.793805,
    lat: 31.309722,
    lastdyn: 1719859821,
    type: 28,
    shiptype: 'navigation',
    name: 'CXQD 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136393,
  },
  {
    mmsi: 999412281,
    lng: 121.93217,
    lat: 31.387645,
    lastdyn: 1719859879,
    type: 30,
    shiptype: 'navigation',
    name: 'HU XUN BAO 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412281,
  },
  {
    mmsi: 994121432,
    lng: 121.840577,
    lat: 31.41546,
    lastdyn: 1719859641,
    type: 30,
    shiptype: 'navigation',
    name: 'HYYJ 10',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121432,
  },
  {
    mmsi: 994136498,
    lng: 121.827083,
    lat: 31.283417,
    lastdyn: 1719859794,
    type: 25,
    shiptype: 'navigation',
    name: 'D39',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136498,
  },
  {
    mmsi: 994136491,
    lng: 121.955528,
    lat: 31.251862,
    lastdyn: 1719859806,
    type: 24,
    shiptype: 'navigation',
    name: 'D32',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136491,
  },
  {
    mmsi: 999412297,
    lng: 121.787545,
    lat: 31.260495,
    lastdyn: 1719859718,
    type: 30,
    shiptype: 'navigation',
    name: 'QIAN DI 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412297,
  },
  {
    mmsi: 994136494,
    lng: 121.886555,
    lat: 31.266472,
    lastdyn: 1719859807,
    type: 25,
    shiptype: 'navigation',
    name: 'D35',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136494,
  },
  {
    mmsi: 994136501,
    lng: 121.751638,
    lat: 31.307667,
    lastdyn: 1719859785,
    type: 24,
    shiptype: 'navigation',
    name: 'D42',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136501,
  },
  {
    mmsi: 999412290,
    lng: 121.840123,
    lat: 31.385483,
    lastdyn: 1719859748,
    type: 30,
    shiptype: 'navigation',
    name: 'GONGQINGWEI SHUIWEN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412290,
  },
  {
    mmsi: 994136490,
    lng: 121.968583,
    lat: 31.252917,
    lastdyn: 1719859809,
    type: 25,
    shiptype: 'navigation',
    name: 'D31',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136490,
  },
  {
    mmsi: 999412280,
    lng: 121.784723,
    lat: 31.384888,
    lastdyn: 1719859763,
    type: 27,
    shiptype: 'navigation',
    name: '611',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412280,
  },
  {
    mmsi: 999413281,
    lng: 122.333778,
    lat: 31.399195,
    lastdyn: 1719859814,
    type: 28,
    shiptype: 'navigation',
    name: 'XIN YUN SHENG 8 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413281,
  },
  {
    mmsi: 994121443,
    lng: 122.333932,
    lat: 31.392018,
    lastdyn: 1719822636,
    type: 30,
    shiptype: 'navigation',
    name: 'HYYJ6',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121443,
  },
  {
    mmsi: 999412258,
    lng: 122.377798,
    lat: 31.266075,
    lastdyn: 1719859276,
    type: 30,
    shiptype: 'navigation',
    name: 'HSD SHUI WEN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412258,
  },
  {
    mmsi: 999992205,
    lng: 122.425227,
    lat: 31.386192,
    lastdyn: 1719853937,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2205',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992205,
  },
  {
    mmsi: 994126344,
    lng: 122.881667,
    lat: 31.344167,
    lastdyn: 1719858898,
    type: 28,
    shiptype: 'navigation',
    name: 'JCY 04810 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126344,
  },
  {
    mmsi: 994136362,
    lng: 122.825,
    lat: 31.329167,
    lastdyn: 1719859859,
    type: 28,
    shiptype: 'navigation',
    name: 'EVER WIN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136362,
  },
  {
    mmsi: 994128323,
    lng: 118.468367,
    lat: 31.745967,
    lastdyn: 1719859888,
    type: 25,
    shiptype: 'navigation',
    name: 'MGS1Z',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128323,
  },
  {
    mmsi: 994128324,
    lng: 118.467132,
    lat: 31.743682,
    lastdyn: 1719859890,
    type: 30,
    shiptype: 'navigation',
    name: 'MGS2Z',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128324,
  },
  {
    mmsi: 994128308,
    lng: 118.437132,
    lat: 31.700717,
    lastdyn: 1719859891,
    type: 0,
    shiptype: 'navigation',
    name: 'JXZ163S',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128308,
  },
  {
    mmsi: 994128307,
    lng: 118.395067,
    lat: 31.663367,
    lastdyn: 1719859888,
    type: 25,
    shiptype: 'navigation',
    name: 'JXZHZSL',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128307,
  },
  {
    mmsi: 994128309,
    lng: 118.401682,
    lat: 31.6482,
    lastdyn: 1719859891,
    type: 0,
    shiptype: 'navigation',
    name: 'JXZJJSS',
    length: 2,
    width: 10,
    left: 5,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128309,
  },
  {
    mmsi: 994128630,
    lng: 121.09825,
    lat: 31.736555,
    lastdyn: 1719859866,
    type: 0,
    shiptype: 'navigation',
    name: 'BM13S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128630,
  },
  {
    mmsi: 994128613,
    lng: 121.183917,
    lat: 31.682167,
    lastdyn: 1719859775,
    type: 25,
    shiptype: 'navigation',
    name: 'BM9L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128613,
  },
  {
    mmsi: 994136329,
    lng: 121.493055,
    lat: 31.5225,
    lastdyn: 1719859746,
    type: 30,
    shiptype: 'navigation',
    name: 'H11A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136329,
  },
  {
    mmsi: 999412284,
    lng: 121.335778,
    lat: 31.550822,
    lastdyn: 1719859771,
    type: 25,
    shiptype: 'navigation',
    name: '87',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412284,
  },
  {
    mmsi: 994136357,
    lng: 121.332333,
    lat: 31.545638,
    lastdyn: 1719851599,
    type: 10,
    shiptype: 'navigation',
    name: 'HEN SHUHOL TIE 13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136357,
  },
  {
    mmsi: 994136470,
    lng: 121.417878,
    lat: 31.528163,
    lastdyn: 1719859914,
    type: 28,
    shiptype: 'navigation',
    name: 'BB QIAN DIAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136470,
  },
  {
    mmsi: 994136363,
    lng: 121.376277,
    lat: 31.597777,
    lastdyn: 1719859764,
    type: 28,
    shiptype: 'navigation',
    name: 'H22',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136363,
  },
  {
    mmsi: 999412206,
    lng: 121.350152,
    lat: 31.53269,
    lastdyn: 1719859502,
    type: 31,
    shiptype: 'navigation',
    name: 'BAO SHAN LANBY',
    length: 6,
    width: 4,
    left: 2,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412206,
  },
  {
    mmsi: 994136575,
    lng: 121.389083,
    lat: 31.60225,
    lastdyn: 1719859740,
    type: 30,
    shiptype: 'navigation',
    name: 'H22A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136575,
  },
  {
    mmsi: 994136325,
    lng: 121.387222,
    lat: 31.516112,
    lastdyn: 1719859887,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NAN JIE 11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136325,
  },
  {
    mmsi: 999412285,
    lng: 121.330282,
    lat: 31.539405,
    lastdyn: 1719859720,
    type: 24,
    shiptype: 'navigation',
    name: 'A86',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412285,
  },
  {
    mmsi: 994136327,
    lng: 121.332333,
    lat: 31.545638,
    lastdyn: 1719859904,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NAN JIE 13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136327,
  },
  {
    mmsi: 994136312,
    lng: 119.17135,
    lat: 39.314517,
    lastdyn: 1719859872,
    type: 30,
    shiptype: 'navigation',
    name: 'YANGZHIQU1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136312,
  },
  {
    mmsi: 994136311,
    lng: 118.867472,
    lat: 38.98675,
    lastdyn: 1719859861,
    type: 28,
    shiptype: 'navigation',
    name: 'TAIHE 9 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136311,
  },
  {
    mmsi: 994136510,
    lng: 121.470867,
    lat: 31.51265,
    lastdyn: 1719859899,
    type: 28,
    shiptype: 'navigation',
    name: 'JSJ 9999 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136510,
  },
  {
    mmsi: 999412331,
    lng: 121.435475,
    lat: 31.501233,
    lastdyn: 1719859334,
    type: 23,
    shiptype: 'navigation',
    name: 'HU QIAN 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412331,
  },
  {
    mmsi: 999412252,
    lng: 121.353667,
    lat: 31.510682,
    lastdyn: 1719859889,
    type: 30,
    shiptype: 'navigation',
    name: 'CH SHUI WEN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412252,
  },
  {
    mmsi: 998000141,
    lng: 121.356112,
    lat: 31.556112,
    lastdyn: 1719859804,
    type: 0,
    shiptype: 'navigation',
    name: 'YZ141',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 998000141,
  },
  {
    mmsi: 999412277,
    lng: 121.406687,
    lat: 31.513177,
    lastdyn: 1719846855,
    type: 25,
    shiptype: 'navigation',
    name: '81',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412277,
  },
  {
    mmsi: 994136313,
    lng: 119.234967,
    lat: 39.2443,
    lastdyn: 1719859875,
    type: 30,
    shiptype: 'navigation',
    name: 'YANGZHIQU2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136313,
  },
  {
    mmsi: 994121431,
    lng: 121.37908,
    lat: 31.55263,
    lastdyn: 1719859577,
    type: 30,
    shiptype: 'navigation',
    name: 'HYYJ 9',
    length: 3,
    width: 3,
    left: 1,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121431,
  },
  {
    mmsi: 994128635,
    lng: 121.278917,
    lat: 31.611443,
    lastdyn: 1719859768,
    type: 0,
    shiptype: 'navigation',
    name: 'LH4S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128635,
  },
  {
    mmsi: 999135135,
    lng: 121.428333,
    lat: 31.609167,
    lastdyn: 1719859844,
    type: 1,
    shiptype: 'navigation',
    name: 'XNHB00135',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999135135,
  },
  {
    mmsi: 994136326,
    lng: 121.352472,
    lat: 31.534778,
    lastdyn: 1719859904,
    type: 24,
    shiptype: 'navigation',
    name: 'SHEN SHUI NAN JIE 12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136326,
  },
  {
    mmsi: 994128653,
    lng: 121.651472,
    lat: 31.723222,
    lastdyn: 1719859898,
    type: 25,
    shiptype: 'navigation',
    name: 'CQ6L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128653,
  },
  {
    mmsi: 994128647,
    lng: 121.670443,
    lat: 31.71761,
    lastdyn: 1719859416,
    type: 0,
    shiptype: 'navigation',
    name: 'CQ3S',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128647,
  },
  {
    mmsi: 994128645,
    lng: 121.670832,
    lat: 31.718917,
    lastdyn: 1719856408,
    type: 25,
    shiptype: 'navigation',
    name: 'CQ3L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128645,
  },
  {
    mmsi: 994128643,
    lng: 121.675972,
    lat: 31.717777,
    lastdyn: 1719859386,
    type: 25,
    shiptype: 'navigation',
    name: 'CQ2L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128643,
  },
  {
    mmsi: 994128642,
    lng: 121.682667,
    lat: 0.003272,
    lastdyn: 1719858096,
    type: 24,
    shiptype: 'navigation',
    name: 'CQ0',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128642,
  },
  {
    mmsi: 994128649,
    lng: 121.663805,
    lat: 31.717332,
    lastdyn: 1719859865,
    type: 24,
    shiptype: 'navigation',
    name: 'CQ4R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128649,
  },
  {
    mmsi: 994128641,
    lng: 121.683555,
    lat: 31.716138,
    lastdyn: 1719859808,
    type: 25,
    shiptype: 'navigation',
    name: 'CQ1L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128641,
  },
  {
    mmsi: 994128654,
    lng: 121.650527,
    lat: 31.720332,
    lastdyn: 1719859471,
    type: 24,
    shiptype: 'navigation',
    name: 'CQ6R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128654,
  },
  {
    mmsi: 999413256,
    lng: 121.5525,
    lat: 31.501112,
    lastdyn: 1719859869,
    type: 24,
    shiptype: 'navigation',
    name: '206A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413256,
  },
  {
    mmsi: 994128650,
    lng: 121.66425,
    lat: 31.718667,
    lastdyn: 1719859873,
    type: 0,
    shiptype: 'navigation',
    name: 'CQ4S',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128650,
  },
  {
    mmsi: 994136522,
    lng: 121.582333,
    lat: 31.50225,
    lastdyn: 1719859917,
    type: 28,
    shiptype: 'navigation',
    name: 'BZG NAN QIAN DIAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136522,
  },
  {
    mmsi: 994128651,
    lng: 121.659638,
    lat: 31.7215,
    lastdyn: 1719859880,
    type: 25,
    shiptype: 'navigation',
    name: 'CQ5L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128651,
  },
  {
    mmsi: 994128652,
    lng: 121.658722,
    lat: 31.7185,
    lastdyn: 1719859889,
    type: 24,
    shiptype: 'navigation',
    name: 'CQ5R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128652,
  },
  {
    mmsi: 994128644,
    lng: 121.675138,
    lat: 31.714917,
    lastdyn: 1719858968,
    type: 24,
    shiptype: 'navigation',
    name: 'CQ2R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128644,
  },
  {
    mmsi: 994128648,
    lng: 121.66461,
    lat: 31.720332,
    lastdyn: 1719859856,
    type: 25,
    shiptype: 'navigation',
    name: 'CQ4L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128648,
  },
  {
    mmsi: 994128646,
    lng: 121.670138,
    lat: 31.715972,
    lastdyn: 1719859842,
    type: 24,
    shiptype: 'navigation',
    name: 'CQ3R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128646,
  },
  {
    mmsi: 994136342,
    lng: 122.153833,
    lat: 31.507167,
    lastdyn: 1719859817,
    type: 28,
    shiptype: 'navigation',
    name: 'SGN 318 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136342,
  },
  {
    mmsi: 994136418,
    lng: 122.00245,
    lat: 31.702567,
    lastdyn: 1719859820,
    type: 28,
    shiptype: 'navigation',
    name: 'HAO YUN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136418,
  },
  {
    mmsi: 994136419,
    lng: 122.1,
    lat: 31.72,
    lastdyn: 1719859823,
    type: 28,
    shiptype: 'navigation',
    name: 'YHX WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136419,
  },
  {
    mmsi: 999412257,
    lng: 122.103643,
    lat: 31.553878,
    lastdyn: 1719859913,
    type: 30,
    shiptype: 'navigation',
    name: 'BEI ZHI KOU MEN SHUI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412257,
  },
  {
    mmsi: 994136565,
    lng: 122.715333,
    lat: 31.634667,
    lastdyn: 1719859682,
    type: 28,
    shiptype: 'navigation',
    name: 'WU MING WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136565,
  },
  {
    mmsi: 994136353,
    lng: 123.486667,
    lat: 31.54,
    lastdyn: 1719859856,
    type: 28,
    shiptype: 'navigation',
    name: 'ESC5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136353,
  },
  {
    mmsi: 994136568,
    lng: 123.950838,
    lat: 31.653153,
    lastdyn: 1719859810,
    type: 28,
    shiptype: 'navigation',
    name: 'ZDY 02611 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136568,
  },
  {
    mmsi: 994126422,
    lng: 118.6678,
    lat: 31.9966,
    lastdyn: 1719859825,
    type: 0,
    shiptype: 'navigation',
    name: 'JXZQ RU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126422,
  },
  {
    mmsi: 994127583,
    lng: 119.978567,
    lat: 31.979432,
    lastdyn: 1719859903,
    type: 25,
    shiptype: 'navigation',
    name: 'CHGXQ3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127583,
  },
  {
    mmsi: 994127588,
    lng: 119.96177,
    lat: 31.987463,
    lastdyn: 1719859764,
    type: 24,
    shiptype: 'navigation',
    name: 'LAZDQ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127588,
  },
  {
    mmsi: 994127516,
    lng: 119.99628,
    lat: 31.98184,
    lastdyn: 1719859893,
    type: 24,
    shiptype: 'navigation',
    name: 'JY72R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127516,
  },
  {
    mmsi: 994127581,
    lng: 119.985682,
    lat: 31.977282,
    lastdyn: 1719859902,
    type: 25,
    shiptype: 'navigation',
    name: 'CHGXQ1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127581,
  },
  {
    mmsi: 994127517,
    lng: 119.97634,
    lat: 31.99875,
    lastdyn: 1719859650,
    type: 24,
    shiptype: 'navigation',
    name: 'TXCTS1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127517,
  },
  {
    mmsi: 994127590,
    lng: 119.961325,
    lat: 31.990097,
    lastdyn: 1719859764,
    type: 25,
    shiptype: 'navigation',
    name: 'LAZDQ4L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127590,
  },
  {
    mmsi: 994127544,
    lng: 119.99327,
    lat: 31.99977,
    lastdyn: 1719859348,
    type: 24,
    shiptype: 'navigation',
    name: 'QWZY2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127544,
  },
  {
    mmsi: 994127582,
    lng: 119.980945,
    lat: 31.975673,
    lastdyn: 1719859404,
    type: 24,
    shiptype: 'navigation',
    name: 'CHGXQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127582,
  },
  {
    mmsi: 994127591,
    lng: 119.96535,
    lat: 31.98675,
    lastdyn: 1719859902,
    type: 25,
    shiptype: 'navigation',
    name: 'LAZDQ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127591,
  },
  {
    mmsi: 994128547,
    lng: 119.993503,
    lat: 31.991708,
    lastdyn: 1719859710,
    type: 0,
    shiptype: 'navigation',
    name: 'TX72S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128547,
  },
  {
    mmsi: 994127584,
    lng: 119.96505,
    lat: 31.984932,
    lastdyn: 1719859904,
    type: 24,
    shiptype: 'navigation',
    name: 'LAZDQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127584,
  },
  {
    mmsi: 994129580,
    lng: 120.20873,
    lat: 31.93362,
    lastdyn: 1719859853,
    type: 30,
    shiptype: 'navigation',
    name: 'JYCHM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129580,
  },
  {
    mmsi: 994127505,
    lng: 120.06386,
    lat: 31.96078,
    lastdyn: 1719855267,
    type: 25,
    shiptype: 'navigation',
    name: 'JY69L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127505,
  },
  {
    mmsi: 999414104,
    lng: 120.13285,
    lat: 31.952967,
    lastdyn: 1719859915,
    type: 0,
    shiptype: 'navigation',
    name: 'JIN 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999414104,
  },
  {
    mmsi: 994127509,
    lng: 120.04536,
    lat: 31.96064,
    lastdyn: 1719859893,
    type: 24,
    shiptype: 'navigation',
    name: 'JY70R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127509,
  },
  {
    mmsi: 995110002,
    lng: 134.453438,
    lat: 7.456368,
    lastdyn: 1718855281,
    type: 24,
    shiptype: 'navigation',
    name: '38',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995110002,
  },
  {
    mmsi: 994128504,
    lng: 120.17815,
    lat: 31.935017,
    lastdyn: 1719859556,
    type: 25,
    shiptype: 'navigation',
    name: 'JY64L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128504,
  },
  {
    mmsi: 999414105,
    lng: 120.133883,
    lat: 31.952717,
    lastdyn: 1719859917,
    type: 0,
    shiptype: 'navigation',
    name: 'JIN 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999414105,
  },
  {
    mmsi: 995110004,
    lng: 134.446127,
    lat: 7.448793,
    lastdyn: 1715189409,
    type: 13,
    shiptype: 'navigation',
    name: '40',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995110004,
  },
  {
    mmsi: 994127543,
    lng: 120.15303,
    lat: 31.94606,
    lastdyn: 1719859348,
    type: 30,
    shiptype: 'navigation',
    name: 'JYHM4Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127543,
  },
  {
    mmsi: 994128514,
    lng: 120.15109,
    lat: 31.93839,
    lastdyn: 1719859828,
    type: 25,
    shiptype: 'navigation',
    name: 'JY65L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128514,
  },
  {
    mmsi: 994127507,
    lng: 120.06543,
    lat: 31.95523,
    lastdyn: 1719859467,
    type: 24,
    shiptype: 'navigation',
    name: 'JY69R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127507,
  },
  {
    mmsi: 994126563,
    lng: 120.14138,
    lat: 31.92757,
    lastdyn: 1719859587,
    type: 25,
    shiptype: 'navigation',
    name: 'JYSGH3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126563,
  },
  {
    mmsi: 994126578,
    lng: 120.18607,
    lat: 31.93564,
    lastdyn: 1719859887,
    type: 30,
    shiptype: 'navigation',
    name: 'JYHM1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126578,
  },
  {
    mmsi: 994127508,
    lng: 120.04972,
    lat: 31.96483,
    lastdyn: 1719859712,
    type: 25,
    shiptype: 'navigation',
    name: 'JY70L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127508,
  },
  {
    mmsi: 999414102,
    lng: 120.130917,
    lat: 31.953433,
    lastdyn: 1719859911,
    type: 0,
    shiptype: 'navigation',
    name: 'JIN 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999414102,
  },
  {
    mmsi: 999414108,
    lng: 120.135983,
    lat: 31.9522,
    lastdyn: 1719859761,
    type: 0,
    shiptype: 'navigation',
    name: 'JIN 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999414108,
  },
  {
    mmsi: 994127503,
    lng: 120.08464,
    lat: 31.95505,
    lastdyn: 1719858628,
    type: 25,
    shiptype: 'navigation',
    name: 'JY68L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127503,
  },
  {
    mmsi: 994126577,
    lng: 120.18712,
    lat: 31.94198,
    lastdyn: 1719859527,
    type: 30,
    shiptype: 'navigation',
    name: 'JYHM3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126577,
  },
  {
    mmsi: 994127512,
    lng: 120.01978,
    lat: 31.97501,
    lastdyn: 1719859893,
    type: 25,
    shiptype: 'navigation',
    name: 'JY71L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127512,
  },
  {
    mmsi: 999414106,
    lng: 120.1349,
    lat: 31.952467,
    lastdyn: 1719859759,
    type: 0,
    shiptype: 'navigation',
    name: 'JIN 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999414106,
  },
  {
    mmsi: 994128505,
    lng: 120.178,
    lat: 31.92965,
    lastdyn: 1719858008,
    type: 24,
    shiptype: 'navigation',
    name: 'JY64R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128505,
  },
  {
    mmsi: 994128528,
    lng: 120.15135,
    lat: 31.9338,
    lastdyn: 1719859768,
    type: 24,
    shiptype: 'navigation',
    name: 'JY65R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128528,
  },
  {
    mmsi: 994129544,
    lng: 120.174512,
    lat: 31.928372,
    lastdyn: 1719859827,
    type: 30,
    shiptype: 'navigation',
    name: 'JYS1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129544,
  },
  {
    mmsi: 994127504,
    lng: 120.08477,
    lat: 31.94972,
    lastdyn: 1719859888,
    type: 24,
    shiptype: 'navigation',
    name: 'JY68R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127504,
  },
  {
    mmsi: 994127500,
    lng: 120.10704,
    lat: 31.94872,
    lastdyn: 1719859588,
    type: 25,
    shiptype: 'navigation',
    name: 'JY67L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127500,
  },
  {
    mmsi: 994127514,
    lng: 120.01999,
    lat: 31.9688,
    lastdyn: 1719859833,
    type: 24,
    shiptype: 'navigation',
    name: 'JY71R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127514,
  },
  {
    mmsi: 994128593,
    lng: 120.12984,
    lat: 31.94275,
    lastdyn: 1719859828,
    type: 25,
    shiptype: 'navigation',
    name: 'JY66L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128593,
  },
  {
    mmsi: 994129545,
    lng: 120.149017,
    lat: 31.9296,
    lastdyn: 1719859816,
    type: 30,
    shiptype: 'navigation',
    name: 'JYS2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129545,
  },
  {
    mmsi: 999414103,
    lng: 120.1318,
    lat: 31.9532,
    lastdyn: 1719859753,
    type: 0,
    shiptype: 'navigation',
    name: 'JIN 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999414103,
  },
  {
    mmsi: 994129586,
    lng: 120.199818,
    lat: 31.943908,
    lastdyn: 1719859831,
    type: 30,
    shiptype: 'navigation',
    name: 'JYDMZ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129586,
  },
  {
    mmsi: 994128606,
    lng: 120.252267,
    lat: 31.935017,
    lastdyn: 1719859680,
    type: 24,
    shiptype: 'navigation',
    name: 'JY61R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128606,
  },
  {
    mmsi: 994128639,
    lng: 120.278667,
    lat: 31.946617,
    lastdyn: 1719859706,
    type: 24,
    shiptype: 'navigation',
    name: 'FZ60R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128639,
  },
  {
    mmsi: 994128603,
    lng: 120.455367,
    lat: 31.986817,
    lastdyn: 1719859832,
    type: 30,
    shiptype: 'navigation',
    name: 'DHZ3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128603,
  },
  {
    mmsi: 994128601,
    lng: 120.455332,
    lat: 31.986967,
    lastdyn: 1719859850,
    type: 30,
    shiptype: 'navigation',
    name: 'DHZ1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128601,
  },
  {
    mmsi: 994128602,
    lng: 120.455367,
    lat: 31.986882,
    lastdyn: 1719859841,
    type: 30,
    shiptype: 'navigation',
    name: 'DHZ2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128602,
  },
  {
    mmsi: 994128638,
    lng: 120.317917,
    lat: 31.959638,
    lastdyn: 1719859439,
    type: 0,
    shiptype: 'navigation',
    name: 'FZ59S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128638,
  },
  {
    mmsi: 994128665,
    lng: 120.691,
    lat: 31.999777,
    lastdyn: 1719859040,
    type: 24,
    shiptype: 'navigation',
    name: 'HTQ4R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128665,
  },
  {
    mmsi: 994128634,
    lng: 120.61075,
    lat: 31.994667,
    lastdyn: 1719859808,
    type: 0,
    shiptype: 'navigation',
    name: 'LHS44S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128634,
  },
  {
    mmsi: 994128612,
    lng: 120.8589,
    lat: 31.94865,
    lastdyn: 1719854638,
    type: 24,
    shiptype: 'navigation',
    name: 'NT27R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128612,
  },
  {
    mmsi: 994127695,
    lng: 120.994917,
    lat: 31.761367,
    lastdyn: 1719859777,
    type: 24,
    shiptype: 'navigation',
    name: 'CSG82R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127695,
  },
  {
    mmsi: 994128609,
    lng: 120.980067,
    lat: 31.801882,
    lastdyn: 1719859842,
    type: 30,
    shiptype: 'navigation',
    name: 'TGGLBX',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128609,
  },
  {
    mmsi: 994128610,
    lng: 120.984832,
    lat: 31.77325,
    lastdyn: 1719859847,
    type: 30,
    shiptype: 'navigation',
    name: 'TGGLZS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128610,
  },
  {
    mmsi: 994128620,
    lng: 120.983132,
    lat: 31.7587,
    lastdyn: 1719859818,
    type: 30,
    shiptype: 'navigation',
    name: 'TGGLNS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128620,
  },
  {
    mmsi: 994128689,
    lng: 120.993832,
    lat: 31.76311,
    lastdyn: 1719859536,
    type: 25,
    shiptype: 'navigation',
    name: 'ZQ2L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128689,
  },
  {
    mmsi: 994128608,
    lng: 120.97755,
    lat: 31.8024,
    lastdyn: 1719859833,
    type: 30,
    shiptype: 'navigation',
    name: 'TGGLBS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128608,
  },
  {
    mmsi: 994128678,
    lng: 120.953555,
    lat: 31.777527,
    lastdyn: 1719859522,
    type: 0,
    shiptype: 'navigation',
    name: 'SQ6S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128678,
  },
  {
    mmsi: 994128688,
    lng: 120.9997,
    lat: 31.762382,
    lastdyn: 1719859530,
    type: 25,
    shiptype: 'navigation',
    name: 'ZQ1L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128688,
  },
  {
    mmsi: 994128693,
    lng: 120.981667,
    lat: 31.766527,
    lastdyn: 1719859145,
    type: 25,
    shiptype: 'navigation',
    name: 'ZQ4L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128693,
  },
  {
    mmsi: 994128677,
    lng: 120.9568,
    lat: 31.783467,
    lastdyn: 1719859513,
    type: 25,
    shiptype: 'navigation',
    name: 'SQ6L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128677,
  },
  {
    mmsi: 994128691,
    lng: 120.988167,
    lat: 31.764332,
    lastdyn: 1719859554,
    type: 25,
    shiptype: 'navigation',
    name: 'ZQ3L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128691,
  },
  {
    mmsi: 994128675,
    lng: 120.972582,
    lat: 31.77561,
    lastdyn: 1719859495,
    type: 24,
    shiptype: 'navigation',
    name: 'SQ5R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128675,
  },
  {
    mmsi: 994128614,
    lng: 120.8331,
    lat: 31.98355,
    lastdyn: 1719856977,
    type: 24,
    shiptype: 'navigation',
    name: 'NT281R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128614,
  },
  {
    mmsi: 994128673,
    lng: 120.989917,
    lat: 31.780777,
    lastdyn: 1719859480,
    type: 25,
    shiptype: 'navigation',
    name: 'SQ4L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128673,
  },
  {
    mmsi: 994128622,
    lng: 120.849482,
    lat: 31.964517,
    lastdyn: 1719855054,
    type: 24,
    shiptype: 'navigation',
    name: 'NT28R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128622,
  },
  {
    mmsi: 994127694,
    lng: 120.999232,
    lat: 31.760717,
    lastdyn: 1719859751,
    type: 24,
    shiptype: 'navigation',
    name: 'CSG81R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127694,
  },
  {
    mmsi: 994128611,
    lng: 120.987167,
    lat: 31.773232,
    lastdyn: 1719859858,
    type: 30,
    shiptype: 'navigation',
    name: 'TGGLZX',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128611,
  },
  {
    mmsi: 994128692,
    lng: 120.987638,
    lat: 31.7625,
    lastdyn: 1719859561,
    type: 24,
    shiptype: 'navigation',
    name: 'ZQ3R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128692,
  },
  {
    mmsi: 994128659,
    lng: 120.9743,
    lat: 31.78695,
    lastdyn: 1719859736,
    type: 24,
    shiptype: 'navigation',
    name: 'YCG1R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128659,
  },
  {
    mmsi: 994128676,
    lng: 120.976367,
    lat: 31.781667,
    lastdyn: 1719859082,
    type: 0,
    shiptype: 'navigation',
    name: 'SQ5S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128676,
  },
  {
    mmsi: 994128694,
    lng: 120.980888,
    lat: 31.764082,
    lastdyn: 1719859578,
    type: 24,
    shiptype: 'navigation',
    name: 'ZQ4R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128694,
  },
  {
    mmsi: 994128674,
    lng: 120.990767,
    lat: 31.775532,
    lastdyn: 1719859489,
    type: 24,
    shiptype: 'navigation',
    name: 'SQ4R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128674,
  },
  {
    mmsi: 994128621,
    lng: 120.98545,
    lat: 31.758582,
    lastdyn: 1719859376,
    type: 30,
    shiptype: 'navigation',
    name: 'TGGLNX',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128621,
  },
  {
    mmsi: 994128690,
    lng: 120.99325,
    lat: 31.761305,
    lastdyn: 1719859121,
    type: 24,
    shiptype: 'navigation',
    name: 'ZQ2R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128690,
  },
  {
    mmsi: 994128615,
    lng: 120.8213,
    lat: 31.993582,
    lastdyn: 1719858495,
    type: 24,
    shiptype: 'navigation',
    name: 'NT29R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128615,
  },
  {
    mmsi: 994128623,
    lng: 120.962967,
    lat: 31.774632,
    lastdyn: 1719859730,
    type: 0,
    shiptype: 'navigation',
    name: 'C14',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128623,
  },
  {
    mmsi: 994128667,
    lng: 121.029082,
    lat: 31.775722,
    lastdyn: 1719859879,
    type: 25,
    shiptype: 'navigation',
    name: 'SQ1L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128667,
  },
  {
    mmsi: 994127693,
    lng: 121.003267,
    lat: 31.75935,
    lastdyn: 1719859759,
    type: 24,
    shiptype: 'navigation',
    name: 'CSG8R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127693,
  },
  {
    mmsi: 994126620,
    lng: 121.038232,
    lat: 31.812432,
    lastdyn: 1719859786,
    type: 19,
    shiptype: 'navigation',
    name: 'SJ1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126620,
  },
  {
    mmsi: 994128671,
    lng: 121.0011,
    lat: 31.779717,
    lastdyn: 1719859914,
    type: 25,
    shiptype: 'navigation',
    name: 'SQ3L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128671,
  },
  {
    mmsi: 994127691,
    lng: 121.019932,
    lat: 31.752967,
    lastdyn: 1719859746,
    type: 24,
    shiptype: 'navigation',
    name: 'CSG71R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127691,
  },
  {
    mmsi: 994128669,
    lng: 121.01425,
    lat: 31.777777,
    lastdyn: 1719859898,
    type: 25,
    shiptype: 'navigation',
    name: 'SQ2L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128669,
  },
  {
    mmsi: 994128672,
    lng: 121.00086,
    lat: 31.774667,
    lastdyn: 1719859475,
    type: 24,
    shiptype: 'navigation',
    name: 'SQ3R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128672,
  },
  {
    mmsi: 994128668,
    lng: 121.027222,
    lat: 31.769138,
    lastdyn: 1719859439,
    type: 24,
    shiptype: 'navigation',
    name: 'SQ1R',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128668,
  },
  {
    mmsi: 994128631,
    lng: 121.0722,
    lat: 31.7632,
    lastdyn: 1719859874,
    type: 0,
    shiptype: 'navigation',
    name: 'BM14S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128631,
  },
  {
    mmsi: 994127692,
    lng: 121.017832,
    lat: 31.7538,
    lastdyn: 1719859626,
    type: 24,
    shiptype: 'navigation',
    name: 'CSG72R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127692,
  },
  {
    mmsi: 994128670,
    lng: 121.014443,
    lat: 31.77225,
    lastdyn: 1719859905,
    type: 24,
    shiptype: 'navigation',
    name: 'SQ2R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128670,
  },
  {
    mmsi: 994128696,
    lng: 121.265917,
    lat: 31.869317,
    lastdyn: 1719859194,
    type: 0,
    shiptype: 'navigation',
    name: 'BZ21',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128696,
  },
  {
    mmsi: 994136456,
    lng: 122.25255,
    lat: 31.863067,
    lastdyn: 1719859798,
    type: 28,
    shiptype: 'navigation',
    name: 'JY 88 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136456,
  },
  {
    mmsi: 994126428,
    lng: 118.674,
    lat: 32.01104,
    lastdyn: 1719859833,
    type: 0,
    shiptype: 'navigation',
    name: 'JXZQ RD',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126428,
  },
  {
    mmsi: 994128418,
    lng: 118.662482,
    lat: 32.003082,
    lastdyn: 1719859916,
    type: 0,
    shiptype: 'navigation',
    name: 'NJJXZQ2S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128418,
  },
  {
    mmsi: 994128419,
    lng: 118.700217,
    lat: 32.013682,
    lastdyn: 1719859914,
    type: 0,
    shiptype: 'navigation',
    name: 'NJJXZQ1S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128419,
  },
  {
    mmsi: 994126420,
    lng: 118.65775,
    lat: 32.016432,
    lastdyn: 1719859913,
    type: 0,
    shiptype: 'navigation',
    name: 'JXZQ LD',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126420,
  },
  {
    mmsi: 994126409,
    lng: 118.76596,
    lat: 32.16176,
    lastdyn: 1719859789,
    type: 0,
    shiptype: 'navigation',
    name: 'SBQ LU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126409,
  },
  {
    mmsi: 994128411,
    lng: 118.933682,
    lat: 32.178932,
    lastdyn: 1719859726,
    type: 25,
    shiptype: 'navigation',
    name: 'LT4Q3L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128411,
  },
  {
    mmsi: 994126412,
    lng: 118.77421,
    lat: 32.17197,
    lastdyn: 1719859807,
    type: 0,
    shiptype: 'navigation',
    name: 'SBQ RD',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126412,
  },
  {
    mmsi: 994128408,
    lng: 118.94857,
    lat: 32.17112,
    lastdyn: 1719859746,
    type: 24,
    shiptype: 'navigation',
    name: 'LT4Q1R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128408,
  },
  {
    mmsi: 994126410,
    lng: 118.76348,
    lat: 32.16959,
    lastdyn: 1719859795,
    type: 0,
    shiptype: 'navigation',
    name: 'SBQ LD',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126410,
  },
  {
    mmsi: 994126411,
    lng: 118.77693,
    lat: 32.16419,
    lastdyn: 1719859801,
    type: 0,
    shiptype: 'navigation',
    name: 'SBQ RU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126411,
  },
  {
    mmsi: 994128407,
    lng: 118.94886,
    lat: 32.176593,
    lastdyn: 1719859740,
    type: 25,
    shiptype: 'navigation',
    name: 'LT4Q1L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128407,
  },
  {
    mmsi: 994128409,
    lng: 118.94244,
    lat: 32.17748,
    lastdyn: 1719859753,
    type: 25,
    shiptype: 'navigation',
    name: 'LT4Q2L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128409,
  },
  {
    mmsi: 994128410,
    lng: 118.94198,
    lat: 32.17177,
    lastdyn: 1719859760,
    type: 24,
    shiptype: 'navigation',
    name: 'LT4Q2R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128410,
  },
  {
    mmsi: 994126405,
    lng: 118.870932,
    lat: 32.17685,
    lastdyn: 1719859917,
    type: 24,
    shiptype: 'navigation',
    name: 'CXX137R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126405,
  },
  {
    mmsi: 994126430,
    lng: 118.76678,
    lat: 0.01479,
    lastdyn: 1719859839,
    type: 30,
    shiptype: 'navigation',
    name: 'BGZ Z',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126430,
  },
  {
    mmsi: 994126406,
    lng: 118.9086,
    lat: 32.18302,
    lastdyn: 1719859742,
    type: 25,
    shiptype: 'navigation',
    name: 'LT135L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126406,
  },
  {
    mmsi: 994128415,
    lng: 118.86837,
    lat: 32.18109,
    lastdyn: 1719859914,
    type: 0,
    shiptype: 'navigation',
    name: 'CXX137S',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128415,
  },
  {
    mmsi: 994128414,
    lng: 118.9236,
    lat: 32.17569,
    lastdyn: 1719859784,
    type: 24,
    shiptype: 'navigation',
    name: 'LT4Q4R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128414,
  },
  {
    mmsi: 994128412,
    lng: 118.93421,
    lat: 32.17372,
    lastdyn: 1719859901,
    type: 24,
    shiptype: 'navigation',
    name: 'LT4Q3R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128412,
  },
  {
    mmsi: 994128413,
    lng: 118.92401,
    lat: 32.18082,
    lastdyn: 1719859779,
    type: 25,
    shiptype: 'navigation',
    name: 'LT4Q4L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128413,
  },
  {
    mmsi: 994128439,
    lng: 119.09689,
    lat: 32.24769,
    lastdyn: 1719859862,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ124 L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128439,
  },
  {
    mmsi: 994128451,
    lng: 119.087132,
    lat: 32.237832,
    lastdyn: 1719801675,
    type: 30,
    shiptype: 'navigation',
    name: 'LTQSR2 Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128451,
  },
  {
    mmsi: 994128428,
    lng: 119.089832,
    lat: 32.239382,
    lastdyn: 1719207269,
    type: 30,
    shiptype: 'navigation',
    name: 'LTQSL1 Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128428,
  },
  {
    mmsi: 994128406,
    lng: 119.00416,
    lat: 32.17383,
    lastdyn: 1719859557,
    type: 24,
    shiptype: 'navigation',
    name: 'LT131R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128406,
  },
  {
    mmsi: 994129584,
    lng: 119.242697,
    lat: 32.223162,
    lastdyn: 1719859708,
    type: 30,
    shiptype: 'navigation',
    name: 'DBS3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129584,
  },
  {
    mmsi: 994126592,
    lng: 119.239167,
    lat: 32.217222,
    lastdyn: 1719859809,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ119L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126592,
  },
  {
    mmsi: 994128401,
    lng: 119.217832,
    lat: 32.230617,
    lastdyn: 1719859916,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ120L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128401,
  },
  {
    mmsi: 994128431,
    lng: 119.086817,
    lat: 32.238417,
    lastdyn: 1719799908,
    type: 30,
    shiptype: 'navigation',
    name: 'LTQSL2 Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128431,
  },
  {
    mmsi: 994128405,
    lng: 119.00327,
    lat: 32.17866,
    lastdyn: 1719859896,
    type: 25,
    shiptype: 'navigation',
    name: 'LT131L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128405,
  },
  {
    mmsi: 994126401,
    lng: 119.0575,
    lat: 32.210382,
    lastdyn: 1719859915,
    type: 24,
    shiptype: 'navigation',
    name: 'LT127R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126401,
  },
  {
    mmsi: 994128402,
    lng: 119.207432,
    lat: 32.2274,
    lastdyn: 1719859916,
    type: 24,
    shiptype: 'navigation',
    name: 'YZ120R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128402,
  },
  {
    mmsi: 994129583,
    lng: 119.242745,
    lat: 32.218572,
    lastdyn: 1719859825,
    type: 30,
    shiptype: 'navigation',
    name: 'DBS4Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129583,
  },
  {
    mmsi: 994128423,
    lng: 119.09886,
    lat: 32.24328,
    lastdyn: 1713409789,
    type: 24,
    shiptype: 'navigation',
    name: 'YZ1241 R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128423,
  },
  {
    mmsi: 994127564,
    lng: 119.317115,
    lat: 32.197997,
    lastdyn: 1719859860,
    type: 30,
    shiptype: 'navigation',
    name: 'YZZY3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127564,
  },
  {
    mmsi: 994127532,
    lng: 119.270467,
    lat: 32.204667,
    lastdyn: 1719859752,
    type: 30,
    shiptype: 'navigation',
    name: 'SYZSH2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127532,
  },
  {
    mmsi: 994126551,
    lng: 119.402057,
    lat: 32.240652,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS112R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126551,
  },
  {
    mmsi: 994128564,
    lng: 119.35567,
    lat: 32.2301,
    lastdyn: 1719859753,
    type: 25,
    shiptype: 'navigation',
    name: 'RYDQBCQ3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128564,
  },
  {
    mmsi: 994128559,
    lng: 119.250567,
    lat: 32.205367,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'YZ118R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128559,
  },
  {
    mmsi: 994126579,
    lng: 119.36254,
    lat: 32.22919,
    lastdyn: 1719859875,
    type: 25,
    shiptype: 'navigation',
    name: 'RYDQBCQ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126579,
  },
  {
    mmsi: 994128543,
    lng: 119.35853,
    lat: 32.20298,
    lastdyn: 1719859823,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ114L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128543,
  },
  {
    mmsi: 994127531,
    lng: 119.269588,
    lat: 32.203642,
    lastdyn: 1719859756,
    type: 30,
    shiptype: 'navigation',
    name: 'SYZSH3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127531,
  },
  {
    mmsi: 994128542,
    lng: 119.36783,
    lat: 32.204062,
    lastdyn: 1719859884,
    type: 24,
    shiptype: 'navigation',
    name: 'YZ113R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128542,
  },
  {
    mmsi: 994128557,
    lng: 119.316712,
    lat: 32.19313,
    lastdyn: 1719859842,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ116L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128557,
  },
  {
    mmsi: 994126580,
    lng: 119.36535,
    lat: 32.2288,
    lastdyn: 1719859875,
    type: 25,
    shiptype: 'navigation',
    name: 'RYDQBCQ1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126580,
  },
  {
    mmsi: 994126581,
    lng: 119.3618,
    lat: 32.22739,
    lastdyn: 1719859875,
    type: 24,
    shiptype: 'navigation',
    name: 'RYDQBCQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126581,
  },
  {
    mmsi: 994128541,
    lng: 119.361812,
    lat: 32.199438,
    lastdyn: 1719859829,
    type: 24,
    shiptype: 'navigation',
    name: 'YZ114R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128541,
  },
  {
    mmsi: 994128554,
    lng: 119.253662,
    lat: 32.20905,
    lastdyn: 1719859912,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ118L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128554,
  },
  {
    mmsi: 994128555,
    lng: 119.277962,
    lat: 32.19552,
    lastdyn: 1719859851,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ1171L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128555,
  },
  {
    mmsi: 994128556,
    lng: 119.29337,
    lat: 32.19262,
    lastdyn: 1719859845,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ117L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128556,
  },
  {
    mmsi: 994127534,
    lng: 119.271372,
    lat: 32.205708,
    lastdyn: 1719859869,
    type: 30,
    shiptype: 'navigation',
    name: 'SYZSH1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127534,
  },
  {
    mmsi: 994127565,
    lng: 119.322405,
    lat: 32.198205,
    lastdyn: 1719859865,
    type: 30,
    shiptype: 'navigation',
    name: 'YZZY3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127565,
  },
  {
    mmsi: 994128551,
    lng: 119.38109,
    lat: 32.22526,
    lastdyn: 1719859881,
    type: 0,
    shiptype: 'navigation',
    name: 'YZ1121S',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128551,
  },
  {
    mmsi: 994128558,
    lng: 119.34173,
    lat: 32.19683,
    lastdyn: 1719859718,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ115L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128558,
  },
  {
    mmsi: 994128544,
    lng: 119.36737,
    lat: 32.21118,
    lastdyn: 1719859878,
    type: 25,
    shiptype: 'navigation',
    name: 'YZ113L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128544,
  },
  {
    mmsi: 994129582,
    lng: 119.257188,
    lat: 32.214987,
    lastdyn: 1719859879,
    type: 30,
    shiptype: 'navigation',
    name: 'DBS1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129582,
  },
  {
    mmsi: 994127563,
    lng: 119.317138,
    lat: 32.196195,
    lastdyn: 1719859857,
    type: 30,
    shiptype: 'navigation',
    name: 'YZZY1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127563,
  },
  {
    mmsi: 994128545,
    lng: 119.35495,
    lat: 32.22822,
    lastdyn: 1719859874,
    type: 24,
    shiptype: 'navigation',
    name: 'RYDQBCQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128545,
  },
  {
    mmsi: 995110006,
    lng: 134.415737,
    lat: 7.415975,
    lastdyn: 1715189411,
    type: 14,
    shiptype: 'navigation',
    name: '43',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995110006,
  },
  {
    mmsi: 994127566,
    lng: 119.322503,
    lat: 32.196412,
    lastdyn: 1719859805,
    type: 30,
    shiptype: 'navigation',
    name: 'YZZY4Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127566,
  },
  {
    mmsi: 994126575,
    lng: 119.6164,
    lat: 32.194717,
    lastdyn: 1719859904,
    type: 30,
    shiptype: 'navigation',
    name: 'HCZZ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126575,
  },
  {
    mmsi: 994128537,
    lng: 119.678288,
    lat: 32.225312,
    lastdyn: 1719859912,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZWFSQ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128537,
  },
  {
    mmsi: 994126583,
    lng: 119.669117,
    lat: 32.229732,
    lastdyn: 1719859730,
    type: 30,
    shiptype: 'navigation',
    name: 'WFSDLZSGXB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126583,
  },
  {
    mmsi: 994129573,
    lng: 119.605472,
    lat: 32.188,
    lastdyn: 1719859850,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ101R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129573,
  },
  {
    mmsi: 994126591,
    lng: 119.68785,
    lat: 32.24773,
    lastdyn: 1719859867,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ95R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126591,
  },
  {
    mmsi: 994126586,
    lng: 119.68215,
    lat: 32.2299,
    lastdyn: 1719859730,
    type: 30,
    shiptype: 'navigation',
    name: 'WFSDLYXGXB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126586,
  },
  {
    mmsi: 994129574,
    lng: 119.595417,
    lat: 32.190612,
    lastdyn: 1719859810,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZ1011L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129574,
  },
  {
    mmsi: 994127542,
    lng: 119.66807,
    lat: 32.21079,
    lastdyn: 1719859875,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ98R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127542,
  },
  {
    mmsi: 994129572,
    lng: 119.610467,
    lat: 32.189217,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ1001R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129572,
  },
  {
    mmsi: 994126569,
    lng: 119.52004,
    lat: 32.24866,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS106R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126569,
  },
  {
    mmsi: 994127572,
    lng: 119.724032,
    lat: 32.249732,
    lastdyn: 1719859213,
    type: 25,
    shiptype: 'navigation',
    name: 'TP29L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127572,
  },
  {
    mmsi: 994129567,
    lng: 119.660967,
    lat: 32.212267,
    lastdyn: 1719859815,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZ98L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129567,
  },
  {
    mmsi: 994128579,
    lng: 119.5559,
    lat: 32.19295,
    lastdyn: 1719859818,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ103R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128579,
  },
  {
    mmsi: 994129523,
    lng: 119.61525,
    lat: 32.203967,
    lastdyn: 1719859911,
    type: 24,
    shiptype: 'navigation',
    name: 'YXZ2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129523,
  },
  {
    mmsi: 994128583,
    lng: 119.74632,
    lat: 32.22585,
    lastdyn: 1719859840,
    type: 25,
    shiptype: 'navigation',
    name: 'TPZYZSQ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128583,
  },
  {
    mmsi: 994127573,
    lng: 119.734617,
    lat: 32.233817,
    lastdyn: 1719859470,
    type: 24,
    shiptype: 'navigation',
    name: 'TP281R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127573,
  },
  {
    mmsi: 994128580,
    lng: 119.56645,
    lat: 32.18967,
    lastdyn: 1719859858,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ1021R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128580,
  },
  {
    mmsi: 994128576,
    lng: 119.54914,
    lat: 32.21421,
    lastdyn: 1719859918,
    type: 24,
    shiptype: 'navigation',
    name: 'JS104R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128576,
  },
  {
    mmsi: 994126568,
    lng: 119.538,
    lat: 32.23524,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS1051R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126568,
  },
  {
    mmsi: 994129541,
    lng: 119.622567,
    lat: 32.218133,
    lastdyn: 1719859895,
    type: 25,
    shiptype: 'navigation',
    name: 'YXZ4L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129541,
  },
  {
    mmsi: 994126584,
    lng: 119.67155,
    lat: 32.233632,
    lastdyn: 1719859901,
    type: 30,
    shiptype: 'navigation',
    name: 'WFSDLZXGXB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126584,
  },
  {
    mmsi: 994126576,
    lng: 119.668067,
    lat: 32.210782,
    lastdyn: 1719859901,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ98R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126576,
  },
  {
    mmsi: 994128539,
    lng: 119.671288,
    lat: 32.224412,
    lastdyn: 1719859726,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZWFSQ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128539,
  },
  {
    mmsi: 994129537,
    lng: 119.617817,
    lat: 32.2105,
    lastdyn: 1719859884,
    type: 25,
    shiptype: 'navigation',
    name: 'YXZ3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129537,
  },
  {
    mmsi: 994128577,
    lng: 119.550117,
    lat: 32.19885,
    lastdyn: 1719859816,
    type: 24,
    shiptype: 'navigation',
    name: 'JS1031R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128577,
  },
  {
    mmsi: 994126567,
    lng: 119.54759,
    lat: 32.22471,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS105R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126567,
  },
  {
    mmsi: 994129569,
    lng: 119.615467,
    lat: 32.19355,
    lastdyn: 1719859818,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZ100L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129569,
  },
  {
    mmsi: 995110007,
    lng: 134.4227,
    lat: 7.363,
    lastdyn: 1719565570,
    type: 24,
    shiptype: 'navigation',
    name: '44',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995110007,
  },
  {
    mmsi: 994129543,
    lng: 119.621028,
    lat: 32.218388,
    lastdyn: 1719859865,
    type: 24,
    shiptype: 'navigation',
    name: 'YXZ4R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129543,
  },
  {
    mmsi: 994129524,
    lng: 119.617033,
    lat: 32.20525,
    lastdyn: 1719859836,
    type: 25,
    shiptype: 'navigation',
    name: 'YXZ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129524,
  },
  {
    mmsi: 994129522,
    lng: 119.617517,
    lat: 32.202117,
    lastdyn: 1719859847,
    type: 25,
    shiptype: 'navigation',
    name: 'YXZ11L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129522,
  },
  {
    mmsi: 994129571,
    lng: 119.607117,
    lat: 32.1914,
    lastdyn: 1719859559,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZ101L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129571,
  },
  {
    mmsi: 994129576,
    lng: 119.572138,
    lat: 32.191222,
    lastdyn: 1719859431,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZ1021L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129576,
  },
  {
    mmsi: 994129521,
    lng: 119.62305,
    lat: 32.198,
    lastdyn: 1719859868,
    type: 25,
    shiptype: 'navigation',
    name: 'YXZ1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129521,
  },
  {
    mmsi: 994129575,
    lng: 119.58325,
    lat: 32.190028,
    lastdyn: 1719859545,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZ102L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129575,
  },
  {
    mmsi: 994128584,
    lng: 119.74988,
    lat: 32.2212,
    lastdyn: 1719859775,
    type: 24,
    shiptype: 'navigation',
    name: 'TPZYZSQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128584,
  },
  {
    mmsi: 994128536,
    lng: 119.675238,
    lat: 32.22012,
    lastdyn: 1719859796,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZWFSQ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128536,
  },
  {
    mmsi: 994129525,
    lng: 119.616283,
    lat: 32.210917,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'YXZ3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129525,
  },
  {
    mmsi: 994129542,
    lng: 119.62075,
    lat: 32.225333,
    lastdyn: 1719859864,
    type: 24,
    shiptype: 'navigation',
    name: 'YXZ5R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129542,
  },
  {
    mmsi: 994126585,
    lng: 119.68045,
    lat: 32.227482,
    lastdyn: 1719859904,
    type: 30,
    shiptype: 'navigation',
    name: 'WFSDLYSGXB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126585,
  },
  {
    mmsi: 994128538,
    lng: 119.68223,
    lat: 32.2357,
    lastdyn: 1719859910,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZWFSQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128538,
  },
  {
    mmsi: 994128581,
    lng: 119.555832,
    lat: 32.197767,
    lastdyn: 1719859041,
    type: 25,
    shiptype: 'navigation',
    name: 'JS1031L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128581,
  },
  {
    mmsi: 994129579,
    lng: 119.56343,
    lat: 32.19347,
    lastdyn: 1719859796,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZ103L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129579,
  },
  {
    mmsi: 994126526,
    lng: 119.57766,
    lat: 32.18751,
    lastdyn: 1719859882,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ102R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126526,
  },
  {
    mmsi: 994129520,
    lng: 119.616967,
    lat: 32.196815,
    lastdyn: 1719859870,
    type: 24,
    shiptype: 'navigation',
    name: 'YXZ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129520,
  },
  {
    mmsi: 994129570,
    lng: 119.61985,
    lat: 32.191167,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'DTZ100R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129570,
  },
  {
    mmsi: 994128540,
    lng: 119.675938,
    lat: 32.236438,
    lastdyn: 1719859663,
    type: 25,
    shiptype: 'navigation',
    name: 'DTZWFSQ1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128540,
  },
  {
    mmsi: 994129503,
    lng: 119.923867,
    lat: 32.089167,
    lastdyn: 1719858010,
    type: 25,
    shiptype: 'navigation',
    name: 'TX78L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129503,
  },
  {
    mmsi: 994127577,
    lng: 119.813633,
    lat: 32.210322,
    lastdyn: 1719859869,
    type: 25,
    shiptype: 'navigation',
    name: 'TP26L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127577,
  },
  {
    mmsi: 994129507,
    lng: 119.90598,
    lat: 32.10617,
    lastdyn: 1719859742,
    type: 24,
    shiptype: 'navigation',
    name: 'TX79R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129507,
  },
  {
    mmsi: 994126556,
    lng: 119.88188,
    lat: 32.242262,
    lastdyn: 1719859807,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZTSX2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126556,
  },
  {
    mmsi: 994126588,
    lng: 119.935417,
    lat: 32.077982,
    lastdyn: 1719859815,
    type: 30,
    shiptype: 'navigation',
    name: 'TXTXM7Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126588,
  },
  {
    mmsi: 994129505,
    lng: 119.91828,
    lat: 32.091912,
    lastdyn: 1719859915,
    type: 0,
    shiptype: 'navigation',
    name: 'TX79S',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129505,
  },
  {
    mmsi: 994129508,
    lng: 119.89613,
    lat: 32.132338,
    lastdyn: 1719859805,
    type: 24,
    shiptype: 'navigation',
    name: 'TX80R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129508,
  },
  {
    mmsi: 994127529,
    lng: 119.945967,
    lat: 32.02825,
    lastdyn: 1719858523,
    type: 24,
    shiptype: 'navigation',
    name: 'TX75R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127529,
  },
  {
    mmsi: 994129504,
    lng: 119.916632,
    lat: 32.082982,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'TX78R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129504,
  },
  {
    mmsi: 994129502,
    lng: 119.926317,
    lat: 32.062867,
    lastdyn: 1719858523,
    type: 24,
    shiptype: 'navigation',
    name: 'TX77R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129502,
  },
  {
    mmsi: 994127520,
    lng: 119.900433,
    lat: 32.14645,
    lastdyn: 1719859895,
    type: 30,
    shiptype: 'navigation',
    name: 'MYS11Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127520,
  },
  {
    mmsi: 994127522,
    lng: 119.96444,
    lat: 32.01547,
    lastdyn: 1719858510,
    type: 25,
    shiptype: 'navigation',
    name: 'TXCTS2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127522,
  },
  {
    mmsi: 994128595,
    lng: 119.892388,
    lat: 32.06392,
    lastdyn: 1719859908,
    type: 24,
    shiptype: 'navigation',
    name: 'TP3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128595,
  },
  {
    mmsi: 994128533,
    lng: 119.809062,
    lat: 32.207462,
    lastdyn: 1719859876,
    type: 24,
    shiptype: 'navigation',
    name: 'TP26R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128533,
  },
  {
    mmsi: 994127550,
    lng: 119.90365,
    lat: 32.147517,
    lastdyn: 1719859868,
    type: 30,
    shiptype: 'navigation',
    name: 'MYS1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127550,
  },
  {
    mmsi: 994127598,
    lng: 119.987667,
    lat: 32.009717,
    lastdyn: 1719859471,
    type: 30,
    shiptype: 'navigation',
    name: 'YXS2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127598,
  },
  {
    mmsi: 994126596,
    lng: 119.827267,
    lat: 32.186232,
    lastdyn: 1719859819,
    type: 25,
    shiptype: 'navigation',
    name: 'TP23L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126596,
  },
  {
    mmsi: 994127605,
    lng: 119.322503,
    lat: 32.196412,
    lastdyn: 1719829508,
    type: 10,
    shiptype: 'navigation',
    name: 'ZZY4Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127605,
  },
  {
    mmsi: 994127530,
    lng: 119.9415,
    lat: 0.001493,
    lastdyn: 1719855422,
    type: 25,
    shiptype: 'navigation',
    name: 'TX76L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127530,
  },
  {
    mmsi: 994129501,
    lng: 119.931482,
    lat: 32.06725,
    lastdyn: 1719855164,
    type: 25,
    shiptype: 'navigation',
    name: 'TX77L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129501,
  },
  {
    mmsi: 994126595,
    lng: 119.785932,
    lat: 32.12085,
    lastdyn: 1719859817,
    type: 24,
    shiptype: 'navigation',
    name: 'TP12R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126595,
  },
  {
    mmsi: 994126539,
    lng: 119.897778,
    lat: 32.127878,
    lastdyn: 1719859841,
    type: 30,
    shiptype: 'navigation',
    name: 'XHTZ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126539,
  },
  {
    mmsi: 994129512,
    lng: 119.88347,
    lat: 32.182238,
    lastdyn: 1719859759,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ82R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129512,
  },
  {
    mmsi: 994126555,
    lng: 119.886288,
    lat: 32.24343,
    lastdyn: 1719859872,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZTSX2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126555,
  },
  {
    mmsi: 994127528,
    lng: 119.949267,
    lat: 32.0346,
    lastdyn: 1719858782,
    type: 25,
    shiptype: 'navigation',
    name: 'TX75L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127528,
  },
  {
    mmsi: 994126558,
    lng: 119.887012,
    lat: 32.230662,
    lastdyn: 1719859860,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZTSX1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126558,
  },
  {
    mmsi: 994126514,
    lng: 119.792317,
    lat: 32.142282,
    lastdyn: 1719859559,
    type: 25,
    shiptype: 'navigation',
    name: 'TP14L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126514,
  },
  {
    mmsi: 994127523,
    lng: 119.95437,
    lat: 32.0167,
    lastdyn: 1719859650,
    type: 24,
    shiptype: 'navigation',
    name: 'TXCTS3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127523,
  },
  {
    mmsi: 994129581,
    lng: 119.878288,
    lat: 32.208162,
    lastdyn: 1719859885,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ83R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129581,
  },
  {
    mmsi: 994127554,
    lng: 119.926967,
    lat: 0.014657,
    lastdyn: 1719852432,
    type: 30,
    shiptype: 'navigation',
    name: 'TXTX',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127554,
  },
  {
    mmsi: 994128567,
    lng: 119.90001,
    lat: 32.131012,
    lastdyn: 1719859845,
    type: 25,
    shiptype: 'navigation',
    name: 'TX80L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128567,
  },
  {
    mmsi: 994126515,
    lng: 119.835205,
    lat: 32.195022,
    lastdyn: 1719859877,
    type: 25,
    shiptype: 'navigation',
    name: 'TP25L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126515,
  },
  {
    mmsi: 994126553,
    lng: 119.866638,
    lat: 32.249238,
    lastdyn: 1719859819,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZTXX3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126553,
  },
  {
    mmsi: 994129506,
    lng: 119.91053,
    lat: 32.10298,
    lastdyn: 1719859739,
    type: 25,
    shiptype: 'navigation',
    name: 'TX79L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129506,
  },
  {
    mmsi: 994129511,
    lng: 119.88722,
    lat: 32.181138,
    lastdyn: 1719859875,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ82L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129511,
  },
  {
    mmsi: 995110008,
    lng: 134.417528,
    lat: 7.353948,
    lastdyn: 1715187614,
    type: 25,
    shiptype: 'navigation',
    name: '45',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995110008,
  },
  {
    mmsi: 994126557,
    lng: 119.89153,
    lat: 32.231812,
    lastdyn: 1719859743,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZTSX1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126557,
  },
  {
    mmsi: 994126594,
    lng: 119.792317,
    lat: 32.11525,
    lastdyn: 1719857749,
    type: 25,
    shiptype: 'navigation',
    name: 'TP111L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126594,
  },
  {
    mmsi: 994127526,
    lng: 119.95959,
    lat: 32.02042,
    lastdyn: 1719859230,
    type: 25,
    shiptype: 'navigation',
    name: 'TXCTS3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127526,
  },
  {
    mmsi: 994129510,
    lng: 119.890412,
    lat: 32.156562,
    lastdyn: 1719859813,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ81L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129510,
  },
  {
    mmsi: 994126537,
    lng: 119.789367,
    lat: 32.208367,
    lastdyn: 1719859903,
    type: 25,
    shiptype: 'navigation',
    name: 'TP28L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126537,
  },
  {
    mmsi: 994129513,
    lng: 119.88162,
    lat: 32.20888,
    lastdyn: 1719859764,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ83L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129513,
  },
  {
    mmsi: 994129551,
    lng: 119.90156,
    lat: 32.188062,
    lastdyn: 1719859913,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZT4L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129551,
  },
  {
    mmsi: 994128586,
    lng: 119.776638,
    lat: 32.20693,
    lastdyn: 1719859888,
    type: 24,
    shiptype: 'navigation',
    name: 'TPZYZSQ1R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128586,
  },
  {
    mmsi: 994128585,
    lng: 119.771892,
    lat: 32.211192,
    lastdyn: 1719859860,
    type: 25,
    shiptype: 'navigation',
    name: 'TPZYZSQ2L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128585,
  },
  {
    mmsi: 994127574,
    lng: 119.79127,
    lat: 32.175438,
    lastdyn: 1719859828,
    type: 24,
    shiptype: 'navigation',
    name: 'TP17R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127574,
  },
  {
    mmsi: 994127578,
    lng: 119.837312,
    lat: 32.10613,
    lastdyn: 1719859832,
    type: 25,
    shiptype: 'navigation',
    name: 'TP7L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127578,
  },
  {
    mmsi: 994129509,
    lng: 119.89602,
    lat: 32.142238,
    lastdyn: 1719859750,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ801L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129509,
  },
  {
    mmsi: 994128587,
    lng: 119.904182,
    lat: 32.059,
    lastdyn: 1719830754,
    type: 24,
    shiptype: 'navigation',
    name: 'TPZYZEQ1R',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128587,
  },
  {
    mmsi: 994127549,
    lng: 119.90365,
    lat: 32.154833,
    lastdyn: 1719859814,
    type: 30,
    shiptype: 'navigation',
    name: 'MYS2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127549,
  },
  {
    mmsi: 994127518,
    lng: 119.98359,
    lat: 32.00022,
    lastdyn: 1719859350,
    type: 25,
    shiptype: 'navigation',
    name: 'TXCTS1L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127518,
  },
  {
    mmsi: 994127519,
    lng: 119.95997,
    lat: 32.01172,
    lastdyn: 1719859770,
    type: 24,
    shiptype: 'navigation',
    name: 'TXCTS2R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127519,
  },
  {
    mmsi: 994128619,
    lng: 120.4787,
    lat: 32.032367,
    lastdyn: 1719859347,
    type: 24,
    shiptype: 'navigation',
    name: 'FZ49R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128619,
  },
  {
    mmsi: 994128637,
    lng: 120.376138,
    lat: 32.005917,
    lastdyn: 1719858937,
    type: 0,
    shiptype: 'navigation',
    name: 'FZ56S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128637,
  },
  {
    mmsi: 994128636,
    lng: 120.4419,
    lat: 0.000582,
    lastdyn: 1719859818,
    type: 0,
    shiptype: 'navigation',
    name: 'FZ51S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128636,
  },
  {
    mmsi: 994128628,
    lng: 120.51565,
    lat: 32.030867,
    lastdyn: 1719859522,
    type: 25,
    shiptype: 'navigation',
    name: 'ZJGNS4L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128628,
  },
  {
    mmsi: 994128681,
    lng: 120.73636,
    lat: 32.035417,
    lastdyn: 1719859076,
    type: 25,
    shiptype: 'navigation',
    name: 'TQ1L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128681,
  },
  {
    mmsi: 994128664,
    lng: 120.705555,
    lat: 32.00761,
    lastdyn: 1719859032,
    type: 25,
    shiptype: 'navigation',
    name: 'HTQ3L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128664,
  },
  {
    mmsi: 994128629,
    lng: 120.513617,
    lat: 32.026682,
    lastdyn: 1719859784,
    type: 24,
    shiptype: 'navigation',
    name: 'ZJGNS4R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128629,
  },
  {
    mmsi: 994128686,
    lng: 120.711888,
    lat: 32.03811,
    lastdyn: 1719858253,
    type: 24,
    shiptype: 'navigation',
    name: 'TQ3R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128686,
  },
  {
    mmsi: 994128655,
    lng: 120.677,
    lat: 32.05186,
    lastdyn: 1719859823,
    type: 25,
    shiptype: 'navigation',
    name: 'DSQ1L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128655,
  },
  {
    mmsi: 994128684,
    lng: 120.725582,
    lat: 32.035082,
    lastdyn: 1719849692,
    type: 24,
    shiptype: 'navigation',
    name: 'TQ2R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128684,
  },
  {
    mmsi: 994128697,
    lng: 120.584217,
    lat: 32.0269,
    lastdyn: 1719859704,
    type: 25,
    shiptype: 'navigation',
    name: 'FB0',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128697,
  },
  {
    mmsi: 994128626,
    lng: 120.52245,
    lat: 32.028367,
    lastdyn: 1719859764,
    type: 25,
    shiptype: 'navigation',
    name: 'ZJGNS3L',
    length: 4,
    width: 2,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128626,
  },
  {
    mmsi: 994128658,
    lng: 120.670055,
    lat: 32.051667,
    lastdyn: 1719851300,
    type: 24,
    shiptype: 'navigation',
    name: 'DSQ2R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128658,
  },
  {
    mmsi: 994128627,
    lng: 120.520417,
    lat: 32.0242,
    lastdyn: 1719859770,
    type: 24,
    shiptype: 'navigation',
    name: 'ZJGNS3R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128627,
  },
  {
    mmsi: 994128625,
    lng: 120.53015,
    lat: 32.020617,
    lastdyn: 1719859495,
    type: 24,
    shiptype: 'navigation',
    name: 'ZJGNS2R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128625,
  },
  {
    mmsi: 994128685,
    lng: 120.712722,
    lat: 32.040167,
    lastdyn: 1719852679,
    type: 25,
    shiptype: 'navigation',
    name: 'TQ3L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128685,
  },
  {
    mmsi: 994128605,
    lng: 120.53695,
    lat: 32.018132,
    lastdyn: 1719859736,
    type: 24,
    shiptype: 'navigation',
    name: 'ZJGNS1R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128605,
  },
  {
    mmsi: 994128624,
    lng: 120.532167,
    lat: 32.0248,
    lastdyn: 1719859747,
    type: 25,
    shiptype: 'navigation',
    name: 'ZJGNS2L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128624,
  },
  {
    mmsi: 994128683,
    lng: 120.726472,
    lat: 32.037527,
    lastdyn: 1719854375,
    type: 25,
    shiptype: 'navigation',
    name: 'TQ2L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128683,
  },
  {
    mmsi: 994128682,
    lng: 120.735917,
    lat: 32.033222,
    lastdyn: 1719858639,
    type: 24,
    shiptype: 'navigation',
    name: 'TQ1R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128682,
  },
  {
    mmsi: 994128662,
    lng: 120.72436,
    lat: 32.003638,
    lastdyn: 1719856005,
    type: 24,
    shiptype: 'navigation',
    name: 'HTQ2R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128662,
  },
  {
    mmsi: 994128657,
    lng: 120.670472,
    lat: 32.052972,
    lastdyn: 1719858991,
    type: 25,
    shiptype: 'navigation',
    name: 'DSQ2L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128657,
  },
  {
    mmsi: 994128604,
    lng: 120.539,
    lat: 32.022332,
    lastdyn: 1719859473,
    type: 25,
    shiptype: 'navigation',
    name: 'ZJGNS1L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128604,
  },
  {
    mmsi: 994128661,
    lng: 120.722722,
    lat: 32.00986,
    lastdyn: 1719859425,
    type: 25,
    shiptype: 'navigation',
    name: 'HTQ2L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128661,
  },
  {
    mmsi: 994128687,
    lng: 120.699917,
    lat: 32.04175,
    lastdyn: 1719856111,
    type: 24,
    shiptype: 'navigation',
    name: 'TQ4R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128687,
  },
  {
    mmsi: 994128666,
    lng: 120.689832,
    lat: 32.004693,
    lastdyn: 1719859898,
    type: 25,
    shiptype: 'navigation',
    name: 'HTQ4L',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128666,
  },
  {
    mmsi: 994128663,
    lng: 120.706277,
    lat: 32.0015,
    lastdyn: 1719856013,
    type: 24,
    shiptype: 'navigation',
    name: 'HTQ3R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128663,
  },
  {
    mmsi: 994128698,
    lng: 120.568567,
    lat: 32.041617,
    lastdyn: 1719859697,
    type: 25,
    shiptype: 'navigation',
    name: 'FB4L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128698,
  },
  {
    mmsi: 994128633,
    lng: 120.611617,
    lat: 32.0004,
    lastdyn: 1719859802,
    type: 0,
    shiptype: 'navigation',
    name: 'LHS441S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128633,
  },
  {
    mmsi: 994128656,
    lng: 120.676443,
    lat: 32.049917,
    lastdyn: 1719858985,
    type: 24,
    shiptype: 'navigation',
    name: 'DSQ1R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128656,
  },
  {
    mmsi: 994128618,
    lng: 120.763567,
    lat: 32.008617,
    lastdyn: 1719858962,
    type: 24,
    shiptype: 'navigation',
    name: 'NT32R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128618,
  },
  {
    mmsi: 994128680,
    lng: 120.7635,
    lat: 32.027277,
    lastdyn: 1719859912,
    type: 0,
    shiptype: 'navigation',
    name: 'TSG6S',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128680,
  },
  {
    mmsi: 994128616,
    lng: 120.808432,
    lat: 32.001817,
    lastdyn: 1719859795,
    type: 24,
    shiptype: 'navigation',
    name: 'NT30R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128616,
  },
  {
    mmsi: 994128617,
    lng: 120.787417,
    lat: 32.007067,
    lastdyn: 1719858954,
    type: 24,
    shiptype: 'navigation',
    name: 'NT31R',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128617,
  },
  {
    mmsi: 994128632,
    lng: 120.808182,
    lat: 32.007817,
    lastdyn: 1719859385,
    type: 0,
    shiptype: 'navigation',
    name: 'NT30S',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128632,
  },
  {
    mmsi: 994128679,
    lng: 120.76975,
    lat: 0.002383,
    lastdyn: 1719856045,
    type: 0,
    shiptype: 'navigation',
    name: 'TSG5S',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128679,
  },
  {
    mmsi: 999412167,
    lng: 121.475908,
    lat: 32.138512,
    lastdyn: 1719819560,
    type: 24,
    shiptype: 'navigation',
    name: 'LVSIGANG33HAODENGF',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412167,
  },
  {
    mmsi: 994126491,
    lng: 121.681388,
    lat: 32.126917,
    lastdyn: 1719859798,
    type: 24,
    shiptype: 'navigation',
    name: 'LV SI 26A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126491,
  },
  {
    mmsi: 994141468,
    lng: 121.7478,
    lat: 32.09031,
    lastdyn: 1719859801,
    type: 24,
    shiptype: 'navigation',
    name: 'LV SI 24',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141468,
  },
  {
    mmsi: 999412174,
    lng: 121.509077,
    lat: 32.142512,
    lastdyn: 1719858368,
    type: 24,
    shiptype: 'navigation',
    name: 'LV SI 40',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412174,
  },
  {
    mmsi: 999412173,
    lng: 121.530415,
    lat: 32.168572,
    lastdyn: 1719859140,
    type: 25,
    shiptype: 'navigation',
    name: 'LV SI 37',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412173,
  },
  {
    mmsi: 999412135,
    lng: 121.670878,
    lat: 32.131777,
    lastdyn: 1719859772,
    type: 24,
    shiptype: 'navigation',
    name: 'LV SI 28',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412135,
  },
  {
    mmsi: 994141469,
    lng: 121.71461,
    lat: 32.09581,
    lastdyn: 1719859744,
    type: 30,
    shiptype: 'navigation',
    name: 'LV SI BD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141469,
  },
  {
    mmsi: 994126346,
    lng: 121.792917,
    lat: 32.069833,
    lastdyn: 1719859797,
    type: 24,
    shiptype: 'navigation',
    name: 'GUANGHUI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126346,
  },
  {
    mmsi: 994121377,
    lng: 122.12631,
    lat: 32.163,
    lastdyn: 1719857271,
    type: 30,
    shiptype: 'navigation',
    name: 'QD H2 FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121377,
  },
  {
    mmsi: 994126470,
    lng: 122.060633,
    lat: 32.224267,
    lastdyn: 1719859762,
    type: 28,
    shiptype: 'navigation',
    name: 'ZH 02 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126470,
  },
  {
    mmsi: 994121372,
    lng: 122.24804,
    lat: 32.068897,
    lastdyn: 1719851893,
    type: 30,
    shiptype: 'navigation',
    name: 'QD H3 FD 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121372,
  },
  {
    mmsi: 994121376,
    lng: 122.06324,
    lat: 32.14938,
    lastdyn: 1719859693,
    type: 19,
    shiptype: 'navigation',
    name: 'QD H1 FD 11',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121376,
  },
  {
    mmsi: 994127709,
    lng: 119.985685,
    lat: -49.698133,
    lastdyn: 1683496164,
    type: 25,
    shiptype: 'navigation',
    name: 'CHGXQ1LX',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 8,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127709,
  },
  {
    mmsi: 994126574,
    lng: 119.43364,
    lat: 32.26041,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS110R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126574,
  },
  {
    mmsi: 994126550,
    lng: 119.41764,
    lat: 32.2528,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS111R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126550,
  },
  {
    mmsi: 994126597,
    lng: 119.41922,
    lat: 32.25062,
    lastdyn: 1719859881,
    type: 30,
    shiptype: 'navigation',
    name: 'JSDYZM12Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126597,
  },
  {
    mmsi: 994126598,
    lng: 119.41831,
    lat: 32.25211,
    lastdyn: 1719859882,
    type: 30,
    shiptype: 'navigation',
    name: 'JSDYZM6Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126598,
  },
  {
    mmsi: 994127552,
    lng: 119.483567,
    lat: 32.265882,
    lastdyn: 1719859903,
    type: 30,
    shiptype: 'navigation',
    name: 'JSDYZM2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127552,
  },
  {
    mmsi: 994126572,
    lng: 119.467885,
    lat: 32.267532,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS1081R',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126572,
  },
  {
    mmsi: 994128570,
    lng: 119.43633,
    lat: 32.26784,
    lastdyn: 1719859918,
    type: 25,
    shiptype: 'navigation',
    name: 'JS110L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128570,
  },
  {
    mmsi: 994126571,
    lng: 119.48396,
    lat: 32.26768,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS108R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126571,
  },
  {
    mmsi: 994126599,
    lng: 119.46584,
    lat: 32.26613,
    lastdyn: 1719859882,
    type: 30,
    shiptype: 'navigation',
    name: 'JSDYZM3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126599,
  },
  {
    mmsi: 994126573,
    lng: 119.45873,
    lat: 32.26695,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS109R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126573,
  },
  {
    mmsi: 994128566,
    lng: 119.413032,
    lat: 32.256967,
    lastdyn: 1719856201,
    type: 25,
    shiptype: 'navigation',
    name: 'JS0',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128566,
  },
  {
    mmsi: 994126565,
    lng: 119.72568,
    lat: 32.308412,
    lastdyn: 1719859878,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ92R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126565,
  },
  {
    mmsi: 994127559,
    lng: 119.704633,
    lat: 32.2622,
    lastdyn: 1719859856,
    type: 30,
    shiptype: 'navigation',
    name: 'ZY2Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127559,
  },
  {
    mmsi: 994129598,
    lng: 119.723258,
    lat: 32.316892,
    lastdyn: 1719859824,
    type: 30,
    shiptype: 'navigation',
    name: 'CS1Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129598,
  },
  {
    mmsi: 994129562,
    lng: 119.71245,
    lat: 32.30024,
    lastdyn: 1719859809,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ93L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129562,
  },
  {
    mmsi: 994126593,
    lng: 119.697303,
    lat: 32.265672,
    lastdyn: 1719859866,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ94R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126593,
  },
  {
    mmsi: 994127561,
    lng: 119.7066,
    lat: 32.264867,
    lastdyn: 1719859788,
    type: 30,
    shiptype: 'navigation',
    name: 'ZY3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127561,
  },
  {
    mmsi: 994128563,
    lng: 119.742812,
    lat: 32.31968,
    lastdyn: 1719859826,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ911R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128563,
  },
  {
    mmsi: 994129565,
    lng: 119.692888,
    lat: 32.2695,
    lastdyn: 1719859876,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ94L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129565,
  },
  {
    mmsi: 994126570,
    lng: 119.50119,
    lat: 32.26218,
    lastdyn: 1719859881,
    type: 24,
    shiptype: 'navigation',
    name: 'JS107R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126570,
  },
  {
    mmsi: 994129563,
    lng: 119.701462,
    lat: 32.28493,
    lastdyn: 1719859814,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ931L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129563,
  },
  {
    mmsi: 995110003,
    lng: 134.440093,
    lat: 7.451212,
    lastdyn: 1715190847,
    type: 25,
    shiptype: 'navigation',
    name: '39',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 995110003,
  },
  {
    mmsi: 994128524,
    lng: 119.694282,
    lat: 32.251167,
    lastdyn: 1719858352,
    type: 30,
    shiptype: 'navigation',
    name: 'SHGWZ',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128524,
  },
  {
    mmsi: 994127570,
    lng: 119.71355,
    lat: 32.2523,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'TP291R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127570,
  },
  {
    mmsi: 994127546,
    lng: 119.746038,
    lat: 32.32668,
    lastdyn: 1719859867,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ911L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994127546,
  },
  {
    mmsi: 994128582,
    lng: 119.7061,
    lat: 32.28067,
    lastdyn: 1719859751,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ931R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128582,
  },
  {
    mmsi: 994126535,
    lng: 119.509532,
    lat: 32.256832,
    lastdyn: 1719859818,
    type: 24,
    shiptype: 'navigation',
    name: 'JS1061R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126535,
  },
  {
    mmsi: 994127562,
    lng: 119.705517,
    lat: 32.26545,
    lastdyn: 1719859915,
    type: 30,
    shiptype: 'navigation',
    name: 'ZY4Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994127562,
  },
  {
    mmsi: 994126566,
    lng: 119.715738,
    lat: 32.295238,
    lastdyn: 1719859874,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ93R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126566,
  },
  {
    mmsi: 994126564,
    lng: 119.705133,
    lat: 32.3135,
    lastdyn: 1719859883,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ92L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126564,
  },
  {
    mmsi: 994128573,
    lng: 119.50621,
    lat: 32.26546,
    lastdyn: 1719859918,
    type: 25,
    shiptype: 'navigation',
    name: 'JS107L',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994128573,
  },
  {
    mmsi: 994129599,
    lng: 119.682222,
    lat: 32.250278,
    lastdyn: 1719859879,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ95L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129599,
  },
  {
    mmsi: 994126560,
    lng: 119.78643,
    lat: 32.321338,
    lastdyn: 1719859714,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ90R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126560,
  },
  {
    mmsi: 994129560,
    lng: 119.77605,
    lat: 32.328867,
    lastdyn: 1719859815,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ901L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129560,
  },
  {
    mmsi: 994126561,
    lng: 119.77013,
    lat: 32.32527,
    lastdyn: 1719859771,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ901R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126561,
  },
  {
    mmsi: 994129555,
    lng: 119.878667,
    lat: 32.256748,
    lastdyn: 1719854135,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZTSX3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129555,
  },
  {
    mmsi: 994128597,
    lng: 119.829788,
    lat: 32.29903,
    lastdyn: 1719859742,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ88R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128597,
  },
  {
    mmsi: 994126554,
    lng: 119.861262,
    lat: 32.26058,
    lastdyn: 1719859755,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZTXX4R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126554,
  },
  {
    mmsi: 994126562,
    lng: 119.754012,
    lat: 32.32392,
    lastdyn: 1719859834,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ91R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126562,
  },
  {
    mmsi: 994129589,
    lng: 119.682222,
    lat: 32.250278,
    lastdyn: 1719790281,
    type: 10,
    shiptype: 'navigation',
    name: 'AZ95L AE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994129589,
  },
  {
    mmsi: 994129558,
    lng: 119.8104,
    lat: 32.3195,
    lastdyn: 1719859815,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ89L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129558,
  },
  {
    mmsi: 994128599,
    lng: 119.85115,
    lat: 32.27528,
    lastdyn: 1719859859,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ87R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128599,
  },
  {
    mmsi: 994129559,
    lng: 119.787167,
    lat: 32.32635,
    lastdyn: 1719857490,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ90L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129559,
  },
  {
    mmsi: 994129556,
    lng: 119.874717,
    lat: 32.254732,
    lastdyn: 1719859815,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZTSX3R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129556,
  },
  {
    mmsi: 994129561,
    lng: 119.761867,
    lat: 32.33115,
    lastdyn: 1719859299,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ91L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129561,
  },
  {
    mmsi: 994129557,
    lng: 119.855232,
    lat: 32.282067,
    lastdyn: 1719853104,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZ87L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994129557,
  },
  {
    mmsi: 994126552,
    lng: 119.87188,
    lat: 32.25241,
    lastdyn: 1719859823,
    type: 25,
    shiptype: 'navigation',
    name: 'KAZTXX3L',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126552,
  },
  {
    mmsi: 994126559,
    lng: 119.806938,
    lat: 32.3146,
    lastdyn: 1719859718,
    type: 24,
    shiptype: 'navigation',
    name: 'KAZ89R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126559,
  },
  {
    mmsi: 994128550,
    lng: 119.86841,
    lat: 32.26258,
    lastdyn: 1719859764,
    type: 0,
    shiptype: 'navigation',
    name: 'KAZTQS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994128550,
  },
  {
    mmsi: 998001412,
    lng: 121.389722,
    lat: 32.372778,
    lastdyn: 1719859808,
    type: 1,
    shiptype: 'navigation',
    name: 'AIS 1412',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 998001412,
  },
  {
    mmsi: 999412188,
    lng: 121.62689,
    lat: 32.365217,
    lastdyn: 1719859854,
    type: 0,
    shiptype: 'navigation',
    name: 'RUDONG FENGDIAN 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412188,
  },
  {
    mmsi: 999412185,
    lng: 121.61621,
    lat: 32.385998,
    lastdyn: 1719859834,
    type: 19,
    shiptype: 'navigation',
    name: 'RUDONG FENGDIAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412185,
  },
  {
    mmsi: 991002018,
    lng: 121.591105,
    lat: 32.466707,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'LYG10261',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 991002018,
  },
  {
    mmsi: 999412186,
    lng: 121.715505,
    lat: 32.378343,
    lastdyn: 1719859914,
    type: 19,
    shiptype: 'navigation',
    name: 'RUDONG FENGDIAN 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412186,
  },
  {
    mmsi: 994136334,
    lng: 121.948833,
    lat: 32.251583,
    lastdyn: 1719859795,
    type: 28,
    shiptype: 'navigation',
    name: 'SU QI YU 02559 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136334,
  },
  {
    mmsi: 999412187,
    lng: 121.759843,
    lat: 32.355135,
    lastdyn: 1719859794,
    type: 19,
    shiptype: 'navigation',
    name: 'RUDONG FENGDIAN 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412187,
  },
  {
    mmsi: 994311571,
    lng: 132.492905,
    lat: 32.396445,
    lastdyn: 1719857532,
    type: 31,
    shiptype: 'navigation',
    name: 'TOSAKUROSHIO21',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311571,
  },
  {
    mmsi: 994311574,
    lng: 133.204897,
    lat: 32.48568,
    lastdyn: 1719859538,
    type: 31,
    shiptype: 'navigation',
    name: 'TOSAKUROSHIO18',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311574,
  },
  {
    mmsi: 994126587,
    lng: 119.23576,
    lat: 32.71327,
    lastdyn: 1719859864,
    type: 24,
    shiptype: 'navigation',
    name: 'YZ119R',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126587,
  },
  {
    mmsi: 994121354,
    lng: 120.989565,
    lat: 32.612092,
    lastdyn: 1719859863,
    type: 0,
    shiptype: 'navigation',
    name: 'ZSDRD FD 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121354,
  },
  {
    mmsi: 994121383,
    lng: 121.17254,
    lat: 32.64966,
    lastdyn: 1719859824,
    type: 30,
    shiptype: 'navigation',
    name: 'LYJJS FD 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121383,
  },
  {
    mmsi: 999412152,
    lng: 121.141797,
    lat: 32.575705,
    lastdyn: 1719859885,
    type: 19,
    shiptype: 'navigation',
    name: 'RU DONG FENG DIAN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412152,
  },
  {
    mmsi: 994121309,
    lng: 121.132975,
    lat: 32.595267,
    lastdyn: 1719825192,
    type: 29,
    shiptype: 'navigation',
    name: 'HAI LAN 2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121309,
  },
  {
    mmsi: 999412138,
    lng: 121.164857,
    lat: 32.62912,
    lastdyn: 1719859870,
    type: 19,
    shiptype: 'navigation',
    name: 'HN FENG DIAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412138,
  },
  {
    mmsi: 994121385,
    lng: 121.06428,
    lat: 32.6506,
    lastdyn: 1719859896,
    type: 30,
    shiptype: 'navigation',
    name: 'LYJJS FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121385,
  },
  {
    mmsi: 994121382,
    lng: 121.21414,
    lat: 32.67013,
    lastdyn: 1719859832,
    type: 30,
    shiptype: 'navigation',
    name: 'LYJJS FD 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121382,
  },
  {
    mmsi: 994121388,
    lng: 121.161523,
    lat: 32.719608,
    lastdyn: 1719859797,
    type: 30,
    shiptype: 'navigation',
    name: 'LYJJS FD 15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121388,
  },
  {
    mmsi: 994121397,
    lng: 121.236943,
    lat: 32.741803,
    lastdyn: 1719859741,
    type: 30,
    shiptype: 'navigation',
    name: 'JJS H2 FD 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121397,
  },
  {
    mmsi: 994121380,
    lng: 121.24665,
    lat: 32.71929,
    lastdyn: 1719859819,
    type: 30,
    shiptype: 'navigation',
    name: 'LYJJS FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121380,
  },
  {
    mmsi: 999412148,
    lng: 121.159068,
    lat: 32.610455,
    lastdyn: 1719842304,
    type: 29,
    shiptype: 'navigation',
    name: 'HAI LAN 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412148,
  },
  {
    mmsi: 999412143,
    lng: 121.220262,
    lat: 32.618875,
    lastdyn: 1719859884,
    type: 19,
    shiptype: 'navigation',
    name: 'HN FENG DIAN 12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412143,
  },
  {
    mmsi: 994121399,
    lng: 121.14143,
    lat: 32.748978,
    lastdyn: 1719859602,
    type: 30,
    shiptype: 'navigation',
    name: 'JJS H2 FD 16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121399,
  },
  {
    mmsi: 994121381,
    lng: 121.24713,
    lat: 32.69887,
    lastdyn: 1719858025,
    type: 30,
    shiptype: 'navigation',
    name: 'LYJJS FD 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121381,
  },
  {
    mmsi: 994121398,
    lng: 121.155865,
    lat: 32.738265,
    lastdyn: 1719859826,
    type: 30,
    shiptype: 'navigation',
    name: 'JJS H2 FD 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121398,
  },
  {
    mmsi: 994121384,
    lng: 121.09184,
    lat: 32.65468,
    lastdyn: 1719859710,
    type: 30,
    shiptype: 'navigation',
    name: 'LYJJS FD 8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121384,
  },
  {
    mmsi: 999412155,
    lng: 121.341102,
    lat: 32.5301,
    lastdyn: 1719859894,
    type: 19,
    shiptype: 'navigation',
    name: 'RU DONG FENG DIAN 18',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412155,
  },
  {
    mmsi: 994141443,
    lng: 121.45033,
    lat: 32.69707,
    lastdyn: 1719859754,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H3 FD 13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141443,
  },
  {
    mmsi: 999412117,
    lng: 121.431718,
    lat: 32.532285,
    lastdyn: 1719859869,
    type: 19,
    shiptype: 'navigation',
    name: 'QUSHUIKOUDENGZHUANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412117,
  },
  {
    mmsi: 999412141,
    lng: 121.41263,
    lat: 32.691513,
    lastdyn: 1719859811,
    type: 19,
    shiptype: 'navigation',
    name: 'HN FENG DIAN 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412141,
  },
  {
    mmsi: 994141459,
    lng: 121.31986,
    lat: 32.71011,
    lastdyn: 1719859681,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H13 FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141459,
  },
  {
    mmsi: 999412154,
    lng: 121.316275,
    lat: 32.549457,
    lastdyn: 1719859834,
    type: 19,
    shiptype: 'navigation',
    name: 'RU DONG FENG DIAN 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412154,
  },
  {
    mmsi: 999412153,
    lng: 121.278827,
    lat: 32.561993,
    lastdyn: 1719859774,
    type: 19,
    shiptype: 'navigation',
    name: 'RU DONG FENG DIAN 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412153,
  },
  {
    mmsi: 994141462,
    lng: 121.37771,
    lat: 32.71013,
    lastdyn: 1719859861,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H13 FD 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141462,
  },
  {
    mmsi: 994141461,
    lng: 121.41842,
    lat: 32.73111,
    lastdyn: 1719859560,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H13 FD 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141461,
  },
  {
    mmsi: 994141463,
    lng: 121.33668,
    lat: 32.71222,
    lastdyn: 1719859812,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H13 FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141463,
  },
  {
    mmsi: 999412116,
    lng: 121.474452,
    lat: 32.549992,
    lastdyn: 1719859810,
    type: 24,
    shiptype: 'navigation',
    name: 'YANG KOU GANG 14 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412116,
  },
  {
    mmsi: 999412147,
    lng: 121.314673,
    lat: 32.653393,
    lastdyn: 1719859859,
    type: 30,
    shiptype: 'navigation',
    name: 'HN FENG DIAN 15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412147,
  },
  {
    mmsi: 994121396,
    lng: 121.260047,
    lat: 32.741555,
    lastdyn: 1719859576,
    type: 30,
    shiptype: 'navigation',
    name: 'JJS H2 FD 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121396,
  },
  {
    mmsi: 994122307,
    lng: 121.5444,
    lat: 32.63709,
    lastdyn: 1719859800,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H4 FD 11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122307,
  },
  {
    mmsi: 994122374,
    lng: 121.72288,
    lat: 32.64543,
    lastdyn: 1719859763,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H6 FD 11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122374,
  },
  {
    mmsi: 994122373,
    lng: 121.72855,
    lat: 32.63456,
    lastdyn: 1719859193,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H6 FD 10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122373,
  },
  {
    mmsi: 994122306,
    lng: 121.68576,
    lat: 32.63479,
    lastdyn: 1719859861,
    type: 0,
    shiptype: 'navigation',
    name: 'RD H4 FD 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122306,
  },
  {
    mmsi: 994122332,
    lng: 121.6558,
    lat: 32.70519,
    lastdyn: 1719859801,
    type: 30,
    shiptype: 'navigation',
    name: 'RD FD HL J1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122332,
  },
  {
    mmsi: 994122305,
    lng: 121.64439,
    lat: 32.69434,
    lastdyn: 1719542945,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H4 FD 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122305,
  },
  {
    mmsi: 999412115,
    lng: 121.673427,
    lat: 32.544115,
    lastdyn: 1719859854,
    type: 25,
    shiptype: 'navigation',
    name: 'YANG KOU GANG 1 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412115,
  },
  {
    mmsi: 994122304,
    lng: 121.51609,
    lat: 32.65365,
    lastdyn: 1719859861,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H4 FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122304,
  },
  {
    mmsi: 994141467,
    lng: 121.711082,
    lat: 32.682238,
    lastdyn: 1719859879,
    type: 0,
    shiptype: 'navigation',
    name: 'RD H5 FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141467,
  },
  {
    mmsi: 994141441,
    lng: 121.54189,
    lat: 32.71313,
    lastdyn: 1719859753,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H3 FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141441,
  },
  {
    mmsi: 994122375,
    lng: 121.82876,
    lat: 32.67986,
    lastdyn: 1719859891,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H6 FD 14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122375,
  },
  {
    mmsi: 994141466,
    lng: 121.81655,
    lat: 32.71904,
    lastdyn: 1719859777,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H5 FD 6',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141466,
  },
  {
    mmsi: 994122370,
    lng: 121.86431,
    lat: 32.67851,
    lastdyn: 1719858359,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H6 FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122370,
  },
  {
    mmsi: 994122380,
    lng: 121.92943,
    lat: 32.66197,
    lastdyn: 1719859716,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H10 FD9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122380,
  },
  {
    mmsi: 994122379,
    lng: 121.947,
    lat: 32.63192,
    lastdyn: 1719855392,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H10 FD8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122379,
  },
  {
    mmsi: 994122377,
    lng: 121.98736,
    lat: 32.71567,
    lastdyn: 1719857904,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H10 FD3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122377,
  },
  {
    mmsi: 994122303,
    lng: 121.85452,
    lat: 32.73009,
    lastdyn: 1719859586,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H8 FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122303,
  },
  {
    mmsi: 994122378,
    lng: 122.02329,
    lat: 32.63147,
    lastdyn: 1719856818,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H10 FD6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122378,
  },
  {
    mmsi: 994121392,
    lng: 121.223867,
    lat: 32.894593,
    lastdyn: 1719859004,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGS H2 FD 12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121392,
  },
  {
    mmsi: 999412121,
    lng: 121.195717,
    lat: 32.93843,
    lastdyn: 1719859851,
    type: 19,
    shiptype: 'navigation',
    name: 'DONG TAI H4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412121,
  },
  {
    mmsi: 994122333,
    lng: 121.41061,
    lat: 32.77134,
    lastdyn: 1719858973,
    type: 30,
    shiptype: 'navigation',
    name: 'RD FD HL J5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122333,
  },
  {
    mmsi: 994121395,
    lng: 121.259797,
    lat: 32.776345,
    lastdyn: 1719859804,
    type: 30,
    shiptype: 'navigation',
    name: 'JJS H2 FD 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121395,
  },
  {
    mmsi: 994141460,
    lng: 121.41838,
    lat: 32.76099,
    lastdyn: 1719859463,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H13 FD 4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141460,
  },
  {
    mmsi: 994121390,
    lng: 121.420185,
    lat: 32.911665,
    lastdyn: 1719859734,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGS H2 FD 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121390,
  },
  {
    mmsi: 994121391,
    lng: 121.317892,
    lat: 32.896067,
    lastdyn: 1719859849,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGS H2 FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121391,
  },
  {
    mmsi: 994122320,
    lng: 121.35652,
    lat: 32.86465,
    lastdyn: 1719859803,
    type: 30,
    shiptype: 'navigation',
    name: 'ZGSH1FD 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122320,
  },
  {
    mmsi: 999412107,
    lng: 121.28937,
    lat: 32.92023,
    lastdyn: 1719859830,
    type: 30,
    shiptype: 'navigation',
    name: 'DONG TAI H1',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412107,
  },
  {
    mmsi: 994121332,
    lng: 121.321065,
    lat: 32.950623,
    lastdyn: 1719859864,
    type: 19,
    shiptype: 'navigation',
    name: 'DT H2 FD 12',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121332,
  },
  {
    mmsi: 994141458,
    lng: 121.51502,
    lat: 32.80015,
    lastdyn: 1719859893,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H15 FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141458,
  },
  {
    mmsi: 994122358,
    lng: 121.64573,
    lat: 32.81776,
    lastdyn: 1719859884,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H2 FD 13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122358,
  },
  {
    mmsi: 994122356,
    lng: 121.71563,
    lat: 32.80072,
    lastdyn: 1719859741,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H2 FD 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122356,
  },
  {
    mmsi: 994141457,
    lng: 121.59431,
    lat: 32.79399,
    lastdyn: 1719859229,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H15 FD 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141457,
  },
  {
    mmsi: 994141454,
    lng: 121.50385,
    lat: 32.7943,
    lastdyn: 1719859471,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H15 FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141454,
  },
  {
    mmsi: 994122357,
    lng: 121.62772,
    lat: 32.79108,
    lastdyn: 1719859807,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H2 FD 11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122357,
  },
  {
    mmsi: 994141455,
    lng: 181,
    lat: 91,
    lastdyn: 1719859447,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H15 FD 3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141455,
  },
  {
    mmsi: 994122311,
    lng: 121.94231,
    lat: 32.84201,
    lastdyn: 1719859326,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H7 FD 7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122311,
  },
  {
    mmsi: 994122312,
    lng: 121.7557,
    lat: 32.80666,
    lastdyn: 1719859741,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H7 FD 12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122312,
  },
  {
    mmsi: 994122313,
    lng: 121.83824,
    lat: 32.83244,
    lastdyn: 1719859801,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H7 FD 14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122313,
  },
  {
    mmsi: 994122300,
    lng: 121.84056,
    lat: 32.76441,
    lastdyn: 1719859683,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H8 FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122300,
  },
  {
    mmsi: 994122309,
    lng: 121.756743,
    lat: 32.857497,
    lastdyn: 1719859880,
    type: 0,
    shiptype: 'navigation',
    name: 'RD H7 FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122309,
  },
  {
    mmsi: 994122302,
    lng: 121.96651,
    lat: 32.76266,
    lastdyn: 1719859868,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H8 FD 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122302,
  },
  {
    mmsi: 994141465,
    lng: 121.797902,
    lat: 32.752642,
    lastdyn: 1719859878,
    type: 0,
    shiptype: 'navigation',
    name: 'RD H5 FD 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141465,
  },
  {
    mmsi: 994122301,
    lng: 121.95255,
    lat: 32.79695,
    lastdyn: 1719859740,
    type: 30,
    shiptype: 'navigation',
    name: 'RD H8 FD 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122301,
  },
  {
    mmsi: 999413230,
    lng: 122.153717,
    lat: 32.8108,
    lastdyn: 1719859744,
    type: 28,
    shiptype: 'navigation',
    name: 'SU QI YU 04827 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413230,
  },
  {
    mmsi: 999413248,
    lng: 122.606638,
    lat: 32.76761,
    lastdyn: 1719859858,
    type: 28,
    shiptype: 'navigation',
    name: 'DE LONG CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413248,
  },
  {
    mmsi: 999412127,
    lng: 120.857253,
    lat: 33.246013,
    lastdyn: 1719859772,
    type: 19,
    shiptype: 'navigation',
    name: 'TONG YONG MA TOU BEI',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412127,
  },
  {
    mmsi: 999412137,
    lng: 119.318675,
    lat: 34.716028,
    lastdyn: 1719859898,
    type: 0,
    shiptype: 'navigation',
    name: 'NAN GANG BEI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412137,
  },
  {
    mmsi: 999412125,
    lng: 120.866173,
    lat: 33.224847,
    lastdyn: 1719859812,
    type: 13,
    shiptype: 'navigation',
    name: 'YOU PIN MA TOU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 114,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412125,
  },
  {
    mmsi: 994121333,
    lng: 121.35365,
    lat: 33.009373,
    lastdyn: 1719859744,
    type: 19,
    shiptype: 'navigation',
    name: 'DT H2 FD 14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121333,
  },
  {
    mmsi: 994121326,
    lng: 121.419367,
    lat: 33.170197,
    lastdyn: 1719859873,
    type: 19,
    shiptype: 'navigation',
    name: 'HN DF FD 15',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121326,
  },
  {
    mmsi: 994121325,
    lng: 121.392305,
    lat: 33.083275,
    lastdyn: 1719859633,
    type: 19,
    shiptype: 'navigation',
    name: 'HN DF FD 12',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121325,
  },
  {
    mmsi: 999413216,
    lng: 122.429317,
    lat: 33.122433,
    lastdyn: 1719859762,
    type: 28,
    shiptype: 'navigation',
    name: 'XIN CHENG 823 CHEN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 999413216,
  },
  {
    mmsi: 994403898,
    lng: 126.478985,
    lat: 33.223072,
    lastdyn: 1719859173,
    type: 10,
    shiptype: 'navigation',
    name: 'SEBYEOLGOT',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403898,
  },
  {
    mmsi: 994311570,
    lng: 133.579858,
    lat: 33.022283,
    lastdyn: 1719858792,
    type: 31,
    shiptype: 'navigation',
    name: 'TOSAKUROSHIO20',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311570,
  },
  {
    mmsi: 999412106,
    lng: 119.318817,
    lat: 34.715837,
    lastdyn: 1719859901,
    type: 0,
    shiptype: 'navigation',
    name: 'DA FENG DENG ZHUANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412106,
  },
  {
    mmsi: 999412126,
    lng: 120.818507,
    lat: 33.292557,
    lastdyn: 1719859892,
    type: 19,
    shiptype: 'navigation',
    name: 'LIANG SHI MA TOU BEI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412126,
  },
  {
    mmsi: 994141449,
    lng: 121.047467,
    lat: 33.324298,
    lastdyn: 1719859813,
    type: 19,
    shiptype: 'navigation',
    name: 'LY DF FD 11',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141449,
  },
  {
    mmsi: 994121307,
    lng: 121.188378,
    lat: 33.359647,
    lastdyn: 1719859803,
    type: 19,
    shiptype: 'navigation',
    name: 'DF H11 FD 14',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121307,
  },
  {
    mmsi: 994121308,
    lng: 121.047317,
    lat: 33.47058,
    lastdyn: 1719859683,
    type: 19,
    shiptype: 'navigation',
    name: 'H3 FENG DIAN 13',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121308,
  },
  {
    mmsi: 994141448,
    lng: 121.054152,
    lat: 33.305415,
    lastdyn: 1719859753,
    type: 19,
    shiptype: 'navigation',
    name: 'LY DF FD 10',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141448,
  },
  {
    mmsi: 994141450,
    lng: 121.217587,
    lat: 33.324307,
    lastdyn: 1719859333,
    type: 19,
    shiptype: 'navigation',
    name: 'LY DF FD 16',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141450,
  },
  {
    mmsi: 994122331,
    lng: 121.05559,
    lat: 33.42746,
    lastdyn: 1719859808,
    type: 30,
    shiptype: 'navigation',
    name: 'DF H5 FD 10',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122331,
  },
  {
    mmsi: 994141446,
    lng: 121.248033,
    lat: 33.286467,
    lastdyn: 1719859804,
    type: 19,
    shiptype: 'navigation',
    name: 'LY DF FD 4',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141446,
  },
  {
    mmsi: 994121305,
    lng: 121.188807,
    lat: 33.390607,
    lastdyn: 1719859863,
    type: 19,
    shiptype: 'navigation',
    name: 'DF H11 FD 9',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121305,
  },
  {
    mmsi: 994122368,
    lng: 121.23256,
    lat: 33.30749,
    lastdyn: 1719859883,
    type: 30,
    shiptype: 'navigation',
    name: 'DF H82 FD GKZ',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122368,
  },
  {
    mmsi: 994122348,
    lng: 121.41878,
    lat: 33.40264,
    lastdyn: 1719560160,
    type: 19,
    shiptype: 'navigation',
    name: 'DF H6 FD 4',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122348,
  },
  {
    mmsi: 994122342,
    lng: 121.27815,
    lat: 33.47255,
    lastdyn: 1719859811,
    type: 30,
    shiptype: 'navigation',
    name: 'DF H4 FD 3',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122342,
  },
  {
    mmsi: 994403900,
    lng: 126.160345,
    lat: 33.337665,
    lastdyn: 1719858284,
    type: 12,
    shiptype: 'navigation',
    name: 'YONGDANGSANGGOT',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 199,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403900,
  },
  {
    mmsi: 994403896,
    lng: 126.847197,
    lat: 33.320292,
    lastdyn: 1719858061,
    type: 12,
    shiptype: 'navigation',
    name: 'GAEMINPO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403896,
  },
  {
    mmsi: 994403890,
    lng: 126.965868,
    lat: 33.492843,
    lastdyn: 1719859553,
    type: 6,
    shiptype: 'navigation',
    name: 'UDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403890,
  },
  {
    mmsi: 994311560,
    lng: 135.126563,
    lat: 33.458357,
    lastdyn: 1719858433,
    type: 31,
    shiptype: 'navigation',
    name: 'MIGUSASAKINANSEI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311560,
  },
  {
    mmsi: 994311561,
    lng: 135.30482,
    lat: 33.438578,
    lastdyn: 1719858253,
    type: 31,
    shiptype: 'navigation',
    name: 'ICHIESAKINANSEI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311561,
  },
  {
    mmsi: 994311569,
    lng: 135.44713,
    lat: 33.430747,
    lastdyn: 1719859556,
    type: 31,
    shiptype: 'navigation',
    name: 'WABUKASAKISW',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311569,
  },
  {
    mmsi: 994316229,
    lng: 135.755,
    lat: 33.378333,
    lastdyn: 1719859590,
    type: 30,
    shiptype: 'navigation',
    name: 'VROUTE SHIONOMISAKI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316229,
  },
  {
    mmsi: 994316227,
    lng: 135.875,
    lat: 33.431667,
    lastdyn: 1719859590,
    type: 29,
    shiptype: 'navigation',
    name: 'VROUTE SHIONOMISAKI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316227,
  },
  {
    mmsi: 994311568,
    lng: 135.954673,
    lat: 33.456685,
    lastdyn: 1719859511,
    type: 31,
    shiptype: 'navigation',
    name: 'KASHINOSAKIE',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311568,
  },
  {
    mmsi: 994316228,
    lng: 135.755,
    lat: 33.405,
    lastdyn: 1719859590,
    type: 29,
    shiptype: 'navigation',
    name: 'VROUTE SHIONOMISAKI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316228,
  },
  {
    mmsi: 994136360,
    lng: 120.728138,
    lat: 33.628638,
    lastdyn: 1719859833,
    type: 28,
    shiptype: 'navigation',
    name: 'XIN YANG PING TAI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136360,
  },
  {
    mmsi: 994122340,
    lng: 120.91174,
    lat: 33.59257,
    lastdyn: 1719859585,
    type: 30,
    shiptype: 'navigation',
    name: 'SY NAN H2 FD 17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122340,
  },
  {
    mmsi: 994122339,
    lng: 120.92189,
    lat: 33.58218,
    lastdyn: 1719829451,
    type: 30,
    shiptype: 'navigation',
    name: 'SY NAN H2 FD 16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122339,
  },
  {
    mmsi: 994121368,
    lng: 121.06014,
    lat: 33.65267,
    lastdyn: 1719859822,
    type: 19,
    shiptype: 'navigation',
    name: 'SY NAN H1 FD 13',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121368,
  },
  {
    mmsi: 994121302,
    lng: 121.061378,
    lat: 33.5098,
    lastdyn: 1719859893,
    type: 30,
    shiptype: 'navigation',
    name: 'H3 FENG DIAN 17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121302,
  },
  {
    mmsi: 994121364,
    lng: 121.040773,
    lat: 33.660385,
    lastdyn: 1719859043,
    type: 19,
    shiptype: 'navigation',
    name: 'SY NAN H1 FD 1',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121364,
  },
  {
    mmsi: 994121367,
    lng: 121.01661,
    lat: 33.639972,
    lastdyn: 1719858683,
    type: 19,
    shiptype: 'navigation',
    name: 'SY NAN H1 FD 12',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121367,
  },
  {
    mmsi: 994126540,
    lng: 121.34,
    lat: 33.6865,
    lastdyn: 1719859870,
    type: 28,
    shiptype: 'navigation',
    name: 'JIANG HAI TONG 12 WR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126540,
  },
  {
    mmsi: 994136570,
    lng: 121.324722,
    lat: 33.651055,
    lastdyn: 1719859839,
    type: 28,
    shiptype: 'navigation',
    name: 'SONG NIM 9 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136570,
  },
  {
    mmsi: 994403894,
    lng: 126.740865,
    lat: 33.561038,
    lastdyn: 1719851244,
    type: 12,
    shiptype: 'navigation',
    name: 'GYMNYEONGHANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403894,
  },
  {
    mmsi: 994403893,
    lng: 126.541168,
    lat: 33.532928,
    lastdyn: 1719858266,
    type: 14,
    shiptype: 'navigation',
    name: 'JEJUHANGWEST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 243,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403893,
  },
  {
    mmsi: 994403897,
    lng: 126.972378,
    lat: 33.514482,
    lastdyn: 1719858262,
    type: 10,
    shiptype: 'navigation',
    name: 'UDOLB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403897,
  },
  {
    mmsi: 994316254,
    lng: 131.897525,
    lat: 33.734417,
    lastdyn: 1719859470,
    type: 29,
    shiptype: 'navigation',
    name: 'VIYONADANO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316254,
  },
  {
    mmsi: 994316256,
    lng: 132.217222,
    lat: 33.714138,
    lastdyn: 1719859471,
    type: 29,
    shiptype: 'navigation',
    name: 'VIYONADANO6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316256,
  },
  {
    mmsi: 994311251,
    lng: 132.134505,
    lat: 33.693375,
    lastdyn: 1719859027,
    type: 18,
    shiptype: 'navigation',
    name: 'IYONADANO5LB',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 1,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311251,
  },
  {
    mmsi: 994316255,
    lng: 132.056417,
    lat: 33.706638,
    lastdyn: 1719859470,
    type: 29,
    shiptype: 'navigation',
    name: 'VIYONADANO4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316255,
  },
  {
    mmsi: 994311559,
    lng: 135.086267,
    lat: 33.505358,
    lastdyn: 1719753305,
    type: 31,
    shiptype: 'navigation',
    name: 'SETOSAKINANSEI',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311559,
  },
  {
    mmsi: 994311566,
    lng: 136.085253,
    lat: 33.500328,
    lastdyn: 1719859503,
    type: 31,
    shiptype: 'navigation',
    name: 'KANTORISAKISE',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311566,
  },
  {
    mmsi: 994136413,
    lng: 120.556055,
    lat: 33.840305,
    lastdyn: 1719859878,
    type: 30,
    shiptype: 'navigation',
    name: 'SYG ND DT',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136413,
  },
  {
    mmsi: 994122386,
    lng: 120.557077,
    lat: 33.838658,
    lastdyn: 1719859743,
    type: 30,
    shiptype: 'navigation',
    name: 'SYG ND T1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122386,
  },
  {
    mmsi: 994136412,
    lng: 120.552222,
    lat: 33.847722,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'SYG BD DT',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136412,
  },
  {
    mmsi: 999412136,
    lng: 120.639192,
    lat: 33.874468,
    lastdyn: 1719859728,
    type: 28,
    shiptype: 'navigation',
    name: 'SHE YANG GANG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412136,
  },
  {
    mmsi: 994136564,
    lng: 120.548472,
    lat: 33.83686,
    lastdyn: 1719859885,
    type: 30,
    shiptype: 'navigation',
    name: 'SYG ND 1A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136564,
  },
  {
    mmsi: 994122385,
    lng: 120.73431,
    lat: 33.26134,
    lastdyn: 1719859701,
    type: 30,
    shiptype: 'navigation',
    name: 'SYG BD T1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122385,
  },
  {
    mmsi: 994136415,
    lng: 120.543943,
    lat: 33.845583,
    lastdyn: 1719859882,
    type: 30,
    shiptype: 'navigation',
    name: 'SYG BD 1A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136415,
  },
  {
    mmsi: 999412160,
    lng: 120.76808,
    lat: 33.9276,
    lastdyn: 1719856690,
    type: 19,
    shiptype: 'navigation',
    name: 'SHEYANG Q1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412160,
  },
  {
    mmsi: 994403125,
    lng: 125.53285,
    lat: 33.928273,
    lastdyn: 1719830357,
    type: 30,
    shiptype: 'navigation',
    name: 'BYEONGPUNGDO C',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403125,
  },
  {
    mmsi: 994403892,
    lng: 126.29658,
    lat: 33.9553,
    lastdyn: 1719858613,
    type: 0,
    shiptype: 'navigation',
    name: 'CHUJADO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403892,
  },
  {
    mmsi: 994403901,
    lng: 126.322527,
    lat: 33.797755,
    lastdyn: 1719858282,
    type: 17,
    shiptype: 'navigation',
    name: 'JUNGNOE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 199,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403901,
  },
  {
    mmsi: 994403154,
    lng: 126.896108,
    lat: 33.91401,
    lastdyn: 1719822049,
    type: 30,
    shiptype: 'navigation',
    name: 'WANDO V3',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403154,
  },
  {
    mmsi: 994403002,
    lng: 126.918297,
    lat: 33.987718,
    lastdyn: 1719848740,
    type: 0,
    shiptype: 'navigation',
    name: 'YEOSEODO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403002,
  },
  {
    mmsi: 994403152,
    lng: 127.084237,
    lat: 33.883402,
    lastdyn: 1719803869,
    type: 30,
    shiptype: 'navigation',
    name: 'WANDO V1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403152,
  },
  {
    mmsi: 994311301,
    lng: 130.884593,
    lat: 33.996725,
    lastdyn: 1719859508,
    type: 24,
    shiptype: 'navigation',
    name: 'KANMONNO1LB',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311301,
  },
  {
    mmsi: 994311572,
    lng: 131.214257,
    lat: 33.833088,
    lastdyn: 1719859547,
    type: 3,
    shiptype: 'navigation',
    name: 'SEIBUSEKIYU SB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311572,
  },
  {
    mmsi: 994311302,
    lng: 131.050162,
    lat: 33.946127,
    lastdyn: 1719859539,
    type: 29,
    shiptype: 'navigation',
    name: 'SHIMONOSEKINO1LB',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311302,
  },
  {
    mmsi: 994316251,
    lng: 131.394222,
    lat: 33.822695,
    lastdyn: 1719859470,
    type: 29,
    shiptype: 'navigation',
    name: 'VSUONADANO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316251,
  },
  {
    mmsi: 994316248,
    lng: 131.74475,
    lat: 33.96186,
    lastdyn: 1719859590,
    type: 29,
    shiptype: 'navigation',
    name: 'VTOKUYAMANO2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316248,
  },
  {
    mmsi: 994316252,
    lng: 131.590888,
    lat: 33.788278,
    lastdyn: 1719859469,
    type: 29,
    shiptype: 'navigation',
    name: 'VSUONADANO4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316252,
  },
  {
    mmsi: 994316253,
    lng: 131.744222,
    lat: 33.761055,
    lastdyn: 1719859470,
    type: 29,
    shiptype: 'navigation',
    name: 'VSUONADANO6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316253,
  },
  {
    mmsi: 994316249,
    lng: 132.520833,
    lat: 33.871667,
    lastdyn: 1719859530,
    type: 29,
    shiptype: 'navigation',
    name: 'VHEIGUNNO4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316249,
  },
  {
    mmsi: 994316257,
    lng: 132.595278,
    lat: 33.878612,
    lastdyn: 1719859471,
    type: 29,
    shiptype: 'navigation',
    name: 'VIYONADANO9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316257,
  },
  {
    mmsi: 994121341,
    lng: 120.526525,
    lat: 34.249973,
    lastdyn: 1719859792,
    type: 19,
    shiptype: 'navigation',
    name: 'DT BH FD 14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121341,
  },
  {
    mmsi: 994121335,
    lng: 120.66611,
    lat: 34.236917,
    lastdyn: 1719830424,
    type: 19,
    shiptype: 'navigation',
    name: 'DT BH FD 4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121335,
  },
  {
    mmsi: 994121342,
    lng: 120.59073,
    lat: 34.210175,
    lastdyn: 1719856762,
    type: 19,
    shiptype: 'navigation',
    name: 'DT BH FD 16',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121342,
  },
  {
    mmsi: 994402998,
    lng: 125.847787,
    lat: 34.2245,
    lastdyn: 1719859182,
    type: 3,
    shiptype: 'navigation',
    name: 'JUKDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402998,
  },
  {
    mmsi: 994403153,
    lng: 127.02698,
    lat: 34.014932,
    lastdyn: 1719824029,
    type: 30,
    shiptype: 'navigation',
    name: 'WANDO V2',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403153,
  },
  {
    mmsi: 994402345,
    lng: 127.09886,
    lat: 34.244282,
    lastdyn: 1719853924,
    type: 19,
    shiptype: 'navigation',
    name: 'WANDOGEUMIL AIS',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402345,
  },
  {
    mmsi: 994402933,
    lng: 127.353127,
    lat: 34.179928,
    lastdyn: 1719819206,
    type: 0,
    shiptype: 'navigation',
    name: 'YEOKMANDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 239,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402933,
  },
  {
    mmsi: 994403122,
    lng: 127.418098,
    lat: 34.212453,
    lastdyn: 1719817414,
    type: 19,
    shiptype: 'navigation',
    name: 'SOGEOMUNDODHGRB',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403122,
  },
  {
    mmsi: 994406681,
    lng: 127.363833,
    lat: 34.127067,
    lastdyn: 1719858720,
    type: 18,
    shiptype: 'navigation',
    name: 'VIRTUALSAFEZONE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406681,
  },
  {
    mmsi: 994402951,
    lng: 127.31154,
    lat: 34.073867,
    lastdyn: 1719818458,
    type: 0,
    shiptype: 'navigation',
    name: 'BANYEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402951,
  },
  {
    mmsi: 994402932,
    lng: 127.582918,
    lat: 34.055297,
    lastdyn: 1719859502,
    type: 0,
    shiptype: 'navigation',
    name: 'SANGBACKDOLH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402932,
  },
  {
    mmsi: 994402931,
    lng: 127.5617,
    lat: 34.140773,
    lastdyn: 1719859370,
    type: 3,
    shiptype: 'navigation',
    name: 'MOONSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402931,
  },
  {
    mmsi: 994311557,
    lng: 130.723873,
    lat: 34.052885,
    lastdyn: 1719859501,
    type: 3,
    shiptype: 'navigation',
    name: 'WINDPOWER HIBIKI',
    length: 50,
    width: 50,
    left: 25,
    trail: 25,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311557,
  },
  {
    mmsi: 994316243,
    lng: 132.918167,
    lat: 34.160167,
    lastdyn: 1719859530,
    type: 29,
    shiptype: 'navigation',
    name: 'VKURUSHIMAWESTB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316243,
  },
  {
    mmsi: 994316242,
    lng: 132.8985,
    lat: 34.156667,
    lastdyn: 1719859530,
    type: 29,
    shiptype: 'navigation',
    name: 'VKURUSHIMAWESTA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316242,
  },
  {
    mmsi: 999412179,
    lng: 119.789282,
    lat: 34.479097,
    lastdyn: 1719859805,
    type: 14,
    shiptype: 'navigation',
    name: 'YAN WEI MATOU 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412179,
  },
  {
    mmsi: 999412158,
    lng: 120.230705,
    lat: 34.396788,
    lastdyn: 1719859857,
    type: 19,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412158,
  },
  {
    mmsi: 999412170,
    lng: 120.12281,
    lat: 34.483873,
    lastdyn: 1719859380,
    type: 19,
    shiptype: 'navigation',
    name: 'H1 FENG DIAN 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412170,
  },
  {
    mmsi: 999412157,
    lng: 120.182093,
    lat: 34.427873,
    lastdyn: 1719859802,
    type: 19,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412157,
  },
  {
    mmsi: 999412156,
    lng: 120.159785,
    lat: 34.410347,
    lastdyn: 1719859824,
    type: 30,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412156,
  },
  {
    mmsi: 999412171,
    lng: 120.10288,
    lat: 34.466652,
    lastdyn: 1719859623,
    type: 19,
    shiptype: 'navigation',
    name: 'H1 FENG DIAN 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412171,
  },
  {
    mmsi: 999412159,
    lng: 120.208415,
    lat: 34.379322,
    lastdyn: 1719859760,
    type: 19,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412159,
  },
  {
    mmsi: 994122353,
    lng: 120.29456,
    lat: 34.29367,
    lastdyn: 1719859681,
    type: 19,
    shiptype: 'navigation',
    name: 'BH FBD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122353,
  },
  {
    mmsi: 994121340,
    lng: 120.486152,
    lat: 34.272833,
    lastdyn: 1719859882,
    type: 19,
    shiptype: 'navigation',
    name: 'DT BH FD 13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121340,
  },
  {
    mmsi: 994126441,
    lng: 120.380555,
    lat: 34.326972,
    lastdyn: 1719859793,
    type: 30,
    shiptype: 'navigation',
    name: 'BQ6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126441,
  },
  {
    mmsi: 999412150,
    lng: 120.34472,
    lat: 34.28131,
    lastdyn: 1719859845,
    type: 18,
    shiptype: 'navigation',
    name: 'BIN HAI KOU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412150,
  },
  {
    mmsi: 994126400,
    lng: 120.304528,
    lat: 34.302862,
    lastdyn: 1719859787,
    type: 25,
    shiptype: 'navigation',
    name: 'BHG B101',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126400,
  },
  {
    mmsi: 994122352,
    lng: 120.300208,
    lat: 34.301972,
    lastdyn: 1719859889,
    type: 26,
    shiptype: 'navigation',
    name: 'BHG B4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122352,
  },
  {
    mmsi: 999412183,
    lng: 120.369947,
    lat: 34.453107,
    lastdyn: 1719859833,
    type: 0,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412183,
  },
  {
    mmsi: 994121338,
    lng: 120.497607,
    lat: 34.277847,
    lastdyn: 1719859792,
    type: 19,
    shiptype: 'navigation',
    name: 'DT BH FD 9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121338,
  },
  {
    mmsi: 994126440,
    lng: 120.40625,
    lat: 34.336805,
    lastdyn: 1719859790,
    type: 30,
    shiptype: 'navigation',
    name: 'BQ5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126440,
  },
  {
    mmsi: 994140803,
    lng: 120.651495,
    lat: 34.322483,
    lastdyn: 1719859824,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 803',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140803,
  },
  {
    mmsi: 994140810,
    lng: 120.684993,
    lat: 34.278653,
    lastdyn: 1719859748,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 810',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140810,
  },
  {
    mmsi: 994140809,
    lng: 120.72051,
    lat: 34.278448,
    lastdyn: 1719859835,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 809',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140809,
  },
  {
    mmsi: 994140812,
    lng: 120.615982,
    lat: 34.300877,
    lastdyn: 1719859843,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 812',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140812,
  },
  {
    mmsi: 994140801,
    lng: 120.582488,
    lat: 34.322892,
    lastdyn: 1719859909,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 801',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140801,
  },
  {
    mmsi: 994140804,
    lng: 120.685998,
    lat: 34.322278,
    lastdyn: 1719859916,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 804',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140804,
  },
  {
    mmsi: 994121334,
    lng: 120.550673,
    lat: 34.306173,
    lastdyn: 1719859882,
    type: 19,
    shiptype: 'navigation',
    name: 'DT BH FD 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121334,
  },
  {
    mmsi: 994140802,
    lng: 120.616992,
    lat: 34.322688,
    lastdyn: 1719859911,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 802',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140802,
  },
  {
    mmsi: 994140805,
    lng: 120.720502,
    lat: 34.322075,
    lastdyn: 1719859917,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 805',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140805,
  },
  {
    mmsi: 994140811,
    lng: 120.649477,
    lat: 34.278857,
    lastdyn: 1719859843,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 811',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140811,
  },
  {
    mmsi: 994121336,
    lng: 120.524693,
    lat: 34.294992,
    lastdyn: 1719859852,
    type: 19,
    shiptype: 'navigation',
    name: 'DT BH FD 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121336,
  },
  {
    mmsi: 994140806,
    lng: 120.756023,
    lat: 34.300062,
    lastdyn: 1719859829,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 806',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140806,
  },
  {
    mmsi: 994140807,
    lng: 120.791543,
    lat: 34.278042,
    lastdyn: 1719859832,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 807',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140807,
  },
  {
    mmsi: 994122360,
    lng: 120.78666,
    lat: 34.26855,
    lastdyn: 1719825576,
    type: 30,
    shiptype: 'navigation',
    name: 'BH HYMC PT 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122360,
  },
  {
    mmsi: 994140808,
    lng: 120.756027,
    lat: 34.278245,
    lastdyn: 1719859833,
    type: 3,
    shiptype: 'navigation',
    name: 'BINHAI 808',
    length: 3,
    width: 7,
    left: 3,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994140808,
  },
  {
    mmsi: 994126322,
    lng: 121.5175,
    lat: 34.268055,
    lastdyn: 1719859873,
    type: 28,
    shiptype: 'navigation',
    name: 'LPYY 60451 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126322,
  },
  {
    mmsi: 994403116,
    lng: 125.852033,
    lat: 34.381972,
    lastdyn: 1719859159,
    type: 19,
    shiptype: 'navigation',
    name: 'WEOBYEONGDOJODO',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403116,
  },
  {
    mmsi: 994403014,
    lng: 126.13502,
    lat: 34.367083,
    lastdyn: 1719859159,
    type: 0,
    shiptype: 'navigation',
    name: 'JANGJUKTIDE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403014,
  },
  {
    mmsi: 994406683,
    lng: 126.090683,
    lat: 34.317867,
    lastdyn: 1719852683,
    type: 0,
    shiptype: 'navigation',
    name: 'VIRTUALJKTIDEBUOY',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406683,
  },
  {
    mmsi: 994402992,
    lng: 126.088333,
    lat: 34.311667,
    lastdyn: 1719716211,
    type: 3,
    shiptype: 'navigation',
    name: 'HAJODO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402992,
  },
  {
    mmsi: 994402997,
    lng: 126.182727,
    lat: 34.261783,
    lastdyn: 1719859144,
    type: 0,
    shiptype: 'navigation',
    name: 'DOKGEODO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402997,
  },
  {
    mmsi: 994402993,
    lng: 126.042777,
    lat: 34.46028,
    lastdyn: 1719859142,
    type: 5,
    shiptype: 'navigation',
    name: 'GASADO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402993,
  },
  {
    mmsi: 994402996,
    lng: 126.330728,
    lat: 34.250145,
    lastdyn: 1719834492,
    type: 0,
    shiptype: 'navigation',
    name: 'MILMAEDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402996,
  },
  {
    mmsi: 994403001,
    lng: 126.612765,
    lat: 34.250437,
    lastdyn: 1719829802,
    type: 28,
    shiptype: 'navigation',
    name: 'HOENGGANDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403001,
  },
  {
    mmsi: 994403007,
    lng: 126.808392,
    lat: 34.25337,
    lastdyn: 1719827858,
    type: 0,
    shiptype: 'navigation',
    name: 'WANDOHANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403007,
  },
  {
    mmsi: 994403012,
    lng: 126.755827,
    lat: 34.273038,
    lastdyn: 1719829301,
    type: 0,
    shiptype: 'navigation',
    name: 'WAEMOLCHO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403012,
  },
  {
    mmsi: 994403011,
    lng: 127.086152,
    lat: 34.405098,
    lastdyn: 1719847812,
    type: 0,
    shiptype: 'navigation',
    name: 'BIGYEONDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403011,
  },
  {
    mmsi: 994403121,
    lng: 127.415998,
    lat: 34.329915,
    lastdyn: 1719856813,
    type: 19,
    shiptype: 'navigation',
    name: 'S0GEOMUNDODHRGA',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403121,
  },
  {
    mmsi: 994403161,
    lng: 127.278702,
    lat: 34.323752,
    lastdyn: 1719858640,
    type: 19,
    shiptype: 'navigation',
    name: 'MUHAKSISANOWT',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403161,
  },
  {
    mmsi: 994402937,
    lng: 127.343777,
    lat: 34.480972,
    lastdyn: 1719839396,
    type: 0,
    shiptype: 'navigation',
    name: 'NAEBALSBKLH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402937,
  },
  {
    mmsi: 994403160,
    lng: 127.498585,
    lat: 34.317893,
    lastdyn: 1719858840,
    type: 3,
    shiptype: 'navigation',
    name: 'SONJUKDO SAMHAE AIS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403160,
  },
  {
    mmsi: 994403157,
    lng: 127.412487,
    lat: 34.364143,
    lastdyn: 1716406436,
    type: 0,
    shiptype: 'navigation',
    name: 'OENARODO GOYI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403157,
  },
  {
    mmsi: 994402936,
    lng: 127.510367,
    lat: 34.366528,
    lastdyn: 1719859552,
    type: 3,
    shiptype: 'navigation',
    name: 'TANGGUNYEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402936,
  },
  {
    mmsi: 994403110,
    lng: 127.51036,
    lat: 34.366538,
    lastdyn: 1719858440,
    type: 2,
    shiptype: 'navigation',
    name: 'YEOSUHAEMAN CENTER A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 200,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403110,
  },
  {
    mmsi: 994402946,
    lng: 127.90361,
    lat: 34.416388,
    lastdyn: 1719859501,
    type: 0,
    shiptype: 'navigation',
    name: 'JAKDOLH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402946,
  },
  {
    mmsi: 994402942,
    lng: 127.854837,
    lat: 34.287752,
    lastdyn: 1719859518,
    type: 3,
    shiptype: 'navigation',
    name: 'GANGYEOAM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402942,
  },
  {
    mmsi: 994401630,
    lng: 128.083897,
    lat: 34.49909,
    lastdyn: 1719845569,
    type: 5,
    shiptype: 'navigation',
    name: 'SEJONDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401630,
  },
  {
    mmsi: 994401606,
    lng: 128.476538,
    lat: 34.497915,
    lastdyn: 1719859553,
    type: 5,
    shiptype: 'navigation',
    name: 'GOAM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401606,
  },
  {
    mmsi: 994316202,
    lng: 134.98,
    lat: 34.297917,
    lastdyn: 1719859589,
    type: 29,
    shiptype: 'navigation',
    name: 'VYURASETON',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316202,
  },
  {
    mmsi: 994316203,
    lng: 134.98,
    lat: 34.267472,
    lastdyn: 1719859589,
    type: 29,
    shiptype: 'navigation',
    name: 'VYURASETOS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316203,
  },
  {
    mmsi: 994311201,
    lng: 135.008795,
    lat: 34.355778,
    lastdyn: 1719859634,
    type: 29,
    shiptype: 'navigation',
    name: 'SUMOTOLB',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 1,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311201,
  },
  {
    mmsi: 994136585,
    lng: 119.491167,
    lat: 34.733833,
    lastdyn: 1719859790,
    type: 24,
    shiptype: 'navigation',
    name: '42 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136585,
  },
  {
    mmsi: 994136356,
    lng: 119.478583,
    lat: 34.74375,
    lastdyn: 1719859775,
    type: 25,
    shiptype: 'navigation',
    name: '43',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136356,
  },
  {
    mmsi: 994136482,
    lng: 119.485972,
    lat: 34.728528,
    lastdyn: 1719859777,
    type: 14,
    shiptype: 'navigation',
    name: 'ZHU JIA YOU BQ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136482,
  },
  {
    mmsi: 994136484,
    lng: 119.48675,
    lat: 34.727222,
    lastdyn: 1719859784,
    type: 14,
    shiptype: 'navigation',
    name: 'ZHU JIA ZUO BQ',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136484,
  },
  {
    mmsi: 994136483,
    lng: 119.473833,
    lat: 34.723417,
    lastdyn: 1719859781,
    type: 14,
    shiptype: 'navigation',
    name: 'ZHU JIA YOU BH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136483,
  },
  {
    mmsi: 994136441,
    lng: 119.415055,
    lat: 34.749667,
    lastdyn: 1719859816,
    type: 24,
    shiptype: 'navigation',
    name: '50 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136441,
  },
  {
    mmsi: 999412134,
    lng: 119.473645,
    lat: 34.737562,
    lastdyn: 1719859790,
    type: 3,
    shiptype: 'navigation',
    name: 'XIN SU GANG XI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412134,
  },
  {
    mmsi: 994136485,
    lng: 119.472305,
    lat: 34.721167,
    lastdyn: 1719859787,
    type: 14,
    shiptype: 'navigation',
    name: 'ZHU JIA ZUO BH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136485,
  },
  {
    mmsi: 990899001,
    lng: 119.318495,
    lat: 34.716013,
    lastdyn: 1719859836,
    type: 30,
    shiptype: 'navigation',
    name: 'EICPLYG09',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 990899001,
  },
  {
    mmsi: 999412129,
    lng: 119.520402,
    lat: 34.737202,
    lastdyn: 1719859876,
    type: 3,
    shiptype: 'navigation',
    name: 'NAN DI DENG ZHUANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412129,
  },
  {
    mmsi: 999412110,
    lng: 119.501962,
    lat: 34.732132,
    lastdyn: 1719859865,
    type: 24,
    shiptype: 'navigation',
    name: '40 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412110,
  },
  {
    mmsi: 994126488,
    lng: 119.649722,
    lat: 34.63525,
    lastdyn: 1719859811,
    type: 19,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126488,
  },
  {
    mmsi: 994126489,
    lng: 119.647055,
    lat: 34.601917,
    lastdyn: 1719859813,
    type: 19,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126489,
  },
  {
    mmsi: 999412112,
    lng: 119.645458,
    lat: 34.665445,
    lastdyn: 1719858658,
    type: 30,
    shiptype: 'navigation',
    name: 'XU WEI HAI YANG ZHAN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412112,
  },
  {
    mmsi: 994126485,
    lng: 119.699,
    lat: 34.709445,
    lastdyn: 1719859802,
    type: 19,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126485,
  },
  {
    mmsi: 999412146,
    lng: 119.595813,
    lat: 34.610813,
    lastdyn: 1719859759,
    type: 24,
    shiptype: 'navigation',
    name: '130',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412146,
  },
  {
    mmsi: 994141437,
    lng: 119.718928,
    lat: 34.738895,
    lastdyn: 1719859880,
    type: 29,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141437,
  },
  {
    mmsi: 994126484,
    lng: 119.708638,
    lat: 34.723945,
    lastdyn: 1719859799,
    type: 19,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126484,
  },
  {
    mmsi: 994126487,
    lng: 119.666138,
    lat: 34.659972,
    lastdyn: 1719859808,
    type: 19,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126487,
  },
  {
    mmsi: 999412128,
    lng: 119.520227,
    lat: 34.74701,
    lastdyn: 1719859875,
    type: 1,
    shiptype: 'navigation',
    name: 'BEI DI DENG ZHUANG',
    length: 8,
    width: 8,
    left: 4,
    trail: 4,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412128,
  },
  {
    mmsi: 999412151,
    lng: 119.617297,
    lat: 34.663452,
    lastdyn: 1719859801,
    type: 19,
    shiptype: 'navigation',
    name: 'DONG DI 1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412151,
  },
  {
    mmsi: 999412111,
    lng: 119.589038,
    lat: 34.60567,
    lastdyn: 1719859817,
    type: 0,
    shiptype: 'navigation',
    name: '120 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412111,
  },
  {
    mmsi: 994126490,
    lng: 119.644388,
    lat: 34.568612,
    lastdyn: 1719859668,
    type: 19,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126490,
  },
  {
    mmsi: 994126486,
    lng: 119.682555,
    lat: 34.684695,
    lastdyn: 1719859804,
    type: 19,
    shiptype: 'navigation',
    name: 'XW GUAN DAO 7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126486,
  },
  {
    mmsi: 994122317,
    lng: 119.7406,
    lat: 34.591442,
    lastdyn: 1719859904,
    type: 30,
    shiptype: 'navigation',
    name: 'HN GY FD 7',
    length: 10,
    width: 4,
    left: 2,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122317,
  },
  {
    mmsi: 994122316,
    lng: 119.81943,
    lat: 34.56943,
    lastdyn: 1719859801,
    type: 30,
    shiptype: 'navigation',
    name: 'HN GY FD 5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122316,
  },
  {
    mmsi: 994136595,
    lng: 119.86,
    lat: 34.575,
    lastdyn: 1719859850,
    type: 28,
    shiptype: 'navigation',
    name: 'WU MING 05 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136595,
  },
  {
    mmsi: 999412169,
    lng: 119.99433,
    lat: 34.539197,
    lastdyn: 1719859843,
    type: 30,
    shiptype: 'navigation',
    name: 'H1 FENG DIAN 1',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412169,
  },
  {
    mmsi: 994122388,
    lng: 119.86996,
    lat: 34.58515,
    lastdyn: 1719859874,
    type: 25,
    shiptype: 'navigation',
    name: 'GHK 17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122388,
  },
  {
    mmsi: 994122318,
    lng: 119.802243,
    lat: 34.604165,
    lastdyn: 1719858239,
    type: 19,
    shiptype: 'navigation',
    name: 'HN GY FD 9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122318,
  },
  {
    mmsi: 994126464,
    lng: 119.939667,
    lat: 34.5925,
    lastdyn: 1719859843,
    type: 28,
    shiptype: 'navigation',
    name: 'WU MING 03 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126464,
  },
  {
    mmsi: 994126505,
    lng: 119.86,
    lat: 34.566667,
    lastdyn: 1719859846,
    type: 28,
    shiptype: 'navigation',
    name: 'WU MING 04 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126505,
  },
  {
    mmsi: 994122389,
    lng: 119.86986,
    lat: 34.57231,
    lastdyn: 1719859837,
    type: 30,
    shiptype: 'navigation',
    name: 'GHK DD1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122389,
  },
  {
    mmsi: 999412172,
    lng: 119.981377,
    lat: 34.519208,
    lastdyn: 1719859863,
    type: 19,
    shiptype: 'navigation',
    name: 'H1 FENG DIAN 10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412172,
  },
  {
    mmsi: 994122387,
    lng: 119.99292,
    lat: 34.63807,
    lastdyn: 1719859851,
    type: 29,
    shiptype: 'navigation',
    name: 'GUAN HE KOU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122387,
  },
  {
    mmsi: 994136579,
    lng: 119.944167,
    lat: 34.592167,
    lastdyn: 1719859837,
    type: 28,
    shiptype: 'navigation',
    name: 'WU MING 02 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136579,
  },
  {
    mmsi: 994126444,
    lng: 119.950733,
    lat: 34.648383,
    lastdyn: 1719859839,
    type: 28,
    shiptype: 'navigation',
    name: 'JIANG DONG WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126444,
  },
  {
    mmsi: 994122314,
    lng: 119.76977,
    lat: 34.63937,
    lastdyn: 1719858845,
    type: 30,
    shiptype: 'navigation',
    name: 'HN GY FD 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994122314,
  },
  {
    mmsi: 994136591,
    lng: 120.228717,
    lat: 34.520583,
    lastdyn: 1719859784,
    type: 28,
    shiptype: 'navigation',
    name: 'SLYGH 8866 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136591,
  },
  {
    mmsi: 999412180,
    lng: 120.325782,
    lat: 34.538788,
    lastdyn: 1719859272,
    type: 19,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412180,
  },
  {
    mmsi: 999412182,
    lng: 120.474383,
    lat: 34.524285,
    lastdyn: 1719855799,
    type: 19,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412182,
  },
  {
    mmsi: 999412181,
    lng: 120.384348,
    lat: 34.538628,
    lastdyn: 1719859623,
    type: 19,
    shiptype: 'navigation',
    name: 'BIN HAI BEI H8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412181,
  },
  {
    mmsi: 994402962,
    lng: 125.203888,
    lat: 34.71111,
    lastdyn: 1719851037,
    type: 3,
    shiptype: 'navigation',
    name: 'HONGDOLH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402962,
  },
  {
    mmsi: 994402977,
    lng: 125.441748,
    lat: 34.701603,
    lastdyn: 1719857548,
    type: 0,
    shiptype: 'navigation',
    name: 'HEUKSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402977,
  },
  {
    mmsi: 994403117,
    lng: 125.730682,
    lat: 34.551068,
    lastdyn: 1719859171,
    type: 3,
    shiptype: 'navigation',
    name: 'UIDO NSEWEATHERTOWER',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403117,
  },
  {
    mmsi: 994402969,
    lng: 125.685895,
    lat: 34.522418,
    lastdyn: 1719859236,
    type: 0,
    shiptype: 'navigation',
    name: 'MAEMULDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402969,
  },
  {
    mmsi: 994403150,
    lng: 125.72704,
    lat: 34.599653,
    lastdyn: 1719858628,
    type: 0,
    shiptype: 'navigation',
    name: 'WINDSEA28',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403150,
  },
  {
    mmsi: 994403114,
    lng: 125.982738,
    lat: 34.531343,
    lastdyn: 1719859162,
    type: 19,
    shiptype: 'navigation',
    name: 'JISILDOSABUWB',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403114,
  },
  {
    mmsi: 994406669,
    lng: 125.987167,
    lat: 34.7395,
    lastdyn: 1719376921,
    type: 0,
    shiptype: 'navigation',
    name: 'JUNGDOSYN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406669,
  },
  {
    mmsi: 994402972,
    lng: 126.198038,
    lat: 34.568135,
    lastdyn: 1719851576,
    type: 3,
    shiptype: 'navigation',
    name: 'GUDO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402972,
  },
  {
    mmsi: 994402968,
    lng: 126.24108,
    lat: 34.699962,
    lastdyn: 1719859136,
    type: 21,
    shiptype: 'navigation',
    name: 'SIHADO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402968,
  },
  {
    mmsi: 994406682,
    lng: 126.302433,
    lat: 34.571667,
    lastdyn: 1719850184,
    type: 0,
    shiptype: 'navigation',
    name: 'VIRTUALMNTIDESENSOR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406682,
  },
  {
    mmsi: 994402999,
    lng: 126.320543,
    lat: 34.559425,
    lastdyn: 1719857185,
    type: 0,
    shiptype: 'navigation',
    name: 'NOKDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402999,
  },
  {
    mmsi: 994403015,
    lng: 126.288243,
    lat: 34.577513,
    lastdyn: 1719854825,
    type: 0,
    shiptype: 'navigation',
    name: 'MYEONGNYANGTIDE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403015,
  },
  {
    mmsi: 994403143,
    lng: 127.534895,
    lat: 34.531997,
    lastdyn: 1719859383,
    type: 3,
    shiptype: 'navigation',
    name: 'GOHEUNG OFFSHORE WIN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403143,
  },
  {
    mmsi: 994403013,
    lng: 127.767815,
    lat: 34.744305,
    lastdyn: 1719859504,
    type: 0,
    shiptype: 'navigation',
    name: 'ODONGDOLH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 230,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403013,
  },
  {
    mmsi: 994403111,
    lng: 127.836492,
    lat: 34.720722,
    lastdyn: 1719859549,
    type: 3,
    shiptype: 'navigation',
    name: 'YEOSUHAEMANC',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403111,
  },
  {
    mmsi: 994406630,
    lng: 127.932,
    lat: 34.6839,
    lastdyn: 1719859506,
    type: 30,
    shiptype: 'navigation',
    name: 'VIRTUAIPILOTZONE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406630,
  },
  {
    mmsi: 994401567,
    lng: 128.241158,
    lat: 34.61423,
    lastdyn: 1719859520,
    type: 3,
    shiptype: 'navigation',
    name: 'YOKJIDOLH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401567,
  },
  {
    mmsi: 994401623,
    lng: 128.062758,
    lat: 34.679242,
    lastdyn: 1719859335,
    type: 0,
    shiptype: 'navigation',
    name: 'GODO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401623,
  },
  {
    mmsi: 994401566,
    lng: 128.117945,
    lat: 34.621712,
    lastdyn: 1719859512,
    type: 19,
    shiptype: 'navigation',
    name: 'GUDOLSEO',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401566,
  },
  {
    mmsi: 994401624,
    lng: 128.306907,
    lat: 34.704243,
    lastdyn: 1719840261,
    type: 17,
    shiptype: 'navigation',
    name: 'GYOBONCHO AIS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401624,
  },
  {
    mmsi: 994401574,
    lng: 128.45932,
    lat: 34.750005,
    lastdyn: 1719856927,
    type: 0,
    shiptype: 'navigation',
    name: 'GAKSUSEO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401574,
  },
  {
    mmsi: 994401642,
    lng: 128.373003,
    lat: 34.578468,
    lastdyn: 1719859520,
    type: 19,
    shiptype: 'navigation',
    name: 'JWASARIDO HYUNDAI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401642,
  },
  {
    mmsi: 994401599,
    lng: 128.626443,
    lat: 34.681805,
    lastdyn: 1719859526,
    type: 19,
    shiptype: 'navigation',
    name: 'DAEBYEONGDAEDO',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401599,
  },
  {
    mmsi: 994401614,
    lng: 128.733037,
    lat: 34.536925,
    lastdyn: 1719854660,
    type: 8,
    shiptype: 'navigation',
    name: 'HONGDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 126,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401614,
  },
  {
    mmsi: 994401607,
    lng: 128.552665,
    lat: 34.579037,
    lastdyn: 1719859540,
    type: 0,
    shiptype: 'navigation',
    name: 'DAEGUULBIDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401607,
  },
  {
    mmsi: 994401600,
    lng: 128.775023,
    lat: 34.683605,
    lastdyn: 1719859483,
    type: 0,
    shiptype: 'navigation',
    name: 'BUGYEODO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401600,
  },
  {
    mmsi: 994311202,
    lng: 135.009062,
    lat: 34.623342,
    lastdyn: 1719859639,
    type: 29,
    shiptype: 'navigation',
    name: 'AKASHICENTERNO2LB',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 1,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311202,
  },
  {
    mmsi: 994316201,
    lng: 135.081943,
    lat: 34.6055,
    lastdyn: 1719859589,
    type: 24,
    shiptype: 'navigation',
    name: 'VAKASHINE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316201,
  },
  {
    mmsi: 994311554,
    lng: 136.977455,
    lat: 34.628575,
    lastdyn: 1719859503,
    type: 13,
    shiptype: 'navigation',
    name: 'NAKAYAMANO1',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311554,
  },
  {
    mmsi: 994316151,
    lng: 136.990055,
    lat: 34.580362,
    lastdyn: 1719859590,
    type: 25,
    shiptype: 'navigation',
    name: 'VIRAGONO4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316151,
  },
  {
    mmsi: 994311151,
    lng: 137.031095,
    lat: 34.540318,
    lastdyn: 1719859508,
    type: 29,
    shiptype: 'navigation',
    name: 'ISEWANNO2LB',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311151,
  },
  {
    mmsi: 994316102,
    lng: 139.166667,
    lat: 34.703333,
    lastdyn: 1719859590,
    type: 29,
    shiptype: 'navigation',
    name: 'VROUTE IZU OSHIMAS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316102,
  },
  {
    mmsi: 999412149,
    lng: 119.44895,
    lat: 34.963817,
    lastdyn: 1719859842,
    type: 0,
    shiptype: 'navigation',
    name: '310 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412149,
  },
  {
    mmsi: 999412130,
    lng: 119.623805,
    lat: 34.955793,
    lastdyn: 1719859143,
    type: 29,
    shiptype: 'navigation',
    name: 'GAN YU KOU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412130,
  },
  {
    mmsi: 994121345,
    lng: 119.652427,
    lat: 34.795253,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: '26 HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121345,
  },
  {
    mmsi: 994136439,
    lng: 119.820667,
    lat: 34.817805,
    lastdyn: 1719859671,
    type: 30,
    shiptype: 'navigation',
    name: 'Q4A HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136439,
  },
  {
    mmsi: 999990126,
    lng: 119.994747,
    lat: 34.836377,
    lastdyn: 1719858840,
    type: 31,
    shiptype: 'navigation',
    name: 'HAITU 0126',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990126,
  },
  {
    mmsi: 994121343,
    lng: 119.999642,
    lat: 34.946423,
    lastdyn: 1719858577,
    type: 25,
    shiptype: 'navigation',
    name: '1 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121343,
  },
  {
    mmsi: 994126340,
    lng: 118.153333,
    lat: 31.248167,
    lastdyn: 1719859782,
    type: 30,
    shiptype: 'navigation',
    name: 'ZCC3Z',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126340,
  },
  {
    mmsi: 994121347,
    lng: 119.77622,
    lat: 34.94943,
    lastdyn: 1719858820,
    type: 30,
    shiptype: 'navigation',
    name: 'CNS CWZ',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121347,
  },
  {
    mmsi: 994121344,
    lng: 119.986333,
    lat: 34.93512,
    lastdyn: 1719858824,
    type: 24,
    shiptype: 'navigation',
    name: '2 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121344,
  },
  {
    mmsi: 994126476,
    lng: 119.86,
    lat: 34.908333,
    lastdyn: 1719859674,
    type: 28,
    shiptype: 'navigation',
    name: 'SHUIYANGSHAN 2 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126476,
  },
  {
    mmsi: 999412101,
    lng: 120.039582,
    lat: 34.960382,
    lastdyn: 1719857937,
    type: 31,
    shiptype: 'navigation',
    name: 'LIAN YUN GANG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412101,
  },
  {
    mmsi: 994136554,
    lng: 120.504092,
    lat: 34.937737,
    lastdyn: 1719859907,
    type: 28,
    shiptype: 'navigation',
    name: '2 HAO WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136554,
  },
  {
    mmsi: 992571020,
    lng: 125.064385,
    lat: 34.775088,
    lastdyn: 1719857027,
    type: 30,
    shiptype: 'navigation',
    name: 'FUGROBUOYSWLB061',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 992571020,
  },
  {
    mmsi: 994403151,
    lng: 125.693758,
    lat: 34.869925,
    lastdyn: 1719853785,
    type: 30,
    shiptype: 'navigation',
    name: 'WINDSEA17B',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403151,
  },
  {
    mmsi: 994401062,
    lng: 125.734565,
    lat: 34.965662,
    lastdyn: 1719856628,
    type: 19,
    shiptype: 'navigation',
    name: 'CHILBALDOKC',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401062,
  },
  {
    mmsi: 994403133,
    lng: 125.92317,
    lat: 34.953112,
    lastdyn: 1719853786,
    type: 0,
    shiptype: 'navigation',
    name: 'JAEUNDOJOWPA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403133,
  },
  {
    mmsi: 994403158,
    lng: 125.795388,
    lat: 34.884053,
    lastdyn: 1719854852,
    type: 30,
    shiptype: 'navigation',
    name: 'RNDSA001',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403158,
  },
  {
    mmsi: 994403134,
    lng: 125.927608,
    lat: 34.983328,
    lastdyn: 1719826574,
    type: 0,
    shiptype: 'navigation',
    name: 'JAEUNDOJOWPD',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403134,
  },
  {
    mmsi: 994403135,
    lng: 125.983823,
    lat: 34.984553,
    lastdyn: 1719851776,
    type: 0,
    shiptype: 'navigation',
    name: 'JAEUNDOJOWPH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403135,
  },
  {
    mmsi: 994406647,
    lng: 126.1735,
    lat: 34.753333,
    lastdyn: 1719849657,
    type: 0,
    shiptype: 'navigation',
    name: 'BYUNDOSYN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406647,
  },
  {
    mmsi: 994402982,
    lng: 126.049668,
    lat: 34.771442,
    lastdyn: 1719854695,
    type: 3,
    shiptype: 'navigation',
    name: 'SAMDO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402982,
  },
  {
    mmsi: 994402960,
    lng: 126.297408,
    lat: 34.762158,
    lastdyn: 1719853974,
    type: 3,
    shiptype: 'navigation',
    name: 'MOKPOGU',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402960,
  },
  {
    mmsi: 994402928,
    lng: 127.815788,
    lat: 34.798465,
    lastdyn: 1719859503,
    type: 0,
    shiptype: 'navigation',
    name: 'NA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402928,
  },
  {
    mmsi: 994402917,
    lng: 127.75992,
    lat: 34.882095,
    lastdyn: 1719859497,
    type: 3,
    shiptype: 'navigation',
    name: 'GWANGYANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402917,
  },
  {
    mmsi: 994401564,
    lng: 128.13272,
    lat: 34.88871,
    lastdyn: 1719859319,
    type: 6,
    shiptype: 'navigation',
    name: 'YOULPOMAL AIS',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401564,
  },
  {
    mmsi: 994401583,
    lng: 128.81261,
    lat: 34.966512,
    lastdyn: 1719859347,
    type: 31,
    shiptype: 'navigation',
    name: 'BUSANNEWPORTLANBY',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401583,
  },
  {
    mmsi: 994401587,
    lng: 128.989542,
    lat: 34.979612,
    lastdyn: 1719859531,
    type: 5,
    shiptype: 'navigation',
    name: 'NAMUSEOM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401587,
  },
  {
    mmsi: 994401595,
    lng: 128.973787,
    lat: 34.93297,
    lastdyn: 1719859535,
    type: 5,
    shiptype: 'navigation',
    name: 'BUKHEYONGJEDO',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401595,
  },
  {
    mmsi: 994401598,
    lng: 128.75158,
    lat: 34.895007,
    lastdyn: 1719859533,
    type: 0,
    shiptype: 'navigation',
    name: 'YANGJIAMCHWI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401598,
  },
  {
    mmsi: 994401588,
    lng: 128.829152,
    lat: 34.989478,
    lastdyn: 1719859614,
    type: 6,
    shiptype: 'navigation',
    name: 'GADEOKDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 239,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401588,
  },
  {
    mmsi: 994401594,
    lng: 128.949972,
    lat: 34.885112,
    lastdyn: 1719859524,
    type: 28,
    shiptype: 'navigation',
    name: 'NAMHYEONGJEDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401594,
  },
  {
    mmsi: 994311562,
    lng: 136.703075,
    lat: 34.930432,
    lastdyn: 1719859506,
    type: 3,
    shiptype: 'navigation',
    name: 'SHOWA YOKKAICHI SSB',
    length: 16,
    width: 16,
    left: 8,
    trail: 8,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311562,
  },
  {
    mmsi: 994316101,
    lng: 139.283333,
    lat: 34.8,
    lastdyn: 1719859590,
    type: 29,
    shiptype: 'navigation',
    name: 'VROUTE IZU OSHIMAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316101,
  },
  {
    mmsi: 994141024,
    lng: 119.384115,
    lat: 35.071187,
    lastdyn: 1719859790,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO134',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141024,
  },
  {
    mmsi: 994141016,
    lng: 119.458492,
    lat: 35.049787,
    lastdyn: 1719859670,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO120',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141016,
  },
  {
    mmsi: 994121286,
    lng: 119.474128,
    lat: 35.101257,
    lastdyn: 1719859854,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO361',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121286,
  },
  {
    mmsi: 994141021,
    lng: 119.408907,
    lat: 35.05643,
    lastdyn: 1719859794,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO128',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141021,
  },
  {
    mmsi: 994121275,
    lng: 119.37186,
    lat: 35.11715,
    lastdyn: 1719859744,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO324',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121275,
  },
  {
    mmsi: 994121272,
    lng: 119.371918,
    lat: 35.117133,
    lastdyn: 1719859909,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO319',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121272,
  },
  {
    mmsi: 994141022,
    lng: 119.407387,
    lat: 35.061125,
    lastdyn: 1719859910,
    type: 22,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO129',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141022,
  },
  {
    mmsi: 994141019,
    lng: 119.41733,
    lat: 35.05117,
    lastdyn: 1719859898,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO126',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141019,
  },
  {
    mmsi: 994136398,
    lng: 119.287555,
    lat: 35.022528,
    lastdyn: 1719859792,
    type: 25,
    shiptype: 'navigation',
    name: '323A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136398,
  },
  {
    mmsi: 994121289,
    lng: 119.433307,
    lat: 35.093035,
    lastdyn: 1719859849,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO368',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121289,
  },
  {
    mmsi: 994141014,
    lng: 119.499277,
    lat: 35.048688,
    lastdyn: 1719857754,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO114',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141014,
  },
  {
    mmsi: 994121288,
    lng: 119.43361,
    lat: 35.097355,
    lastdyn: 1719859793,
    type: 21,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO367',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121288,
  },
  {
    mmsi: 994141020,
    lng: 119.416768,
    lat: 35.056278,
    lastdyn: 1719859374,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO127',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141020,
  },
  {
    mmsi: 994141023,
    lng: 119.38601,
    lat: 35.07493,
    lastdyn: 1719859808,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO133',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141023,
  },
  {
    mmsi: 994141025,
    lng: 119.382027,
    lat: 35.077667,
    lastdyn: 1719859851,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO135',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141025,
  },
  {
    mmsi: 999412132,
    lng: 119.300655,
    lat: 35.010688,
    lastdyn: 1719859875,
    type: 25,
    shiptype: 'navigation',
    name: '321 HAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999412132,
  },
  {
    mmsi: 994126549,
    lng: 119.283055,
    lat: 35.03161,
    lastdyn: 1719859817,
    type: 25,
    shiptype: 'navigation',
    name: '327HAO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126549,
  },
  {
    mmsi: 994141013,
    lng: 119.371943,
    lat: 35.117145,
    lastdyn: 1719859853,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO113',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141013,
  },
  {
    mmsi: 994121287,
    lng: 119.475205,
    lat: 35.097088,
    lastdyn: 1719859913,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO362',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121287,
  },
  {
    mmsi: 994141015,
    lng: 119.458578,
    lat: 35.0537,
    lastdyn: 1719859794,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO119',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141015,
  },
  {
    mmsi: 994141018,
    lng: 119.42625,
    lat: 35.05447,
    lastdyn: 1719859876,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO125',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141018,
  },
  {
    mmsi: 999900246,
    lng: 91,
    lat: -42.696213,
    lastdyn: 1719859882,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 046',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900246,
  },
  {
    mmsi: 994121274,
    lng: 119.37184,
    lat: 35.11713,
    lastdyn: 1719859867,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO323',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121274,
  },
  {
    mmsi: 994131654,
    lng: 110.41739,
    lat: 21.27518,
    lastdyn: 1719859918,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHAN JIANG GANG 69',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131654,
  },
  {
    mmsi: 994131656,
    lng: 119.66668,
    lat: 35.21765,
    lastdyn: 1719859448,
    type: 25,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S19',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131656,
  },
  {
    mmsi: 994121277,
    lng: 119.682745,
    lat: 35.117343,
    lastdyn: 1719858941,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHAN PORTNO332',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121277,
  },
  {
    mmsi: 994141012,
    lng: 119.540375,
    lat: 35.04777,
    lastdyn: 1719858891,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO108',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141012,
  },
  {
    mmsi: 994121279,
    lng: 119.64107,
    lat: 35.11325,
    lastdyn: 1719858686,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO338',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121279,
  },
  {
    mmsi: 994121281,
    lng: 119.599357,
    lat: 35.109277,
    lastdyn: 1719859002,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO344',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121281,
  },
  {
    mmsi: 994121282,
    lng: 119.55766,
    lat: 35.1097,
    lastdyn: 1719858706,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO349',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121282,
  },
  {
    mmsi: 994121280,
    lng: 119.598585,
    lat: 35.113582,
    lastdyn: 1719858941,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO343',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121280,
  },
  {
    mmsi: 994141010,
    lng: 119.581018,
    lat: 35.046278,
    lastdyn: 1719857326,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHAN PORTNO102',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141010,
  },
  {
    mmsi: 994121285,
    lng: 119.516073,
    lat: 35.100983,
    lastdyn: 1719858700,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO356',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121285,
  },
  {
    mmsi: 994121284,
    lng: 119.515628,
    lat: 35.105625,
    lastdyn: 1719859006,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO355',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121284,
  },
  {
    mmsi: 994141011,
    lng: 119.540538,
    lat: 35.051148,
    lastdyn: 1719858964,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO107',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141011,
  },
  {
    mmsi: 994141009,
    lng: 119.581168,
    lat: 35.049837,
    lastdyn: 1719857986,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO101',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141009,
  },
  {
    mmsi: 994121278,
    lng: 119.640362,
    lat: 35.117798,
    lastdyn: 1719859002,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO337',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121278,
  },
  {
    mmsi: 994121276,
    lng: 119.681883,
    lat: 35.121917,
    lastdyn: 1719858882,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO331',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121276,
  },
  {
    mmsi: 994131658,
    lng: 119.62997,
    lat: 35.23302,
    lastdyn: 1719859494,
    type: 25,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S25',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131658,
  },
  {
    mmsi: 994121283,
    lng: 119.557947,
    lat: 35.105267,
    lastdyn: 1719856366,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO350',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121283,
  },
  {
    mmsi: 994131650,
    lng: 119.7769,
    lat: 35.17177,
    lastdyn: 1719857792,
    type: 25,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S01',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131650,
  },
  {
    mmsi: 994121268,
    lng: 119.862125,
    lat: 35.109113,
    lastdyn: 1719859602,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO307',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121268,
  },
  {
    mmsi: 994121271,
    lng: 119.818965,
    lat: 35.110143,
    lastdyn: 1719858941,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO314',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121271,
  },
  {
    mmsi: 994121269,
    lng: 119.860795,
    lat: 35.104337,
    lastdyn: 1719859001,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO308',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121269,
  },
  {
    mmsi: 994141105,
    lng: 119.945332,
    lat: 35.18677,
    lastdyn: 1719858961,
    type: 30,
    shiptype: 'navigation',
    name: 'RZCEFENG 1',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141105,
  },
  {
    mmsi: 994121267,
    lng: 119.902485,
    lat: 35.098813,
    lastdyn: 1719858701,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO302',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121267,
  },
  {
    mmsi: 994131651,
    lng: 119.77492,
    lat: 35.1685,
    lastdyn: 1719856474,
    type: 24,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S02',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131651,
  },
  {
    mmsi: 994121273,
    lng: 119.776975,
    lat: 35.115473,
    lastdyn: 1719858881,
    type: 24,
    shiptype: 'navigation',
    name: 'LANSHAN PORTNO320',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121273,
  },
  {
    mmsi: 994121270,
    lng: 119.82006,
    lat: 35.11474,
    lastdyn: 1719854757,
    type: 25,
    shiptype: 'navigation',
    name: 'LANSHANPORTNO313',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121270,
  },
  {
    mmsi: 994126439,
    lng: 120.025167,
    lat: 35.044055,
    lastdyn: 1719859834,
    type: 29,
    shiptype: 'navigation',
    name: 'LYG WAI',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126439,
  },
  {
    mmsi: 999991718,
    lng: 120.089507,
    lat: 35.151717,
    lastdyn: 1719857701,
    type: 24,
    shiptype: 'navigation',
    name: 'QF107',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991718,
  },
  {
    mmsi: 994141106,
    lng: 120.30255,
    lat: 35.215818,
    lastdyn: 1719858427,
    type: 30,
    shiptype: 'navigation',
    name: 'RZCEFENG 2',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141106,
  },
  {
    mmsi: 999991005,
    lng: 121.683407,
    lat: 35.232697,
    lastdyn: 1719858430,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 1005',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991005,
  },
  {
    mmsi: 999000074,
    lng: 122.006062,
    lat: 35.147192,
    lastdyn: 1719782419,
    type: 31,
    shiptype: 'navigation',
    name: 'QF113',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000074,
  },
  {
    mmsi: 994136556,
    lng: 122.35239,
    lat: 35.044578,
    lastdyn: 1719859913,
    type: 28,
    shiptype: 'navigation',
    name: '3 HAO WRECK HOU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136556,
  },
  {
    mmsi: 994136555,
    lng: 122.352915,
    lat: 35.057602,
    lastdyn: 1719859910,
    type: 28,
    shiptype: 'navigation',
    name: '3 HAO WRECK QIAN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136555,
  },
  {
    mmsi: 994401056,
    lng: 125.66876,
    lat: 35.138673,
    lastdyn: 1719858058,
    type: 0,
    shiptype: 'navigation',
    name: 'SOHEOSADOJNDC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401056,
  },
  {
    mmsi: 994403120,
    lng: 125.699083,
    lat: 35.227313,
    lastdyn: 1719858997,
    type: 0,
    shiptype: 'navigation',
    name: 'SOBICHIDOYOUTOP',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403120,
  },
  {
    mmsi: 994401061,
    lng: 125.761958,
    lat: 35.053628,
    lastdyn: 1719856081,
    type: 19,
    shiptype: 'navigation',
    name: 'BUNAMKEPCO',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401061,
  },
  {
    mmsi: 994403112,
    lng: 125.784775,
    lat: 35.13499,
    lastdyn: 1719859010,
    type: 19,
    shiptype: 'navigation',
    name: 'SOHEOSADOSFWT',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403112,
  },
  {
    mmsi: 994402976,
    lng: 125.987962,
    lat: 35.10308,
    lastdyn: 1719849700,
    type: 0,
    shiptype: 'navigation',
    name: 'DAENOROKDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402976,
  },
  {
    mmsi: 994401601,
    lng: 128.672547,
    lat: 35.075688,
    lastdyn: 1719858775,
    type: 0,
    shiptype: 'navigation',
    name: 'DOCHINYEO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401601,
  },
  {
    mmsi: 994401620,
    lng: 128.620068,
    lat: 35.02092,
    lastdyn: 1719859176,
    type: 0,
    shiptype: 'navigation',
    name: 'KOHYUNJOONGANG3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401620,
  },
  {
    mmsi: 994401611,
    lng: 128.600058,
    lat: 35.137562,
    lastdyn: 1719859323,
    type: 6,
    shiptype: 'navigation',
    name: 'MAKGYEDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 246,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401611,
  },
  {
    mmsi: 994401603,
    lng: 128.672278,
    lat: 35.04683,
    lastdyn: 1719858829,
    type: 31,
    shiptype: 'navigation',
    name: 'GOHYENHANGRO4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401603,
  },
  {
    mmsi: 994401025,
    lng: 128.78522,
    lat: 35.077615,
    lastdyn: 1719859524,
    type: 3,
    shiptype: 'navigation',
    name: 'ATONSTATION',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401025,
  },
  {
    mmsi: 994401586,
    lng: 128.972773,
    lat: 35.02775,
    lastdyn: 1719859525,
    type: 5,
    shiptype: 'navigation',
    name: 'SEODO',
    length: 200,
    width: 72,
    left: 36,
    trail: 100,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401586,
  },
  {
    mmsi: 994401584,
    lng: 128.788758,
    lat: 35.024172,
    lastdyn: 1719859350,
    type: 31,
    shiptype: 'navigation',
    name: 'NEW PORT CENTER C',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401584,
  },
  {
    mmsi: 994406113,
    lng: 128.790167,
    lat: 35.071138,
    lastdyn: 1719856633,
    type: 29,
    shiptype: 'navigation',
    name: 'VNEWPORTSAFE1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406113,
  },
  {
    mmsi: 994406187,
    lng: 128.784417,
    lat: 35.060417,
    lastdyn: 1719859551,
    type: 29,
    shiptype: 'navigation',
    name: 'VNEWPORTSAFE2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406187,
  },
  {
    mmsi: 994406200,
    lng: 129.058333,
    lat: 35.1125,
    lastdyn: 1719859518,
    type: 0,
    shiptype: 'navigation',
    name: 'VIRBUSAN PORT TS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994406200,
  },
  {
    mmsi: 994401576,
    lng: 129.06498,
    lat: 35.105527,
    lastdyn: 1719859623,
    type: 0,
    shiptype: 'navigation',
    name: 'BUSANHABORBRIDGE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401576,
  },
  {
    mmsi: 994401641,
    lng: 129.032675,
    lat: 35.079652,
    lastdyn: 1719859535,
    type: 2,
    shiptype: 'navigation',
    name: 'NAMHANG BRIDGE AIS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 200,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401641,
  },
  {
    mmsi: 994401597,
    lng: 129.131455,
    lat: 35.066482,
    lastdyn: 1719859555,
    type: 31,
    shiptype: 'navigation',
    name: 'BUSANHANG LANBY',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401597,
  },
  {
    mmsi: 994401591,
    lng: 129.20312,
    lat: 35.157687,
    lastdyn: 1719859158,
    type: 10,
    shiptype: 'navigation',
    name: 'GYOSEOKCHU',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401591,
  },
  {
    mmsi: 994401578,
    lng: 129.126975,
    lat: 35.091243,
    lastdyn: 1719859521,
    type: 6,
    shiptype: 'navigation',
    name: 'ORYUKDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401578,
  },
  {
    mmsi: 994401579,
    lng: 129.022472,
    lat: 35.032475,
    lastdyn: 1719859533,
    type: 31,
    shiptype: 'navigation',
    name: 'GAMCHEONHANGLANBY',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401579,
  },
  {
    mmsi: 994401596,
    lng: 129.093027,
    lat: 35.037192,
    lastdyn: 1719859530,
    type: 6,
    shiptype: 'navigation',
    name: 'SAENGDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401596,
  },
  {
    mmsi: 994401589,
    lng: 129.093022,
    lat: 35.037187,
    lastdyn: 1719854511,
    type: 10,
    shiptype: 'navigation',
    name: 'AENGDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401589,
  },
  {
    mmsi: 994316106,
    lng: 139.740833,
    lat: 35.097222,
    lastdyn: 1719859591,
    type: 29,
    shiptype: 'navigation',
    name: 'VTOKYOWANNO1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316106,
  },
  {
    mmsi: 994316108,
    lng: 139.764722,
    lat: 35.173888,
    lastdyn: 1719859592,
    type: 29,
    shiptype: 'navigation',
    name: 'VTOKYOWANNO3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316108,
  },
  {
    mmsi: 994311101,
    lng: 139.776577,
    lat: 35.211848,
    lastdyn: 1719859578,
    type: 18,
    shiptype: 'navigation',
    name: 'URAGACENTERNO1LB',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 1,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311101,
  },
  {
    mmsi: 994316107,
    lng: 139.752778,
    lat: 35.135555,
    lastdyn: 1719859592,
    type: 29,
    shiptype: 'navigation',
    name: 'VTOKYOWANNO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316107,
  },
  {
    mmsi: 994131666,
    lng: 119.52986,
    lat: 35.270102,
    lastdyn: 1719820454,
    type: 24,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S42',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131666,
  },
  {
    mmsi: 999900250,
    lng: 119.540323,
    lat: 35.36886,
    lastdyn: 1719859882,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 050',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900250,
  },
  {
    mmsi: 994141007,
    lng: 119.541418,
    lat: 35.363318,
    lastdyn: 1719859783,
    type: 30,
    shiptype: 'navigation',
    name: 'RIZHAOPORTNO120',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141007,
  },
  {
    mmsi: 994131664,
    lng: 119.554307,
    lat: 35.260078,
    lastdyn: 1719859876,
    type: 24,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S38',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131664,
  },
  {
    mmsi: 994131606,
    lng: 119.534038,
    lat: 35.33888,
    lastdyn: 1719859900,
    type: 30,
    shiptype: 'navigation',
    name: 'QD W6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131606,
  },
  {
    mmsi: 994131663,
    lng: 119.556147,
    lat: 35.263165,
    lastdyn: 1719859823,
    type: 25,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S37',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131663,
  },
  {
    mmsi: 994141003,
    lng: 119.57406,
    lat: 35.328247,
    lastdyn: 1719858415,
    type: 24,
    shiptype: 'navigation',
    name: 'RIZHAO PORT NO108',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141003,
  },
  {
    mmsi: 994141001,
    lng: 119.613812,
    lat: 35.311803,
    lastdyn: 1719857036,
    type: 24,
    shiptype: 'navigation',
    name: 'RIZHAOPORTNO102',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141001,
  },
  {
    mmsi: 994141002,
    lng: 119.575848,
    lat: 35.33143,
    lastdyn: 1719859604,
    type: 25,
    shiptype: 'navigation',
    name: 'RIZHAOPORT107',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141002,
  },
  {
    mmsi: 994141004,
    lng: 119.55793,
    lat: 35.33886,
    lastdyn: 1719859870,
    type: 25,
    shiptype: 'navigation',
    name: 'RIZHAO PORT 111',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141004,
  },
  {
    mmsi: 994141000,
    lng: 119.615493,
    lat: 35.314975,
    lastdyn: 1719859893,
    type: 25,
    shiptype: 'navigation',
    name: 'RIZHAO PORT NO101',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141000,
  },
  {
    mmsi: 994131665,
    lng: 119.535353,
    lat: 35.274415,
    lastdyn: 1719859840,
    type: 25,
    shiptype: 'navigation',
    name: 'SHIJIU PORT S41',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131665,
  },
  {
    mmsi: 994141005,
    lng: 119.55448,
    lat: 35.33632,
    lastdyn: 1719859711,
    type: 24,
    shiptype: 'navigation',
    name: 'RIZHAO PORT 112',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141005,
  },
  {
    mmsi: 994131600,
    lng: 120.476238,
    lat: 36.00692,
    lastdyn: 1719859803,
    type: 25,
    shiptype: 'navigation',
    name: 'QDPORTNO9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131600,
  },
  {
    mmsi: 999900278,
    lng: 119.53401,
    lat: 35.332502,
    lastdyn: 1719859884,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 078',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900278,
  },
  {
    mmsi: 994141006,
    lng: 119.53911,
    lat: 35.34703,
    lastdyn: 1719859800,
    type: 24,
    shiptype: 'navigation',
    name: 'RIZHAO PORT 116',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141006,
  },
  {
    mmsi: 994121214,
    lng: 119.89727,
    lat: 35.402908,
    lastdyn: 1719822580,
    type: 24,
    shiptype: 'navigation',
    name: 'DJK PORT NO128',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121214,
  },
  {
    mmsi: 994121213,
    lng: 119.90542,
    lat: 35.408375,
    lastdyn: 1719826296,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO127',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121213,
  },
  {
    mmsi: 994126202,
    lng: 119.884722,
    lat: 35.323333,
    lastdyn: 1719859787,
    type: 28,
    shiptype: 'navigation',
    name: 'LURISHANYU63388 WREC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126202,
  },
  {
    mmsi: 994121211,
    lng: 119.946765,
    lat: 35.370323,
    lastdyn: 1719822577,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO123',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121211,
  },
  {
    mmsi: 994121210,
    lng: 119.97983,
    lat: 35.32588,
    lastdyn: 1719831693,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO120',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121210,
  },
  {
    mmsi: 994121220,
    lng: 119.81184,
    lat: 35.485927,
    lastdyn: 1719750100,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO142',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121220,
  },
  {
    mmsi: 994121212,
    lng: 119.938147,
    lat: 35.364285,
    lastdyn: 1719827794,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO124',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121212,
  },
  {
    mmsi: 994121217,
    lng: 119.843325,
    lat: 35.462643,
    lastdyn: 1719753626,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO135',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121217,
  },
  {
    mmsi: 994136604,
    lng: 116.20407,
    lat: 22.783905,
    lastdyn: 1719859892,
    type: 19,
    shiptype: 'navigation',
    name: 'HOUHU WIND FARM V1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136604,
  },
  {
    mmsi: 994403140,
    lng: 125.21128,
    lat: 35.307462,
    lastdyn: 1719854812,
    type: 30,
    shiptype: 'navigation',
    name: 'ANMADO YG GLORY D',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403140,
  },
  {
    mmsi: 994403139,
    lng: 125.115487,
    lat: 35.355512,
    lastdyn: 1719854846,
    type: 30,
    shiptype: 'navigation',
    name: 'ANMADO YG GLORY C',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403139,
  },
  {
    mmsi: 994403138,
    lng: 125.179395,
    lat: 35.431063,
    lastdyn: 1719854813,
    type: 30,
    shiptype: 'navigation',
    name: 'ANMADO YG GLORY B',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403138,
  },
  {
    mmsi: 992571017,
    lng: 125.402857,
    lat: 35.422237,
    lastdyn: 1719854820,
    type: 30,
    shiptype: 'navigation',
    name: 'FUGRO SWLB066',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 992571017,
  },
  {
    mmsi: 994403131,
    lng: 125.30394,
    lat: 35.365183,
    lastdyn: 1719854823,
    type: 3,
    shiptype: 'navigation',
    name: 'ANMADOHOLIMFL',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403131,
  },
  {
    mmsi: 994403130,
    lng: 125.28854,
    lat: 35.454385,
    lastdyn: 1719854837,
    type: 3,
    shiptype: 'navigation',
    name: 'ANMADOGONGCHIFL',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403130,
  },
  {
    mmsi: 992571198,
    lng: 125.513043,
    lat: 35.423608,
    lastdyn: 1719851573,
    type: 30,
    shiptype: 'navigation',
    name: 'FUGRO SWLB067',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 992571198,
  },
  {
    mmsi: 994403128,
    lng: 125.881495,
    lat: 35.45673,
    lastdyn: 1719856630,
    type: 19,
    shiptype: 'navigation',
    name: 'BUOY00HWYC02',
    length: 5,
    width: 3,
    left: 2,
    trail: 4,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403128,
  },
  {
    mmsi: 994403670,
    lng: 126.340433,
    lat: 35.481847,
    lastdyn: 1719831252,
    type: 0,
    shiptype: 'navigation',
    name: 'GOCHANGHAESANGAIS',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403670,
  },
  {
    mmsi: 994403671,
    lng: 126.29376,
    lat: 35.47683,
    lastdyn: 1719820560,
    type: 0,
    shiptype: 'navigation',
    name: 'GOCHANGHAESANGAIS2',
    length: 30,
    width: 30,
    left: 15,
    trail: 15,
    offsetstatus: 0,
    atonstatus: 233,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403671,
  },
  {
    mmsi: 994401644,
    lng: 129.398693,
    lat: 35.466842,
    lastdyn: 1719859536,
    type: 30,
    shiptype: 'navigation',
    name: 'HLD AISB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401644,
  },
  {
    mmsi: 994401048,
    lng: 129.393045,
    lat: 35.386273,
    lastdyn: 1719859533,
    type: 28,
    shiptype: 'navigation',
    name: 'ULSANKNOC',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401048,
  },
  {
    mmsi: 994401562,
    lng: 129.388885,
    lat: 35.498332,
    lastdyn: 1719859519,
    type: 14,
    shiptype: 'navigation',
    name: 'JANG SAENG PO 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401562,
  },
  {
    mmsi: 994401643,
    lng: 129.3997,
    lat: 35.464377,
    lastdyn: 1719859554,
    type: 30,
    shiptype: 'navigation',
    name: 'HLD AISA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401643,
  },
  {
    mmsi: 994401546,
    lng: 129.442917,
    lat: 35.492777,
    lastdyn: 1719859501,
    type: 3,
    shiptype: 'navigation',
    name: 'ULGILH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401546,
  },
  {
    mmsi: 994401639,
    lng: 129.393412,
    lat: 35.438802,
    lastdyn: 1719859517,
    type: 5,
    shiptype: 'navigation',
    name: 'SKSPMA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401639,
  },
  {
    mmsi: 994401633,
    lng: 129.393263,
    lat: 35.42953,
    lastdyn: 1719859523,
    type: 0,
    shiptype: 'navigation',
    name: 'SKSPMB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401633,
  },
  {
    mmsi: 994402346,
    lng: 129.354445,
    lat: 35.458055,
    lastdyn: 1719859534,
    type: 0,
    shiptype: 'navigation',
    name: 'VIRONSANPORTOTK',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402346,
  },
  {
    mmsi: 994406222,
    lng: 129.352203,
    lat: 35.456582,
    lastdyn: 1719859552,
    type: 0,
    shiptype: 'navigation',
    name: 'ONSANPORTOTK1AIS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994406222,
  },
  {
    mmsi: 994401557,
    lng: 129.39578,
    lat: 35.487755,
    lastdyn: 1719859504,
    type: 3,
    shiptype: 'navigation',
    name: 'ULSANHANG2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401557,
  },
  {
    mmsi: 994401561,
    lng: 129.388323,
    lat: 35.49573,
    lastdyn: 1719859549,
    type: 13,
    shiptype: 'navigation',
    name: 'JANGSAENGPO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 199,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401561,
  },
  {
    mmsi: 994401631,
    lng: 129.3931,
    lat: 35.396608,
    lastdyn: 1719859547,
    type: 28,
    shiptype: 'navigation',
    name: 'SOILSPMB',
    length: 12,
    width: 12,
    left: 6,
    trail: 6,
    offsetstatus: 0,
    atonstatus: 199,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401631,
  },
  {
    mmsi: 994401556,
    lng: 129.392623,
    lat: 35.487517,
    lastdyn: 1719859541,
    type: 29,
    shiptype: 'navigation',
    name: 'ULSAN HANG1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401556,
  },
  {
    mmsi: 994401636,
    lng: 129.395422,
    lat: 35.407083,
    lastdyn: 1719859544,
    type: 3,
    shiptype: 'navigation',
    name: 'SOILSPMA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401636,
  },
  {
    mmsi: 994401552,
    lng: 129.38144,
    lat: 35.389308,
    lastdyn: 1719820643,
    type: 3,
    shiptype: 'navigation',
    name: 'ULSAN SIN4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401552,
  },
  {
    mmsi: 994401563,
    lng: 129.436832,
    lat: 35.364132,
    lastdyn: 1719859503,
    type: 3,
    shiptype: 'navigation',
    name: 'ULSANHANGLAMBY',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401563,
  },
  {
    mmsi: 994311558,
    lng: 139.76763,
    lat: 35.467215,
    lastdyn: 1719859501,
    type: 3,
    shiptype: 'navigation',
    name: 'KAWASAKI SEABERTH',
    length: 12,
    width: 12,
    left: 6,
    trail: 6,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994311558,
  },
  {
    mmsi: 994121255,
    lng: 119.747132,
    lat: 35.575473,
    lastdyn: 1719742717,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNOL8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121255,
  },
  {
    mmsi: 994121250,
    lng: 119.75949,
    lat: 35.55578,
    lastdyn: 1719859751,
    type: 22,
    shiptype: 'navigation',
    name: 'PORTNOL1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121250,
  },
  {
    mmsi: 994121256,
    lng: 119.75094,
    lat: 35.57834,
    lastdyn: 1719852842,
    type: 22,
    shiptype: 'navigation',
    name: 'PORTNOL10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121256,
  },
  {
    mmsi: 994121227,
    lng: 119.800308,
    lat: 35.552032,
    lastdyn: 1719859532,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO208',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121227,
  },
  {
    mmsi: 994121233,
    lng: 119.774602,
    lat: 35.526892,
    lastdyn: 1719748825,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO303',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121233,
  },
  {
    mmsi: 994121234,
    lng: 119.779303,
    lat: 35.623,
    lastdyn: 1719859712,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO303',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121234,
  },
  {
    mmsi: 994121219,
    lng: 119.779312,
    lat: 35.623015,
    lastdyn: 1719859774,
    type: 30,
    shiptype: 'navigation',
    name: 'DJKPORTNO141',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121219,
  },
  {
    mmsi: 994121235,
    lng: 119.768303,
    lat: 35.541507,
    lastdyn: 1719828932,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO305',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121235,
  },
  {
    mmsi: 994121231,
    lng: 119.80444,
    lat: 35.562633,
    lastdyn: 1719858692,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO213',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121231,
  },
  {
    mmsi: 994121221,
    lng: 119.779315,
    lat: 35.623032,
    lastdyn: 1719859894,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO147',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121221,
  },
  {
    mmsi: 994121266,
    lng: 119.779287,
    lat: 35.622992,
    lastdyn: 1719859895,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO000',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121266,
  },
  {
    mmsi: 994141033,
    lng: 119.922967,
    lat: 35.616,
    lastdyn: 1719754108,
    type: 30,
    shiptype: 'navigation',
    name: 'CMECTESTAREANO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141033,
  },
  {
    mmsi: 994121232,
    lng: 119.804243,
    lat: 35.575467,
    lastdyn: 1719859836,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO215',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121232,
  },
  {
    mmsi: 994121229,
    lng: 119.795738,
    lat: 35.557807,
    lastdyn: 1719853536,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO210',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121229,
  },
  {
    mmsi: 994121252,
    lng: 119.755412,
    lat: 35.566885,
    lastdyn: 1719858635,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTL3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121252,
  },
  {
    mmsi: 994121225,
    lng: 119.774512,
    lat: 35.562745,
    lastdyn: 1719830078,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO158',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121225,
  },
  {
    mmsi: 994121224,
    lng: 119.784172,
    lat: 35.532337,
    lastdyn: 1719823174,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO152',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121224,
  },
  {
    mmsi: 994121251,
    lng: 119.755523,
    lat: 35.553268,
    lastdyn: 1719851737,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTL2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121251,
  },
  {
    mmsi: 994141034,
    lng: 119.93195,
    lat: 35.616317,
    lastdyn: 1719644594,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141034,
  },
  {
    mmsi: 999900242,
    lng: 119.770535,
    lat: 35.571698,
    lastdyn: 1719741680,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 042',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900242,
  },
  {
    mmsi: 994121236,
    lng: 119.769092,
    lat: 35.556067,
    lastdyn: 1719859898,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO307',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121236,
  },
  {
    mmsi: 994141035,
    lng: 119.93125,
    lat: 35.618467,
    lastdyn: 1719670898,
    type: 30,
    shiptype: 'navigation',
    name: 'CMECTESTAREANO4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141035,
  },
  {
    mmsi: 994121230,
    lng: 119.808487,
    lat: 35.557532,
    lastdyn: 1719859896,
    type: 25,
    shiptype: 'navigation',
    name: 'DJKPORTNO211',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121230,
  },
  {
    mmsi: 994121218,
    lng: 119.779332,
    lat: 35.62302,
    lastdyn: 1719859893,
    type: 24,
    shiptype: 'navigation',
    name: 'DJKPORTNO136',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121218,
  },
  {
    mmsi: 994121299,
    lng: 120.030438,
    lat: 35.639705,
    lastdyn: 1719749792,
    type: 21,
    shiptype: 'navigation',
    name: 'DJKPORTNOQSL',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121299,
  },
  {
    mmsi: 999900310,
    lng: 120.15742,
    lat: 35.744902,
    lastdyn: 1719771278,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 110',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900310,
  },
  {
    mmsi: 994126203,
    lng: 120.251667,
    lat: 35.615,
    lastdyn: 1719859894,
    type: 28,
    shiptype: 'navigation',
    name: 'HONGPU6 WRECK PA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126203,
  },
  {
    mmsi: 994403137,
    lng: 125.207877,
    lat: 35.520043,
    lastdyn: 1719854812,
    type: 30,
    shiptype: 'navigation',
    name: 'ANMADO YG GLORY A',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403137,
  },
  {
    mmsi: 994403129,
    lng: 125.358577,
    lat: 35.523847,
    lastdyn: 1719854822,
    type: 3,
    shiptype: 'navigation',
    name: 'ANMADOKUMSANFL',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403129,
  },
  {
    mmsi: 992571194,
    lng: 125.511228,
    lat: 35.513702,
    lastdyn: 1719850672,
    type: 30,
    shiptype: 'navigation',
    name: 'FUGRO SWLB064',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 992571194,
  },
  {
    mmsi: 994403654,
    lng: 126.107083,
    lat: 35.662155,
    lastdyn: 1719859201,
    type: 0,
    shiptype: 'navigation',
    name: 'SANGWANGDEUNGDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403654,
  },
  {
    mmsi: 994403658,
    lng: 126.363375,
    lat: 35.619083,
    lastdyn: 1719844147,
    type: 8,
    shiptype: 'navigation',
    name: 'HEUKSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 124,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403658,
  },
  {
    mmsi: 994402349,
    lng: 129.489735,
    lat: 35.625867,
    lastdyn: 1719859006,
    type: 30,
    shiptype: 'navigation',
    name: 'DNOWF',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402349,
  },
  {
    mmsi: 994401551,
    lng: 129.473848,
    lat: 35.566885,
    lastdyn: 1719859331,
    type: 31,
    shiptype: 'navigation',
    name: 'EDUKSEO LB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401551,
  },
  {
    mmsi: 994401637,
    lng: 129.392305,
    lat: 35.514752,
    lastdyn: 1719859623,
    type: 25,
    shiptype: 'navigation',
    name: 'VIRTUALULSAN14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994401637,
  },
  {
    mmsi: 994316110,
    lng: 139.802043,
    lat: 35.579797,
    lastdyn: 1719859591,
    type: 14,
    shiptype: 'navigation',
    name: 'VTOKYOWESTNO6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316110,
  },
  {
    mmsi: 999992423,
    lng: 116.522793,
    lat: 35.884197,
    lastdyn: 1719859866,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST 023',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992423,
  },
  {
    mmsi: 994121208,
    lng: 120.164558,
    lat: 35.885033,
    lastdyn: 1719858982,
    type: 3,
    shiptype: 'navigation',
    name: 'LAOLINGSHI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121208,
  },
  {
    mmsi: 994121297,
    lng: 120.13759,
    lat: 35.76393,
    lastdyn: 1719809228,
    type: 30,
    shiptype: 'navigation',
    name: 'LINGSHAN G NO3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121297,
  },
  {
    mmsi: 994121207,
    lng: 120.161083,
    lat: 35.892038,
    lastdyn: 1719858802,
    type: 3,
    shiptype: 'navigation',
    name: 'YUMINGZUI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121207,
  },
  {
    mmsi: 994121206,
    lng: 120.161712,
    lat: 35.910853,
    lastdyn: 1719857296,
    type: 3,
    shiptype: 'navigation',
    name: 'ANGUSHI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121206,
  },
  {
    mmsi: 999900265,
    lng: 120.161698,
    lat: 35.910883,
    lastdyn: 1719843582,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 065',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900265,
  },
  {
    mmsi: 994121298,
    lng: 120.17324,
    lat: 35.84338,
    lastdyn: 1719821202,
    type: 30,
    shiptype: 'navigation',
    name: 'CHUANCHANG NO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121298,
  },
  {
    mmsi: 999999004,
    lng: 120.23201,
    lat: 35.912813,
    lastdyn: 1719858881,
    type: 31,
    shiptype: 'navigation',
    name: '233',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999004,
  },
  {
    mmsi: 994121203,
    lng: 120.327765,
    lat: 35.990835,
    lastdyn: 1719859895,
    type: 3,
    shiptype: 'navigation',
    name: 'DA QIAO DAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121203,
  },
  {
    mmsi: 994131630,
    lng: 120.343332,
    lat: 35.928675,
    lastdyn: 1719859832,
    type: 25,
    shiptype: 'navigation',
    name: 'QD 507',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131630,
  },
  {
    mmsi: 994131607,
    lng: 120.479513,
    lat: 35.997103,
    lastdyn: 1719859767,
    type: 30,
    shiptype: 'navigation',
    name: 'QD W7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131607,
  },
  {
    mmsi: 999062419,
    lng: 120.257427,
    lat: 35.911075,
    lastdyn: 1719859462,
    type: 31,
    shiptype: 'navigation',
    name: 'QDYUYEWEATHER',
    length: 4,
    width: 4,
    left: 2,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999062419,
  },
  {
    mmsi: 994131605,
    lng: 113.20904,
    lat: 21.91062,
    lastdyn: 1719859905,
    type: 0,
    shiptype: 'navigation',
    name: 'GAO LAN 21',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131605,
  },
  {
    mmsi: 994403651,
    lng: 126.222427,
    lat: 35.989465,
    lastdyn: 1719859206,
    type: 0,
    shiptype: 'navigation',
    name: 'SIPIDONGPA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403651,
  },
  {
    mmsi: 994403661,
    lng: 126.37217,
    lat: 35.8262,
    lastdyn: 1719859440,
    type: 3,
    shiptype: 'navigation',
    name: 'HUKDOLB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 198,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403661,
  },
  {
    mmsi: 994403664,
    lng: 126.315167,
    lat: 35.858222,
    lastdyn: 1719852593,
    type: 3,
    shiptype: 'navigation',
    name: 'MALDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 242,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403664,
  },
  {
    mmsi: 994403660,
    lng: 126.641305,
    lat: 35.983267,
    lastdyn: 1719711902,
    type: 3,
    shiptype: 'navigation',
    name: 'BYOUNG HO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 226,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403660,
  },
  {
    mmsi: 994403659,
    lng: 126.608103,
    lat: 35.980465,
    lastdyn: 1719859321,
    type: 17,
    shiptype: 'navigation',
    name: 'GUNSANEULHO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403659,
  },
  {
    mmsi: 994403594,
    lng: 129.54019,
    lat: 35.928977,
    lastdyn: 1719828546,
    type: 28,
    shiptype: 'navigation',
    name: 'SEOK MA AM LB',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403594,
  },
  {
    mmsi: 994403569,
    lng: 129.511405,
    lat: 35.807265,
    lastdyn: 1719859569,
    type: 5,
    shiptype: 'navigation',
    name: 'SONGDAEMAL LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403569,
  },
  {
    mmsi: 994403593,
    lng: 129.573827,
    lat: 35.991705,
    lastdyn: 1719827998,
    type: 28,
    shiptype: 'navigation',
    name: 'SARAMAL LB',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403593,
  },
  {
    mmsi: 994131620,
    lng: 120.234172,
    lat: 36.066615,
    lastdyn: 1719859851,
    type: 25,
    shiptype: 'navigation',
    name: 'QD205',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131620,
  },
  {
    mmsi: 994131622,
    lng: 120.222287,
    lat: 36.07652,
    lastdyn: 1719859715,
    type: 25,
    shiptype: 'navigation',
    name: 'QD 222',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131622,
  },
  {
    mmsi: 994126210,
    lng: 120.242083,
    lat: 36.028917,
    lastdyn: 1719859917,
    type: 25,
    shiptype: 'navigation',
    name: 'QINGDAO PORT QW4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126210,
  },
  {
    mmsi: 994126204,
    lng: 120.246667,
    lat: 36.029722,
    lastdyn: 1719859914,
    type: 24,
    shiptype: 'navigation',
    name: 'QINGDAO PORT QW3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126204,
  },
  {
    mmsi: 994131619,
    lng: 120.237222,
    lat: 36.06381,
    lastdyn: 1719859767,
    type: 24,
    shiptype: 'navigation',
    name: 'QD 204',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131619,
  },
  {
    mmsi: 994126211,
    lng: 120.236583,
    lat: 36.024138,
    lastdyn: 1719859740,
    type: 25,
    shiptype: 'navigation',
    name: 'QINGDAO PORT QW6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126211,
  },
  {
    mmsi: 994131635,
    lng: 120.332398,
    lat: 36.002472,
    lastdyn: 1719859910,
    type: 31,
    shiptype: 'navigation',
    name: 'QD 518',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131635,
  },
  {
    mmsi: 994121204,
    lng: 120.254458,
    lat: 36.023787,
    lastdyn: 1719859783,
    type: 3,
    shiptype: 'navigation',
    name: 'AN HU SHI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 225,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121204,
  },
  {
    mmsi: 999990641,
    lng: 120.414695,
    lat: 27.028355,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'NDGC641',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990641,
  },
  {
    mmsi: 994131634,
    lng: 113.6748,
    lat: 22.18252,
    lastdyn: 1719859869,
    type: 29,
    shiptype: 'navigation',
    name: 'QING ZHOU 2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131634,
  },
  {
    mmsi: 994126207,
    lng: 120.378708,
    lat: 36.052462,
    lastdyn: 1719859749,
    type: 24,
    shiptype: 'navigation',
    name: 'QD AFL2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126207,
  },
  {
    mmsi: 994131626,
    lng: 120.257322,
    lat: 36.031253,
    lastdyn: 1719859886,
    type: 24,
    shiptype: 'navigation',
    name: 'QD 301',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131626,
  },
  {
    mmsi: 994131612,
    lng: 113.60739,
    lat: 22.80657,
    lastdyn: 1719859891,
    type: 24,
    shiptype: 'navigation',
    name: 'GUANG ZHOU GANG 55',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131612,
  },
  {
    mmsi: 994131616,
    lng: 120.28218,
    lat: 36.084937,
    lastdyn: 1719859886,
    type: 24,
    shiptype: 'navigation',
    name: 'QD PORT108',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131616,
  },
  {
    mmsi: 994121205,
    lng: 120.289638,
    lat: 36.076618,
    lastdyn: 1719859819,
    type: 3,
    shiptype: 'navigation',
    name: 'MA TI JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121205,
  },
  {
    mmsi: 999900282,
    lng: 120.3032,
    lat: 36.076657,
    lastdyn: 1719857401,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 082',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900282,
  },
  {
    mmsi: 994131618,
    lng: 120.29701,
    lat: 36.07995,
    lastdyn: 1719859807,
    type: 20,
    shiptype: 'navigation',
    name: 'QINGDAO PORT MN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131618,
  },
  {
    mmsi: 994131625,
    lng: 120.258283,
    lat: 36.06757,
    lastdyn: 1719859842,
    type: 31,
    shiptype: 'navigation',
    name: 'QD ZHONG SHA JIAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131625,
  },
  {
    mmsi: 994131613,
    lng: 120.276727,
    lat: 36.074512,
    lastdyn: 1719859765,
    type: 24,
    shiptype: 'navigation',
    name: 'QD 104',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131613,
  },
  {
    mmsi: 994131610,
    lng: 114.69174,
    lat: 22.58276,
    lastdyn: 1719859871,
    type: 15,
    shiptype: 'navigation',
    name: 'MA BIAN ZHOU 121',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131610,
  },
  {
    mmsi: 994121237,
    lng: 120.301925,
    lat: 36.050655,
    lastdyn: 1719859887,
    type: 3,
    shiptype: 'navigation',
    name: 'QING DAO HSA PIER BE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121237,
  },
  {
    mmsi: 994131603,
    lng: 120.274315,
    lat: 36.024175,
    lastdyn: 1719859884,
    type: 24,
    shiptype: 'navigation',
    name: 'QD 20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131603,
  },
  {
    mmsi: 994131615,
    lng: 120.288455,
    lat: 36.081178,
    lastdyn: 1719859885,
    type: 25,
    shiptype: 'navigation',
    name: 'QD 107',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131615,
  },
  {
    mmsi: 994131602,
    lng: 120.339053,
    lat: 36.032848,
    lastdyn: 1719859828,
    type: 25,
    shiptype: 'navigation',
    name: 'QD 17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131602,
  },
  {
    mmsi: 994131614,
    lng: 120.285532,
    lat: 36.07846,
    lastdyn: 1719859828,
    type: 25,
    shiptype: 'navigation',
    name: 'QD 105',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131614,
  },
  {
    mmsi: 999900292,
    lng: 120.29731,
    lat: 36.070985,
    lastdyn: 1719859871,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 092',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900292,
  },
  {
    mmsi: 999900244,
    lng: 120.306913,
    lat: 36.0853,
    lastdyn: 1719859771,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 044',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900244,
  },
  {
    mmsi: 994126209,
    lng: 120.378112,
    lat: 36.054292,
    lastdyn: 1719859743,
    type: 24,
    shiptype: 'navigation',
    name: 'QD AFL6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126209,
  },
  {
    mmsi: 994121201,
    lng: 120.441933,
    lat: 36.050282,
    lastdyn: 1719859622,
    type: 31,
    shiptype: 'navigation',
    name: '',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121201,
  },
  {
    mmsi: 994126208,
    lng: 120.381138,
    lat: 36.055745,
    lastdyn: 1719859752,
    type: 22,
    shiptype: 'navigation',
    name: 'QD AFL4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126208,
  },
  {
    mmsi: 990000101,
    lng: 120.31376,
    lat: 36.08422,
    lastdyn: 1719857519,
    type: 24,
    shiptype: 'navigation',
    name: 'QDTEST211101',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 990000101,
  },
  {
    mmsi: 994126206,
    lng: 120.378888,
    lat: 36.050303,
    lastdyn: 1719859746,
    type: 24,
    shiptype: 'navigation',
    name: 'QD AFL1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126206,
  },
  {
    mmsi: 994131601,
    lng: 120.40734,
    lat: 36.020252,
    lastdyn: 1719859771,
    type: 25,
    shiptype: 'navigation',
    name: 'QD 13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131601,
  },
  {
    mmsi: 999900248,
    lng: 120.81663,
    lat: 36.2335,
    lastdyn: 1719859725,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 048',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900248,
  },
  {
    mmsi: 994121295,
    lng: 120.8167,
    lat: 36.23349,
    lastdyn: 1719859867,
    type: 3,
    shiptype: 'navigation',
    name: 'MAERDAO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121295,
  },
  {
    mmsi: 994126215,
    lng: 120.31405,
    lat: 36.083983,
    lastdyn: 1692440311,
    type: 25,
    shiptype: 'navigation',
    name: 'QINGDAO PORT NO11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126215,
  },
  {
    mmsi: 994126214,
    lng: 120.31405,
    lat: 36.084017,
    lastdyn: 1692526172,
    type: 30,
    shiptype: 'navigation',
    name: 'Q',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126214,
  },
  {
    mmsi: 994401064,
    lng: 124.706552,
    lat: 36.003138,
    lastdyn: 1719856094,
    type: 0,
    shiptype: 'navigation',
    name: 'MTIDE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401064,
  },
  {
    mmsi: 994403650,
    lng: 125.997797,
    lat: 36.10584,
    lastdyn: 1719858040,
    type: 0,
    shiptype: 'navigation',
    name: 'GAJINSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403650,
  },
  {
    mmsi: 994403663,
    lng: 125.968438,
    lat: 36.12524,
    lastdyn: 1719858269,
    type: 6,
    shiptype: 'navigation',
    name: 'EOCHEONGDOLH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 199,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403663,
  },
  {
    mmsi: 994401060,
    lng: 126.222672,
    lat: 36.217738,
    lastdyn: 1719858449,
    type: 3,
    shiptype: 'navigation',
    name: 'HANWHA DAEHWASADO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401060,
  },
  {
    mmsi: 994403652,
    lng: 126.435943,
    lat: 36.081145,
    lastdyn: 1719859431,
    type: 0,
    shiptype: 'navigation',
    name: 'YEONDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403652,
  },
  {
    mmsi: 994403577,
    lng: 129.453705,
    lat: 36.037892,
    lastdyn: 1719482221,
    type: 0,
    shiptype: 'navigation',
    name: 'POHANGSINHANG BUOY2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403577,
  },
  {
    mmsi: 994403592,
    lng: 129.453897,
    lat: 36.091133,
    lastdyn: 1719857704,
    type: 13,
    shiptype: 'navigation',
    name: 'YEONGILMANHANGS LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 230,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403592,
  },
  {
    mmsi: 994403576,
    lng: 129.446203,
    lat: 36.028962,
    lastdyn: 1719796175,
    type: 0,
    shiptype: 'navigation',
    name: 'POHANGSINHANG BUOYC',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403576,
  },
  {
    mmsi: 994403578,
    lng: 129.454832,
    lat: 36.025618,
    lastdyn: 1719450546,
    type: 24,
    shiptype: 'navigation',
    name: 'POHANGSINHANG BUOY3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403578,
  },
  {
    mmsi: 994403573,
    lng: 129.431773,
    lat: 36.02741,
    lastdyn: 1719828362,
    type: 14,
    shiptype: 'navigation',
    name: 'POHANGSINHANGN LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403573,
  },
  {
    mmsi: 994403575,
    lng: 129.456545,
    lat: 36.033722,
    lastdyn: 1719795961,
    type: 29,
    shiptype: 'navigation',
    name: 'POHANGSIN HANG B LB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403575,
  },
  {
    mmsi: 994403579,
    lng: 129.476675,
    lat: 36.07798,
    lastdyn: 1719826567,
    type: 31,
    shiptype: 'navigation',
    name: 'YEONGILMANHANG LANBY',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403579,
  },
  {
    mmsi: 994403568,
    lng: 129.464102,
    lat: 36.089307,
    lastdyn: 1719828366,
    type: 14,
    shiptype: 'navigation',
    name: 'YEONGILMANHANGN LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403568,
  },
  {
    mmsi: 994403590,
    lng: 129.375198,
    lat: 36.052053,
    lastdyn: 1719828900,
    type: 0,
    shiptype: 'navigation',
    name: 'MOFPOHANGATONCS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403590,
  },
  {
    mmsi: 994403574,
    lng: 129.466288,
    lat: 36.038398,
    lastdyn: 1719765540,
    type: 29,
    shiptype: 'navigation',
    name: 'POHANGSIN HANG A LB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403574,
  },
  {
    mmsi: 994406859,
    lng: 129.557778,
    lat: 36.09125,
    lastdyn: 1719828360,
    type: 17,
    shiptype: 'navigation',
    name: 'SYNTHETICGYOSUKCHO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406859,
  },
  {
    mmsi: 994403591,
    lng: 129.56925,
    lat: 36.077502,
    lastdyn: 1719827845,
    type: 0,
    shiptype: 'navigation',
    name: 'HOMIGOT LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403591,
  },
  {
    mmsi: 994406860,
    lng: 129.52,
    lat: 36.096112,
    lastdyn: 1719823678,
    type: 0,
    shiptype: 'navigation',
    name: 'VIRTUALDEPTH188M',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406860,
  },
  {
    mmsi: 999992209,
    lng: 120.669593,
    lat: 36.34309,
    lastdyn: 1719859505,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON 2209',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999992209,
  },
  {
    mmsi: 999900264,
    lng: 120.9278,
    lat: 36.40258,
    lastdyn: 1719824874,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 064',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900264,
  },
  {
    mmsi: 999900293,
    lng: 120.86451,
    lat: 36.37476,
    lastdyn: 1719785695,
    type: 0,
    shiptype: 'navigation',
    name: 'WF XIN AB 093',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999900293,
  },
  {
    mmsi: 994121291,
    lng: 120.88476,
    lat: 36.36517,
    lastdyn: 1719853870,
    type: 3,
    shiptype: 'navigation',
    name: 'YAQUESHI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121291,
  },
  {
    mmsi: 994121294,
    lng: 120.811673,
    lat: 36.36131,
    lastdyn: 1719785532,
    type: 28,
    shiptype: 'navigation',
    name: 'DONGJIAOISOLATE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121294,
  },
  {
    mmsi: 999131401,
    lng: 120.871062,
    lat: 36.365562,
    lastdyn: 1719854314,
    type: 24,
    shiptype: 'navigation',
    name: 'QF114',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999131401,
  },
  {
    mmsi: 994121007,
    lng: 120.854363,
    lat: 36.371605,
    lastdyn: 1719857148,
    type: 3,
    shiptype: 'navigation',
    name: 'NVDAO LB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121007,
  },
  {
    mmsi: 994141044,
    lng: 121.23284,
    lat: 36.36395,
    lastdyn: 1719824723,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A69',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141044,
  },
  {
    mmsi: 994141040,
    lng: 121.2472,
    lat: 36.41662,
    lastdyn: 1719828980,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A46',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141040,
  },
  {
    mmsi: 994141037,
    lng: 121.22283,
    lat: 36.47709,
    lastdyn: 1719859639,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141037,
  },
  {
    mmsi: 999000050,
    lng: 121.235785,
    lat: 36.423008,
    lastdyn: 1719830852,
    type: 31,
    shiptype: 'navigation',
    name: 'QF105',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000050,
  },
  {
    mmsi: 994141042,
    lng: 121.19995,
    lat: 36.39755,
    lastdyn: 1719826587,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A57',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141042,
  },
  {
    mmsi: 994141039,
    lng: 121.19989,
    lat: 36.43874,
    lastdyn: 1719833840,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A27',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141039,
  },
  {
    mmsi: 999062430,
    lng: 121.339925,
    lat: 36.282657,
    lastdyn: 1719828200,
    type: 31,
    shiptype: 'navigation',
    name: 'QF101',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999062430,
  },
  {
    mmsi: 994121239,
    lng: 121.37527,
    lat: 36.38164,
    lastdyn: 1719836018,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS3 WINDFARM A01',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121239,
  },
  {
    mmsi: 994141036,
    lng: 121.2579,
    lat: 36.47617,
    lastdyn: 1719836118,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141036,
  },
  {
    mmsi: 994121242,
    lng: 121.38326,
    lat: 36.35643,
    lastdyn: 1719830057,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS3 WINDFARM A58',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121242,
  },
  {
    mmsi: 994141038,
    lng: 121.27185,
    lat: 36.4623,
    lastdyn: 1719840940,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141038,
  },
  {
    mmsi: 994121243,
    lng: 121.43101,
    lat: 36.38026,
    lastdyn: 1719859833,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS3 WINDFARM BS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121243,
  },
  {
    mmsi: 994141041,
    lng: 121.2721,
    lat: 36.4219,
    lastdyn: 1719825634,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM A49',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141041,
  },
  {
    mmsi: 994141045,
    lng: 121.25245,
    lat: 36.44176,
    lastdyn: 1719859434,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS V WINDFARM SS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141045,
  },
  {
    mmsi: 994121241,
    lng: 121.53174,
    lat: 36.41144,
    lastdyn: 1719849433,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS3 WINDFARM A30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121241,
  },
  {
    mmsi: 994121248,
    lng: 121.525085,
    lat: 36.461383,
    lastdyn: 1719859880,
    type: 19,
    shiptype: 'navigation',
    name: 'SDS 4 WINDFARM 58',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121248,
  },
  {
    mmsi: 994141104,
    lng: 121.65775,
    lat: 36.474383,
    lastdyn: 1719858643,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS U2 WIND FARM SS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141104,
  },
  {
    mmsi: 994141050,
    lng: 121.685333,
    lat: 36.489267,
    lastdyn: 1719810712,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS U2 WIND FARM A1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141050,
  },
  {
    mmsi: 994141102,
    lng: 121.701667,
    lat: 36.44385,
    lastdyn: 1719827383,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS U2 WIND FARM A52',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141102,
  },
  {
    mmsi: 994121240,
    lng: 121.527277,
    lat: 36.429167,
    lastdyn: 1719859802,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS3 WINDFARM A29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121240,
  },
  {
    mmsi: 994136624,
    lng: 122.6585,
    lat: 36.463467,
    lastdyn: 1719859758,
    type: 28,
    shiptype: 'navigation',
    name: 'LIAODANYU23862 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136624,
  },
  {
    mmsi: 994402675,
    lng: 126.472988,
    lat: 36.32004,
    lastdyn: 1719858426,
    type: 25,
    shiptype: 'navigation',
    name: 'SONYEOCHO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402675,
  },
  {
    mmsi: 994403572,
    lng: 129.392805,
    lat: 36.354385,
    lastdyn: 1719550824,
    type: 5,
    shiptype: 'navigation',
    name: 'GANGGUHANGN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403572,
  },
  {
    mmsi: 994141027,
    lng: 121.65899,
    lat: 36.58822,
    lastdyn: 1719855421,
    type: 30,
    shiptype: 'navigation',
    name: 'SDS U1 WINDFARM S6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141027,
  },
  {
    mmsi: 994126213,
    lng: 119.330527,
    lat: 35.439363,
    lastdyn: 1697054240,
    type: 1,
    shiptype: 'navigation',
    name: 'TECVPLAR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126213,
  },
  {
    mmsi: 994126212,
    lng: 122.83,
    lat: 30.615555,
    lastdyn: 1688437163,
    type: 30,
    shiptype: 'navigation',
    name: 'MAANLIEDAODAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126212,
  },
  {
    mmsi: 994512009,
    lng: 122.266667,
    lat: 36.733332,
    lastdyn: 1716102968,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI09',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512009,
  },
  {
    mmsi: 994512016,
    lng: 122.266667,
    lat: 36.707407,
    lastdyn: 1716103699,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI16',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512016,
  },
  {
    mmsi: 994512005,
    lng: 122.25,
    lat: 36.714813,
    lastdyn: 1716103036,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI05',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512005,
  },
  {
    mmsi: 994512023,
    lng: 122.253333,
    lat: 36.699998,
    lastdyn: 1716103415,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI23',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512023,
  },
  {
    mmsi: 994512020,
    lng: 122.26,
    lat: 36.733332,
    lastdyn: 1716101377,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI20',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512020,
  },
  {
    mmsi: 994512010,
    lng: 122.266667,
    lat: 36.729628,
    lastdyn: 1716102979,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI10',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512010,
  },
  {
    mmsi: 994512004,
    lng: 122.25,
    lat: 36.718518,
    lastdyn: 1716103044,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI04',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512004,
  },
  {
    mmsi: 994512003,
    lng: 122.25,
    lat: 36.722222,
    lastdyn: 1716103201,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI03',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512003,
  },
  {
    mmsi: 994512014,
    lng: 122.266667,
    lat: 36.714813,
    lastdyn: 1716101913,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI14',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512014,
  },
  {
    mmsi: 994512017,
    lng: 122.266667,
    lat: 36.703703,
    lastdyn: 1716101375,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI17',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512017,
  },
  {
    mmsi: 994512019,
    lng: 122.256667,
    lat: 36.733332,
    lastdyn: 1716103309,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI19',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512019,
  },
  {
    mmsi: 994512006,
    lng: 122.25,
    lat: 36.71111,
    lastdyn: 1716103027,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI06',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512006,
  },
  {
    mmsi: 994512001,
    lng: 122.25,
    lat: 36.729628,
    lastdyn: 1716103455,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI01',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512001,
  },
  {
    mmsi: 994512018,
    lng: 122.253333,
    lat: 36.733332,
    lastdyn: 1716103160,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI18',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512018,
  },
  {
    mmsi: 994512002,
    lng: 122.25,
    lat: 36.725925,
    lastdyn: 1716101898,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI02',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512002,
  },
  {
    mmsi: 994512024,
    lng: 122.256667,
    lat: 36.699998,
    lastdyn: 1716102517,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI24',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512024,
  },
  {
    mmsi: 994512011,
    lng: 122.266667,
    lat: 36.725925,
    lastdyn: 1716101367,
    type: 0,
    shiptype: 'navigation',
    name: 'MARI11',
    length: 19,
    width: 15,
    left: 8,
    trail: 9,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994512011,
  },
  {
    mmsi: 994126216,
    lng: 122.716667,
    lat: 30.615555,
    lastdyn: 1688437328,
    type: 30,
    shiptype: 'navigation',
    name: 'MAANLIEDAODAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126216,
  },
  {
    mmsi: 994136531,
    lng: 122.919383,
    lat: 36.727017,
    lastdyn: 1719859779,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136531,
  },
  {
    mmsi: 994401065,
    lng: 125.787448,
    lat: 36.737547,
    lastdyn: 1719858430,
    type: 3,
    shiptype: 'navigation',
    name: 'TAEANMETMAST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401065,
  },
  {
    mmsi: 994402651,
    lng: 126.008372,
    lat: 36.647198,
    lastdyn: 1719856639,
    type: 5,
    shiptype: 'navigation',
    name: 'ONGDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402651,
  },
  {
    mmsi: 994403585,
    lng: 129.462038,
    lat: 36.680702,
    lastdyn: 1719859133,
    type: 6,
    shiptype: 'navigation',
    name: 'HUPO LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403585,
  },
  {
    mmsi: 994403570,
    lng: 129.45109,
    lat: 36.507403,
    lastdyn: 1719849654,
    type: 5,
    shiptype: 'navigation',
    name: 'CHUKSANHANG LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403570,
  },
  {
    mmsi: 994403587,
    lng: 129.732308,
    lat: 36.719085,
    lastdyn: 1719809276,
    type: 17,
    shiptype: 'navigation',
    name: 'WANGDOLCHOLB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403587,
  },
  {
    mmsi: 994146087,
    lng: 119.0995,
    lat: 36.860667,
    lastdyn: 1719859740,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST SGG1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146087,
  },
  {
    mmsi: 994126159,
    lng: 122.471617,
    lat: 36.872217,
    lastdyn: 1719859801,
    type: 11,
    shiptype: 'navigation',
    name: 'SHI DAO S1 LIGHTED B',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126159,
  },
  {
    mmsi: 994126155,
    lng: 122.513722,
    lat: 36.780888,
    lastdyn: 1719859748,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK LIAOPANYU 2528',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126155,
  },
  {
    mmsi: 994126161,
    lng: 122.573333,
    lat: 36.82,
    lastdyn: 1719859821,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK PA LUWEIYU 606',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126161,
  },
  {
    mmsi: 994136508,
    lng: 122.836833,
    lat: 36.828667,
    lastdyn: 1719859914,
    type: 28,
    shiptype: 'navigation',
    name: 'DALVBU 1030 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136508,
  },
  {
    mmsi: 994126162,
    lng: 122.768667,
    lat: 36.868388,
    lastdyn: 1719859911,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK LIAODAZHONG YU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126162,
  },
  {
    mmsi: 994402690,
    lng: 125.97861,
    lat: 36.772755,
    lastdyn: 1719859878,
    type: 3,
    shiptype: 'navigation',
    name: 'GADAEAM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402690,
  },
  {
    mmsi: 994401017,
    lng: 125.787008,
    lat: 36.92868,
    lastdyn: 1719859515,
    type: 6,
    shiptype: 'navigation',
    name: 'MOKDEOKDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401017,
  },
  {
    mmsi: 994401036,
    lng: 125.853682,
    lat: 36.969385,
    lastdyn: 1719859154,
    type: 0,
    shiptype: 'navigation',
    name: 'BANSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401036,
  },
  {
    mmsi: 994402692,
    lng: 126.150678,
    lat: 36.894702,
    lastdyn: 1719859884,
    type: 0,
    shiptype: 'navigation',
    name: 'SINDOTASEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402692,
  },
  {
    mmsi: 994401012,
    lng: 126.80156,
    lat: 36.98099,
    lastdyn: 1719858436,
    type: 24,
    shiptype: 'navigation',
    name: 'PYEONGTAEKDANGIN14',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401012,
  },
  {
    mmsi: 994401052,
    lng: 126.838258,
    lat: 36.951158,
    lastdyn: 1719858602,
    type: 29,
    shiptype: 'navigation',
    name: 'SEOHAEDAEGYO2HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401052,
  },
  {
    mmsi: 994401051,
    lng: 126.842363,
    lat: 36.953125,
    lastdyn: 1719858780,
    type: 0,
    shiptype: 'navigation',
    name: 'SEOHAEDAEGYO1HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401051,
  },
  {
    mmsi: 994403571,
    lng: 129.417847,
    lat: 36.894322,
    lastdyn: 1719791362,
    type: 5,
    shiptype: 'navigation',
    name: 'JIMMIMAL LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403571,
  },
  {
    mmsi: 994121185,
    lng: 119.41393,
    lat: 37.24605,
    lastdyn: 1719859873,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANGYI F29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121185,
  },
  {
    mmsi: 994121188,
    lng: 119.486532,
    lat: 37.24844,
    lastdyn: 1719859743,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANGYI BOOSTER STAT',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121188,
  },
  {
    mmsi: 994146086,
    lng: 119.514167,
    lat: 37.011333,
    lastdyn: 1719859770,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST SGG2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146086,
  },
  {
    mmsi: 994121198,
    lng: 119.692488,
    lat: 37.238542,
    lastdyn: 1719859749,
    type: 30,
    shiptype: 'navigation',
    name: 'LZ WIND F16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121198,
  },
  {
    mmsi: 994121196,
    lng: 119.564322,
    lat: 37.22792,
    lastdyn: 1719859809,
    type: 30,
    shiptype: 'navigation',
    name: 'LZ WIND F1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121196,
  },
  {
    mmsi: 994121197,
    lng: 119.671067,
    lat: 37.228305,
    lastdyn: 1719859869,
    type: 30,
    shiptype: 'navigation',
    name: 'LZ WIND F15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121197,
  },
  {
    mmsi: 994121199,
    lng: 119.566643,
    lat: 37.2445,
    lastdyn: 1719859813,
    type: 30,
    shiptype: 'navigation',
    name: 'LZ WIND F29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121199,
  },
  {
    mmsi: 994126107,
    lng: 122.983233,
    lat: 37.054632,
    lastdyn: 1719859842,
    type: 28,
    shiptype: 'navigation',
    name: 'LIAOCHANGYUYUN 15001',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126107,
  },
  {
    mmsi: 994401070,
    lng: 124.7588,
    lat: 37.148188,
    lastdyn: 1719858604,
    type: 19,
    shiptype: 'navigation',
    name: '994401070',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401070,
  },
  {
    mmsi: 994401071,
    lng: 129.346585,
    lat: 35.517892,
    lastdyn: 1719813936,
    type: 30,
    shiptype: 'navigation',
    name: 'RWE A',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401071,
  },
  {
    mmsi: 994401028,
    lng: 126.18005,
    lat: 37.156642,
    lastdyn: 1719859782,
    type: 0,
    shiptype: 'navigation',
    name: 'SEOSUDO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401028,
  },
  {
    mmsi: 994401034,
    lng: 126.073612,
    lat: 37.059532,
    lastdyn: 1719859764,
    type: 0,
    shiptype: 'navigation',
    name: 'WOODUAM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401034,
  },
  {
    mmsi: 994401019,
    lng: 126.193905,
    lat: 37.208225,
    lastdyn: 1719859911,
    type: 28,
    shiptype: 'navigation',
    name: 'SOYADO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401019,
  },
  {
    mmsi: 994401021,
    lng: 126.091575,
    lat: 37.213657,
    lastdyn: 1719859166,
    type: 29,
    shiptype: 'navigation',
    name: 'SEOPORI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401021,
  },
  {
    mmsi: 994402863,
    lng: 126.39647,
    lat: 37.032897,
    lastdyn: 1719859893,
    type: 25,
    shiptype: 'navigation',
    name: 'DAESANHANG19HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402863,
  },
  {
    mmsi: 994401037,
    lng: 126.416623,
    lat: 37.156302,
    lastdyn: 1719859891,
    type: 0,
    shiptype: 'navigation',
    name: 'MUDANGSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401037,
  },
  {
    mmsi: 994402691,
    lng: 126.29257,
    lat: 37.07603,
    lastdyn: 1719859896,
    type: 0,
    shiptype: 'navigation',
    name: 'JANGANSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402691,
  },
  {
    mmsi: 994402869,
    lng: 126.37799,
    lat: 37.059007,
    lastdyn: 1719859887,
    type: 3,
    shiptype: 'navigation',
    name: 'DAESAN31HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402869,
  },
  {
    mmsi: 994406106,
    lng: 126.4161,
    lat: 37.230833,
    lastdyn: 1719859849,
    type: 17,
    shiptype: 'navigation',
    name: 'VIRTUALWRECKSHIP14',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406106,
  },
  {
    mmsi: 994402879,
    lng: 126.321408,
    lat: 37.04161,
    lastdyn: 1719859161,
    type: 31,
    shiptype: 'navigation',
    name: 'DAESANHANG22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402879,
  },
  {
    mmsi: 994402640,
    lng: 126.345192,
    lat: 37.032253,
    lastdyn: 1719859873,
    type: 28,
    shiptype: 'navigation',
    name: 'HYUNDAI OIL SPM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402640,
  },
  {
    mmsi: 994401067,
    lng: 126.420753,
    lat: 37.01976,
    lastdyn: 1719859789,
    type: 0,
    shiptype: 'navigation',
    name: 'DAESANHANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401067,
  },
  {
    mmsi: 994402873,
    lng: 126.269787,
    lat: 37.006863,
    lastdyn: 1719859885,
    type: 3,
    shiptype: 'navigation',
    name: 'JANG AN TEOI A',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402873,
  },
  {
    mmsi: 994401000,
    lng: 126.41938,
    lat: 37.218165,
    lastdyn: 1719859871,
    type: 29,
    shiptype: 'navigation',
    name: 'DONGSUDO12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401000,
  },
  {
    mmsi: 994401002,
    lng: 126.385612,
    lat: 37.115963,
    lastdyn: 1719859861,
    type: 6,
    shiptype: 'navigation',
    name: 'PUNGDOLH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 228,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401002,
  },
  {
    mmsi: 994401041,
    lng: 126.343832,
    lat: 37.168377,
    lastdyn: 1719859894,
    type: 29,
    shiptype: 'navigation',
    name: 'DONGSOODO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401041,
  },
  {
    mmsi: 994401014,
    lng: 126.348035,
    lat: 37.14955,
    lastdyn: 1719859706,
    type: 0,
    shiptype: 'navigation',
    name: 'BUDO AIS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401014,
  },
  {
    mmsi: 994401035,
    lng: 126.353987,
    lat: 37.226075,
    lastdyn: 1719859693,
    type: 29,
    shiptype: 'navigation',
    name: 'HANGSEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401035,
  },
  {
    mmsi: 994400001,
    lng: 126.34715,
    lat: 37.149747,
    lastdyn: 1719859863,
    type: 3,
    shiptype: 'navigation',
    name: 'GYOUNGINHANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994400001,
  },
  {
    mmsi: 994402877,
    lng: 126.343657,
    lat: 37.045565,
    lastdyn: 1719859889,
    type: 7,
    shiptype: 'navigation',
    name: 'JANG AN TEOIE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994402877,
  },
  {
    mmsi: 994401003,
    lng: 126.528858,
    lat: 37.14245,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'ASANMAN01',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 13,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401003,
  },
  {
    mmsi: 994401042,
    lng: 126.539715,
    lat: 37.10867,
    lastdyn: 1719859904,
    type: 3,
    shiptype: 'navigation',
    name: 'IPPADO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401042,
  },
  {
    mmsi: 994401008,
    lng: 126.64892,
    lat: 37.060543,
    lastdyn: 1719859896,
    type: 0,
    shiptype: 'navigation',
    name: 'ASANMAN26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401008,
  },
  {
    mmsi: 994401010,
    lng: 126.682713,
    lat: 37.033403,
    lastdyn: 1719859374,
    type: 0,
    shiptype: 'navigation',
    name: 'ASANMAN34HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 4,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401010,
  },
  {
    mmsi: 994401007,
    lng: 126.658113,
    lat: 37.067557,
    lastdyn: 1719859891,
    type: 25,
    shiptype: 'navigation',
    name: 'ASANMAN25HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401007,
  },
  {
    mmsi: 994401006,
    lng: 126.594822,
    lat: 37.098782,
    lastdyn: 1719859727,
    type: 25,
    shiptype: 'navigation',
    name: 'ASANMAN14HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401006,
  },
  {
    mmsi: 994401004,
    lng: 126.520088,
    lat: 37.127693,
    lastdyn: 1719859864,
    type: 0,
    shiptype: 'navigation',
    name: 'ASANMAN02',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401004,
  },
  {
    mmsi: 994401043,
    lng: 126.622138,
    lat: 37.179483,
    lastdyn: 1719859870,
    type: 24,
    shiptype: 'navigation',
    name: 'JEBUDOHANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401043,
  },
  {
    mmsi: 994406120,
    lng: 126.723847,
    lat: 37.010292,
    lastdyn: 1719859726,
    type: 0,
    shiptype: 'navigation',
    name: 'BANGDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994406120,
  },
  {
    mmsi: 994401011,
    lng: 126.728495,
    lat: 37.002075,
    lastdyn: 1719859329,
    type: 14,
    shiptype: 'navigation',
    name: 'PYEONGTAEKDANGJIN3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401011,
  },
  {
    mmsi: 994401005,
    lng: 126.603112,
    lat: 37.107488,
    lastdyn: 1719859896,
    type: 0,
    shiptype: 'navigation',
    name: 'ASANMAN13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401005,
  },
  {
    mmsi: 994401009,
    lng: 126.692622,
    lat: 37.038315,
    lastdyn: 1719859539,
    type: 3,
    shiptype: 'navigation',
    name: 'ASANMAN33',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401009,
  },
  {
    mmsi: 994403586,
    lng: 129.42899,
    lat: 37.058172,
    lastdyn: 1719857711,
    type: 5,
    shiptype: 'navigation',
    name: 'JUGBYOUN LH',
    length: 10,
    width: 2,
    left: 1,
    trail: 5,
    offsetstatus: 0,
    atonstatus: 230,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403586,
  },
  {
    mmsi: 994403807,
    lng: 129.345215,
    lat: 37.224858,
    lastdyn: 1719809297,
    type: 14,
    shiptype: 'navigation',
    name: 'IMWONHANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 243,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403807,
  },
  {
    mmsi: 994403584,
    lng: 131.869912,
    lat: 37.239368,
    lastdyn: 1719859173,
    type: 0,
    shiptype: 'navigation',
    name: 'DOKDO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403584,
  },
  {
    mmsi: 994121149,
    lng: 119.188497,
    lat: 37.254,
    lastdyn: 1719859871,
    type: 26,
    shiptype: 'navigation',
    name: 'WF PORT NO58',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121149,
  },
  {
    mmsi: 994121148,
    lng: 119.186963,
    lat: 37.255407,
    lastdyn: 1719859882,
    type: 25,
    shiptype: 'navigation',
    name: 'WF PORT NO57',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121148,
  },
  {
    mmsi: 994136533,
    lng: 119.237063,
    lat: 37.29228,
    lastdyn: 1719859777,
    type: 28,
    shiptype: 'navigation',
    name: 'WEIFANG PORT WRECK N',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136533,
  },
  {
    mmsi: 994121150,
    lng: 119.183935,
    lat: 37.250248,
    lastdyn: 1719859884,
    type: 20,
    shiptype: 'navigation',
    name: 'WF PORT NO60',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121150,
  },
  {
    mmsi: 994136532,
    lng: 119.146667,
    lat: 37.313333,
    lastdyn: 1719859774,
    type: 28,
    shiptype: 'navigation',
    name: 'UNKNOWN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136532,
  },
  {
    mmsi: 994121145,
    lng: 119.413208,
    lat: 37.4208,
    lastdyn: 1719735488,
    type: 24,
    shiptype: 'navigation',
    name: 'WF PORT NO26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121145,
  },
  {
    mmsi: 994121144,
    lng: 119.411515,
    lat: 37.4224,
    lastdyn: 1719711378,
    type: 25,
    shiptype: 'navigation',
    name: 'WF PORT NO25',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121144,
  },
  {
    mmsi: 994121146,
    lng: 119.296782,
    lat: 37.337305,
    lastdyn: 1719849980,
    type: 25,
    shiptype: 'navigation',
    name: 'WF PORT NO41',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121146,
  },
  {
    mmsi: 994126156,
    lng: 119.361667,
    lat: 37.496667,
    lastdyn: 1719859771,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK JILEYUYUN 0001',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994126156,
  },
  {
    mmsi: 994121183,
    lng: 119.408032,
    lat: 37.268027,
    lastdyn: 1719859886,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANGYI F49',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121183,
  },
  {
    mmsi: 994121181,
    lng: 119.409445,
    lat: 37.29023,
    lastdyn: 1719859785,
    type: 30,
    shiptype: 'navigation',
    name: 'CHANGYI F11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121181,
  },
  {
    mmsi: 994121147,
    lng: 119.298393,
    lat: 37.335877,
    lastdyn: 1719859869,
    type: 24,
    shiptype: 'navigation',
    name: 'WF PORT NO42',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121147,
  },
  {
    mmsi: 994121200,
    lng: 119.562627,
    lat: 37.261005,
    lastdyn: 1719859873,
    type: 30,
    shiptype: 'navigation',
    name: 'LZ WIND F30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121200,
  },
  {
    mmsi: 994141052,
    lng: 119.668478,
    lat: 37.25798,
    lastdyn: 1719859809,
    type: 30,
    shiptype: 'navigation',
    name: 'LZ WIND F41',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141052,
  },
  {
    mmsi: 999993018,
    lng: 119.651152,
    lat: 37.288637,
    lastdyn: 1719828730,
    type: 31,
    shiptype: 'navigation',
    name: 'ATON 3018',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999993018,
  },
  {
    mmsi: 994141051,
    lng: 119.648855,
    lat: 37.26129,
    lastdyn: 1719859749,
    type: 30,
    shiptype: 'navigation',
    name: 'LZ WIND F39',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141051,
  },
  {
    mmsi: 994136537,
    lng: 119.755833,
    lat: 37.465167,
    lastdyn: 1719859843,
    type: 28,
    shiptype: 'navigation',
    name: 'LAIZHOU PORT UNKNOWN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136537,
  },
  {
    mmsi: 994131503,
    lng: 119.886078,
    lat: 37.4637,
    lastdyn: 1719859812,
    type: 7,
    shiptype: 'navigation',
    name: 'YANTAILAIZHOU SD03',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131503,
  },
  {
    mmsi: 994131504,
    lng: 122.507823,
    lat: 37.44497,
    lastdyn: 1719859831,
    type: 7,
    shiptype: 'navigation',
    name: 'WEIHAIRONGCHENG04',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131504,
  },
  {
    mmsi: 994126157,
    lng: 122.509583,
    lat: 37.468583,
    lastdyn: 1719859770,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK YUHONGXIANG 6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126157,
  },
  {
    mmsi: 994126154,
    lng: 122.790083,
    lat: 37.320945,
    lastdyn: 1719859740,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK LIAOHUYU 35473',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126154,
  },
  {
    mmsi: 994126119,
    lng: 123.020367,
    lat: 37.264112,
    lastdyn: 1719859756,
    type: 28,
    shiptype: 'navigation',
    name: 'QIONGCHANGYU20318 WR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126119,
  },
  {
    mmsi: 994401074,
    lng: 129.346182,
    lat: 35.517968,
    lastdyn: 1719813936,
    type: 30,
    shiptype: 'navigation',
    name: 'RWE D',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401074,
  },
  {
    mmsi: 994401073,
    lng: 129.346162,
    lat: 35.518128,
    lastdyn: 1719818229,
    type: 30,
    shiptype: 'navigation',
    name: 'RWE C',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401073,
  },
  {
    mmsi: 994401066,
    lng: 125.917798,
    lat: 37.372787,
    lastdyn: 1719859203,
    type: 19,
    shiptype: 'navigation',
    name: '994401066',
    length: 2,
    width: 1,
    left: 0,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401066,
  },
  {
    mmsi: 994401023,
    lng: 126.222662,
    lat: 37.328037,
    lastdyn: 1719859913,
    type: 0,
    shiptype: 'navigation',
    name: 'CHOCHIAM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401023,
  },
  {
    mmsi: 994401015,
    lng: 126.077572,
    lat: 37.287323,
    lastdyn: 1719859902,
    type: 24,
    shiptype: 'navigation',
    name: 'SEONMIDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401015,
  },
  {
    mmsi: 994401001,
    lng: 126.236812,
    lat: 37.277552,
    lastdyn: 1719859888,
    type: 25,
    shiptype: 'navigation',
    name: 'SEOSUDO5HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401001,
  },
  {
    mmsi: 994401039,
    lng: 126.303227,
    lat: 37.485017,
    lastdyn: 1719859706,
    type: 25,
    shiptype: 'navigation',
    name: 'GOSIKI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 238,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401039,
  },
  {
    mmsi: 994401022,
    lng: 126.477657,
    lat: 37.330542,
    lastdyn: 1719859887,
    type: 29,
    shiptype: 'navigation',
    name: 'BUKJANGJASEO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401022,
  },
  {
    mmsi: 994401038,
    lng: 126.391602,
    lat: 37.328535,
    lastdyn: 1719859884,
    type: 0,
    shiptype: 'navigation',
    name: 'SEOSUDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401038,
  },
  {
    mmsi: 994401040,
    lng: 126.458838,
    lat: 37.339327,
    lastdyn: 1719857536,
    type: 31,
    shiptype: 'navigation',
    name: 'HANGROBUNGI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401040,
  },
  {
    mmsi: 994401029,
    lng: 126.332875,
    lat: 37.334553,
    lastdyn: 1719859512,
    type: 0,
    shiptype: 'navigation',
    name: 'SEOSUDO17',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401029,
  },
  {
    mmsi: 994401053,
    lng: 126.584155,
    lat: 37.428087,
    lastdyn: 1719859710,
    type: 6,
    shiptype: 'navigation',
    name: 'INCHENHANG16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401053,
  },
  {
    mmsi: 994401044,
    lng: 126.560798,
    lat: 37.413035,
    lastdyn: 1719859869,
    type: 0,
    shiptype: 'navigation',
    name: 'INCHEONA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401044,
  },
  {
    mmsi: 994401046,
    lng: 126.564478,
    lat: 37.418072,
    lastdyn: 1719859880,
    type: 0,
    shiptype: 'navigation',
    name: 'INHCEONF',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401046,
  },
  {
    mmsi: 994401018,
    lng: 126.586725,
    lat: 37.438393,
    lastdyn: 1719859863,
    type: 19,
    shiptype: 'navigation',
    name: 'SUKTAN A HO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401018,
  },
  {
    mmsi: 994401013,
    lng: 126.510708,
    lat: 37.35846,
    lastdyn: 1719859892,
    type: 18,
    shiptype: 'navigation',
    name: 'PALMIDO AIS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401013,
  },
  {
    mmsi: 994401111,
    lng: 126.607717,
    lat: 37.454833,
    lastdyn: 1719859900,
    type: 28,
    shiptype: 'navigation',
    name: 'TEST0001',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401111,
  },
  {
    mmsi: 994401045,
    lng: 126.56845,
    lat: 37.409055,
    lastdyn: 1719859909,
    type: 0,
    shiptype: 'navigation',
    name: 'INCHEONM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401045,
  },
  {
    mmsi: 994401047,
    lng: 126.572332,
    lat: 37.414263,
    lastdyn: 1719859708,
    type: 0,
    shiptype: 'navigation',
    name: 'INCHEONG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401047,
  },
  {
    mmsi: 994406949,
    lng: 129.232638,
    lat: 37.404,
    lastdyn: 1719748983,
    type: 0,
    shiptype: 'navigation',
    name: 'VSAMCHEOKBLUE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994406949,
  },
  {
    mmsi: 994406948,
    lng: 129.1786,
    lat: 37.499433,
    lastdyn: 1719748659,
    type: 25,
    shiptype: 'navigation',
    name: 'VIRTUALDONGHAEPORT',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406948,
  },
  {
    mmsi: 994403819,
    lng: 129.219182,
    lat: 37.412717,
    lastdyn: 1719809300,
    type: 6,
    shiptype: 'navigation',
    name: 'SAMCHEOKBLUE AIS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403819,
  },
  {
    mmsi: 994403808,
    lng: 129.14435,
    lat: 37.49622,
    lastdyn: 1719482266,
    type: 14,
    shiptype: 'navigation',
    name: 'DONGHAEHANGS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403808,
  },
  {
    mmsi: 994403805,
    lng: 129.25647,
    lat: 37.379438,
    lastdyn: 1719808937,
    type: 14,
    shiptype: 'navigation',
    name: 'BIMAL',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403805,
  },
  {
    mmsi: 994406855,
    lng: 130.874082,
    lat: 37.453417,
    lastdyn: 1719856881,
    type: 7,
    shiptype: 'navigation',
    name: 'VGADUBONG LH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406855,
  },
  {
    mmsi: 994403582,
    lng: 130.919432,
    lat: 37.486987,
    lastdyn: 1719859015,
    type: 3,
    shiptype: 'navigation',
    name: 'DODONG LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403582,
  },
  {
    mmsi: 999999027,
    lng: 119.70226,
    lat: 37.554052,
    lastdyn: 1719859811,
    type: 31,
    shiptype: 'navigation',
    name: 'ZHHY0197',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 255,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999999027,
  },
  {
    mmsi: 994121138,
    lng: 119.584205,
    lat: 37.54985,
    lastdyn: 1719845292,
    type: 25,
    shiptype: 'navigation',
    name: 'WF PORT NO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121138,
  },
  {
    mmsi: 994121125,
    lng: 120.242703,
    lat: 37.638362,
    lastdyn: 1719859636,
    type: 25,
    shiptype: 'navigation',
    name: 'LONGKOU PORT NO 111',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121125,
  },
  {
    mmsi: 994136524,
    lng: 120.245028,
    lat: 37.638528,
    lastdyn: 1719859840,
    type: 30,
    shiptype: 'navigation',
    name: 'LONGKOU 1111',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136524,
  },
  {
    mmsi: 994141060,
    lng: 120.213583,
    lat: 37.67071,
    lastdyn: 1719859830,
    type: 25,
    shiptype: 'navigation',
    name: 'LONGKOU 103',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141060,
  },
  {
    mmsi: 994126103,
    lng: 120.2125,
    lat: 37.729638,
    lastdyn: 1719859852,
    type: 23,
    shiptype: 'navigation',
    name: 'LONGKOU NORTH ROUTE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126103,
  },
  {
    mmsi: 994141061,
    lng: 120.205812,
    lat: 37.675033,
    lastdyn: 1719859638,
    type: 21,
    shiptype: 'navigation',
    name: 'LONGKOU LN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141061,
  },
  {
    mmsi: 994121123,
    lng: 120.221912,
    lat: 37.661215,
    lastdyn: 1719859876,
    type: 25,
    shiptype: 'navigation',
    name: 'LONGKOU PORT NO 105',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121123,
  },
  {
    mmsi: 994121122,
    lng: 120.227722,
    lat: 37.661438,
    lastdyn: 1719859829,
    type: 24,
    shiptype: 'navigation',
    name: 'LONGKOU PORT NO 104',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121122,
  },
  {
    mmsi: 994121101,
    lng: 120.3193,
    lat: 37.643922,
    lastdyn: 1719859876,
    type: 0,
    shiptype: 'navigation',
    name: 'LK LDG LTS FRONT',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121101,
  },
  {
    mmsi: 994121130,
    lng: 120.30571,
    lat: 37.642582,
    lastdyn: 1719859757,
    type: 25,
    shiptype: 'navigation',
    name: 'LONGKOU PORT NO 119',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121130,
  },
  {
    mmsi: 994121128,
    lng: 120.275667,
    lat: 37.639678,
    lastdyn: 1719859817,
    type: 25,
    shiptype: 'navigation',
    name: 'LONGKOUPORTNO115',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121128,
  },
  {
    mmsi: 994121127,
    lng: 120.259643,
    lat: 37.638995,
    lastdyn: 1719859770,
    type: 25,
    shiptype: 'navigation',
    name: 'LONGKOU PORT NO 113',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121127,
  },
  {
    mmsi: 994126106,
    lng: 120.260445,
    lat: 37.621638,
    lastdyn: 1719859855,
    type: 8,
    shiptype: 'navigation',
    name: 'LONGKOU LEADING LIGH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126106,
  },
  {
    mmsi: 994121133,
    lng: 121.150073,
    lat: 37.749493,
    lastdyn: 1719859825,
    type: 24,
    shiptype: 'navigation',
    name: 'YANTAIWESTPORTNO40',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121133,
  },
  {
    mmsi: 994141064,
    lng: 121.129553,
    lat: 37.731663,
    lastdyn: 1719859829,
    type: 24,
    shiptype: 'navigation',
    name: 'YT WEST NO44',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141064,
  },
  {
    mmsi: 994141065,
    lng: 121.109595,
    lat: 37.719763,
    lastdyn: 1719859890,
    type: 24,
    shiptype: 'navigation',
    name: 'YT WEST NO46',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141065,
  },
  {
    mmsi: 994121115,
    lng: 121.395578,
    lat: 37.588332,
    lastdyn: 1719859847,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO53',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121115,
  },
  {
    mmsi: 994121108,
    lng: 121.417943,
    lat: 37.576615,
    lastdyn: 1719859785,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121108,
  },
  {
    mmsi: 994121111,
    lng: 121.412635,
    lat: 37.577303,
    lastdyn: 1719859764,
    type: 21,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO40',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121111,
  },
  {
    mmsi: 994121114,
    lng: 121.39506,
    lat: 37.586365,
    lastdyn: 1719859765,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO52',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121114,
  },
  {
    mmsi: 994121104,
    lng: 121.450432,
    lat: 37.593625,
    lastdyn: 1719859884,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121104,
  },
  {
    mmsi: 994121118,
    lng: 121.371868,
    lat: 37.583188,
    lastdyn: 1719859884,
    type: 0,
    shiptype: 'navigation',
    name: 'ZFW SANQI LDG LTS FR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121118,
  },
  {
    mmsi: 994121112,
    lng: 121.410188,
    lat: 37.579872,
    lastdyn: 1719859846,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO41',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121112,
  },
  {
    mmsi: 994121107,
    lng: 121.421872,
    lat: 37.580602,
    lastdyn: 1719859889,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHIFUWAN PORT NO25',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121107,
  },
  {
    mmsi: 994121119,
    lng: 121.369867,
    lat: 37.5834,
    lastdyn: 1719859770,
    type: 8,
    shiptype: 'navigation',
    name: 'ZFW SANQI LDG LTS RE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121119,
  },
  {
    mmsi: 994121136,
    lng: 121.466335,
    lat: 37.521932,
    lastdyn: 1719859575,
    type: 3,
    shiptype: 'navigation',
    name: 'GENG HAI 001',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121136,
  },
  {
    mmsi: 994121105,
    lng: 121.447322,
    lat: 37.585827,
    lastdyn: 1719859785,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121105,
  },
  {
    mmsi: 994121113,
    lng: 121.400182,
    lat: 37.583582,
    lastdyn: 1719859885,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHIFUWAN PORT NO51',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121113,
  },
  {
    mmsi: 999000059,
    lng: 121.416512,
    lat: 37.594772,
    lastdyn: 1719859879,
    type: 31,
    shiptype: 'navigation',
    name: 'CESHI006',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000059,
  },
  {
    mmsi: 994136538,
    lng: 121.47,
    lat: 37.748862,
    lastdyn: 1719859835,
    type: 28,
    shiptype: 'navigation',
    name: 'YANTAI PORT UNKNOWN',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136538,
  },
  {
    mmsi: 994121109,
    lng: 121.397817,
    lat: 37.569028,
    lastdyn: 1719859824,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121109,
  },
  {
    mmsi: 994121110,
    lng: 121.3948,
    lat: 37.56472,
    lastdyn: 1719859884,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121110,
  },
  {
    mmsi: 994121116,
    lng: 121.379255,
    lat: 37.593488,
    lastdyn: 1719859889,
    type: 25,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO55',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121116,
  },
  {
    mmsi: 994121117,
    lng: 121.389278,
    lat: 37.588888,
    lastdyn: 1719859787,
    type: 24,
    shiptype: 'navigation',
    name: 'ZHIFUWANPORT NO56',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121117,
  },
  {
    mmsi: 994121137,
    lng: 121.466347,
    lat: 37.517572,
    lastdyn: 1719859798,
    type: 3,
    shiptype: 'navigation',
    name: 'GENG HAI 002',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121137,
  },
  {
    mmsi: 994126116,
    lng: 121.669472,
    lat: 37.646862,
    lastdyn: 1719859869,
    type: 20,
    shiptype: 'navigation',
    name: 'YW ROUTE NO9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126116,
  },
  {
    mmsi: 994126117,
    lng: 121.556667,
    lat: 37.675,
    lastdyn: 1719859871,
    type: 22,
    shiptype: 'navigation',
    name: 'YW ROUTE NO10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126117,
  },
  {
    mmsi: 994126118,
    lng: 121.56,
    lat: 37.641667,
    lastdyn: 1719859874,
    type: 20,
    shiptype: 'navigation',
    name: 'YW ROUTE NO11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126118,
  },
  {
    mmsi: 994126115,
    lng: 121.666222,
    lat: 37.679722,
    lastdyn: 1719859865,
    type: 22,
    shiptype: 'navigation',
    name: 'YW ROUTE NO8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126115,
  },
  {
    mmsi: 994126110,
    lng: 121.99755,
    lat: 37.661778,
    lastdyn: 1719859848,
    type: 20,
    shiptype: 'navigation',
    name: 'YW ROUTE NO3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126110,
  },
  {
    mmsi: 994126113,
    lng: 121.775805,
    lat: 37.684362,
    lastdyn: 1719859859,
    type: 22,
    shiptype: 'navigation',
    name: 'YW ROUTE NO6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126113,
  },
  {
    mmsi: 994136539,
    lng: 121.923945,
    lat: 37.707612,
    lastdyn: 1719859840,
    type: 28,
    shiptype: 'navigation',
    name: 'JIHUANGGANGYUYUN0138',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136539,
  },
  {
    mmsi: 994126109,
    lng: 121.995,
    lat: 37.693333,
    lastdyn: 1719859845,
    type: 21,
    shiptype: 'navigation',
    name: 'YW ROUTE NO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126109,
  },
  {
    mmsi: 994126112,
    lng: 121.8885,
    lat: 37.656917,
    lastdyn: 1719859854,
    type: 20,
    shiptype: 'navigation',
    name: 'YW ROUTE NO5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126112,
  },
  {
    mmsi: 994126111,
    lng: 121.885383,
    lat: 37.688883,
    lastdyn: 1719859852,
    type: 22,
    shiptype: 'navigation',
    name: 'YW ROUTE NO4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126111,
  },
  {
    mmsi: 994126114,
    lng: 121.778972,
    lat: 37.651945,
    lastdyn: 1719859862,
    type: 20,
    shiptype: 'navigation',
    name: 'YW ROUTE NO7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126114,
  },
  {
    mmsi: 994126104,
    lng: 122.145,
    lat: 37.728332,
    lastdyn: 1719859863,
    type: 28,
    shiptype: 'navigation',
    name: 'JIHUANGYU30683 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126104,
  },
  {
    mmsi: 994126108,
    lng: 122.11,
    lat: 37.666667,
    lastdyn: 1719859842,
    type: 20,
    shiptype: 'navigation',
    name: 'YW ROUTE NO1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126108,
  },
  {
    mmsi: 994401020,
    lng: 125.718383,
    lat: 37.604277,
    lastdyn: 1719859888,
    type: 24,
    shiptype: 'navigation',
    name: 'SOYEENPENGDO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401020,
  },
  {
    mmsi: 994401030,
    lng: 126.59463,
    lat: 37.518103,
    lastdyn: 1719859151,
    type: 0,
    shiptype: 'navigation',
    name: 'GYEONGINHANG',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401030,
  },
  {
    mmsi: 994401031,
    lng: 126.586458,
    lat: 37.541758,
    lastdyn: 1719858369,
    type: 0,
    shiptype: 'navigation',
    name: 'GYEONGIN HANG10',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401031,
  },
  {
    mmsi: 994401033,
    lng: 126.57635,
    lat: 37.556793,
    lastdyn: 1719842340,
    type: 0,
    shiptype: 'navigation',
    name: 'GYEONGIN HANG15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401033,
  },
  {
    mmsi: 994401032,
    lng: 126.580222,
    lat: 37.547925,
    lastdyn: 1718584738,
    type: 0,
    shiptype: 'navigation',
    name: 'GYEONGINHANG11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401032,
  },
  {
    mmsi: 994403804,
    lng: 129.054133,
    lat: 37.675653,
    lastdyn: 1719799058,
    type: 5,
    shiptype: 'navigation',
    name: 'JEONGDONGJIN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403804,
  },
  {
    mmsi: 994403800,
    lng: 129.118587,
    lat: 37.554513,
    lastdyn: 1719797047,
    type: 6,
    shiptype: 'navigation',
    name: 'MUKHO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403800,
  },
  {
    mmsi: 994403816,
    lng: 129.123522,
    lat: 37.566397,
    lastdyn: 1719791290,
    type: 17,
    shiptype: 'navigation',
    name: 'EODALHANGN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403816,
  },
  {
    mmsi: 994403818,
    lng: 129.1188,
    lat: 37.524,
    lastdyn: 1719748630,
    type: 0,
    shiptype: 'navigation',
    name: 'DONGHAEMOF',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403818,
  },
  {
    mmsi: 994403809,
    lng: 129.12031,
    lat: 37.539407,
    lastdyn: 1719751176,
    type: 14,
    shiptype: 'navigation',
    name: 'MUKHOHANGE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403809,
  },
  {
    mmsi: 994403583,
    lng: 130.93986,
    lat: 37.55689,
    lastdyn: 1719804103,
    type: 0,
    shiptype: 'navigation',
    name: 'SSANGJEONGCHO LB',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 247,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403583,
  },
  {
    mmsi: 994403580,
    lng: 130.79789,
    lat: 37.51815,
    lastdyn: 1708929917,
    type: 5,
    shiptype: 'navigation',
    name: 'ULLEUNGDO LH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403580,
  },
  {
    mmsi: 999062429,
    lng: 119.896885,
    lat: 37.956033,
    lastdyn: 1719859740,
    type: 0,
    shiptype: 'navigation',
    name: 'QF103',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999062429,
  },
  {
    mmsi: 994126101,
    lng: 120.2125,
    lat: 37.816667,
    lastdyn: 1719859846,
    type: 23,
    shiptype: 'navigation',
    name: 'LONGKOU NORTH ROUTE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126101,
  },
  {
    mmsi: 994126102,
    lng: 120.2125,
    lat: 37.773138,
    lastdyn: 1719859849,
    type: 23,
    shiptype: 'navigation',
    name: 'LONGKOU NORTH ROUTE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126102,
  },
  {
    mmsi: 994141058,
    lng: 120.229945,
    lat: 37.812362,
    lastdyn: 1719859895,
    type: 30,
    shiptype: 'navigation',
    name: 'BWS15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141058,
  },
  {
    mmsi: 994141054,
    lng: 120.353863,
    lat: 37.881003,
    lastdyn: 1719844261,
    type: 30,
    shiptype: 'navigation',
    name: 'BWS3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141054,
  },
  {
    mmsi: 994121168,
    lng: 120.708838,
    lat: 37.997398,
    lastdyn: 1719859869,
    type: 24,
    shiptype: 'navigation',
    name: 'CHANGSHANNO12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121168,
  },
  {
    mmsi: 994131507,
    lng: 120.720178,
    lat: 37.922813,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'CHANGDAO PORT SOUTH',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131507,
  },
  {
    mmsi: 994121158,
    lng: 120.970437,
    lat: 37.936868,
    lastdyn: 1719859817,
    type: 24,
    shiptype: 'navigation',
    name: 'CHANGSHANNO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121158,
  },
  {
    mmsi: 994121162,
    lng: 120.862882,
    lat: 37.970377,
    lastdyn: 1719859868,
    type: 24,
    shiptype: 'navigation',
    name: 'CHANGSHANNO6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121162,
  },
  {
    mmsi: 994121166,
    lng: 120.76513,
    lat: 37.987655,
    lastdyn: 1719859749,
    type: 24,
    shiptype: 'navigation',
    name: 'CHANGSHANNO10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121166,
  },
  {
    mmsi: 994126153,
    lng: 120.973333,
    lat: 37.974167,
    lastdyn: 1719859857,
    type: 30,
    shiptype: 'navigation',
    name: 'CS TSS EAST END',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126153,
  },
  {
    mmsi: 994121160,
    lng: 120.916847,
    lat: 37.950653,
    lastdyn: 1719859751,
    type: 24,
    shiptype: 'navigation',
    name: 'CHANGSHANNO4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121160,
  },
  {
    mmsi: 994121164,
    lng: 120.813698,
    lat: 37.979123,
    lastdyn: 1719859814,
    type: 24,
    shiptype: 'navigation',
    name: 'CHANGSHANNO8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121164,
  },
  {
    mmsi: 994126160,
    lng: 121.146667,
    lat: 37.943417,
    lastdyn: 1719859867,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK LIAOJINYU 1508',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126160,
  },
  {
    mmsi: 994141063,
    lng: 121.17348,
    lat: 37.805628,
    lastdyn: 1719859769,
    type: 24,
    shiptype: 'navigation',
    name: 'YT WEST NO32',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141063,
  },
  {
    mmsi: 994121195,
    lng: 121.84584,
    lat: 37.874237,
    lastdyn: 1719850909,
    type: 30,
    shiptype: 'navigation',
    name: 'BDB6S11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121195,
  },
  {
    mmsi: 994126158,
    lng: 121.796667,
    lat: 37.993333,
    lastdyn: 1719859830,
    type: 28,
    shiptype: 'navigation',
    name: 'APPROXIMATE WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126158,
  },
  {
    mmsi: 994121191,
    lng: 121.847083,
    lat: 37.982972,
    lastdyn: 1719849956,
    type: 30,
    shiptype: 'navigation',
    name: 'BDB6S1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121191,
  },
  {
    mmsi: 994121192,
    lng: 121.887213,
    lat: 37.959325,
    lastdyn: 1719857560,
    type: 30,
    shiptype: 'navigation',
    name: 'BDB6S3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121192,
  },
  {
    mmsi: 994121103,
    lng: 122.920442,
    lat: 37.94795,
    lastdyn: 1719859149,
    type: 30,
    shiptype: 'navigation',
    name: 'WEIHAI ANEMOMET ER T',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121103,
  },
  {
    mmsi: 994136507,
    lng: 123.188933,
    lat: 37.85945,
    lastdyn: 1719859917,
    type: 28,
    shiptype: 'navigation',
    name: 'L7DAGANYU 15279 WR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136507,
  },
  {
    mmsi: 999991017,
    lng: 123.500687,
    lat: 37.998128,
    lastdyn: 1719858640,
    type: 24,
    shiptype: 'navigation',
    name: 'QF104',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991017,
  },
  {
    mmsi: 994401016,
    lng: 124.728628,
    lat: 37.760787,
    lastdyn: 1719859876,
    type: 17,
    shiptype: 'navigation',
    name: 'SOCHUNGDO AIS',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994401016,
  },
  {
    mmsi: 994403813,
    lng: 128.890757,
    lat: 37.826452,
    lastdyn: 1719790402,
    type: 21,
    shiptype: 'navigation',
    name: 'SANDAEWOLRI',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 135,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403813,
  },
  {
    mmsi: 994403803,
    lng: 128.833908,
    lat: 37.89767,
    lastdyn: 1719790754,
    type: 7,
    shiptype: 'navigation',
    name: 'JUMUNJIN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403803,
  },
  {
    mmsi: 994403810,
    lng: 128.834722,
    lat: 37.885915,
    lastdyn: 1719790240,
    type: 14,
    shiptype: 'navigation',
    name: 'JUMUNJINHANGE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 243,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403810,
  },
  {
    mmsi: 994121023,
    lng: 117.795677,
    lat: 38.213887,
    lastdyn: 1719856965,
    type: 0,
    shiptype: 'navigation',
    name: 'ZHANGWEI BRIDGE NO13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121023,
  },
  {
    mmsi: 994121021,
    lng: 117.797015,
    lat: 38.21333,
    lastdyn: 1719859911,
    type: 0,
    shiptype: 'navigation',
    name: 'ZHANGWEI BRIDGE NO3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121021,
  },
  {
    mmsi: 994121022,
    lng: 117.796872,
    lat: 38.213098,
    lastdyn: 1719840889,
    type: 0,
    shiptype: 'navigation',
    name: 'ZHANGWEI BRIDGE NO4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121022,
  },
  {
    mmsi: 994121024,
    lng: 117.795515,
    lat: 38.21368,
    lastdyn: 1719859915,
    type: 0,
    shiptype: 'navigation',
    name: 'ZHANGWEI BRIDGE NO14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121024,
  },
  {
    mmsi: 994146026,
    lng: 118.992222,
    lat: 38.11,
    lastdyn: 1719859747,
    type: 28,
    shiptype: 'navigation',
    name: 'APPROXIMATE WRECK HA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146026,
  },
  {
    mmsi: 994146025,
    lng: 118.991945,
    lat: 38.108612,
    lastdyn: 1719859744,
    type: 28,
    shiptype: 'navigation',
    name: 'APPROXIMATE WRECK LA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146025,
  },
  {
    mmsi: 994121068,
    lng: 119.1133,
    lat: 38.149283,
    lastdyn: 1719858665,
    type: 25,
    shiptype: 'navigation',
    name: 'DONGYINGNO109',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121068,
  },
  {
    mmsi: 994121072,
    lng: 119.057367,
    lat: 38.117733,
    lastdyn: 1719859443,
    type: 25,
    shiptype: 'navigation',
    name: 'DONGYINGNO117',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121072,
  },
  {
    mmsi: 994141205,
    lng: 119.09785,
    lat: 38.1427,
    lastdyn: 1719824336,
    type: 22,
    shiptype: 'navigation',
    name: 'DONGYINGNOFN1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141205,
  },
  {
    mmsi: 994121069,
    lng: 119.116117,
    lat: 38.145883,
    lastdyn: 1719858901,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGYINGNO110',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121069,
  },
  {
    mmsi: 994141203,
    lng: 119.10615,
    lat: 38.13375,
    lastdyn: 1719855897,
    type: 20,
    shiptype: 'navigation',
    name: 'DONGYINGNOFS1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141203,
  },
  {
    mmsi: 994141204,
    lng: 119.035897,
    lat: 38.094488,
    lastdyn: 1719859801,
    type: 20,
    shiptype: 'navigation',
    name: 'DONGYING NOFS6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141204,
  },
  {
    mmsi: 994121075,
    lng: 119.03565,
    lat: 38.100833,
    lastdyn: 1719804422,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGYINGNO122',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121075,
  },
  {
    mmsi: 994121066,
    lng: 119.1407,
    lat: 38.165,
    lastdyn: 1719859261,
    type: 25,
    shiptype: 'navigation',
    name: 'DONGYINGNO105',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121066,
  },
  {
    mmsi: 994121071,
    lng: 119.088067,
    lat: 38.130567,
    lastdyn: 1719803056,
    type: 24,
    shiptype: 'navigation',
    name: 'DONGYING NO114',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121071,
  },
  {
    mmsi: 994121074,
    lng: 119.032883,
    lat: 38.104333,
    lastdyn: 1719858488,
    type: 25,
    shiptype: 'navigation',
    name: 'DONGYINGNO121',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121074,
  },
  {
    mmsi: 994146042,
    lng: 119.094967,
    lat: 38.210888,
    lastdyn: 1719859918,
    type: 3,
    shiptype: 'navigation',
    name: 'BZ251D PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146042,
  },
  {
    mmsi: 994141206,
    lng: 119.028407,
    lat: 38.103442,
    lastdyn: 1719859681,
    type: 22,
    shiptype: 'navigation',
    name: 'DONGYING NOFN6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141206,
  },
  {
    mmsi: 991231231,
    lng: 119.338,
    lat: 38.091,
    lastdyn: 1719859885,
    type: 0,
    shiptype: 'navigation',
    name: 'TEST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 991231231,
  },
  {
    mmsi: 994146040,
    lng: 119.554333,
    lat: 38.227083,
    lastdyn: 1719859915,
    type: 3,
    shiptype: 'navigation',
    name: 'HYSY 102 FPSO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146040,
  },
  {
    mmsi: 994126152,
    lng: 120.488333,
    lat: 38.056945,
    lastdyn: 1719859863,
    type: 30,
    shiptype: 'navigation',
    name: 'CS TSS WEST END',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126152,
  },
  {
    mmsi: 994121170,
    lng: 120.66799,
    lat: 38.006603,
    lastdyn: 1719859809,
    type: 24,
    shiptype: 'navigation',
    name: 'CHANGSHANNO14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121170,
  },
  {
    mmsi: 994121169,
    lng: 120.696392,
    lat: 38.04125,
    lastdyn: 1719859749,
    type: 25,
    shiptype: 'navigation',
    name: 'CHANGSHANNO13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121169,
  },
  {
    mmsi: 994121167,
    lng: 120.73631,
    lat: 38.034812,
    lastdyn: 1719859809,
    type: 25,
    shiptype: 'navigation',
    name: 'CHANGSHANNO11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121167,
  },
  {
    mmsi: 994121171,
    lng: 120.645082,
    lat: 38.046868,
    lastdyn: 1719859816,
    type: 25,
    shiptype: 'navigation',
    name: 'CHANGSHAN NO15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121171,
  },
  {
    mmsi: 994121157,
    lng: 120.977627,
    lat: 38.011645,
    lastdyn: 1719859028,
    type: 25,
    shiptype: 'navigation',
    name: 'CHANGSHANNO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121157,
  },
  {
    mmsi: 994121165,
    lng: 120.77894,
    lat: 38.02769,
    lastdyn: 1719859869,
    type: 25,
    shiptype: 'navigation',
    name: 'CHANGSHANNO9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121165,
  },
  {
    mmsi: 994121159,
    lng: 120.923892,
    lat: 38.01178,
    lastdyn: 1719858792,
    type: 25,
    shiptype: 'navigation',
    name: 'CHANGSHANNO3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121159,
  },
  {
    mmsi: 994121161,
    lng: 120.871113,
    lat: 38.01082,
    lastdyn: 1719859818,
    type: 25,
    shiptype: 'navigation',
    name: 'CHANGSHANNO5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121161,
  },
  {
    mmsi: 994126151,
    lng: 120.76,
    lat: 38.010555,
    lastdyn: 1719859861,
    type: 30,
    shiptype: 'navigation',
    name: 'CS TSS CENTRAL MARK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126151,
  },
  {
    mmsi: 994403811,
    lng: 128.674098,
    lat: 38.082477,
    lastdyn: 1719791301,
    type: 14,
    shiptype: 'navigation',
    name: 'SUSANDAN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403811,
  },
  {
    mmsi: 994403812,
    lng: 128.622815,
    lat: 38.199417,
    lastdyn: 1719484595,
    type: 21,
    shiptype: 'navigation',
    name: 'JODOE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 243,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403812,
  },
  {
    mmsi: 994403817,
    lng: 128.610855,
    lat: 38.20565,
    lastdyn: 1718928960,
    type: 17,
    shiptype: 'navigation',
    name: 'SOKCHOHANGJODON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403817,
  },
  {
    mmsi: 994403815,
    lng: 128.608945,
    lat: 38.193417,
    lastdyn: 1719583956,
    type: 24,
    shiptype: 'navigation',
    name: 'JODOSW',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403815,
  },
  {
    mmsi: 994403801,
    lng: 128.600592,
    lat: 38.213493,
    lastdyn: 1719666010,
    type: 6,
    shiptype: 'navigation',
    name: 'SOKCHO',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 254,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403801,
  },
  {
    mmsi: 994146024,
    lng: 117.898167,
    lat: 38.369972,
    lastdyn: 1719859764,
    type: 24,
    shiptype: 'navigation',
    name: 'HUANGHUA 264',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146024,
  },
  {
    mmsi: 994126041,
    lng: 117.904167,
    lat: 38.330667,
    lastdyn: 1719859785,
    type: 24,
    shiptype: 'navigation',
    name: 'HUANGHUA NO56',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126041,
  },
  {
    mmsi: 994126039,
    lng: 117.887528,
    lat: 38.323,
    lastdyn: 1719859770,
    type: 24,
    shiptype: 'navigation',
    name: 'HUANGHUA PORT NO60',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126039,
  },
  {
    mmsi: 994146028,
    lng: 118.027972,
    lat: 38.415833,
    lastdyn: 1719859773,
    type: 28,
    shiptype: 'navigation',
    name: 'HUANGHUA PORT UNKNOW',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146028,
  },
  {
    mmsi: 994146033,
    lng: 118.186667,
    lat: 38.311667,
    lastdyn: 1719859767,
    type: 28,
    shiptype: 'navigation',
    name: 'XIANGYUEYANGHUO 1860',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146033,
  },
  {
    mmsi: 994146027,
    lng: 118.448612,
    lat: 38.452778,
    lastdyn: 1719859769,
    type: 28,
    shiptype: 'navigation',
    name: 'CB DRILLING PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146027,
  },
  {
    mmsi: 994126099,
    lng: 118.4438,
    lat: 38.299667,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'AY20 BOZHONG WINDFAR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126099,
  },
  {
    mmsi: 994126098,
    lng: 118.477238,
    lat: 38.30045,
    lastdyn: 1719859875,
    type: 30,
    shiptype: 'navigation',
    name: 'AY19 BOZHONG WINDFAR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126098,
  },
  {
    mmsi: 994146093,
    lng: 118.436333,
    lat: 38.443333,
    lastdyn: 1719859742,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST CB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146093,
  },
  {
    mmsi: 994121046,
    lng: 118.483777,
    lat: 38.343373,
    lastdyn: 1719859871,
    type: 19,
    shiptype: 'navigation',
    name: 'AY01 BOZHONG WIND FA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121046,
  },
  {
    mmsi: 994121047,
    lng: 118.628783,
    lat: 38.3313,
    lastdyn: 1719859743,
    type: 30,
    shiptype: 'navigation',
    name: 'AY07 BOZHONG WIND FA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121047,
  },
  {
    mmsi: 994121052,
    lng: 118.60219,
    lat: 38.287078,
    lastdyn: 1719859867,
    type: 19,
    shiptype: 'navigation',
    name: 'A BOZHONG WIND FARM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121052,
  },
  {
    mmsi: 994126096,
    lng: 118.542733,
    lat: 38.300933,
    lastdyn: 1719859874,
    type: 30,
    shiptype: 'navigation',
    name: 'AY17 BOZHONG WINDFAR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126096,
  },
  {
    mmsi: 994126097,
    lng: 118.508862,
    lat: 38.300072,
    lastdyn: 1719859876,
    type: 30,
    shiptype: 'navigation',
    name: 'AY18 BOZHONG WINDFAR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126097,
  },
  {
    mmsi: 994126094,
    lng: 118.634542,
    lat: 38.310322,
    lastdyn: 1719859875,
    type: 30,
    shiptype: 'navigation',
    name: 'AY08 BOZHONG WINDFAR',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126094,
  },
  {
    mmsi: 994121050,
    lng: 118.544675,
    lat: 38.264977,
    lastdyn: 1719859743,
    type: 19,
    shiptype: 'navigation',
    name: 'AY15 BOZHONG WIND FA',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121050,
  },
  {
    mmsi: 994126095,
    lng: 118.54298,
    lat: 38.283333,
    lastdyn: 1719859875,
    type: 30,
    shiptype: 'navigation',
    name: 'AY16 BOZHONG WINDFAR',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126095,
  },
  {
    mmsi: 994121059,
    lng: 118.8548,
    lat: 38.264283,
    lastdyn: 1719859696,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121059,
  },
  {
    mmsi: 994121058,
    lng: 118.90785,
    lat: 38.251117,
    lastdyn: 1719859867,
    type: 30,
    shiptype: 'navigation',
    name: 'B1Y08 BOZHONG WIND F',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121058,
  },
  {
    mmsi: 994121062,
    lng: 118.831803,
    lat: 38.289375,
    lastdyn: 1719859508,
    type: 30,
    shiptype: 'navigation',
    name: 'B1Y15 BOZHONG WIND F',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121062,
  },
  {
    mmsi: 999990007,
    lng: 118.920917,
    lat: 38.311045,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'HYSZJC007',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999990007,
  },
  {
    mmsi: 994121061,
    lng: 118.751867,
    lat: 38.2849,
    lastdyn: 1719859814,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121061,
  },
  {
    mmsi: 994121063,
    lng: 118.85453,
    lat: 38.280665,
    lastdyn: 1719859744,
    type: 30,
    shiptype: 'navigation',
    name: 'B1 BOZHONG WIND FARM',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121063,
  },
  {
    mmsi: 994121057,
    lng: 118.872233,
    lat: 38.307133,
    lastdyn: 1719859743,
    type: 30,
    shiptype: 'navigation',
    name: 'B1Y06 BOZHONG WIND F',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121057,
  },
  {
    mmsi: 994146039,
    lng: 119.62775,
    lat: 38.31525,
    lastdyn: 1719859912,
    type: 3,
    shiptype: 'navigation',
    name: 'BOHAI YOUYI FPSO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146039,
  },
  {
    mmsi: 994146092,
    lng: 120.1185,
    lat: 38.392167,
    lastdyn: 1719859815,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST PL193',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146092,
  },
  {
    mmsi: 994146047,
    lng: 120.081222,
    lat: 38.392833,
    lastdyn: 1719859783,
    type: 3,
    shiptype: 'navigation',
    name: 'BOHAI PENGBO FPSO',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146047,
  },
  {
    mmsi: 994131508,
    lng: 118.96097,
    lat: 25.21866,
    lastdyn: 1719859781,
    type: 25,
    shiptype: 'navigation',
    name: 'MEI ZHOU WAN 907',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131508,
  },
  {
    mmsi: 994131510,
    lng: 121.007827,
    lat: 38.348327,
    lastdyn: 1719858300,
    type: 3,
    shiptype: 'navigation',
    name: 'JING HAI 003 HAO',
    length: 50,
    width: 50,
    left: 25,
    trail: 25,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131510,
  },
  {
    mmsi: 994403806,
    lng: 128.464758,
    lat: 38.449497,
    lastdyn: 1719653397,
    type: 6,
    shiptype: 'navigation',
    name: 'GEOJIN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 199,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403806,
  },
  {
    mmsi: 994406944,
    lng: 128.550167,
    lat: 38.291278,
    lastdyn: 1719640491,
    type: 19,
    shiptype: 'navigation',
    name: 'VIRTUALGYOAMBW',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994406944,
  },
  {
    mmsi: 994403814,
    lng: 128.564908,
    lat: 38.281767,
    lastdyn: 1718886623,
    type: 17,
    shiptype: 'navigation',
    name: 'AYAJINE',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 231,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403814,
  },
  {
    mmsi: 994121076,
    lng: 117.986683,
    lat: 38.682433,
    lastdyn: 1719859002,
    type: 30,
    shiptype: 'navigation',
    name: 'NO1 NANGANG WIND FAR',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121076,
  },
  {
    mmsi: 994146036,
    lng: 117.960472,
    lat: 38.658362,
    lastdyn: 1719859748,
    type: 3,
    shiptype: 'navigation',
    name: 'QK181 PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146036,
  },
  {
    mmsi: 994131701,
    lng: 117.963553,
    lat: 38.55229,
    lastdyn: 1719859874,
    type: 0,
    shiptype: 'navigation',
    name: 'FENGLIJIANCE',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131701,
  },
  {
    mmsi: 994121077,
    lng: 118.063183,
    lat: 38.681717,
    lastdyn: 1719858174,
    type: 30,
    shiptype: 'navigation',
    name: 'NO3 NANGANG WIND FAR',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121077,
  },
  {
    mmsi: 994146038,
    lng: 118.894195,
    lat: 38.707055,
    lastdyn: 1719859765,
    type: 3,
    shiptype: 'navigation',
    name: 'CFD181 WHPF PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146038,
  },
  {
    mmsi: 994146045,
    lng: 118.955333,
    lat: 38.579778,
    lastdyn: 1719859782,
    type: 3,
    shiptype: 'navigation',
    name: 'CFD182 PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146045,
  },
  {
    mmsi: 994146044,
    lng: 118.899028,
    lat: 38.626472,
    lastdyn: 1719859768,
    type: 3,
    shiptype: 'navigation',
    name: 'CFD181 PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146044,
  },
  {
    mmsi: 994146094,
    lng: 119.071333,
    lat: 38.5515,
    lastdyn: 1719859871,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST BZ131',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146094,
  },
  {
    mmsi: 994146046,
    lng: 119.065305,
    lat: 38.550555,
    lastdyn: 1719859741,
    type: 3,
    shiptype: 'navigation',
    name: 'BZ131 PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146046,
  },
  {
    mmsi: 994146029,
    lng: 119.558138,
    lat: 38.55355,
    lastdyn: 1719859751,
    type: 28,
    shiptype: 'navigation',
    name: 'BZ OBSTRUCTION NO1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146029,
  },
  {
    mmsi: 994146031,
    lng: 119.55627,
    lat: 38.55605,
    lastdyn: 1719859769,
    type: 28,
    shiptype: 'navigation',
    name: 'BZ OBSTRUCTION NO3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146031,
  },
  {
    mmsi: 994146032,
    lng: 119.5588,
    lat: 38.549138,
    lastdyn: 1719859769,
    type: 28,
    shiptype: 'navigation',
    name: 'BZ OBSTRUCTION NO4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146032,
  },
  {
    mmsi: 994146030,
    lng: 119.5558,
    lat: 38.55518,
    lastdyn: 1719859769,
    type: 28,
    shiptype: 'navigation',
    name: 'BZ OBSTRUCTION NO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146030,
  },
  {
    mmsi: 994136112,
    lng: 120.358333,
    lat: 38.601667,
    lastdyn: 1719859789,
    type: 28,
    shiptype: 'navigation',
    name: 'JOSCOYANGZHOU OBSTRU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136112,
  },
  {
    mmsi: 994136107,
    lng: 120.595,
    lat: 38.593333,
    lastdyn: 1719859870,
    type: 28,
    shiptype: 'navigation',
    name: 'WANRENHE 9099 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136107,
  },
  {
    mmsi: 994136106,
    lng: 120.558333,
    lat: 38.5,
    lastdyn: 1719859787,
    type: 28,
    shiptype: 'navigation',
    name: '916 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136106,
  },
  {
    mmsi: 999062440,
    lng: 121.16622,
    lat: 38.548577,
    lastdyn: 1719858651,
    type: 31,
    shiptype: 'navigation',
    name: 'QF109',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999062440,
  },
  {
    mmsi: 994136126,
    lng: 121.018445,
    lat: 38.572917,
    lastdyn: 1719859912,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK LDY23632',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136126,
  },
  {
    mmsi: 994136124,
    lng: 121.403333,
    lat: 38.628333,
    lastdyn: 1719859839,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK PA LIAOCHANGYU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136124,
  },
  {
    mmsi: 994403802,
    lng: 128.428767,
    lat: 38.503737,
    lastdyn: 1719659367,
    type: 18,
    shiptype: 'navigation',
    name: 'DAEJIN',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 227,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994403802,
  },
  {
    mmsi: 994141165,
    lng: 117.644725,
    lat: 38.767873,
    lastdyn: 1719684346,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGANG NO169',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141165,
  },
  {
    mmsi: 994126040,
    lng: 117.712595,
    lat: 38.763862,
    lastdyn: 1719859759,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGANG NO160',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126040,
  },
  {
    mmsi: 994121037,
    lng: 117.951232,
    lat: 38.885818,
    lastdyn: 1719859337,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHANO227',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121037,
  },
  {
    mmsi: 994141166,
    lng: 117.929467,
    lat: 38.903877,
    lastdyn: 1719859868,
    type: 5,
    shiptype: 'navigation',
    name: 'DAGUKOU N BERAKWATER',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141166,
  },
  {
    mmsi: 994121036,
    lng: 117.970827,
    lat: 38.86891,
    lastdyn: 1719859272,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHANO224',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121036,
  },
  {
    mmsi: 994121039,
    lng: 117.928297,
    lat: 38.899067,
    lastdyn: 1719859097,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHA NO231',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121039,
  },
  {
    mmsi: 994146058,
    lng: 117.82522,
    lat: 38.92153,
    lastdyn: 1718085095,
    type: 28,
    shiptype: 'navigation',
    name: 'DGS OBSTRUCTION NO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146058,
  },
  {
    mmsi: 994131408,
    lng: 117.848237,
    lat: 38.963368,
    lastdyn: 1719859870,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 41',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131408,
  },
  {
    mmsi: 994121004,
    lng: 117.804133,
    lat: 38.970183,
    lastdyn: 1719859873,
    type: 21,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO47',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121004,
  },
  {
    mmsi: 994141164,
    lng: 117.779335,
    lat: 38.767203,
    lastdyn: 1719858685,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGANG NO151',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141164,
  },
  {
    mmsi: 994141191,
    lng: 117.888988,
    lat: 38.952918,
    lastdyn: 1719859286,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO38',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141191,
  },
  {
    mmsi: 994141154,
    lng: 117.76244,
    lat: 38.957197,
    lastdyn: 1719859739,
    type: 5,
    shiptype: 'navigation',
    name: 'SINOCHEM PIER EAST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 118,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141154,
  },
  {
    mmsi: 994146018,
    lng: 117.824363,
    lat: 38.96695,
    lastdyn: 1719859758,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOX1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146018,
  },
  {
    mmsi: 994131448,
    lng: 117.96409,
    lat: 38.942168,
    lastdyn: 1719859221,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131448,
  },
  {
    mmsi: 994121042,
    lng: 117.901137,
    lat: 38.915588,
    lastdyn: 1719859277,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHA NO237',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121042,
  },
  {
    mmsi: 994131453,
    lng: 117.846977,
    lat: 38.959037,
    lastdyn: 1719859771,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 42',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131453,
  },
  {
    mmsi: 994146020,
    lng: 117.78547,
    lat: 38.991517,
    lastdyn: 1719859763,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOX3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146020,
  },
  {
    mmsi: 994141153,
    lng: 117.803157,
    lat: 38.934782,
    lastdyn: 1719859864,
    type: 5,
    shiptype: 'navigation',
    name: 'GRAINOIL BERTH EAST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141153,
  },
  {
    mmsi: 994141195,
    lng: 117.829895,
    lat: 38.961753,
    lastdyn: 1719859814,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO44',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141195,
  },
  {
    mmsi: 994146019,
    lng: 117.7844,
    lat: 38.983667,
    lastdyn: 1719859769,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOX2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146019,
  },
  {
    mmsi: 994146021,
    lng: 117.78223,
    lat: 38.99122,
    lastdyn: 1719859891,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOX4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146021,
  },
  {
    mmsi: 994141156,
    lng: 117.879575,
    lat: 38.927425,
    lastdyn: 1719859873,
    type: 5,
    shiptype: 'navigation',
    name: 'LNG PIER EAST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141156,
  },
  {
    mmsi: 994121033,
    lng: 117.99734,
    lat: 38.858775,
    lastdyn: 1719859450,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHANO219',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121033,
  },
  {
    mmsi: 994141197,
    lng: 117.754735,
    lat: 38.97526,
    lastdyn: 1719859865,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO48',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141197,
  },
  {
    mmsi: 994121006,
    lng: 117.793417,
    lat: 38.977217,
    lastdyn: 1719859831,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOD2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121006,
  },
  {
    mmsi: 994121035,
    lng: 117.974412,
    lat: 38.872185,
    lastdyn: 1719859214,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHANO223',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121035,
  },
  {
    mmsi: 994146057,
    lng: 117.82473,
    lat: 38.920983,
    lastdyn: 1718085213,
    type: 28,
    shiptype: 'navigation',
    name: 'DGS OBSTRUCTION NO1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146057,
  },
  {
    mmsi: 994121086,
    lng: 117.792835,
    lat: 38.983003,
    lastdyn: 1719859861,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOD3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121086,
  },
  {
    mmsi: 994141199,
    lng: 117.963445,
    lat: 38.940292,
    lastdyn: 1719859085,
    type: 20,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOS30',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141199,
  },
  {
    mmsi: 994131447,
    lng: 117.965137,
    lat: 38.946558,
    lastdyn: 1719859524,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131447,
  },
  {
    mmsi: 994141162,
    lng: 117.767,
    lat: 38.757495,
    lastdyn: 1719859789,
    type: 5,
    shiptype: 'navigation',
    name: 'DAGANG S BREAKWATER',
    length: 12,
    width: 12,
    left: 6,
    trail: 6,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141162,
  },
  {
    mmsi: 994131450,
    lng: 117.930988,
    lat: 38.9467,
    lastdyn: 1719859350,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 34',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131450,
  },
  {
    mmsi: 994131434,
    lng: 119.41159,
    lat: 25.389957,
    lastdyn: 1719859809,
    type: 30,
    shiptype: 'navigation',
    name: 'XHFD 20',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131434,
  },
  {
    mmsi: 994131451,
    lng: 117.88886,
    lat: 38.95739,
    lastdyn: 1719859765,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 37',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131451,
  },
  {
    mmsi: 994141168,
    lng: 117.776165,
    lat: 38.842978,
    lastdyn: 1719858489,
    type: 25,
    shiptype: 'navigation',
    name: 'GAOSHALING NO337',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141168,
  },
  {
    mmsi: 994121005,
    lng: 117.803767,
    lat: 38.976033,
    lastdyn: 1719859907,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOD1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121005,
  },
  {
    mmsi: 994141155,
    lng: 117.770408,
    lat: 38.944778,
    lastdyn: 1719859504,
    type: 5,
    shiptype: 'navigation',
    name: 'NO14 BERTH EAST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141155,
  },
  {
    mmsi: 994131404,
    lng: 119.669707,
    lat: 26.715038,
    lastdyn: 1719859866,
    type: 24,
    shiptype: 'navigation',
    name: 'SANSHA610',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131404,
  },
  {
    mmsi: 994131449,
    lng: 117.931972,
    lat: 38.951298,
    lastdyn: 1719859281,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 33',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131449,
  },
  {
    mmsi: 994131411,
    lng: 117.813337,
    lat: 38.96437,
    lastdyn: 1719859834,
    type: 0,
    shiptype: 'navigation',
    name: 'XINGANG 46',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 195,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131411,
  },
  {
    mmsi: 994121034,
    lng: 117.993868,
    lat: 38.855435,
    lastdyn: 1719853572,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHA NO220',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121034,
  },
  {
    mmsi: 994121040,
    lng: 117.924855,
    lat: 38.895927,
    lastdyn: 1719857718,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHA NO232',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121040,
  },
  {
    mmsi: 994141174,
    lng: 118.1929,
    lat: 38.8779,
    lastdyn: 1719858841,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141174,
  },
  {
    mmsi: 994121031,
    lng: 118.020202,
    lat: 38.845073,
    lastdyn: 1719859511,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHA NO 215',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121031,
  },
  {
    mmsi: 994141179,
    lng: 118.122742,
    lat: 38.913402,
    lastdyn: 1719859020,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141179,
  },
  {
    mmsi: 994121028,
    lng: 118.063045,
    lat: 38.814678,
    lastdyn: 1719859510,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHANO208',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121028,
  },
  {
    mmsi: 994131446,
    lng: 118.002015,
    lat: 38.935985,
    lastdyn: 1719859278,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131446,
  },
  {
    mmsi: 994141184,
    lng: 118.003302,
    lat: 38.941135,
    lastdyn: 1719858963,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO25',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141184,
  },
  {
    mmsi: 994121030,
    lng: 118.039952,
    lat: 38.828297,
    lastdyn: 1719859270,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHA NO212',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121030,
  },
  {
    mmsi: 994121029,
    lng: 118.043383,
    lat: 38.831617,
    lastdyn: 1719859395,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHA NO211',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121029,
  },
  {
    mmsi: 994141180,
    lng: 118.088957,
    lat: 38.92728,
    lastdyn: 1719858368,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141180,
  },
  {
    mmsi: 994141172,
    lng: 118.22543,
    lat: 38.859155,
    lastdyn: 1719859501,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141172,
  },
  {
    mmsi: 994121026,
    lng: 118.091297,
    lat: 38.797915,
    lastdyn: 1719859030,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHANO204',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121026,
  },
  {
    mmsi: 994121027,
    lng: 118.06613,
    lat: 38.81811,
    lastdyn: 1719859453,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHA NO207',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121027,
  },
  {
    mmsi: 994121032,
    lng: 118.016688,
    lat: 38.84172,
    lastdyn: 1719859391,
    type: 24,
    shiptype: 'navigation',
    name: 'DAGUSHANO216',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121032,
  },
  {
    mmsi: 994121025,
    lng: 118.094948,
    lat: 38.801383,
    lastdyn: 1719859330,
    type: 25,
    shiptype: 'navigation',
    name: 'DAGUSHANO203',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121025,
  },
  {
    mmsi: 994141175,
    lng: 118.189942,
    lat: 38.874167,
    lastdyn: 1719859442,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141175,
  },
  {
    mmsi: 994131443,
    lng: 118.04622,
    lat: 38.934125,
    lastdyn: 1719859458,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 21',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131443,
  },
  {
    mmsi: 994131440,
    lng: 118.12253,
    lat: 38.919148,
    lastdyn: 1719859446,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131440,
  },
  {
    mmsi: 994131444,
    lng: 118.044987,
    lat: 38.92913,
    lastdyn: 1719859516,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO 22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131444,
  },
  {
    mmsi: 994141173,
    lng: 118.222252,
    lat: 38.85555,
    lastdyn: 1719859504,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141173,
  },
  {
    mmsi: 994141177,
    lng: 118.155633,
    lat: 38.894312,
    lastdyn: 1719859440,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141177,
  },
  {
    mmsi: 994141151,
    lng: 118.521932,
    lat: 38.915277,
    lastdyn: 1719859779,
    type: 5,
    shiptype: 'navigation',
    name: 'OIL PIER WEST LT BN',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141151,
  },
  {
    mmsi: 994146001,
    lng: 118.578333,
    lat: 38.906667,
    lastdyn: 1719859799,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK PA JILUANYU039',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146001,
  },
  {
    mmsi: 994126046,
    lng: 118.671778,
    lat: 38.983972,
    lastdyn: 1719859822,
    type: 24,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 310',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126046,
  },
  {
    mmsi: 994121003,
    lng: 118.752232,
    lat: 38.966287,
    lastdyn: 1719859899,
    type: 0,
    shiptype: 'navigation',
    name: 'LAOTINGFENGDIANNO63',
    length: 11,
    width: 11,
    left: 10,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121003,
  },
  {
    mmsi: 994121002,
    lng: 118.837032,
    lat: 38.971012,
    lastdyn: 1719859655,
    type: 0,
    shiptype: 'navigation',
    name: 'LAOTINGFENGDIANNO36',
    length: 11,
    width: 11,
    left: 1,
    trail: 10,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121002,
  },
  {
    mmsi: 994131006,
    lng: 181,
    lat: 91,
    lastdyn: 1704421890,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO D23',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131006,
  },
  {
    mmsi: 994131002,
    lng: 119.016013,
    lat: 38.963483,
    lastdyn: 1719859145,
    type: 30,
    shiptype: 'navigation',
    name: 'JTGCF 3',
    length: 6,
    width: 6,
    left: 3,
    trail: 3,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131002,
  },
  {
    mmsi: 994131108,
    lng: 121.133918,
    lat: 38.81538,
    lastdyn: 1719859748,
    type: 22,
    shiptype: 'navigation',
    name: 'LVSHUN PORT NO 12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131108,
  },
  {
    mmsi: 994131106,
    lng: 121.130107,
    lat: 38.813343,
    lastdyn: 1719859808,
    type: 24,
    shiptype: 'navigation',
    name: 'LVSHUN PORT NO 10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131106,
  },
  {
    mmsi: 994131103,
    lng: 121.118123,
    lat: 38.796602,
    lastdyn: 1719859808,
    type: 24,
    shiptype: 'navigation',
    name: 'LVSHUN PORT NO 6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131103,
  },
  {
    mmsi: 994131107,
    lng: 121.136032,
    lat: 38.811113,
    lastdyn: 1719859868,
    type: 25,
    shiptype: 'navigation',
    name: 'LVSHUN PORT NO 11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131107,
  },
  {
    mmsi: 994131113,
    lng: 121.710502,
    lat: 38.956537,
    lastdyn: 1719859880,
    type: 25,
    shiptype: 'navigation',
    name: 'GANJINGZI CHANNEL H7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131113,
  },
  {
    mmsi: 994130034,
    lng: -111.827745,
    lat: 21.496445,
    lastdyn: 1685331457,
    type: 22,
    shiptype: 'navigation',
    name: 'QPLD',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994130034,
  },
  {
    mmsi: 994131118,
    lng: 121.680442,
    lat: 38.93229,
    lastdyn: 1719859876,
    type: 24,
    shiptype: 'navigation',
    name: 'DL EAST NO3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131118,
  },
  {
    mmsi: 994131114,
    lng: 121.692908,
    lat: 38.956567,
    lastdyn: 1719859757,
    type: 25,
    shiptype: 'navigation',
    name: 'GANJINGZI CHANNEL H9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131114,
  },
  {
    mmsi: 994131128,
    lng: 121.613473,
    lat: 38.932217,
    lastdyn: 1719859877,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANGLUJIAOAREANO8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131128,
  },
  {
    mmsi: 994131120,
    lng: 121.628367,
    lat: 38.948832,
    lastdyn: 1719859876,
    type: 25,
    shiptype: 'navigation',
    name: 'XIANGLUJIAO AREA NO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131120,
  },
  {
    mmsi: 994131116,
    lng: 121.704202,
    lat: 38.925538,
    lastdyn: 1719824291,
    type: 24,
    shiptype: 'navigation',
    name: 'DL EAST NO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131116,
  },
  {
    mmsi: 994131111,
    lng: 121.745517,
    lat: 38.956492,
    lastdyn: 1719859760,
    type: 25,
    shiptype: 'navigation',
    name: 'DALIAN PORT H3',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131111,
  },
  {
    mmsi: 994131117,
    lng: 121.692548,
    lat: 38.928793,
    lastdyn: 1719859816,
    type: 24,
    shiptype: 'navigation',
    name: 'DL EAST NO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131117,
  },
  {
    mmsi: 994131115,
    lng: 121.638418,
    lat: 38.955588,
    lastdyn: 1719855316,
    type: 27,
    shiptype: 'navigation',
    name: 'GANJINGZI CH H11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131115,
  },
  {
    mmsi: 994131126,
    lng: 121.623243,
    lat: 38.938297,
    lastdyn: 1719859760,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANGLUJIAOAREANO4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131126,
  },
  {
    mmsi: 994131127,
    lng: 121.616698,
    lat: 38.933093,
    lastdyn: 1719859816,
    type: 26,
    shiptype: 'navigation',
    name: 'XIANGLUJIAOAREANO6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131127,
  },
  {
    mmsi: 994131112,
    lng: 121.728032,
    lat: 38.95639,
    lastdyn: 1719859816,
    type: 25,
    shiptype: 'navigation',
    name: 'GANJINGZI CHANNEL H5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131112,
  },
  {
    mmsi: 994131119,
    lng: 121.668397,
    lat: 38.93609,
    lastdyn: 1719859757,
    type: 24,
    shiptype: 'navigation',
    name: 'DL EAST NO4',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131119,
  },
  {
    mmsi: 994131124,
    lng: 121.621975,
    lat: 38.9416,
    lastdyn: 1719859877,
    type: 24,
    shiptype: 'navigation',
    name: 'XIANGLUJIAOAREANO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131124,
  },
  {
    mmsi: 994146085,
    lng: 121.538833,
    lat: 38.906833,
    lastdyn: 1719859740,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST NDQ1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146085,
  },
  {
    mmsi: 994131153,
    lng: 121.983857,
    lat: 38.955528,
    lastdyn: 1719857544,
    type: 22,
    shiptype: 'navigation',
    name: 'NANSANLIANGCHEJIAO 1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131153,
  },
  {
    mmsi: 994131137,
    lng: 121.784857,
    lat: 38.972645,
    lastdyn: 1719859886,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131137,
  },
  {
    mmsi: 994131142,
    lng: 121.774277,
    lat: 38.993272,
    lastdyn: 1719859872,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131142,
  },
  {
    mmsi: 994131158,
    lng: 121.966892,
    lat: 38.993172,
    lastdyn: 1719859540,
    type: 25,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO27',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131158,
  },
  {
    mmsi: 994131141,
    lng: 121.772077,
    lat: 38.992432,
    lastdyn: 1719859902,
    type: 24,
    shiptype: 'navigation',
    name: 'HESHANGDAONO12',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131141,
  },
  {
    mmsi: 994131134,
    lng: 121.785772,
    lat: 38.963657,
    lastdyn: 1719859883,
    type: 24,
    shiptype: 'navigation',
    name: 'HESHANGDAONO6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131134,
  },
  {
    mmsi: 994131138,
    lng: 121.779915,
    lat: 38.981508,
    lastdyn: 1719859892,
    type: 24,
    shiptype: 'navigation',
    name: 'HESHANGDAONO10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131138,
  },
  {
    mmsi: 994131140,
    lng: 121.781272,
    lat: 38.983817,
    lastdyn: 1719859881,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131140,
  },
  {
    mmsi: 994131139,
    lng: 121.777995,
    lat: 38.98465,
    lastdyn: 1719859897,
    type: 24,
    shiptype: 'navigation',
    name: 'HESHANGDAONO101',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131139,
  },
  {
    mmsi: 994136119,
    lng: 121.923263,
    lat: 38.912303,
    lastdyn: 1719859789,
    type: 28,
    shiptype: 'navigation',
    name: 'DALVBU1022 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136119,
  },
  {
    mmsi: 994131157,
    lng: 121.991422,
    lat: 38.992075,
    lastdyn: 1719856657,
    type: 25,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131157,
  },
  {
    mmsi: 994136121,
    lng: 121.84,
    lat: 38.936667,
    lastdyn: 1719859793,
    type: 28,
    shiptype: 'navigation',
    name: 'LIAODAKAIYU61115 WRE',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136121,
  },
  {
    mmsi: 994131159,
    lng: 121.916312,
    lat: 38.993173,
    lastdyn: 1719859876,
    type: 24,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131159,
  },
  {
    mmsi: 994131160,
    lng: 121.918295,
    lat: 38.995133,
    lastdyn: 1719859905,
    type: 25,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131160,
  },
  {
    mmsi: 994131136,
    lng: 121.782895,
    lat: 38.972068,
    lastdyn: 1719859889,
    type: 24,
    shiptype: 'navigation',
    name: 'HESHANGDAONO8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131136,
  },
  {
    mmsi: 994131109,
    lng: 121.770265,
    lat: 38.930233,
    lastdyn: 1719859269,
    type: 30,
    shiptype: 'navigation',
    name: 'DALIAN PORT H1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131109,
  },
  {
    mmsi: 994131110,
    lng: 121.770742,
    lat: 38.95473,
    lastdyn: 1719859389,
    type: 30,
    shiptype: 'navigation',
    name: 'DALIAN PORT H2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131110,
  },
  {
    mmsi: 994131135,
    lng: 121.788057,
    lat: 38.963442,
    lastdyn: 1719859739,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131135,
  },
  {
    mmsi: 994131156,
    lng: 122.015408,
    lat: 38.991098,
    lastdyn: 1719857547,
    type: 30,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO25',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131156,
  },
  {
    mmsi: 994146077,
    lng: 117,
    lat: 39,
    lastdyn: 1719859905,
    type: 1,
    shiptype: 'navigation',
    name: 'TYH TEST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146077,
  },
  {
    mmsi: 994146076,
    lng: 117.016667,
    lat: 39.016667,
    lastdyn: 1719859906,
    type: 1,
    shiptype: 'navigation',
    name: 'TYH TEST02',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146076,
  },
  {
    mmsi: 994146143,
    lng: 117.733667,
    lat: 39.061388,
    lastdyn: 1719736617,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST YLMG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146143,
  },
  {
    mmsi: 994146079,
    lng: 117.733667,
    lat: 39.061388,
    lastdyn: 1719859917,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST YLMG',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146079,
  },
  {
    mmsi: 994146023,
    lng: 117.777803,
    lat: 39.00675,
    lastdyn: 1719859744,
    type: 24,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOX6',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146023,
  },
  {
    mmsi: 994141200,
    lng: 117.78205,
    lat: 39.007717,
    lastdyn: 1719859742,
    type: 22,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOD5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141200,
  },
  {
    mmsi: 994146022,
    lng: 117.78097,
    lat: 39.007238,
    lastdyn: 1719859847,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOX5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146022,
  },
  {
    mmsi: 990230113,
    lng: 117.866633,
    lat: 39.040717,
    lastdyn: 1719859883,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON1030303230113',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 990230113,
  },
  {
    mmsi: 994141201,
    lng: 117.7757,
    lat: 39.020183,
    lastdyn: 1719859802,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOD7',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141201,
  },
  {
    mmsi: 994146002,
    lng: 117.772767,
    lat: 39.009255,
    lastdyn: 1719859849,
    type: 5,
    shiptype: 'navigation',
    name: 'TJ PORT C SOUTH BEAC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146002,
  },
  {
    mmsi: 994121087,
    lng: 117.770607,
    lat: 39.039275,
    lastdyn: 1719859753,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NOD13',
    length: 4,
    width: 4,
    left: 2,
    trail: 2,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121087,
  },
  {
    mmsi: 994126072,
    lng: 118.547028,
    lat: 39.073195,
    lastdyn: 1719859786,
    type: 25,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 357',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126072,
  },
  {
    mmsi: 994126063,
    lng: 118.598695,
    lat: 39.091112,
    lastdyn: 1719859826,
    type: 24,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 348',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126063,
  },
  {
    mmsi: 991901264,
    lng: 118.74751,
    lat: 39.04586,
    lastdyn: 1719859376,
    type: 0,
    shiptype: 'navigation',
    name: '1901264',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 991901264,
  },
  {
    mmsi: 994126071,
    lng: 118.560472,
    lat: 39.076167,
    lastdyn: 1719859783,
    type: 24,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 356',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126071,
  },
  {
    mmsi: 994126068,
    lng: 118.568695,
    lat: 39.081667,
    lastdyn: 1719859810,
    type: 25,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 353',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126068,
  },
  {
    mmsi: 994126064,
    lng: 118.587888,
    lat: 39.089195,
    lastdyn: 1719859825,
    type: 25,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 349',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126064,
  },
  {
    mmsi: 994141160,
    lng: 118.6061,
    lat: 39.096233,
    lastdyn: 1719859873,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141160,
  },
  {
    mmsi: 994141157,
    lng: 118.658688,
    lat: 39.003867,
    lastdyn: 1719858629,
    type: 24,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN316',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141157,
  },
  {
    mmsi: 994126075,
    lng: 118.536112,
    lat: 39.066583,
    lastdyn: 1719859799,
    type: 24,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 360',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126075,
  },
  {
    mmsi: 994126058,
    lng: 118.614695,
    lat: 39.092278,
    lastdyn: 1719859819,
    type: 24,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 344',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126058,
  },
  {
    mmsi: 994141158,
    lng: 118.663043,
    lat: 39.061482,
    lastdyn: 1719859535,
    type: 25,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN329',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994141158,
  },
  {
    mmsi: 994126067,
    lng: 118.5795,
    lat: 39.083583,
    lastdyn: 1719859807,
    type: 24,
    shiptype: 'navigation',
    name: 'CAOFEIDIAN 352',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994126067,
  },
  {
    mmsi: 994146035,
    lng: 118.802,
    lat: 39.001667,
    lastdyn: 1719859777,
    type: 28,
    shiptype: 'navigation',
    name: 'TANGSHAN WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146035,
  },
  {
    mmsi: 994146043,
    lng: 118.916112,
    lat: 39.070638,
    lastdyn: 1719859867,
    type: 3,
    shiptype: 'navigation',
    name: 'NB352CEP PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146043,
  },
  {
    mmsi: 994146034,
    lng: 118.750112,
    lat: 39.072722,
    lastdyn: 1719859782,
    type: 28,
    shiptype: 'navigation',
    name: 'YUEANYUN61 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146034,
  },
  {
    mmsi: 994131003,
    lng: 118.969448,
    lat: 39.045298,
    lastdyn: 1719858248,
    type: 30,
    shiptype: 'navigation',
    name: 'NO3OF NO3WIND TO WER',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131003,
  },
  {
    mmsi: 994121001,
    lng: 118.861367,
    lat: 39.022875,
    lastdyn: 1719859602,
    type: 0,
    shiptype: 'navigation',
    name: 'LAOTINGFENGDIANNO13',
    length: 11,
    width: 11,
    left: 1,
    trail: 10,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121001,
  },
  {
    mmsi: 994131005,
    lng: 119.505642,
    lat: 35.386172,
    lastdyn: 1704417381,
    type: 24,
    shiptype: 'navigation',
    name: 'ATON 801231008023537',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131005,
  },
  {
    mmsi: 994131057,
    lng: 119.2343,
    lat: 39.024633,
    lastdyn: 1719859091,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131057,
  },
  {
    mmsi: 994131085,
    lng: 119.089817,
    lat: 39.138933,
    lastdyn: 1719859153,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO36',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131085,
  },
  {
    mmsi: 994131056,
    lng: 119.231017,
    lat: 39.0224,
    lastdyn: 1719859394,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131056,
  },
  {
    mmsi: 994131060,
    lng: 119.1857,
    lat: 39.05835,
    lastdyn: 1719859634,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131060,
  },
  {
    mmsi: 994131066,
    lng: 119.010933,
    lat: 39.1961,
    lastdyn: 1719859515,
    type: 24,
    shiptype: 'navigation',
    name: 'JTG NO49',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131066,
  },
  {
    mmsi: 994146095,
    lng: 119.203333,
    lat: 39.111667,
    lastdyn: 1719859741,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST QHD326',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146095,
  },
  {
    mmsi: 994131081,
    lng: 119.13525,
    lat: 39.102867,
    lastdyn: 1719859646,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO28',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131081,
  },
  {
    mmsi: 994131061,
    lng: 119.189117,
    lat: 39.060667,
    lastdyn: 1719859519,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO18',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131061,
  },
  {
    mmsi: 994146041,
    lng: 119.182667,
    lat: 39.10725,
    lastdyn: 1719859864,
    type: 3,
    shiptype: 'navigation',
    name: 'QHD326F PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146041,
  },
  {
    mmsi: 994131068,
    lng: 119.000033,
    lat: 39.2043,
    lastdyn: 1719859629,
    type: 24,
    shiptype: 'navigation',
    name: 'JTG NO55',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131068,
  },
  {
    mmsi: 994131058,
    lng: 119.20835,
    lat: 39.040383,
    lastdyn: 1719859518,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131058,
  },
  {
    mmsi: 994131078,
    lng: 119.151417,
    lat: 39.085117,
    lastdyn: 1719859630,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO23',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131078,
  },
  {
    mmsi: 994131059,
    lng: 119.211417,
    lat: 39.042717,
    lastdyn: 1719859576,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131059,
  },
  {
    mmsi: 994131084,
    lng: 119.086783,
    lat: 39.136533,
    lastdyn: 1719859632,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO35',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131084,
  },
  {
    mmsi: 994131076,
    lng: 181,
    lat: 91,
    lastdyn: 1719859536,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131076,
  },
  {
    mmsi: 994131080,
    lng: 119.1321,
    lat: 39.100717,
    lastdyn: 1719859390,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO27',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131080,
  },
  {
    mmsi: 994131082,
    lng: 119.1096,
    lat: 39.118717,
    lastdyn: 1719859508,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO31',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131082,
  },
  {
    mmsi: 994131072,
    lng: 119.0407,
    lat: 39.2164,
    lastdyn: 1719859328,
    type: 24,
    shiptype: 'navigation',
    name: 'JTG NO405',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131072,
  },
  {
    mmsi: 994131075,
    lng: 119.072483,
    lat: 39.23425,
    lastdyn: 1719859516,
    type: 24,
    shiptype: 'navigation',
    name: 'JTG NO411',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131075,
  },
  {
    mmsi: 994131079,
    lng: 119.11065,
    lat: 39.099833,
    lastdyn: 1719859681,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO24',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131079,
  },
  {
    mmsi: 994131073,
    lng: 119.030183,
    lat: 39.203083,
    lastdyn: 1719859407,
    type: 0,
    shiptype: 'navigation',
    name: 'ATON TEST',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131073,
  },
  {
    mmsi: 994131004,
    lng: 181,
    lat: 91,
    lastdyn: 1710219051,
    type: 25,
    shiptype: 'navigation',
    name: 'TIANJIN PORT NO D17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131004,
  },
  {
    mmsi: 994131055,
    lng: 119.256683,
    lat: 39.006633,
    lastdyn: 1719859142,
    type: 25,
    shiptype: 'navigation',
    name: 'JTGNO6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131055,
  },
  {
    mmsi: 994131054,
    lng: 119.253633,
    lat: 39.0043,
    lastdyn: 1719859079,
    type: 24,
    shiptype: 'navigation',
    name: 'JTGNO5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131054,
  },
  {
    mmsi: 994146055,
    lng: 124.158028,
    lat: 39.853152,
    lastdyn: 1719859868,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST DD',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146055,
  },
  {
    mmsi: 994146056,
    lng: 120.4185,
    lat: 39.249638,
    lastdyn: 1719859750,
    type: 3,
    shiptype: 'navigation',
    name: 'LD272WHPB PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146056,
  },
  {
    mmsi: 994146096,
    lng: 120.312882,
    lat: 39.161647,
    lastdyn: 1719859584,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST LD322',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994146096,
  },
  {
    mmsi: 994131170,
    lng: 121.888867,
    lat: 39.017042,
    lastdyn: 1719859870,
    type: 25,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO58',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131170,
  },
  {
    mmsi: 994131169,
    lng: 121.84588,
    lat: 39.036615,
    lastdyn: 1719859873,
    type: 25,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO48',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131169,
  },
  {
    mmsi: 994131149,
    lng: 121.756703,
    lat: 39.016705,
    lastdyn: 1719859890,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO18',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131149,
  },
  {
    mmsi: 994131146,
    lng: 121.755165,
    lat: 39.015873,
    lastdyn: 1719859915,
    type: 24,
    shiptype: 'navigation',
    name: 'HESHANGDAONO16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131146,
  },
  {
    mmsi: 994131148,
    lng: 121.758613,
    lat: 39.014267,
    lastdyn: 1719859863,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO171',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131148,
  },
  {
    mmsi: 994131167,
    lng: 121.85101,
    lat: 39.029187,
    lastdyn: 1719859895,
    type: 24,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO411',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131167,
  },
  {
    mmsi: 994131166,
    lng: 121.855687,
    lat: 39.023023,
    lastdyn: 1719859882,
    type: 21,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO391',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131166,
  },
  {
    mmsi: 994131147,
    lng: 121.762632,
    lat: 39.008705,
    lastdyn: 1719859879,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131147,
  },
  {
    mmsi: 994131161,
    lng: 121.893412,
    lat: 39.005742,
    lastdyn: 1719859873,
    type: 26,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO33',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131161,
  },
  {
    mmsi: 994131164,
    lng: 121.876253,
    lat: 39.004542,
    lastdyn: 1719859880,
    type: 30,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO37',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131164,
  },
  {
    mmsi: 994131143,
    lng: 121.766505,
    lat: 39.000333,
    lastdyn: 1719859906,
    type: 24,
    shiptype: 'navigation',
    name: 'HESHANGDAONO14',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131143,
  },
  {
    mmsi: 994131162,
    lng: 121.879617,
    lat: 39.006853,
    lastdyn: 1719859875,
    type: 24,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO35',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131162,
  },
  {
    mmsi: 994131145,
    lng: 121.7684,
    lat: 39.000843,
    lastdyn: 1719859909,
    type: 25,
    shiptype: 'navigation',
    name: 'HESHANGDAONO15',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131145,
  },
  {
    mmsi: 994131168,
    lng: 121.858683,
    lat: 39.031157,
    lastdyn: 1719859862,
    type: 25,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO44',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131168,
  },
  {
    mmsi: 994131163,
    lng: 121.895345,
    lat: 39.007187,
    lastdyn: 1719859911,
    type: 25,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO36',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131163,
  },
  {
    mmsi: 994131165,
    lng: 121.864622,
    lat: 39.021778,
    lastdyn: 1719859878,
    type: 26,
    shiptype: 'navigation',
    name: 'DAYAO WAN NO39',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131165,
  },
  {
    mmsi: 994136125,
    lng: 122.23971,
    lat: 39.230093,
    lastdyn: 1719859866,
    type: 28,
    shiptype: 'navigation',
    name: 'YX WATERWAY OBSTRUCT',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136125,
  },
  {
    mmsi: 994146154,
    lng: 117.521833,
    lat: 39.290667,
    lastdyn: 1718620832,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST DGDT2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146154,
  },
  {
    mmsi: 994146090,
    lng: 117.521833,
    lat: 39.290667,
    lastdyn: 1719859770,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST DGDT2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146090,
  },
  {
    mmsi: 994131047,
    lng: 119.29614,
    lat: 39.47632,
    lastdyn: 1719859797,
    type: 30,
    shiptype: 'navigation',
    name: 'GFS NO10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131047,
  },
  {
    mmsi: 994136120,
    lng: 121.11,
    lat: 39.321667,
    lastdyn: 1719859808,
    type: 28,
    shiptype: 'navigation',
    name: 'LIAOYINGYU55102 WREC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136120,
  },
  {
    mmsi: 994136110,
    lng: 121.453,
    lat: 39.270667,
    lastdyn: 1719859802,
    type: 28,
    shiptype: 'navigation',
    name: 'XINGHANG666 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136110,
  },
  {
    mmsi: 994136109,
    lng: 121.4465,
    lat: 39.2625,
    lastdyn: 1719859799,
    type: 28,
    shiptype: 'navigation',
    name: 'HAOYANG69 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136109,
  },
  {
    mmsi: 994131180,
    lng: 123.237263,
    lat: 39.444217,
    lastdyn: 1719858599,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHUANGHEFENGDIANATON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131180,
  },
  {
    mmsi: 994131179,
    lng: 123.161468,
    lat: 39.444228,
    lastdyn: 1719858573,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHUANGHEFENGDIANATON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131179,
  },
  {
    mmsi: 994131185,
    lng: 123.3755,
    lat: 39.390917,
    lastdyn: 1719816462,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHFD VS8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131185,
  },
  {
    mmsi: 994131181,
    lng: 123.29455,
    lat: 39.390933,
    lastdyn: 1719846465,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHFD VS1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131181,
  },
  {
    mmsi: 994131155,
    lng: 123.63118,
    lat: 39.35447,
    lastdyn: 1719858611,
    type: 30,
    shiptype: 'navigation',
    name: 'DD ANEMOMETER TOWER',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131155,
  },
  {
    mmsi: 994131121,
    lng: 123.710185,
    lat: 39.417858,
    lastdyn: 1719859686,
    type: 31,
    shiptype: 'navigation',
    name: 'ATON 2205',
    length: 10,
    width: 10,
    left: 5,
    trail: 5,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131121,
  },
  {
    mmsi: 999000044,
    lng: 119.592597,
    lat: 39.68159,
    lastdyn: 1719859482,
    type: 31,
    shiptype: 'navigation',
    name: '0023FUBIAO',
    length: 13,
    width: 10,
    left: 5,
    trail: 3,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999000044,
  },
  {
    mmsi: 999991014,
    lng: 120.595117,
    lat: 39.500413,
    lastdyn: 1719855934,
    type: 24,
    shiptype: 'navigation',
    name: 'QF112',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 999991014,
  },
  {
    mmsi: 994136111,
    lng: 121.0175,
    lat: 39.535833,
    lastdyn: 1719859805,
    type: 28,
    shiptype: 'navigation',
    name: 'LURONGYU51997 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136111,
  },
  {
    mmsi: 994146084,
    lng: 121.678507,
    lat: 39.504833,
    lastdyn: 1719859770,
    type: 1,
    shiptype: 'navigation',
    name: 'T4 NDQ2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146084,
  },
  {
    mmsi: 994131177,
    lng: 123.175473,
    lat: 39.501542,
    lastdyn: 1719859905,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHUANGHEFENGDIANATON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131177,
  },
  {
    mmsi: 994131178,
    lng: 123.237248,
    lat: 39.50161,
    lastdyn: 1719856796,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHUANGHEFENGDIANATON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131178,
  },
  {
    mmsi: 994131175,
    lng: 123.175592,
    lat: 39.515555,
    lastdyn: 1719859643,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHUANGHEFENGDIANATON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131175,
  },
  {
    mmsi: 994131176,
    lng: 123.23327,
    lat: 39.515435,
    lastdyn: 1719859729,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHUANGHEFENGDIANATON',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131176,
  },
  {
    mmsi: 994136113,
    lng: 123.996805,
    lat: 39.577055,
    lastdyn: 1719859848,
    type: 25,
    shiptype: 'navigation',
    name: 'DANDONG PORT NO1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136113,
  },
  {
    mmsi: 994136115,
    lng: 124.023417,
    lat: 39.603833,
    lastdyn: 1719859853,
    type: 25,
    shiptype: 'navigation',
    name: 'DANDONG PORT NO3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136115,
  },
  {
    mmsi: 994136116,
    lng: 124.032722,
    lat: 39.618888,
    lastdyn: 1719859860,
    type: 24,
    shiptype: 'navigation',
    name: 'DANDONG PORT NO4',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136116,
  },
  {
    mmsi: 994136117,
    lng: 124.090277,
    lat: 39.676443,
    lastdyn: 1719859860,
    type: 24,
    shiptype: 'navigation',
    name: 'DANDONG PORT NO7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136117,
  },
  {
    mmsi: 994136118,
    lng: 124.116827,
    lat: 39.704472,
    lastdyn: 1719859860,
    type: 24,
    shiptype: 'navigation',
    name: 'DANDONG PORT NO9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136118,
  },
  {
    mmsi: 994136114,
    lng: 124.006527,
    lat: 39.592305,
    lastdyn: 1719859853,
    type: 24,
    shiptype: 'navigation',
    name: 'DANDONG PORT NO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136114,
  },
  {
    mmsi: 994131095,
    lng: 119.679258,
    lat: 39.902153,
    lastdyn: 1719859872,
    type: 24,
    shiptype: 'navigation',
    name: 'QINHUANGDAO ATON 419',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131095,
  },
  {
    mmsi: 994136002,
    lng: 119.692597,
    lat: 39.916222,
    lastdyn: 1719859800,
    type: 25,
    shiptype: 'navigation',
    name: 'QINSHAN H22',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136002,
  },
  {
    mmsi: 994131092,
    lng: 119.73595,
    lat: 39.832427,
    lastdyn: 1719859036,
    type: 25,
    shiptype: 'navigation',
    name: 'QINHUANGDAO ATON 408',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131092,
  },
  {
    mmsi: 994136001,
    lng: 119.690895,
    lat: 39.91632,
    lastdyn: 1719859797,
    type: 24,
    shiptype: 'navigation',
    name: 'QINSHAN H11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136001,
  },
  {
    mmsi: 994136003,
    lng: 119.757467,
    lat: 39.897883,
    lastdyn: 1719859802,
    type: 28,
    shiptype: 'navigation',
    name: 'DUMP AREA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136003,
  },
  {
    mmsi: 994131089,
    lng: 119.75647,
    lat: 39.79982,
    lastdyn: 1719858850,
    type: 24,
    shiptype: 'navigation',
    name: 'QINHUANGDAO ATON 401',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131089,
  },
  {
    mmsi: 994131090,
    lng: 119.759623,
    lat: 39.801158,
    lastdyn: 1719859155,
    type: 25,
    shiptype: 'navigation',
    name: 'QINHUANGDAO ATON 402',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131090,
  },
  {
    mmsi: 994121566,
    lng: 120.010512,
    lat: 39.87653,
    lastdyn: 1719859868,
    type: 0,
    shiptype: 'navigation',
    name: 'JZHNDS1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994121566,
  },
  {
    mmsi: 994136122,
    lng: 120.972858,
    lat: 39.996503,
    lastdyn: 1719859841,
    type: 28,
    shiptype: 'navigation',
    name: 'JILEYU01066 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136122,
  },
  {
    mmsi: 994146048,
    lng: 120.816695,
    lat: 39.927862,
    lastdyn: 1719859794,
    type: 3,
    shiptype: 'navigation',
    name: 'SZ361C PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146048,
  },
  {
    mmsi: 994146054,
    lng: 121.058333,
    lat: 39.977472,
    lastdyn: 1719859789,
    type: 3,
    shiptype: 'navigation',
    name: 'JX11CEPA PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146054,
  },
  {
    mmsi: 994136108,
    lng: 121.419167,
    lat: 39.824667,
    lastdyn: 1719859796,
    type: 28,
    shiptype: 'navigation',
    name: 'HAIHONG01 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136108,
  },
  {
    mmsi: 994136213,
    lng: 121.059362,
    lat: 40.095083,
    lastdyn: 1719859885,
    type: 22,
    shiptype: 'navigation',
    name: 'JINZHOU NO3112',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136213,
  },
  {
    mmsi: 994136818,
    lng: 113.541778,
    lat: 22.972083,
    lastdyn: 1719859910,
    type: 25,
    shiptype: 'navigation',
    name: 'LIAN HUA SHAN 6A',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136818,
  },
  {
    mmsi: 994146052,
    lng: 121.024583,
    lat: 40.243,
    lastdyn: 1719859868,
    type: 3,
    shiptype: 'navigation',
    name: 'JZ251SCEP PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146052,
  },
  {
    mmsi: 994136212,
    lng: 121.061167,
    lat: 40.096888,
    lastdyn: 1719859882,
    type: 21,
    shiptype: 'navigation',
    name: 'JINZHOU NO3111',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136212,
  },
  {
    mmsi: 994136215,
    lng: 121.059362,
    lat: 40.098667,
    lastdyn: 1719859891,
    type: 20,
    shiptype: 'navigation',
    name: 'JINZHOU NO3114',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136215,
  },
  {
    mmsi: 994136214,
    lng: 121.057555,
    lat: 40.096888,
    lastdyn: 1719859888,
    type: 23,
    shiptype: 'navigation',
    name: 'JINZHOU NO3113',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136214,
  },
  {
    mmsi: 994136238,
    lng: 121.07475,
    lat: 40.035028,
    lastdyn: 1719859876,
    type: 28,
    shiptype: 'navigation',
    name: 'LIAOWAYU75119 WRECK',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136238,
  },
  {
    mmsi: 994131205,
    lng: 121.7463,
    lat: 40.215333,
    lastdyn: 1719857987,
    type: 23,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO0',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131205,
  },
  {
    mmsi: 994136230,
    lng: 121.805333,
    lat: 40.177333,
    lastdyn: 1719859833,
    type: 28,
    shiptype: 'navigation',
    name: 'LJJ ISOLATED DANGER',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136230,
  },
  {
    mmsi: 994131207,
    lng: 121.78537,
    lat: 40.2394,
    lastdyn: 1719858288,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131207,
  },
  {
    mmsi: 994131230,
    lng: 121.796137,
    lat: 40.249942,
    lastdyn: 1719858534,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO8',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131230,
  },
  {
    mmsi: 994131208,
    lng: 121.782823,
    lat: 40.241765,
    lastdyn: 1719858344,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO6',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131208,
  },
  {
    mmsi: 994131206,
    lng: 121.75597,
    lat: 40.22507,
    lastdyn: 1719858772,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO2',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131206,
  },
  {
    mmsi: 994131226,
    lng: 121.75828,
    lat: 40.222757,
    lastdyn: 1719858654,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131226,
  },
  {
    mmsi: 994131225,
    lng: 122.004382,
    lat: 40.171577,
    lastdyn: 1719859751,
    type: 0,
    shiptype: 'navigation',
    name: 'BYQ ANEMOMETER T N02',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131225,
  },
  {
    mmsi: 994146053,
    lng: 121.103612,
    lat: 40.340388,
    lastdyn: 1719859865,
    type: 3,
    shiptype: 'navigation',
    name: 'JZ251CEP PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146053,
  },
  {
    mmsi: 994146050,
    lng: 121.395972,
    lat: 40.376972,
    lastdyn: 1719859877,
    type: 3,
    shiptype: 'navigation',
    name: 'JZ211 PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146050,
  },
  {
    mmsi: 994131217,
    lng: 121.925282,
    lat: 40.299285,
    lastdyn: 1719859789,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO25',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131217,
  },
  {
    mmsi: 994131238,
    lng: 121.937122,
    lat: 40.299937,
    lastdyn: 1719859911,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO27',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131238,
  },
  {
    mmsi: 994131218,
    lng: 121.92477,
    lat: 40.304802,
    lastdyn: 1719859673,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO26',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131218,
  },
  {
    mmsi: 994131239,
    lng: 121.938842,
    lat: 40.303555,
    lastdyn: 1719859791,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO28',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131239,
  },
  {
    mmsi: 994131236,
    lng: 121.913668,
    lat: 40.298663,
    lastdyn: 1719859434,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO23',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131236,
  },
  {
    mmsi: 994131210,
    lng: 121.810025,
    lat: 40.258425,
    lastdyn: 1719859913,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO10',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131210,
  },
  {
    mmsi: 994131203,
    lng: 121.80301,
    lat: 40.373167,
    lastdyn: 1719858292,
    type: 25,
    shiptype: 'navigation',
    name: 'RONGXING PORT NO1',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131203,
  },
  {
    mmsi: 994131219,
    lng: 121.954955,
    lat: 40.298063,
    lastdyn: 1719859909,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO29',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131219,
  },
  {
    mmsi: 994131231,
    lng: 121.826218,
    lat: 40.264415,
    lastdyn: 1719857874,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO11',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131231,
  },
  {
    mmsi: 994131240,
    lng: 121.976027,
    lat: 40.296035,
    lastdyn: 1719859855,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO31',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131240,
  },
  {
    mmsi: 994131215,
    lng: 121.898168,
    lat: 40.295017,
    lastdyn: 1719858773,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO 21',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131215,
  },
  {
    mmsi: 994131209,
    lng: 121.812488,
    lat: 40.25605,
    lastdyn: 1719859852,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO9',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131209,
  },
  {
    mmsi: 994131220,
    lng: 121.955708,
    lat: 40.302063,
    lastdyn: 1719859789,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO30',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131220,
  },
  {
    mmsi: 994131233,
    lng: 121.850882,
    lat: 40.283457,
    lastdyn: 1719857270,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO16',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131233,
  },
  {
    mmsi: 994131213,
    lng: 121.864953,
    lat: 40.285483,
    lastdyn: 1719859909,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO17',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131213,
  },
  {
    mmsi: 994131214,
    lng: 121.861465,
    lat: 40.29011,
    lastdyn: 1719858169,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO18',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131214,
  },
  {
    mmsi: 994131221,
    lng: 121.997023,
    lat: 40.293948,
    lastdyn: 1719859849,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO 33',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131221,
  },
  {
    mmsi: 994131241,
    lng: 121.97666,
    lat: 40.299935,
    lastdyn: 1719859915,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO32',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131241,
  },
  {
    mmsi: 994131222,
    lng: 121.99767,
    lat: 40.298095,
    lastdyn: 1719859909,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO34',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131222,
  },
  {
    mmsi: 994131216,
    lng: 121.896857,
    lat: 40.298375,
    lastdyn: 1719859913,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO 22',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131216,
  },
  {
    mmsi: 994131235,
    lng: 121.87656,
    lat: 40.293787,
    lastdyn: 1719856855,
    type: 24,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO20',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131235,
  },
  {
    mmsi: 994131211,
    lng: 121.83987,
    lat: 40.272555,
    lastdyn: 1719858938,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO13',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131211,
  },
  {
    mmsi: 994131247,
    lng: 122.057107,
    lat: 40.29938,
    lastdyn: 1719859912,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NOA5',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131247,
  },
  {
    mmsi: 994131244,
    lng: 122.054092,
    lat: 40.288323,
    lastdyn: 1719859911,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO39',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131244,
  },
  {
    mmsi: 994131246,
    lng: 122.065993,
    lat: 40.287085,
    lastdyn: 1719859851,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO41',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131246,
  },
  {
    mmsi: 994131224,
    lng: 122.04003,
    lat: 40.293988,
    lastdyn: 1719859849,
    type: 23,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO38',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131224,
  },
  {
    mmsi: 994131245,
    lng: 122.060733,
    lat: 40.292903,
    lastdyn: 1719859840,
    type: 26,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO40',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131245,
  },
  {
    mmsi: 994131223,
    lng: 122.038912,
    lat: 40.289987,
    lastdyn: 1719859789,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO37',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 1,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131223,
  },
  {
    mmsi: 994131242,
    lng: 122.021795,
    lat: 40.29152,
    lastdyn: 1719859839,
    type: 25,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO35',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131242,
  },
  {
    mmsi: 994131243,
    lng: 122.022037,
    lat: 40.295555,
    lastdyn: 1719859851,
    type: 26,
    shiptype: 'navigation',
    name: 'BAYUQUAN PORT NO36',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131243,
  },
  {
    mmsi: 994169266,
    lng: 120.059682,
    lat: 23.68196,
    lastdyn: 1696294053,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC266 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169266,
  },
  {
    mmsi: 994136259,
    lng: 121.091805,
    lat: 40.513,
    lastdyn: 1719859886,
    type: 25,
    shiptype: 'navigation',
    name: 'JINZHOU PORT NO1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136259,
  },
  {
    mmsi: 994136011,
    lng: 121.020638,
    lat: 40.749695,
    lastdyn: 1719859916,
    type: 25,
    shiptype: 'navigation',
    name: 'HLD NORTH NO11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136011,
  },
  {
    mmsi: 994136005,
    lng: 121.034167,
    lat: 40.733333,
    lastdyn: 1719859745,
    type: 28,
    shiptype: 'navigation',
    name: 'DISABLED SHIP YDWG08',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136005,
  },
  {
    mmsi: 994136008,
    lng: 121.042862,
    lat: 40.7365,
    lastdyn: 1719859907,
    type: 25,
    shiptype: 'navigation',
    name: 'HLD NORTH NO3',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136008,
  },
  {
    mmsi: 994136007,
    lng: 121.046333,
    lat: 40.733028,
    lastdyn: 1719859904,
    type: 25,
    shiptype: 'navigation',
    name: 'HLD NORTH NO1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136007,
  },
  {
    mmsi: 994136264,
    lng: 121.080138,
    lat: 40.583138,
    lastdyn: 1719859901,
    type: 25,
    shiptype: 'navigation',
    name: 'JINZHOU PORT NO11',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136264,
  },
  {
    mmsi: 994136263,
    lng: 121.083055,
    lat: 40.565612,
    lastdyn: 1719859898,
    type: 25,
    shiptype: 'navigation',
    name: 'JINZHOU PORT NO9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136263,
  },
  {
    mmsi: 994136010,
    lng: 121.029862,
    lat: 40.7495,
    lastdyn: 1719859913,
    type: 25,
    shiptype: 'navigation',
    name: 'HLD NORTH NO9',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136010,
  },
  {
    mmsi: 994136262,
    lng: 121.080055,
    lat: 40.547528,
    lastdyn: 1719859895,
    type: 24,
    shiptype: 'navigation',
    name: 'JINZHOU PORT NO8',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136262,
  },
  {
    mmsi: 994136260,
    lng: 121.086055,
    lat: 40.513167,
    lastdyn: 1719859889,
    type: 24,
    shiptype: 'navigation',
    name: 'JINZHOU PORT NO2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136260,
  },
  {
    mmsi: 994136261,
    lng: 121.086055,
    lat: 40.548,
    lastdyn: 1719859892,
    type: 25,
    shiptype: 'navigation',
    name: 'JINZHOU PORT NO7',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136261,
  },
  {
    mmsi: 994136009,
    lng: 121.0355,
    lat: 40.743862,
    lastdyn: 1719859910,
    type: 25,
    shiptype: 'navigation',
    name: 'HLD NORTH NO5',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136009,
  },
  {
    mmsi: 994146049,
    lng: 121.351693,
    lat: 40.500362,
    lastdyn: 1719859874,
    type: 3,
    shiptype: 'navigation',
    name: 'JZ202MN PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146049,
  },
  {
    mmsi: 994146051,
    lng: 121.451833,
    lat: 40.654333,
    lastdyn: 1719859871,
    type: 3,
    shiptype: 'navigation',
    name: 'JZ93WHPB PLATFORM',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146051,
  },
  {
    mmsi: 994131204,
    lng: 121.971745,
    lat: 40.668975,
    lastdyn: 1719859900,
    type: 22,
    shiptype: 'navigation',
    name: 'RONGXING PORT NO52',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994131204,
  },
  {
    mmsi: 994136236,
    lng: 122.125695,
    lat: 40.626167,
    lastdyn: 1719859746,
    type: 25,
    shiptype: 'navigation',
    name: 'YINGKOU PORT NO211',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136236,
  },
  {
    mmsi: 994136201,
    lng: 122.1105,
    lat: 40.513833,
    lastdyn: 1719859888,
    type: 28,
    shiptype: 'navigation',
    name: 'WRECK LYY23222',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136201,
  },
  {
    mmsi: 994316054,
    lng: 141.523333,
    lat: 40.594443,
    lastdyn: 1719859473,
    type: 12,
    shiptype: 'navigation',
    name: 'VHACHINOHEND',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316054,
  },
  {
    mmsi: 994316053,
    lng: 141.527505,
    lat: 40.591325,
    lastdyn: 1719859471,
    type: 11,
    shiptype: 'navigation',
    name: 'VHACHINOHENC',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316053,
  },
  {
    mmsi: 994316052,
    lng: 141.531638,
    lat: 40.594447,
    lastdyn: 1719859471,
    type: 10,
    shiptype: 'navigation',
    name: 'VHACHINOHENB',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316052,
  },
  {
    mmsi: 994316051,
    lng: 141.527492,
    lat: 40.597622,
    lastdyn: 1719859471,
    type: 9,
    shiptype: 'navigation',
    name: 'VHACHINOHENA',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316051,
  },
  {
    mmsi: 994169269,
    lng: 119.689828,
    lat: 23.530893,
    lastdyn: 1696948208,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC269 4V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169269,
  },
  {
    mmsi: 994169267,
    lng: 120.763663,
    lat: 21.949103,
    lastdyn: 1719638642,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC267 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169267,
  },
  {
    mmsi: 994169270,
    lng: 121.346183,
    lat: 25.168302,
    lastdyn: 1714363516,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC270 1V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169270,
  },
  {
    mmsi: 994169264,
    lng: 120.374003,
    lat: 22.297925,
    lastdyn: 1696329582,
    type: 0,
    shiptype: 'navigation',
    name: 'COMC264 9V',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 224,
    isvirtual: 0,
    serverTime: 1720684659,
    shipid: 994169264,
  },
  {
    mmsi: 994136013,
    lng: 120.981945,
    lat: 40.750112,
    lastdyn: 1719859742,
    type: 25,
    shiptype: 'navigation',
    name: 'HLD NORTH NO15',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136013,
  },
  {
    mmsi: 994136012,
    lng: 121.0015,
    lat: 40.750028,
    lastdyn: 1719859739,
    type: 25,
    shiptype: 'navigation',
    name: 'HLD NORTH NO13',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994136012,
  },
  {
    mmsi: 994146100,
    lng: 122.6095,
    lat: 40.885667,
    lastdyn: 1719859770,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST SDG2',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146100,
  },
  {
    mmsi: 994316993,
    lng: 142.571667,
    lat: 41.380737,
    lastdyn: 1719859064,
    type: 1,
    shiptype: 'navigation',
    name: 'TANSA SUBMERGED CABL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316993,
  },
  {
    mmsi: 994316990,
    lng: 142.568037,
    lat: 41.39283,
    lastdyn: 1719859034,
    type: 1,
    shiptype: 'navigation',
    name: 'TANSA SUBMERGED CABL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316990,
  },
  {
    mmsi: 994316991,
    lng: 142.517018,
    lat: 41.390702,
    lastdyn: 1719859044,
    type: 1,
    shiptype: 'navigation',
    name: 'TANSA SUBMERGED CABL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316991,
  },
  {
    mmsi: 994316992,
    lng: 142.466852,
    lat: 41.390377,
    lastdyn: 1719859054,
    type: 1,
    shiptype: 'navigation',
    name: 'TANSA SUBMERGED CABL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316992,
  },
  {
    mmsi: 994316994,
    lng: 142.520725,
    lat: 41.378672,
    lastdyn: 1719859074,
    type: 1,
    shiptype: 'navigation',
    name: 'TANSA SUBMERGED CABL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316994,
  },
  {
    mmsi: 994316995,
    lng: 142.469268,
    lat: 41.377,
    lastdyn: 1719859024,
    type: 1,
    shiptype: 'navigation',
    name: 'TANSA SUBMERGED CABL',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994316995,
  },
  {
    mmsi: 994146099,
    lng: 122.034,
    lat: 41.1355,
    lastdyn: 1719859740,
    type: 1,
    shiptype: 'navigation',
    name: 'TEST SDG1',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994146099,
  },
  {
    mmsi: 994130115,
    lng: 122.806,
    lat: 30.222667,
    lastdyn: 1707051180,
    type: 30,
    shiptype: 'navigation',
    name: 'ZHONGJIERANBAOHUQU',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994130115,
  },
  {
    mmsi: 994130117,
    lng: 121.316965,
    lat: 33.434457,
    lastdyn: 1650357265,
    type: 0,
    shiptype: 'navigation',
    name: 'LYDFH6012',
    length: 2,
    width: 2,
    left: 1,
    trail: 1,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994130117,
  },
  {
    mmsi: 994000001,
    lng: 44.922003,
    lat: 12.765518,
    lastdyn: 1666573130,
    type: 5,
    shiptype: 'navigation',
    name: 'OIL HARB LH',
    length: 0,
    width: 0,
    left: 0,
    trail: 0,
    offsetstatus: 0,
    atonstatus: 0,
    isvirtual: 1,
    serverTime: 1720684659,
    shipid: 994000001,
  },
]
